function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}
parcelRequire.register("9Dess", function(module, exports) {

$parcel$export(module.exports, "captureException", function () { return $7032f89ee0058fb7$export$f5282963edea4a68; });
$parcel$export(module.exports, "captureMessage", function () { return $7032f89ee0058fb7$export$45654777c133ae80; });
$parcel$export(module.exports, "captureEvent", function () { return $7032f89ee0058fb7$export$1462b974fdcf6ba2; });
$parcel$export(module.exports, "addBreadcrumb", function () { return $7032f89ee0058fb7$export$efda9a273d7a036d; });
$parcel$export(module.exports, "withScope", function () { return $7032f89ee0058fb7$export$ec58d9285c204497; });
$parcel$export(module.exports, "getCurrentScope", function () { return $7032f89ee0058fb7$export$c7be4b0125a10cba; });
$parcel$export(module.exports, "getClient", function () { return $7032f89ee0058fb7$export$6bb76d6eba7e258c; });
$parcel$export(module.exports, "startSession", function () { return $7032f89ee0058fb7$export$c0d84948cecf78d8; });
$parcel$export(module.exports, "captureSession", function () { return $7032f89ee0058fb7$export$667e7b4d445d566b; });

var $hi0PN = parcelRequire("hi0PN");
var $5lwZa = parcelRequire("5lwZa");
var $fi7Bg = parcelRequire("fi7Bg");
var $kTBeD = parcelRequire("kTBeD");
var $gYD4g = parcelRequire("gYD4g");

var $fc74V = parcelRequire("fc74V");

var $tgF2D = parcelRequire("tgF2D");

var $8XTAO = parcelRequire("8XTAO");

var $a6smX = parcelRequire("a6smX");

var $dW8zo = parcelRequire("dW8zo");
/**
 * Captures an exception event and sends it to Sentry.
 *
 * @param exception The exception to capture.
 * @param hint Optional additional data to attach to the Sentry event.
 * @returns the id of the captured Sentry event.
 */ function $7032f89ee0058fb7$export$f5282963edea4a68(// eslint-disable-next-line @typescript-eslint/no-explicit-any
exception, hint) {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $8XTAO.getCurrentHub)().captureException(exception, (0, $dW8zo.parseEventHintOrCaptureContext)(hint));
}
/**
 * Captures a message event and sends it to Sentry.
 *
 * @param exception The exception to capture.
 * @param captureContext Define the level of the message or pass in additional data to attach to the message.
 * @returns the id of the captured message.
 */ function $7032f89ee0058fb7$export$45654777c133ae80(message, // eslint-disable-next-line deprecation/deprecation
captureContext) {
    // This is necessary to provide explicit scopes upgrade, without changing the original
    // arity of the `captureMessage(message, level)` method.
    const level = typeof captureContext === "string" ? captureContext : undefined;
    const context = typeof captureContext !== "string" ? {
        captureContext: captureContext
    } : undefined;
    // eslint-disable-next-line deprecation/deprecation
    return (0, $8XTAO.getCurrentHub)().captureMessage(message, level, context);
}
/**
 * Captures a manually created event and sends it to Sentry.
 *
 * @param exception The event to send to Sentry.
 * @param hint Optional additional data to attach to the Sentry event.
 * @returns the id of the captured event.
 */ function $7032f89ee0058fb7$export$1462b974fdcf6ba2(event, hint) {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $8XTAO.getCurrentHub)().captureEvent(event, hint);
}
/**
 * Callback to set context information onto the scope.
 * @param callback Callback function that receives Scope.
 *
 * @deprecated Use getCurrentScope() directly.
 */ // eslint-disable-next-line deprecation/deprecation
function $7032f89ee0058fb7$export$99d44f04437e9cb8(callback) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $8XTAO.getCurrentHub)().configureScope(callback);
}
/**
 * Records a new breadcrumb which will be attached to future events.
 *
 * Breadcrumbs will be added to subsequent events to provide more context on
 * user's actions prior to an error or crash.
 *
 * @param breadcrumb The breadcrumb to record.
 */ // eslint-disable-next-line deprecation/deprecation
function $7032f89ee0058fb7$export$efda9a273d7a036d(breadcrumb, hint) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $8XTAO.getCurrentHub)().addBreadcrumb(breadcrumb, hint);
}
/**
 * Sets context data with the given name.
 * @param name of the context
 * @param context Any kind of data. This data will be normalized.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any, deprecation/deprecation
function $7032f89ee0058fb7$export$2f04de43fe27971a(name, context) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $8XTAO.getCurrentHub)().setContext(name, context);
}
/**
 * Set an object that will be merged sent as extra data with the event.
 * @param extras Extras object to merge into current context.
 */ // eslint-disable-next-line deprecation/deprecation
function $7032f89ee0058fb7$export$bb4922da0dd51b92(extras) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $8XTAO.getCurrentHub)().setExtras(extras);
}
/**
 * Set key:value that will be sent as extra data with the event.
 * @param key String of extra
 * @param extra Any kind of data. This data will be normalized.
 */ // eslint-disable-next-line deprecation/deprecation
function $7032f89ee0058fb7$export$8e8e7789d42ed61d(key, extra) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $8XTAO.getCurrentHub)().setExtra(key, extra);
}
/**
 * Set an object that will be merged sent as tags data with the event.
 * @param tags Tags context object to merge into current context.
 */ // eslint-disable-next-line deprecation/deprecation
function $7032f89ee0058fb7$export$74a8fb34822092e6(tags) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $8XTAO.getCurrentHub)().setTags(tags);
}
/**
 * Set key:value that will be sent as tags data with the event.
 *
 * Can also be used to unset a tag, by passing `undefined`.
 *
 * @param key String key of tag
 * @param value Value of tag
 */ // eslint-disable-next-line deprecation/deprecation
function $7032f89ee0058fb7$export$a37d07ee78eb4569(key, value) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $8XTAO.getCurrentHub)().setTag(key, value);
}
/**
 * Updates user context information for future events.
 *
 * @param user User context object to be set in the current context. Pass `null` to unset the user.
 */ // eslint-disable-next-line deprecation/deprecation
function $7032f89ee0058fb7$export$8b6bb3dd62a01be2(user) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $8XTAO.getCurrentHub)().setUser(user);
}
/**
 * Creates a new scope with and executes the given operation within.
 * The scope is automatically removed once the operation
 * finishes or throws.
 *
 * This is essentially a convenience function for:
 *
 *     pushScope();
 *     callback();
 *     popScope();
 */ /**
 * Either creates a new active scope, or sets the given scope as active scope in the given callback.
 */ function $7032f89ee0058fb7$export$ec58d9285c204497(...rest) {
    // eslint-disable-next-line deprecation/deprecation
    const hub = (0, $8XTAO.getCurrentHub)();
    // If a scope is defined, we want to make this the active scope instead of the default one
    if (rest.length === 2) {
        const [scope, callback] = rest;
        if (!scope) // eslint-disable-next-line deprecation/deprecation
        return hub.withScope(callback);
        // eslint-disable-next-line deprecation/deprecation
        return hub.withScope(()=>{
            // eslint-disable-next-line deprecation/deprecation
            hub.getStackTop().scope = scope;
            return callback(scope);
        });
    }
    // eslint-disable-next-line deprecation/deprecation
    return hub.withScope(rest[0]);
}
/**
 * Attempts to fork the current isolation scope and the current scope based on the current async context strategy. If no
 * async context strategy is set, the isolation scope and the current scope will not be forked (this is currently the
 * case, for example, in the browser).
 *
 * Usage of this function in environments without async context strategy is discouraged and may lead to unexpected behaviour.
 *
 * This function is intended for Sentry SDK and SDK integration development. It is not recommended to be used in "normal"
 * applications directly because it comes with pitfalls. Use at your own risk!
 *
 * @param callback The callback in which the passed isolation scope is active. (Note: In environments without async
 * context strategy, the currently active isolation scope may change within execution of the callback.)
 * @returns The same value that `callback` returns.
 */ function $7032f89ee0058fb7$export$9a4fed82c350c2bd(callback) {
    return (0, $8XTAO.runWithAsyncContext)(()=>{
        return callback((0, $8XTAO.getIsolationScope)());
    });
}
/**
 * Forks the current scope and sets the provided span as active span in the context of the provided callback.
 *
 * @param span Spans started in the context of the provided callback will be children of this span.
 * @param callback Execution context in which the provided span will be active. Is passed the newly forked scope.
 * @returns the value returned from the provided callback function.
 */ function $7032f89ee0058fb7$export$e57ac09b143d92a2(span, callback) {
    return $7032f89ee0058fb7$export$ec58d9285c204497((scope)=>{
        // eslint-disable-next-line deprecation/deprecation
        scope.setSpan(span);
        return callback(scope);
    });
}
/**
 * Starts a new `Transaction` and returns it. This is the entry point to manual tracing instrumentation.
 *
 * A tree structure can be built by adding child spans to the transaction, and child spans to other spans. To start a
 * new child span within the transaction or any span, call the respective `.startChild()` method.
 *
 * Every child span must be finished before the transaction is finished, otherwise the unfinished spans are discarded.
 *
 * The transaction must be finished with a call to its `.end()` method, at which point the transaction with all its
 * finished child spans will be sent to Sentry.
 *
 * NOTE: This function should only be used for *manual* instrumentation. Auto-instrumentation should call
 * `startTransaction` directly on the hub.
 *
 * @param context Properties of the new `Transaction`.
 * @param customSamplingContext Information given to the transaction sampling function (along with context-dependent
 * default values). See {@link Options.tracesSampler}.
 *
 * @returns The transaction which was just started
 *
 * @deprecated Use `startSpan()`, `startSpanManual()` or `startInactiveSpan()` instead.
 */ function $7032f89ee0058fb7$export$e262da7ae6480481(context, customSamplingContext) {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $8XTAO.getCurrentHub)().startTransaction({
        ...context
    }, customSamplingContext);
}
/**
 * Create a cron monitor check in and send it to Sentry.
 *
 * @param checkIn An object that describes a check in.
 * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
 * to create a monitor automatically when sending a check in.
 */ function $7032f89ee0058fb7$export$413528111fbc67c(checkIn, upsertMonitorConfig) {
    const scope = $7032f89ee0058fb7$export$c7be4b0125a10cba();
    const client = $7032f89ee0058fb7$export$6bb76d6eba7e258c();
    if (!client) (0, $tgF2D.DEBUG_BUILD) && (0, $fi7Bg.logger).warn("Cannot capture check-in. No client defined.");
    else if (!client.captureCheckIn) (0, $tgF2D.DEBUG_BUILD) && (0, $fi7Bg.logger).warn("Cannot capture check-in. Client does not support sending check-ins.");
    else return client.captureCheckIn(checkIn, upsertMonitorConfig, scope);
    return (0, $gYD4g.uuid4)();
}
/**
 * Wraps a callback with a cron monitor check in. The check in will be sent to Sentry when the callback finishes.
 *
 * @param monitorSlug The distinct slug of the monitor.
 * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
 * to create a monitor automatically when sending a check in.
 */ function $7032f89ee0058fb7$export$553526fc5f03c0b1(monitorSlug, callback, upsertMonitorConfig) {
    const checkInId = $7032f89ee0058fb7$export$413528111fbc67c({
        monitorSlug: monitorSlug,
        status: "in_progress"
    }, upsertMonitorConfig);
    const now = (0, $kTBeD.timestampInSeconds)();
    function finishCheckIn(status) {
        $7032f89ee0058fb7$export$413528111fbc67c({
            monitorSlug: monitorSlug,
            status: status,
            checkInId: checkInId,
            duration: (0, $kTBeD.timestampInSeconds)() - now
        });
    }
    let maybePromiseResult;
    try {
        maybePromiseResult = callback();
    } catch (e) {
        finishCheckIn("error");
        throw e;
    }
    if ((0, $5lwZa.isThenable)(maybePromiseResult)) Promise.resolve(maybePromiseResult).then(()=>{
        finishCheckIn("ok");
    }, ()=>{
        finishCheckIn("error");
    });
    else finishCheckIn("ok");
    return maybePromiseResult;
}
/**
 * Call `flush()` on the current client, if there is one. See {@link Client.flush}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue. Omitting this parameter will cause
 * the client to wait until all events are sent before resolving the promise.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */ async function $7032f89ee0058fb7$export$4909b86c8034bf73(timeout) {
    const client = $7032f89ee0058fb7$export$6bb76d6eba7e258c();
    if (client) return client.flush(timeout);
    (0, $tgF2D.DEBUG_BUILD) && (0, $fi7Bg.logger).warn("Cannot flush events. No client defined.");
    return Promise.resolve(false);
}
/**
 * Call `close()` on the current client, if there is one. See {@link Client.close}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue before shutting down. Omitting this
 * parameter will cause the client to wait until all events are sent before disabling itself.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */ async function $7032f89ee0058fb7$export$8360e631d277ea4d(timeout) {
    const client = $7032f89ee0058fb7$export$6bb76d6eba7e258c();
    if (client) return client.close(timeout);
    (0, $tgF2D.DEBUG_BUILD) && (0, $fi7Bg.logger).warn("Cannot flush events and disable SDK. No client defined.");
    return Promise.resolve(false);
}
/**
 * This is the getter for lastEventId.
 *
 * @returns The last event id of a captured event.
 */ function $7032f89ee0058fb7$export$5d4e9fd7fac8e617() {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $8XTAO.getCurrentHub)().lastEventId();
}
/**
 * Get the currently active client.
 */ function $7032f89ee0058fb7$export$6bb76d6eba7e258c() {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $8XTAO.getCurrentHub)().getClient();
}
/**
 * Returns true if Sentry has been properly initialized.
 */ function $7032f89ee0058fb7$export$3f95c6f800b78024() {
    return !!$7032f89ee0058fb7$export$6bb76d6eba7e258c();
}
/**
 * Get the currently active scope.
 */ function $7032f89ee0058fb7$export$c7be4b0125a10cba() {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $8XTAO.getCurrentHub)().getScope();
}
/**
 * Start a session on the current isolation scope.
 *
 * @param context (optional) additional properties to be applied to the returned session object
 *
 * @returns the new active session
 */ function $7032f89ee0058fb7$export$c0d84948cecf78d8(context) {
    const client = $7032f89ee0058fb7$export$6bb76d6eba7e258c();
    const isolationScope = (0, $8XTAO.getIsolationScope)();
    const currentScope = $7032f89ee0058fb7$export$c7be4b0125a10cba();
    const { release: release, environment: environment = (0, $fc74V.DEFAULT_ENVIRONMENT) } = client && client.getOptions() || {};
    // Will fetch userAgent if called from browser sdk
    const { userAgent: userAgent } = (0, $hi0PN.GLOBAL_OBJ).navigator || {};
    const session = (0, $a6smX.makeSession)({
        release: release,
        environment: environment,
        user: currentScope.getUser() || isolationScope.getUser(),
        ...userAgent && {
            userAgent: userAgent
        },
        ...context
    });
    // End existing session if there's one
    const currentSession = isolationScope.getSession();
    if (currentSession && currentSession.status === "ok") (0, $a6smX.updateSession)(currentSession, {
        status: "exited"
    });
    $7032f89ee0058fb7$export$17a5be43989a0bc1();
    // Afterwards we set the new session on the scope
    isolationScope.setSession(session);
    // TODO (v8): Remove this and only use the isolation scope(?).
    // For v7 though, we can't "soft-break" people using getCurrentHub().getScope().setSession()
    currentScope.setSession(session);
    return session;
}
/**
 * End the session on the current isolation scope.
 */ function $7032f89ee0058fb7$export$17a5be43989a0bc1() {
    const isolationScope = (0, $8XTAO.getIsolationScope)();
    const currentScope = $7032f89ee0058fb7$export$c7be4b0125a10cba();
    const session = currentScope.getSession() || isolationScope.getSession();
    if (session) (0, $a6smX.closeSession)(session);
    $7032f89ee0058fb7$var$_sendSessionUpdate();
    // the session is over; take it off of the scope
    isolationScope.setSession();
    // TODO (v8): Remove this and only use the isolation scope(?).
    // For v7 though, we can't "soft-break" people using getCurrentHub().getScope().setSession()
    currentScope.setSession();
}
/**
 * Sends the current Session on the scope
 */ function $7032f89ee0058fb7$var$_sendSessionUpdate() {
    const isolationScope = (0, $8XTAO.getIsolationScope)();
    const currentScope = $7032f89ee0058fb7$export$c7be4b0125a10cba();
    const client = $7032f89ee0058fb7$export$6bb76d6eba7e258c();
    // TODO (v8): Remove currentScope and only use the isolation scope(?).
    // For v7 though, we can't "soft-break" people using getCurrentHub().getScope().setSession()
    const session = currentScope.getSession() || isolationScope.getSession();
    if (session && client && client.captureSession) client.captureSession(session);
}
/**
 * Sends the current session on the scope to Sentry
 *
 * @param end If set the session will be marked as exited and removed from the scope.
 *            Defaults to `false`.
 */ function $7032f89ee0058fb7$export$667e7b4d445d566b(end = false) {
    // both send the update and pull the session from the scope
    if (end) {
        $7032f89ee0058fb7$export$17a5be43989a0bc1();
        return;
    }
    // only send the update
    $7032f89ee0058fb7$var$_sendSessionUpdate();
}

});
parcelRequire.register("hi0PN", function(module, exports) {

$parcel$export(module.exports, "GLOBAL_OBJ", function () { return $c964c3d2f4ee9d9f$export$f1a6cdb1459e81d1; });
$parcel$export(module.exports, "getGlobalObject", function () { return $c964c3d2f4ee9d9f$export$256479dc0cea61c4; });
$parcel$export(module.exports, "getGlobalSingleton", function () { return $c964c3d2f4ee9d9f$export$7e223ec222791509; });
/** Internal global with common properties and Sentry extensions  */ // The code below for 'isGlobalObj' and 'GLOBAL_OBJ' was copied from core-js before modification
// https://github.com/zloirock/core-js/blob/1b944df55282cdc99c90db5f49eb0b6eda2cc0a3/packages/core-js/internals/global.js
// core-js has the following licence:
//
// Copyright (c) 2014-2022 Denis Pushkarev
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.
/** Returns 'obj' if it's the global object, otherwise returns undefined */ function $c964c3d2f4ee9d9f$var$isGlobalObj(obj) {
    return obj && obj.Math == Math ? obj : undefined;
}
/** Get's the global object for the current JavaScript runtime */ const $c964c3d2f4ee9d9f$export$f1a6cdb1459e81d1 = typeof globalThis == "object" && $c964c3d2f4ee9d9f$var$isGlobalObj(globalThis) || // eslint-disable-next-line no-restricted-globals
typeof window == "object" && $c964c3d2f4ee9d9f$var$isGlobalObj(window) || typeof self == "object" && $c964c3d2f4ee9d9f$var$isGlobalObj(self) || typeof $parcel$global == "object" && $c964c3d2f4ee9d9f$var$isGlobalObj($parcel$global) || function() {
    return this;
}() || {};
/**
 * @deprecated Use GLOBAL_OBJ instead or WINDOW from @sentry/browser. This will be removed in v8
 */ function $c964c3d2f4ee9d9f$export$256479dc0cea61c4() {
    return $c964c3d2f4ee9d9f$export$f1a6cdb1459e81d1;
}
/**
 * Returns a global singleton contained in the global `__SENTRY__` object.
 *
 * If the singleton doesn't already exist in `__SENTRY__`, it will be created using the given factory
 * function and added to the `__SENTRY__` object.
 *
 * @param name name of the global singleton on __SENTRY__
 * @param creator creator Factory function to create the singleton if it doesn't already exist on `__SENTRY__`
 * @param obj (Optional) The global object on which to look for `__SENTRY__`, if not `GLOBAL_OBJ`'s return value
 * @returns the singleton
 */ function $c964c3d2f4ee9d9f$export$7e223ec222791509(name, creator, obj) {
    const gbl = obj || $c964c3d2f4ee9d9f$export$f1a6cdb1459e81d1;
    const __SENTRY__ = gbl.__SENTRY__ = gbl.__SENTRY__ || {};
    const singleton = __SENTRY__[name] || (__SENTRY__[name] = creator());
    return singleton;
}

});

parcelRequire.register("5lwZa", function(module, exports) {

$parcel$export(module.exports, "isError", function () { return $3e48802e9a673f4d$export$e6127cc7fe7395c3; });
$parcel$export(module.exports, "isInstanceOf", function () { return $3e48802e9a673f4d$export$49034edbe6b62415; });
$parcel$export(module.exports, "isErrorEvent", function () { return $3e48802e9a673f4d$export$9f9636d330b71954; });
$parcel$export(module.exports, "isDOMError", function () { return $3e48802e9a673f4d$export$ef9e2056653f0c8e; });
$parcel$export(module.exports, "isDOMException", function () { return $3e48802e9a673f4d$export$12e869b2a583f783; });
$parcel$export(module.exports, "isString", function () { return $3e48802e9a673f4d$export$844ec244b1367d54; });
$parcel$export(module.exports, "isParameterizedString", function () { return $3e48802e9a673f4d$export$dbcbffa59149b824; });
$parcel$export(module.exports, "isPrimitive", function () { return $3e48802e9a673f4d$export$c3825b437cbdea5c; });
$parcel$export(module.exports, "isPlainObject", function () { return $3e48802e9a673f4d$export$53b83ca8eaab0383; });
$parcel$export(module.exports, "isEvent", function () { return $3e48802e9a673f4d$export$9671ea99bd126ace; });
$parcel$export(module.exports, "isElement", function () { return $3e48802e9a673f4d$export$45a5e7f76e0caa8d; });
$parcel$export(module.exports, "isRegExp", function () { return $3e48802e9a673f4d$export$49841c62b9eff15; });
$parcel$export(module.exports, "isThenable", function () { return $3e48802e9a673f4d$export$f5b060c2914b97c8; });
$parcel$export(module.exports, "isSyntheticEvent", function () { return $3e48802e9a673f4d$export$bc2894c7158efbac; });
$parcel$export(module.exports, "isNaN", function () { return $3e48802e9a673f4d$export$c9f5652083b8129d; });
$parcel$export(module.exports, "isVueViewModel", function () { return $3e48802e9a673f4d$export$7916fad0ebc23f48; });
// eslint-disable-next-line @typescript-eslint/unbound-method
const $3e48802e9a673f4d$var$objectToString = Object.prototype.toString;
/**
 * Checks whether given value's type is one of a few Error or Error-like
 * {@link isError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $3e48802e9a673f4d$export$e6127cc7fe7395c3(wat) {
    switch($3e48802e9a673f4d$var$objectToString.call(wat)){
        case "[object Error]":
        case "[object Exception]":
        case "[object DOMException]":
            return true;
        default:
            return $3e48802e9a673f4d$export$49034edbe6b62415(wat, Error);
    }
}
/**
 * Checks whether given value is an instance of the given built-in class.
 *
 * @param wat The value to be checked
 * @param className
 * @returns A boolean representing the result.
 */ function $3e48802e9a673f4d$var$isBuiltin(wat, className) {
    return $3e48802e9a673f4d$var$objectToString.call(wat) === `[object ${className}]`;
}
/**
 * Checks whether given value's type is ErrorEvent
 * {@link isErrorEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $3e48802e9a673f4d$export$9f9636d330b71954(wat) {
    return $3e48802e9a673f4d$var$isBuiltin(wat, "ErrorEvent");
}
/**
 * Checks whether given value's type is DOMError
 * {@link isDOMError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $3e48802e9a673f4d$export$ef9e2056653f0c8e(wat) {
    return $3e48802e9a673f4d$var$isBuiltin(wat, "DOMError");
}
/**
 * Checks whether given value's type is DOMException
 * {@link isDOMException}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $3e48802e9a673f4d$export$12e869b2a583f783(wat) {
    return $3e48802e9a673f4d$var$isBuiltin(wat, "DOMException");
}
/**
 * Checks whether given value's type is a string
 * {@link isString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $3e48802e9a673f4d$export$844ec244b1367d54(wat) {
    return $3e48802e9a673f4d$var$isBuiltin(wat, "String");
}
/**
 * Checks whether given string is parameterized
 * {@link isParameterizedString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $3e48802e9a673f4d$export$dbcbffa59149b824(wat) {
    return typeof wat === "object" && wat !== null && "__sentry_template_string__" in wat && "__sentry_template_values__" in wat;
}
/**
 * Checks whether given value is a primitive (undefined, null, number, boolean, string, bigint, symbol)
 * {@link isPrimitive}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $3e48802e9a673f4d$export$c3825b437cbdea5c(wat) {
    return wat === null || $3e48802e9a673f4d$export$dbcbffa59149b824(wat) || typeof wat !== "object" && typeof wat !== "function";
}
/**
 * Checks whether given value's type is an object literal, or a class instance.
 * {@link isPlainObject}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $3e48802e9a673f4d$export$53b83ca8eaab0383(wat) {
    return $3e48802e9a673f4d$var$isBuiltin(wat, "Object");
}
/**
 * Checks whether given value's type is an Event instance
 * {@link isEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $3e48802e9a673f4d$export$9671ea99bd126ace(wat) {
    return typeof Event !== "undefined" && $3e48802e9a673f4d$export$49034edbe6b62415(wat, Event);
}
/**
 * Checks whether given value's type is an Element instance
 * {@link isElement}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $3e48802e9a673f4d$export$45a5e7f76e0caa8d(wat) {
    return typeof Element !== "undefined" && $3e48802e9a673f4d$export$49034edbe6b62415(wat, Element);
}
/**
 * Checks whether given value's type is an regexp
 * {@link isRegExp}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $3e48802e9a673f4d$export$49841c62b9eff15(wat) {
    return $3e48802e9a673f4d$var$isBuiltin(wat, "RegExp");
}
/**
 * Checks whether given value has a then function.
 * @param wat A value to be checked.
 */ function $3e48802e9a673f4d$export$f5b060c2914b97c8(wat) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return Boolean(wat && wat.then && typeof wat.then === "function");
}
/**
 * Checks whether given value's type is a SyntheticEvent
 * {@link isSyntheticEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $3e48802e9a673f4d$export$bc2894c7158efbac(wat) {
    return $3e48802e9a673f4d$export$53b83ca8eaab0383(wat) && "nativeEvent" in wat && "preventDefault" in wat && "stopPropagation" in wat;
}
/**
 * Checks whether given value is NaN
 * {@link isNaN}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $3e48802e9a673f4d$export$c9f5652083b8129d(wat) {
    return typeof wat === "number" && wat !== wat;
}
/**
 * Checks whether given value's type is an instance of provided constructor.
 * {@link isInstanceOf}.
 *
 * @param wat A value to be checked.
 * @param base A constructor to be used in a check.
 * @returns A boolean representing the result.
 */ function $3e48802e9a673f4d$export$49034edbe6b62415(wat, base) {
    try {
        return wat instanceof base;
    } catch (_e) {
        return false;
    }
}
/**
 * Checks whether given value's type is a Vue ViewModel.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $3e48802e9a673f4d$export$7916fad0ebc23f48(wat) {
    // Not using Object.prototype.toString because in Vue 3 it would read the instance's Symbol(Symbol.toStringTag) property.
    return !!(typeof wat === "object" && wat !== null && (wat.__isVue || wat._isVue));
}

});

parcelRequire.register("fi7Bg", function(module, exports) {

$parcel$export(module.exports, "CONSOLE_LEVELS", function () { return $b21e6eaf6c076384$export$2a2b1d2252a69ecb; });
$parcel$export(module.exports, "originalConsoleMethods", function () { return $b21e6eaf6c076384$export$77c4ce905194557b; });
$parcel$export(module.exports, "consoleSandbox", function () { return $b21e6eaf6c076384$export$cda52e2a8927a2ca; });
$parcel$export(module.exports, "logger", function () { return $b21e6eaf6c076384$export$af88d00dbe7f521; });

var $7qutn = parcelRequire("7qutn");

var $hi0PN = parcelRequire("hi0PN");
/** Prefix for logging strings */ const $b21e6eaf6c076384$var$PREFIX = "Sentry Logger ";
const $b21e6eaf6c076384$export$2a2b1d2252a69ecb = [
    "debug",
    "info",
    "warn",
    "error",
    "log",
    "assert",
    "trace"
];
/** This may be mutated by the console instrumentation. */ const $b21e6eaf6c076384$export$77c4ce905194557b = {};
/** JSDoc */ /**
 * Temporarily disable sentry console instrumentations.
 *
 * @param callback The function to run against the original `console` messages
 * @returns The results of the callback
 */ function $b21e6eaf6c076384$export$cda52e2a8927a2ca(callback) {
    if (!("console" in (0, $hi0PN.GLOBAL_OBJ))) return callback();
    const console = (0, $hi0PN.GLOBAL_OBJ).console;
    const wrappedFuncs = {};
    const wrappedLevels = Object.keys($b21e6eaf6c076384$export$77c4ce905194557b);
    // Restore all wrapped console methods
    wrappedLevels.forEach((level)=>{
        const originalConsoleMethod = $b21e6eaf6c076384$export$77c4ce905194557b[level];
        wrappedFuncs[level] = console[level];
        console[level] = originalConsoleMethod;
    });
    try {
        return callback();
    } finally{
        // Revert restoration to wrapped state
        wrappedLevels.forEach((level)=>{
            console[level] = wrappedFuncs[level];
        });
    }
}
function $b21e6eaf6c076384$var$makeLogger() {
    let enabled = false;
    const logger = {
        enable: ()=>{
            enabled = true;
        },
        disable: ()=>{
            enabled = false;
        },
        isEnabled: ()=>enabled
    };
    if (0, $7qutn.DEBUG_BUILD) $b21e6eaf6c076384$export$2a2b1d2252a69ecb.forEach((name)=>{
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        logger[name] = (...args)=>{
            if (enabled) $b21e6eaf6c076384$export$cda52e2a8927a2ca(()=>{
                (0, $hi0PN.GLOBAL_OBJ).console[name](`${$b21e6eaf6c076384$var$PREFIX}[${name}]:`, ...args);
            });
        };
    });
    else $b21e6eaf6c076384$export$2a2b1d2252a69ecb.forEach((name)=>{
        logger[name] = ()=>undefined;
    });
    return logger;
}
const $b21e6eaf6c076384$export$af88d00dbe7f521 = $b21e6eaf6c076384$var$makeLogger();

});
parcelRequire.register("7qutn", function(module, exports) {

$parcel$export(module.exports, "DEBUG_BUILD", function () { return $56829964645c4ce6$export$16a28057038b10ef; });
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $56829964645c4ce6$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__;

});


parcelRequire.register("kTBeD", function(module, exports) {

$parcel$export(module.exports, "dateTimestampInSeconds", function () { return $f365d3ca326acbe6$export$7740643b9eeaf0c4; });
$parcel$export(module.exports, "timestampInSeconds", function () { return $f365d3ca326acbe6$export$ee52dced521e3e18; });

var $hi0PN = parcelRequire("hi0PN");
const $f365d3ca326acbe6$var$ONE_SECOND_IN_MS = 1000;
/**
 * A partial definition of the [Performance Web API]{@link https://developer.mozilla.org/en-US/docs/Web/API/Performance}
 * for accessing a high-resolution monotonic clock.
 */ /**
 * Returns a timestamp in seconds since the UNIX epoch using the Date API.
 *
 * TODO(v8): Return type should be rounded.
 */ function $f365d3ca326acbe6$export$7740643b9eeaf0c4() {
    return Date.now() / $f365d3ca326acbe6$var$ONE_SECOND_IN_MS;
}
/**
 * Returns a wrapper around the native Performance API browser implementation, or undefined for browsers that do not
 * support the API.
 *
 * Wrapping the native API works around differences in behavior from different browsers.
 */ function $f365d3ca326acbe6$var$createUnixTimestampInSecondsFunc() {
    const { performance: performance } = (0, $hi0PN.GLOBAL_OBJ);
    if (!performance || !performance.now) return $f365d3ca326acbe6$export$7740643b9eeaf0c4;
    // Some browser and environments don't have a timeOrigin, so we fallback to
    // using Date.now() to compute the starting time.
    const approxStartingTimeOrigin = Date.now() - performance.now();
    const timeOrigin = performance.timeOrigin == undefined ? approxStartingTimeOrigin : performance.timeOrigin;
    // performance.now() is a monotonic clock, which means it starts at 0 when the process begins. To get the current
    // wall clock time (actual UNIX timestamp), we need to add the starting time origin and the current time elapsed.
    //
    // TODO: This does not account for the case where the monotonic clock that powers performance.now() drifts from the
    // wall clock time, which causes the returned timestamp to be inaccurate. We should investigate how to detect and
    // correct for this.
    // See: https://github.com/getsentry/sentry-javascript/issues/2590
    // See: https://github.com/mdn/content/issues/4713
    // See: https://dev.to/noamr/when-a-millisecond-is-not-a-millisecond-3h6
    return ()=>{
        return (timeOrigin + performance.now()) / $f365d3ca326acbe6$var$ONE_SECOND_IN_MS;
    };
}
/**
 * Returns a timestamp in seconds since the UNIX epoch using either the Performance or Date APIs, depending on the
 * availability of the Performance API.
 *
 * BUG: Note that because of how browsers implement the Performance API, the clock might stop when the computer is
 * asleep. This creates a skew between `dateTimestampInSeconds` and `timestampInSeconds`. The
 * skew can grow to arbitrary amounts like days, weeks or months.
 * See https://github.com/getsentry/sentry-javascript/issues/2590.
 */ const $f365d3ca326acbe6$export$ee52dced521e3e18 = $f365d3ca326acbe6$var$createUnixTimestampInSecondsFunc();
/**
 * Re-exported with an old name for backwards-compatibility.
 * TODO (v8): Remove this
 *
 * @deprecated Use `timestampInSeconds` instead.
 */ const $f365d3ca326acbe6$export$c5907b5a8838db13 = $f365d3ca326acbe6$export$ee52dced521e3e18;
/**
 * Internal helper to store what is the source of browserPerformanceTimeOrigin below. For debugging only.
 */ let $f365d3ca326acbe6$export$f9f8cce55af5194c;
/**
 * The number of milliseconds since the UNIX epoch. This value is only usable in a browser, and only when the
 * performance API is available.
 */ const $f365d3ca326acbe6$export$baf075a948ffc0bf = (()=>{
    // Unfortunately browsers may report an inaccurate time origin data, through either performance.timeOrigin or
    // performance.timing.navigationStart, which results in poor results in performance data. We only treat time origin
    // data as reliable if they are within a reasonable threshold of the current time.
    const { performance: performance } = (0, $hi0PN.GLOBAL_OBJ);
    if (!performance || !performance.now) {
        $f365d3ca326acbe6$export$f9f8cce55af5194c = "none";
        return undefined;
    }
    const threshold = 3600000;
    const performanceNow = performance.now();
    const dateNow = Date.now();
    // if timeOrigin isn't available set delta to threshold so it isn't used
    const timeOriginDelta = performance.timeOrigin ? Math.abs(performance.timeOrigin + performanceNow - dateNow) : threshold;
    const timeOriginIsReliable = timeOriginDelta < threshold;
    // While performance.timing.navigationStart is deprecated in favor of performance.timeOrigin, performance.timeOrigin
    // is not as widely supported. Namely, performance.timeOrigin is undefined in Safari as of writing.
    // Also as of writing, performance.timing is not available in Web Workers in mainstream browsers, so it is not always
    // a valid fallback. In the absence of an initial time provided by the browser, fallback to the current time from the
    // Date API.
    // eslint-disable-next-line deprecation/deprecation
    const navigationStart = performance.timing && performance.timing.navigationStart;
    const hasNavigationStart = typeof navigationStart === "number";
    // if navigationStart isn't available set delta to threshold so it isn't used
    const navigationStartDelta = hasNavigationStart ? Math.abs(navigationStart + performanceNow - dateNow) : threshold;
    const navigationStartIsReliable = navigationStartDelta < threshold;
    if (timeOriginIsReliable || navigationStartIsReliable) {
        // Use the more reliable time origin
        if (timeOriginDelta <= navigationStartDelta) {
            $f365d3ca326acbe6$export$f9f8cce55af5194c = "timeOrigin";
            return performance.timeOrigin;
        } else {
            $f365d3ca326acbe6$export$f9f8cce55af5194c = "navigationStart";
            return navigationStart;
        }
    }
    // Either both timeOrigin and navigationStart are skewed or neither is available, fallback to Date.
    $f365d3ca326acbe6$export$f9f8cce55af5194c = "dateNow";
    return dateNow;
})();

});

parcelRequire.register("gYD4g", function(module, exports) {

$parcel$export(module.exports, "uuid4", function () { return $c5c08dfaa2e5c707$export$19f53698e68b2496; });
$parcel$export(module.exports, "getEventDescription", function () { return $c5c08dfaa2e5c707$export$4157119e2b157127; });
$parcel$export(module.exports, "addExceptionTypeValue", function () { return $c5c08dfaa2e5c707$export$f26508487bf83ee7; });
$parcel$export(module.exports, "addExceptionMechanism", function () { return $c5c08dfaa2e5c707$export$c69a9a0313b03bb1; });
$parcel$export(module.exports, "checkOrSetAlreadyCaught", function () { return $c5c08dfaa2e5c707$export$6de4ffac6a2f1098; });
$parcel$export(module.exports, "arrayify", function () { return $c5c08dfaa2e5c707$export$3131421a7d01b4fb; });

var $eKFW4 = parcelRequire("eKFW4");

var $2AO4R = parcelRequire("2AO4R");

var $hi0PN = parcelRequire("hi0PN");
/**
 * UUID4 generator
 *
 * @returns string Generated UUID4.
 */ function $c5c08dfaa2e5c707$export$19f53698e68b2496() {
    const gbl = (0, $hi0PN.GLOBAL_OBJ);
    const crypto = gbl.crypto || gbl.msCrypto;
    let getRandomByte = ()=>Math.random() * 16;
    try {
        if (crypto && crypto.randomUUID) return crypto.randomUUID().replace(/-/g, "");
        if (crypto && crypto.getRandomValues) getRandomByte = ()=>{
            // crypto.getRandomValues might return undefined instead of the typed array
            // in old Chromium versions (e.g. 23.0.1235.0 (151422))
            // However, `typedArray` is still filled in-place.
            // @see https://developer.mozilla.org/en-US/docs/Web/API/Crypto/getRandomValues#typedarray
            const typedArray = new Uint8Array(1);
            crypto.getRandomValues(typedArray);
            return typedArray[0];
        };
    } catch (_) {
    // some runtimes can crash invoking crypto
    // https://github.com/getsentry/sentry-javascript/issues/8935
    }
    // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
    // Concatenating the following numbers as strings results in '10000000100040008000100000000000'
    return "10000000100040008000100000000000".replace(/[018]/g, (c)=>// eslint-disable-next-line no-bitwise
        (c ^ (getRandomByte() & 15) >> c / 4).toString(16));
}
function $c5c08dfaa2e5c707$var$getFirstException(event) {
    return event.exception && event.exception.values ? event.exception.values[0] : undefined;
}
/**
 * Extracts either message or type+value from an event that can be used for user-facing logs
 * @returns event's description
 */ function $c5c08dfaa2e5c707$export$4157119e2b157127(event) {
    const { message: message, event_id: eventId } = event;
    if (message) return message;
    const firstException = $c5c08dfaa2e5c707$var$getFirstException(event);
    if (firstException) {
        if (firstException.type && firstException.value) return `${firstException.type}: ${firstException.value}`;
        return firstException.type || firstException.value || eventId || "<unknown>";
    }
    return eventId || "<unknown>";
}
/**
 * Adds exception values, type and value to an synthetic Exception.
 * @param event The event to modify.
 * @param value Value of the exception.
 * @param type Type of the exception.
 * @hidden
 */ function $c5c08dfaa2e5c707$export$f26508487bf83ee7(event, value, type) {
    const exception = event.exception = event.exception || {};
    const values = exception.values = exception.values || [];
    const firstException = values[0] = values[0] || {};
    if (!firstException.value) firstException.value = value || "";
    if (!firstException.type) firstException.type = type || "Error";
}
/**
 * Adds exception mechanism data to a given event. Uses defaults if the second parameter is not passed.
 *
 * @param event The event to modify.
 * @param newMechanism Mechanism data to add to the event.
 * @hidden
 */ function $c5c08dfaa2e5c707$export$c69a9a0313b03bb1(event, newMechanism) {
    const firstException = $c5c08dfaa2e5c707$var$getFirstException(event);
    if (!firstException) return;
    const defaultMechanism = {
        type: "generic",
        handled: true
    };
    const currentMechanism = firstException.mechanism;
    firstException.mechanism = {
        ...defaultMechanism,
        ...currentMechanism,
        ...newMechanism
    };
    if (newMechanism && "data" in newMechanism) {
        const mergedData = {
            ...currentMechanism && currentMechanism.data,
            ...newMechanism.data
        };
        firstException.mechanism.data = mergedData;
    }
}
// https://semver.org/#is-there-a-suggested-regular-expression-regex-to-check-a-semver-string
const $c5c08dfaa2e5c707$var$SEMVER_REGEXP = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;
/**
 * Represents Semantic Versioning object
 */ /**
 * Parses input into a SemVer interface
 * @param input string representation of a semver version
 */ function $c5c08dfaa2e5c707$export$d364f2020ab30578(input) {
    const match = input.match($c5c08dfaa2e5c707$var$SEMVER_REGEXP) || [];
    const major = parseInt(match[1], 10);
    const minor = parseInt(match[2], 10);
    const patch = parseInt(match[3], 10);
    return {
        buildmetadata: match[5],
        major: isNaN(major) ? undefined : major,
        minor: isNaN(minor) ? undefined : minor,
        patch: isNaN(patch) ? undefined : patch,
        prerelease: match[4]
    };
}
/**
 * This function adds context (pre/post/line) lines to the provided frame
 *
 * @param lines string[] containing all lines
 * @param frame StackFrame that will be mutated
 * @param linesOfContext number of context lines we want to add pre/post
 */ function $c5c08dfaa2e5c707$export$ec2291bfc64632f0(lines, frame, linesOfContext = 5) {
    // When there is no line number in the frame, attaching context is nonsensical and will even break grouping
    if (frame.lineno === undefined) return;
    const maxLines = lines.length;
    const sourceLine = Math.max(Math.min(maxLines - 1, frame.lineno - 1), 0);
    frame.pre_context = lines.slice(Math.max(0, sourceLine - linesOfContext), sourceLine).map((line)=>(0, $2AO4R.snipLine)(line, 0));
    frame.context_line = (0, $2AO4R.snipLine)(lines[Math.min(maxLines - 1, sourceLine)], frame.colno || 0);
    frame.post_context = lines.slice(Math.min(sourceLine + 1, maxLines), sourceLine + 1 + linesOfContext).map((line)=>(0, $2AO4R.snipLine)(line, 0));
}
/**
 * Checks whether or not we've already captured the given exception (note: not an identical exception - the very object
 * in question), and marks it captured if not.
 *
 * This is useful because it's possible for an error to get captured by more than one mechanism. After we intercept and
 * record an error, we rethrow it (assuming we've intercepted it before it's reached the top-level global handlers), so
 * that we don't interfere with whatever effects the error might have had were the SDK not there. At that point, because
 * the error has been rethrown, it's possible for it to bubble up to some other code we've instrumented. If it's not
 * caught after that, it will bubble all the way up to the global handlers (which of course we also instrument). This
 * function helps us ensure that even if we encounter the same error more than once, we only record it the first time we
 * see it.
 *
 * Note: It will ignore primitives (always return `false` and not mark them as seen), as properties can't be set on
 * them. {@link: Object.objectify} can be used on exceptions to convert any that are primitives into their equivalent
 * object wrapper forms so that this check will always work. However, because we need to flag the exact object which
 * will get rethrown, and because that rethrowing happens outside of the event processing pipeline, the objectification
 * must be done before the exception captured.
 *
 * @param A thrown exception to check or flag as having been seen
 * @returns `true` if the exception has already been captured, `false` if not (with the side effect of marking it seen)
 */ function $c5c08dfaa2e5c707$export$6de4ffac6a2f1098(exception) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    if (exception && exception.__sentry_captured__) return true;
    try {
        // set it this way rather than by assignment so that it's not ennumerable and therefore isn't recorded by the
        // `ExtraErrorData` integration
        (0, $eKFW4.addNonEnumerableProperty)(exception, "__sentry_captured__", true);
    } catch (err) {
    // `exception` is a primitive, so we can't mark it seen
    }
    return false;
}
/**
 * Checks whether the given input is already an array, and if it isn't, wraps it in one.
 *
 * @param maybeArray Input to turn into an array, if necessary
 * @returns The input, if already an array, or an array with the input as the only element, if not
 */ function $c5c08dfaa2e5c707$export$3131421a7d01b4fb(maybeArray) {
    return Array.isArray(maybeArray) ? maybeArray : [
        maybeArray
    ];
}

});
parcelRequire.register("eKFW4", function(module, exports) {

$parcel$export(module.exports, "fill", function () { return $abd5e421cc04bf71$export$9563e054e6f787fb; });
$parcel$export(module.exports, "markFunctionWrapped", function () { return $abd5e421cc04bf71$export$5c1499e2e5d010ae; });
$parcel$export(module.exports, "addNonEnumerableProperty", function () { return $abd5e421cc04bf71$export$e73679ffaf56810e; });
$parcel$export(module.exports, "getOriginalFunction", function () { return $abd5e421cc04bf71$export$e6cc1e135e2092e5; });
$parcel$export(module.exports, "urlEncode", function () { return $abd5e421cc04bf71$export$9ef804feabbcbaf1; });
$parcel$export(module.exports, "convertToPlainObject", function () { return $abd5e421cc04bf71$export$62ff257738bf57f5; });
$parcel$export(module.exports, "extractExceptionKeysForMessage", function () { return $abd5e421cc04bf71$export$b0244d5063c0b61b; });
$parcel$export(module.exports, "dropUndefinedKeys", function () { return $abd5e421cc04bf71$export$d25f2688db1bb433; });

var $ffqzi = parcelRequire("ffqzi");

var $7qutn = parcelRequire("7qutn");

var $5lwZa = parcelRequire("5lwZa");

var $fi7Bg = parcelRequire("fi7Bg");

var $2AO4R = parcelRequire("2AO4R");
/**
 * Replace a method in an object with a wrapped version of itself.
 *
 * @param source An object that contains a method to be wrapped.
 * @param name The name of the method to be wrapped.
 * @param replacementFactory A higher-order function that takes the original version of the given method and returns a
 * wrapped version. Note: The function returned by `replacementFactory` needs to be a non-arrow function, in order to
 * preserve the correct value of `this`, and the original method must be called using `origMethod.call(this, <other
 * args>)` or `origMethod.apply(this, [<other args>])` (rather than being called directly), again to preserve `this`.
 * @returns void
 */ function $abd5e421cc04bf71$export$9563e054e6f787fb(source, name, replacementFactory) {
    if (!(name in source)) return;
    const original = source[name];
    const wrapped = replacementFactory(original);
    // Make sure it's a function first, as we need to attach an empty prototype for `defineProperties` to work
    // otherwise it'll throw "TypeError: Object.defineProperties called on non-object"
    if (typeof wrapped === "function") $abd5e421cc04bf71$export$5c1499e2e5d010ae(wrapped, original);
    source[name] = wrapped;
}
/**
 * Defines a non-enumerable property on the given object.
 *
 * @param obj The object on which to set the property
 * @param name The name of the property to be set
 * @param value The value to which to set the property
 */ function $abd5e421cc04bf71$export$e73679ffaf56810e(obj, name, value) {
    try {
        Object.defineProperty(obj, name, {
            // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
            value: value,
            writable: true,
            configurable: true
        });
    } catch (o_O) {
        (0, $7qutn.DEBUG_BUILD) && (0, $fi7Bg.logger).log(`Failed to add non-enumerable property "${name}" to object`, obj);
    }
}
/**
 * Remembers the original function on the wrapped function and
 * patches up the prototype.
 *
 * @param wrapped the wrapper function
 * @param original the original function that gets wrapped
 */ function $abd5e421cc04bf71$export$5c1499e2e5d010ae(wrapped, original) {
    try {
        const proto = original.prototype || {};
        wrapped.prototype = original.prototype = proto;
        $abd5e421cc04bf71$export$e73679ffaf56810e(wrapped, "__sentry_original__", original);
    } catch (o_O) {} // eslint-disable-line no-empty
}
/**
 * This extracts the original function if available.  See
 * `markFunctionWrapped` for more information.
 *
 * @param func the function to unwrap
 * @returns the unwrapped version of the function if available.
 */ function $abd5e421cc04bf71$export$e6cc1e135e2092e5(func) {
    return func.__sentry_original__;
}
/**
 * Encodes given object into url-friendly format
 *
 * @param object An object that contains serializable values
 * @returns string Encoded
 */ function $abd5e421cc04bf71$export$9ef804feabbcbaf1(object) {
    return Object.keys(object).map((key)=>`${encodeURIComponent(key)}=${encodeURIComponent(object[key])}`).join("&");
}
/**
 * Transforms any `Error` or `Event` into a plain object with all of their enumerable properties, and some of their
 * non-enumerable properties attached.
 *
 * @param value Initial source that we have to transform in order for it to be usable by the serializer
 * @returns An Event or Error turned into an object - or the value argurment itself, when value is neither an Event nor
 *  an Error.
 */ function $abd5e421cc04bf71$export$62ff257738bf57f5(value) {
    if ((0, $5lwZa.isError)(value)) return {
        message: value.message,
        name: value.name,
        stack: value.stack,
        ...$abd5e421cc04bf71$var$getOwnProperties(value)
    };
    else if ((0, $5lwZa.isEvent)(value)) {
        const newObj = {
            type: value.type,
            target: $abd5e421cc04bf71$var$serializeEventTarget(value.target),
            currentTarget: $abd5e421cc04bf71$var$serializeEventTarget(value.currentTarget),
            ...$abd5e421cc04bf71$var$getOwnProperties(value)
        };
        if (typeof CustomEvent !== "undefined" && (0, $5lwZa.isInstanceOf)(value, CustomEvent)) newObj.detail = value.detail;
        return newObj;
    } else return value;
}
/** Creates a string representation of the target of an `Event` object */ function $abd5e421cc04bf71$var$serializeEventTarget(target) {
    try {
        return (0, $5lwZa.isElement)(target) ? (0, $ffqzi.htmlTreeAsString)(target) : Object.prototype.toString.call(target);
    } catch (_oO) {
        return "<unknown>";
    }
}
/** Filters out all but an object's own properties */ function $abd5e421cc04bf71$var$getOwnProperties(obj) {
    if (typeof obj === "object" && obj !== null) {
        const extractedProps = {};
        for(const property in obj)if (Object.prototype.hasOwnProperty.call(obj, property)) extractedProps[property] = obj[property];
        return extractedProps;
    } else return {};
}
/**
 * Given any captured exception, extract its keys and create a sorted
 * and truncated list that will be used inside the event message.
 * eg. `Non-error exception captured with keys: foo, bar, baz`
 */ function $abd5e421cc04bf71$export$b0244d5063c0b61b(exception, maxLength = 40) {
    const keys = Object.keys($abd5e421cc04bf71$export$62ff257738bf57f5(exception));
    keys.sort();
    if (!keys.length) return "[object has no keys]";
    if (keys[0].length >= maxLength) return (0, $2AO4R.truncate)(keys[0], maxLength);
    for(let includedKeys = keys.length; includedKeys > 0; includedKeys--){
        const serialized = keys.slice(0, includedKeys).join(", ");
        if (serialized.length > maxLength) continue;
        if (includedKeys === keys.length) return serialized;
        return (0, $2AO4R.truncate)(serialized, maxLength);
    }
    return "";
}
/**
 * Given any object, return a new object having removed all fields whose value was `undefined`.
 * Works recursively on objects and arrays.
 *
 * Attention: This function keeps circular references in the returned object.
 */ function $abd5e421cc04bf71$export$d25f2688db1bb433(inputValue) {
    // This map keeps track of what already visited nodes map to.
    // Our Set - based memoBuilder doesn't work here because we want to the output object to have the same circular
    // references as the input object.
    const memoizationMap = new Map();
    // This function just proxies `_dropUndefinedKeys` to keep the `memoBuilder` out of this function's API
    return $abd5e421cc04bf71$var$_dropUndefinedKeys(inputValue, memoizationMap);
}
function $abd5e421cc04bf71$var$_dropUndefinedKeys(inputValue, memoizationMap) {
    if ($abd5e421cc04bf71$var$isPojo(inputValue)) {
        // If this node has already been visited due to a circular reference, return the object it was mapped to in the new object
        const memoVal = memoizationMap.get(inputValue);
        if (memoVal !== undefined) return memoVal;
        const returnValue = {};
        // Store the mapping of this value in case we visit it again, in case of circular data
        memoizationMap.set(inputValue, returnValue);
        for (const key of Object.keys(inputValue))if (typeof inputValue[key] !== "undefined") returnValue[key] = $abd5e421cc04bf71$var$_dropUndefinedKeys(inputValue[key], memoizationMap);
        return returnValue;
    }
    if (Array.isArray(inputValue)) {
        // If this node has already been visited due to a circular reference, return the array it was mapped to in the new object
        const memoVal = memoizationMap.get(inputValue);
        if (memoVal !== undefined) return memoVal;
        const returnValue = [];
        // Store the mapping of this value in case we visit it again, in case of circular data
        memoizationMap.set(inputValue, returnValue);
        inputValue.forEach((item)=>{
            returnValue.push($abd5e421cc04bf71$var$_dropUndefinedKeys(item, memoizationMap));
        });
        return returnValue;
    }
    return inputValue;
}
function $abd5e421cc04bf71$var$isPojo(input) {
    if (!(0, $5lwZa.isPlainObject)(input)) return false;
    try {
        const name = Object.getPrototypeOf(input).constructor.name;
        return !name || name === "Object";
    } catch (e) {
        return true;
    }
}
/**
 * Ensure that something is an object.
 *
 * Turns `undefined` and `null` into `String`s and all other primitives into instances of their respective wrapper
 * classes (String, Boolean, Number, etc.). Acts as the identity function on non-primitives.
 *
 * @param wat The subject of the objectification
 * @returns A version of `wat` which can safely be used with `Object` class methods
 */ function $abd5e421cc04bf71$export$92b78acdbe066b6b(wat) {
    let objectified;
    switch(true){
        case wat === undefined || wat === null:
            objectified = new String(wat);
            break;
        // Though symbols and bigints do have wrapper classes (`Symbol` and `BigInt`, respectively), for whatever reason
        // those classes don't have constructors which can be used with the `new` keyword. We therefore need to cast each as
        // an object in order to wrap it.
        case typeof wat === "symbol" || typeof wat === "bigint":
            objectified = Object(wat);
            break;
        // this will catch the remaining primitives: `String`, `Number`, and `Boolean`
        case (0, $5lwZa.isPrimitive)(wat):
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            objectified = new wat.constructor(wat);
            break;
        // by process of elimination, at this point we know that `wat` must already be an object
        default:
            objectified = wat;
            break;
    }
    return objectified;
}

});
parcelRequire.register("ffqzi", function(module, exports) {

$parcel$export(module.exports, "htmlTreeAsString", function () { return $b19cdd9d5b8c474d$export$5647df6b7814ac86; });
$parcel$export(module.exports, "getLocationHref", function () { return $b19cdd9d5b8c474d$export$1cfafeee2987818b; });
$parcel$export(module.exports, "getComponentName", function () { return $b19cdd9d5b8c474d$export$26727cfcc4d7e0fc; });

var $5lwZa = parcelRequire("5lwZa");

var $hi0PN = parcelRequire("hi0PN");
// eslint-disable-next-line deprecation/deprecation
const $b19cdd9d5b8c474d$var$WINDOW = (0, $hi0PN.getGlobalObject)();
const $b19cdd9d5b8c474d$var$DEFAULT_MAX_STRING_LENGTH = 80;
/**
 * Given a child DOM element, returns a query-selector statement describing that
 * and its ancestors
 * e.g. [HTMLElement] => body > div > input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $b19cdd9d5b8c474d$export$5647df6b7814ac86(elem, options = {}) {
    if (!elem) return "<unknown>";
    // try/catch both:
    // - accessing event.target (see getsentry/raven-js#838, #768)
    // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
    // - can throw an exception in some circumstances.
    try {
        let currentElem = elem;
        const MAX_TRAVERSE_HEIGHT = 5;
        const out = [];
        let height = 0;
        let len = 0;
        const separator = " > ";
        const sepLength = separator.length;
        let nextStr;
        const keyAttrs = Array.isArray(options) ? options : options.keyAttrs;
        const maxStringLength = !Array.isArray(options) && options.maxStringLength || $b19cdd9d5b8c474d$var$DEFAULT_MAX_STRING_LENGTH;
        while(currentElem && height++ < MAX_TRAVERSE_HEIGHT){
            nextStr = $b19cdd9d5b8c474d$var$_htmlElementAsString(currentElem, keyAttrs);
            // bail out if
            // - nextStr is the 'html' element
            // - the length of the string that would be created exceeds maxStringLength
            //   (ignore this limit if we are on the first iteration)
            if (nextStr === "html" || height > 1 && len + out.length * sepLength + nextStr.length >= maxStringLength) break;
            out.push(nextStr);
            len += nextStr.length;
            currentElem = currentElem.parentNode;
        }
        return out.reverse().join(separator);
    } catch (_oO) {
        return "<unknown>";
    }
}
/**
 * Returns a simple, query-selector representation of a DOM element
 * e.g. [HTMLElement] => input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $b19cdd9d5b8c474d$var$_htmlElementAsString(el, keyAttrs) {
    const elem = el;
    const out = [];
    let className;
    let classes;
    let key;
    let attr;
    let i;
    if (!elem || !elem.tagName) return "";
    // @ts-expect-error WINDOW has HTMLElement
    if ($b19cdd9d5b8c474d$var$WINDOW.HTMLElement) {
        // If using the component name annotation plugin, this value may be available on the DOM node
        if (elem instanceof HTMLElement && elem.dataset && elem.dataset["sentryComponent"]) return elem.dataset["sentryComponent"];
    }
    out.push(elem.tagName.toLowerCase());
    // Pairs of attribute keys defined in `serializeAttribute` and their values on element.
    const keyAttrPairs = keyAttrs && keyAttrs.length ? keyAttrs.filter((keyAttr)=>elem.getAttribute(keyAttr)).map((keyAttr)=>[
            keyAttr,
            elem.getAttribute(keyAttr)
        ]) : null;
    if (keyAttrPairs && keyAttrPairs.length) keyAttrPairs.forEach((keyAttrPair)=>{
        out.push(`[${keyAttrPair[0]}="${keyAttrPair[1]}"]`);
    });
    else {
        if (elem.id) out.push(`#${elem.id}`);
        // eslint-disable-next-line prefer-const
        className = elem.className;
        if (className && (0, $5lwZa.isString)(className)) {
            classes = className.split(/\s+/);
            for(i = 0; i < classes.length; i++)out.push(`.${classes[i]}`);
        }
    }
    const allowedAttrs = [
        "aria-label",
        "type",
        "name",
        "title",
        "alt"
    ];
    for(i = 0; i < allowedAttrs.length; i++){
        key = allowedAttrs[i];
        attr = elem.getAttribute(key);
        if (attr) out.push(`[${key}="${attr}"]`);
    }
    return out.join("");
}
/**
 * A safe form of location.href
 */ function $b19cdd9d5b8c474d$export$1cfafeee2987818b() {
    try {
        return $b19cdd9d5b8c474d$var$WINDOW.document.location.href;
    } catch (oO) {
        return "";
    }
}
/**
 * Gets a DOM element by using document.querySelector.
 *
 * This wrapper will first check for the existance of the function before
 * actually calling it so that we don't have to take care of this check,
 * every time we want to access the DOM.
 *
 * Reason: DOM/querySelector is not available in all environments.
 *
 * We have to cast to any because utils can be consumed by a variety of environments,
 * and we don't want to break TS users. If you know what element will be selected by
 * `document.querySelector`, specify it as part of the generic call. For example,
 * `const element = getDomElement<Element>('selector');`
 *
 * @param selector the selector string passed on to document.querySelector
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $b19cdd9d5b8c474d$export$c660c1f3ab49225c(selector) {
    if ($b19cdd9d5b8c474d$var$WINDOW.document && $b19cdd9d5b8c474d$var$WINDOW.document.querySelector) return $b19cdd9d5b8c474d$var$WINDOW.document.querySelector(selector);
    return null;
}
/**
 * Given a DOM element, traverses up the tree until it finds the first ancestor node
 * that has the `data-sentry-component` attribute. This attribute is added at build-time
 * by projects that have the component name annotation plugin installed.
 *
 * @returns a string representation of the component for the provided DOM element, or `null` if not found
 */ function $b19cdd9d5b8c474d$export$26727cfcc4d7e0fc(elem) {
    // @ts-expect-error WINDOW has HTMLElement
    if (!$b19cdd9d5b8c474d$var$WINDOW.HTMLElement) return null;
    let currentElem = elem;
    const MAX_TRAVERSE_HEIGHT = 5;
    for(let i = 0; i < MAX_TRAVERSE_HEIGHT; i++){
        if (!currentElem) return null;
        if (currentElem instanceof HTMLElement && currentElem.dataset["sentryComponent"]) return currentElem.dataset["sentryComponent"];
        currentElem = currentElem.parentNode;
    }
    return null;
}

});

parcelRequire.register("2AO4R", function(module, exports) {

$parcel$export(module.exports, "truncate", function () { return $1e35c9e305eca54f$export$6a506b36fdea397d; });
$parcel$export(module.exports, "snipLine", function () { return $1e35c9e305eca54f$export$4215662d762d6f9d; });
$parcel$export(module.exports, "safeJoin", function () { return $1e35c9e305eca54f$export$465e9d514283d4fd; });
$parcel$export(module.exports, "stringMatchesSomePattern", function () { return $1e35c9e305eca54f$export$a7a5ec66062ea5d; });

var $5lwZa = parcelRequire("5lwZa");
/**
 * Truncates given string to the maximum characters count
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string (0 = unlimited)
 * @returns string Encoded
 */ function $1e35c9e305eca54f$export$6a506b36fdea397d(str, max = 0) {
    if (typeof str !== "string" || max === 0) return str;
    return str.length <= max ? str : `${str.slice(0, max)}...`;
}
/**
 * This is basically just `trim_line` from
 * https://github.com/getsentry/sentry/blob/master/src/sentry/lang/javascript/processor.py#L67
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string
 * @returns string Encoded
 */ function $1e35c9e305eca54f$export$4215662d762d6f9d(line, colno) {
    let newLine = line;
    const lineLength = newLine.length;
    if (lineLength <= 150) return newLine;
    if (colno > lineLength) // eslint-disable-next-line no-param-reassign
    colno = lineLength;
    let start = Math.max(colno - 60, 0);
    if (start < 5) start = 0;
    let end = Math.min(start + 140, lineLength);
    if (end > lineLength - 5) end = lineLength;
    if (end === lineLength) start = Math.max(end - 140, 0);
    newLine = newLine.slice(start, end);
    if (start > 0) newLine = `'{snip} ${newLine}`;
    if (end < lineLength) newLine += " {snip}";
    return newLine;
}
/**
 * Join values in array
 * @param input array of values to be joined together
 * @param delimiter string to be placed in-between values
 * @returns Joined values
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $1e35c9e305eca54f$export$465e9d514283d4fd(input, delimiter) {
    if (!Array.isArray(input)) return "";
    const output = [];
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for(let i = 0; i < input.length; i++){
        const value = input[i];
        try {
            // This is a hack to fix a Vue3-specific bug that causes an infinite loop of
            // console warnings. This happens when a Vue template is rendered with
            // an undeclared variable, which we try to stringify, ultimately causing
            // Vue to issue another warning which repeats indefinitely.
            // see: https://github.com/getsentry/sentry-javascript/pull/8981
            if ((0, $5lwZa.isVueViewModel)(value)) output.push("[VueViewModel]");
            else output.push(String(value));
        } catch (e) {
            output.push("[value cannot be serialized]");
        }
    }
    return output.join(delimiter);
}
/**
 * Checks if the given value matches a regex or string
 *
 * @param value The string to test
 * @param pattern Either a regex or a string against which `value` will be matched
 * @param requireExactStringMatch If true, `value` must match `pattern` exactly. If false, `value` will match
 * `pattern` if it contains `pattern`. Only applies to string-type patterns.
 */ function $1e35c9e305eca54f$export$cdded5b28a5f8c6d(value, pattern, requireExactStringMatch = false) {
    if (!(0, $5lwZa.isString)(value)) return false;
    if ((0, $5lwZa.isRegExp)(pattern)) return pattern.test(value);
    if ((0, $5lwZa.isString)(pattern)) return requireExactStringMatch ? value === pattern : value.includes(pattern);
    return false;
}
/**
 * Test the given string against an array of strings and regexes. By default, string matching is done on a
 * substring-inclusion basis rather than a strict equality basis
 *
 * @param testString The string to test
 * @param patterns The patterns against which to test the string
 * @param requireExactStringMatch If true, `testString` must match one of the given string patterns exactly in order to
 * count. If false, `testString` will match a string pattern if it contains that pattern.
 * @returns
 */ function $1e35c9e305eca54f$export$a7a5ec66062ea5d(testString, patterns = [], requireExactStringMatch = false) {
    return patterns.some((pattern)=>$1e35c9e305eca54f$export$cdded5b28a5f8c6d(testString, pattern, requireExactStringMatch));
}

});



parcelRequire.register("fc74V", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_ENVIRONMENT", function () { return $b0fd77a271a8158b$export$849dbeeeda01ae98; });
const $b0fd77a271a8158b$export$849dbeeeda01ae98 = "production";

});

parcelRequire.register("tgF2D", function(module, exports) {

$parcel$export(module.exports, "DEBUG_BUILD", function () { return $057fa2116581874b$export$16a28057038b10ef; });
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $057fa2116581874b$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__;

});

parcelRequire.register("8XTAO", function(module, exports) {

$parcel$export(module.exports, "getCurrentHub", function () { return $686ef4f87987f0b2$export$a07cdf6544bbd7c; });
$parcel$export(module.exports, "getIsolationScope", function () { return $686ef4f87987f0b2$export$68f3af03034c9e90; });
$parcel$export(module.exports, "runWithAsyncContext", function () { return $686ef4f87987f0b2$export$70d775fb1f267027; });

var $fi7Bg = parcelRequire("fi7Bg");
var $kTBeD = parcelRequire("kTBeD");
var $hi0PN = parcelRequire("hi0PN");
var $5lwZa = parcelRequire("5lwZa");
var $gYD4g = parcelRequire("gYD4g");

var $fc74V = parcelRequire("fc74V");

var $tgF2D = parcelRequire("tgF2D");

var $k4vcv = parcelRequire("k4vcv");

var $a6smX = parcelRequire("a6smX");

var $lFUnc = parcelRequire("lFUnc");
/**
 * API compatibility version of this hub.
 *
 * WARNING: This number should only be increased when the global interface
 * changes and new methods are introduced.
 *
 * @hidden
 */ const $686ef4f87987f0b2$export$24a86ef7798177e4 = parseFloat((0, $lFUnc.SDK_VERSION));
/**
 * Default maximum number of breadcrumbs added to an event. Can be overwritten
 * with {@link Options.maxBreadcrumbs}.
 */ const $686ef4f87987f0b2$var$DEFAULT_BREADCRUMBS = 100;
/**
 * @deprecated The `Hub` class will be removed in version 8 of the SDK in favour of `Scope` and `Client` objects.
 *
 * If you previously used the `Hub` class directly, replace it with `Scope` and `Client` objects. More information:
 * - [Multiple Sentry Instances](https://docs.sentry.io/platforms/javascript/best-practices/multiple-sentry-instances/)
 * - [Browser Extensions](https://docs.sentry.io/platforms/javascript/best-practices/browser-extensions/)
 *
 * Some of our APIs are typed with the Hub class instead of the interface (e.g. `getCurrentHub`). Most of them are deprecated
 * themselves and will also be removed in version 8. More information:
 * - [Migration Guide](https://github.com/getsentry/sentry-javascript/blob/develop/MIGRATION.md#deprecate-hub)
 */ // eslint-disable-next-line deprecation/deprecation
class $686ef4f87987f0b2$export$8c41bb232f1008b1 {
    /** Is a {@link Layer}[] containing the client and scope */ /** Contains the last event id of a captured event.  */ /**
   * Creates a new instance of the hub, will push one {@link Layer} into the
   * internal stack on creation.
   *
   * @param client bound to the hub.
   * @param scope bound to the hub.
   * @param version number, higher number means higher priority.
   *
   * @deprecated Instantiation of Hub objects is deprecated and the constructor will be removed in version 8 of the SDK.
   *
   * If you are currently using the Hub for multi-client use like so:
   *
   * ```
   * // OLD
   * const hub = new Hub();
   * hub.bindClient(client);
   * makeMain(hub)
   * ```
   *
   * instead initialize the client as follows:
   *
   * ```
   * // NEW
   * Sentry.withIsolationScope(() => {
   *    Sentry.setCurrentClient(client);
   *    client.init();
   * });
   * ```
   *
   * If you are using the Hub to capture events like so:
   *
   * ```
   * // OLD
   * const client = new Client();
   * const hub = new Hub(client);
   * hub.captureException()
   * ```
   *
   * instead capture isolated events as follows:
   *
   * ```
   * // NEW
   * const client = new Client();
   * const scope = new Scope();
   * scope.setClient(client);
   * scope.captureException();
   * ```
   */ constructor(client, scope, isolationScope, _version = $686ef4f87987f0b2$export$24a86ef7798177e4){
        this._version = _version;
        let assignedScope;
        if (!scope) {
            assignedScope = new (0, $k4vcv.Scope)();
            assignedScope.setClient(client);
        } else assignedScope = scope;
        let assignedIsolationScope;
        if (!isolationScope) {
            assignedIsolationScope = new (0, $k4vcv.Scope)();
            assignedIsolationScope.setClient(client);
        } else assignedIsolationScope = isolationScope;
        this._stack = [
            {
                scope: assignedScope
            }
        ];
        if (client) // eslint-disable-next-line deprecation/deprecation
        this.bindClient(client);
        this._isolationScope = assignedIsolationScope;
    }
    /**
   * Checks if this hub's version is older than the given version.
   *
   * @param version A version number to compare to.
   * @return True if the given version is newer; otherwise false.
   *
   * @deprecated This will be removed in v8.
   */ isOlderThan(version) {
        return this._version < version;
    }
    /**
   * This binds the given client to the current scope.
   * @param client An SDK client (client) instance.
   *
   * @deprecated Use `initAndBind()` directly, or `setCurrentClient()` and/or `client.init()` instead.
   */ bindClient(client) {
        // eslint-disable-next-line deprecation/deprecation
        const top = this.getStackTop();
        top.client = client;
        top.scope.setClient(client);
        // eslint-disable-next-line deprecation/deprecation
        if (client && client.setupIntegrations) // eslint-disable-next-line deprecation/deprecation
        client.setupIntegrations();
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `withScope` instead.
   */ pushScope() {
        // We want to clone the content of prev scope
        // eslint-disable-next-line deprecation/deprecation
        const scope = this.getScope().clone();
        // eslint-disable-next-line deprecation/deprecation
        this.getStack().push({
            // eslint-disable-next-line deprecation/deprecation
            client: this.getClient(),
            scope: scope
        });
        return scope;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `withScope` instead.
   */ popScope() {
        // eslint-disable-next-line deprecation/deprecation
        if (this.getStack().length <= 1) return false;
        // eslint-disable-next-line deprecation/deprecation
        return !!this.getStack().pop();
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.withScope()` instead.
   */ withScope(callback) {
        // eslint-disable-next-line deprecation/deprecation
        const scope = this.pushScope();
        let maybePromiseResult;
        try {
            maybePromiseResult = callback(scope);
        } catch (e) {
            // eslint-disable-next-line deprecation/deprecation
            this.popScope();
            throw e;
        }
        if ((0, $5lwZa.isThenable)(maybePromiseResult)) // @ts-expect-error - isThenable returns the wrong type
        return maybePromiseResult.then((res)=>{
            // eslint-disable-next-line deprecation/deprecation
            this.popScope();
            return res;
        }, (e)=>{
            // eslint-disable-next-line deprecation/deprecation
            this.popScope();
            throw e;
        });
        // eslint-disable-next-line deprecation/deprecation
        this.popScope();
        return maybePromiseResult;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.getClient()` instead.
   */ getClient() {
        // eslint-disable-next-line deprecation/deprecation
        return this.getStackTop().client;
    }
    /**
   * Returns the scope of the top stack.
   *
   * @deprecated Use `Sentry.getCurrentScope()` instead.
   */ getScope() {
        // eslint-disable-next-line deprecation/deprecation
        return this.getStackTop().scope;
    }
    /**
   * @deprecated Use `Sentry.getIsolationScope()` instead.
   */ getIsolationScope() {
        return this._isolationScope;
    }
    /**
   * Returns the scope stack for domains or the process.
   * @deprecated This will be removed in v8.
   */ getStack() {
        return this._stack;
    }
    /**
   * Returns the topmost scope layer in the order domain > local > process.
   * @deprecated This will be removed in v8.
   */ getStackTop() {
        return this._stack[this._stack.length - 1];
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.captureException()` instead.
   */ captureException(exception, hint) {
        const eventId = this._lastEventId = hint && hint.event_id ? hint.event_id : (0, $gYD4g.uuid4)();
        const syntheticException = new Error("Sentry syntheticException");
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().captureException(exception, {
            originalException: exception,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        });
        return eventId;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use  `Sentry.captureMessage()` instead.
   */ captureMessage(message, // eslint-disable-next-line deprecation/deprecation
    level, hint) {
        const eventId = this._lastEventId = hint && hint.event_id ? hint.event_id : (0, $gYD4g.uuid4)();
        const syntheticException = new Error(message);
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().captureMessage(message, level, {
            originalException: message,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        });
        return eventId;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.captureEvent()` instead.
   */ captureEvent(event, hint) {
        const eventId = hint && hint.event_id ? hint.event_id : (0, $gYD4g.uuid4)();
        if (!event.type) this._lastEventId = eventId;
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().captureEvent(event, {
            ...hint,
            event_id: eventId
        });
        return eventId;
    }
    /**
   * @inheritDoc
   *
   * @deprecated This will be removed in v8.
   */ lastEventId() {
        return this._lastEventId;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.addBreadcrumb()` instead.
   */ addBreadcrumb(breadcrumb, hint) {
        // eslint-disable-next-line deprecation/deprecation
        const { scope: scope, client: client } = this.getStackTop();
        if (!client) return;
        const { beforeBreadcrumb: beforeBreadcrumb = null, maxBreadcrumbs: maxBreadcrumbs = $686ef4f87987f0b2$var$DEFAULT_BREADCRUMBS } = client.getOptions && client.getOptions() || {};
        if (maxBreadcrumbs <= 0) return;
        const timestamp = (0, $kTBeD.dateTimestampInSeconds)();
        const mergedBreadcrumb = {
            timestamp: timestamp,
            ...breadcrumb
        };
        const finalBreadcrumb = beforeBreadcrumb ? (0, $fi7Bg.consoleSandbox)(()=>beforeBreadcrumb(mergedBreadcrumb, hint)) : mergedBreadcrumb;
        if (finalBreadcrumb === null) return;
        if (client.emit) client.emit("beforeAddBreadcrumb", finalBreadcrumb, hint);
        // TODO(v8): I know this comment doesn't make much sense because the hub will be deprecated but I still wanted to
        // write it down. In theory, we would have to add the breadcrumbs to the isolation scope here, however, that would
        // duplicate all of the breadcrumbs. There was the possibility of adding breadcrumbs to both, the isolation scope
        // and the normal scope, and deduplicating it down the line in the event processing pipeline. However, that would
        // have been very fragile, because the breadcrumb objects would have needed to keep their identity all throughout
        // the event processing pipeline.
        // In the new implementation, the top level `Sentry.addBreadcrumb()` should ONLY write to the isolation scope.
        scope.addBreadcrumb(finalBreadcrumb, maxBreadcrumbs);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setUser()` instead.
   */ setUser(user) {
        // TODO(v8): The top level `Sentry.setUser()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setUser(user);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setUser(user);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setTags()` instead.
   */ setTags(tags) {
        // TODO(v8): The top level `Sentry.setTags()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setTags(tags);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setTags(tags);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setExtras()` instead.
   */ setExtras(extras) {
        // TODO(v8): The top level `Sentry.setExtras()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setExtras(extras);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setExtras(extras);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setTag()` instead.
   */ setTag(key, value) {
        // TODO(v8): The top level `Sentry.setTag()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setTag(key, value);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setTag(key, value);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setExtra()` instead.
   */ setExtra(key, extra) {
        // TODO(v8): The top level `Sentry.setExtra()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setExtra(key, extra);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setExtra(key, extra);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setContext()` instead.
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    setContext(name, context) {
        // TODO(v8): The top level `Sentry.setContext()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setContext(name, context);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setContext(name, context);
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `getScope()` directly.
   */ configureScope(callback) {
        // eslint-disable-next-line deprecation/deprecation
        const { scope: scope, client: client } = this.getStackTop();
        if (client) callback(scope);
    }
    /**
   * @inheritDoc
   */ // eslint-disable-next-line deprecation/deprecation
    run(callback) {
        // eslint-disable-next-line deprecation/deprecation
        const oldHub = $686ef4f87987f0b2$export$4188a14ad302d1bc(this);
        try {
            callback(this);
        } finally{
            // eslint-disable-next-line deprecation/deprecation
            $686ef4f87987f0b2$export$4188a14ad302d1bc(oldHub);
        }
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.getClient().getIntegrationByName()` instead.
   */ getIntegration(integration) {
        // eslint-disable-next-line deprecation/deprecation
        const client = this.getClient();
        if (!client) return null;
        try {
            // eslint-disable-next-line deprecation/deprecation
            return client.getIntegration(integration);
        } catch (_oO) {
            (0, $tgF2D.DEBUG_BUILD) && (0, $fi7Bg.logger).warn(`Cannot retrieve integration ${integration.id} from the current Hub`);
            return null;
        }
    }
    /**
   * Starts a new `Transaction` and returns it. This is the entry point to manual tracing instrumentation.
   *
   * A tree structure can be built by adding child spans to the transaction, and child spans to other spans. To start a
   * new child span within the transaction or any span, call the respective `.startChild()` method.
   *
   * Every child span must be finished before the transaction is finished, otherwise the unfinished spans are discarded.
   *
   * The transaction must be finished with a call to its `.end()` method, at which point the transaction with all its
   * finished child spans will be sent to Sentry.
   *
   * @param context Properties of the new `Transaction`.
   * @param customSamplingContext Information given to the transaction sampling function (along with context-dependent
   * default values). See {@link Options.tracesSampler}.
   *
   * @returns The transaction which was just started
   *
   * @deprecated Use `startSpan()`, `startSpanManual()` or `startInactiveSpan()` instead.
   */ startTransaction(context, customSamplingContext) {
        const result = this._callExtensionMethod("startTransaction", context, customSamplingContext);
        if ((0, $tgF2D.DEBUG_BUILD) && !result) {
            // eslint-disable-next-line deprecation/deprecation
            const client = this.getClient();
            if (!client) (0, $fi7Bg.logger).warn("Tracing extension 'startTransaction' is missing. You should 'init' the SDK before calling 'startTransaction'");
            else (0, $fi7Bg.logger).warn(`Tracing extension 'startTransaction' has not been added. Call 'addTracingExtensions' before calling 'init':
Sentry.addTracingExtensions();
Sentry.init({...});
`);
        }
        return result;
    }
    /**
   * @inheritDoc
   * @deprecated Use `spanToTraceHeader()` instead.
   */ traceHeaders() {
        return this._callExtensionMethod("traceHeaders");
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use top level `captureSession` instead.
   */ captureSession(endSession = false) {
        // both send the update and pull the session from the scope
        if (endSession) // eslint-disable-next-line deprecation/deprecation
        return this.endSession();
        // only send the update
        this._sendSessionUpdate();
    }
    /**
   * @inheritDoc
   * @deprecated Use top level `endSession` instead.
   */ endSession() {
        // eslint-disable-next-line deprecation/deprecation
        const layer = this.getStackTop();
        const scope = layer.scope;
        const session = scope.getSession();
        if (session) (0, $a6smX.closeSession)(session);
        this._sendSessionUpdate();
        // the session is over; take it off of the scope
        scope.setSession();
    }
    /**
   * @inheritDoc
   * @deprecated Use top level `startSession` instead.
   */ startSession(context) {
        // eslint-disable-next-line deprecation/deprecation
        const { scope: scope, client: client } = this.getStackTop();
        const { release: release, environment: environment = (0, $fc74V.DEFAULT_ENVIRONMENT) } = client && client.getOptions() || {};
        // Will fetch userAgent if called from browser sdk
        const { userAgent: userAgent } = (0, $hi0PN.GLOBAL_OBJ).navigator || {};
        const session = (0, $a6smX.makeSession)({
            release: release,
            environment: environment,
            user: scope.getUser(),
            ...userAgent && {
                userAgent: userAgent
            },
            ...context
        });
        // End existing session if there's one
        const currentSession = scope.getSession && scope.getSession();
        if (currentSession && currentSession.status === "ok") (0, $a6smX.updateSession)(currentSession, {
            status: "exited"
        });
        // eslint-disable-next-line deprecation/deprecation
        this.endSession();
        // Afterwards we set the new session on the scope
        scope.setSession(session);
        return session;
    }
    /**
   * Returns if default PII should be sent to Sentry and propagated in ourgoing requests
   * when Tracing is used.
   *
   * @deprecated Use top-level `getClient().getOptions().sendDefaultPii` instead. This function
   * only unnecessarily increased API surface but only wrapped accessing the option.
   */ shouldSendDefaultPii() {
        // eslint-disable-next-line deprecation/deprecation
        const client = this.getClient();
        const options = client && client.getOptions();
        return Boolean(options && options.sendDefaultPii);
    }
    /**
   * Sends the current Session on the scope
   */ _sendSessionUpdate() {
        // eslint-disable-next-line deprecation/deprecation
        const { scope: scope, client: client } = this.getStackTop();
        const session = scope.getSession();
        if (session && client && client.captureSession) client.captureSession(session);
    }
    /**
   * Calls global extension method and binding current instance to the function call
   */ // @ts-expect-error Function lacks ending return statement and return type does not include 'undefined'. ts(2366)
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    _callExtensionMethod(method, ...args) {
        const carrier = $686ef4f87987f0b2$export$19eade501500c6c1();
        const sentry = carrier.__SENTRY__;
        if (sentry && sentry.extensions && typeof sentry.extensions[method] === "function") return sentry.extensions[method].apply(this, args);
        (0, $tgF2D.DEBUG_BUILD) && (0, $fi7Bg.logger).warn(`Extension method ${method} couldn't be found, doing nothing.`);
    }
}
/**
 * Returns the global shim registry.
 *
 * FIXME: This function is problematic, because despite always returning a valid Carrier,
 * it has an optional `__SENTRY__` property, which then in turn requires us to always perform an unnecessary check
 * at the call-site. We always access the carrier through this function, so we can guarantee that `__SENTRY__` is there.
 **/ function $686ef4f87987f0b2$export$19eade501500c6c1() {
    (0, $hi0PN.GLOBAL_OBJ).__SENTRY__ = (0, $hi0PN.GLOBAL_OBJ).__SENTRY__ || {
        extensions: {},
        hub: undefined
    };
    return 0, $hi0PN.GLOBAL_OBJ;
}
/**
 * Replaces the current main hub with the passed one on the global object
 *
 * @returns The old replaced hub
 *
 * @deprecated Use `setCurrentClient()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
function $686ef4f87987f0b2$export$4188a14ad302d1bc(hub) {
    const registry = $686ef4f87987f0b2$export$19eade501500c6c1();
    const oldHub = $686ef4f87987f0b2$export$bfa8a924a84a76b7(registry);
    $686ef4f87987f0b2$export$849f05434e95d2f2(registry, hub);
    return oldHub;
}
/**
 * Returns the default hub instance.
 *
 * If a hub is already registered in the global carrier but this module
 * contains a more recent version, it replaces the registered version.
 * Otherwise, the currently registered hub will be returned.
 *
 * @deprecated Use the respective replacement method directly instead.
 */ // eslint-disable-next-line deprecation/deprecation
function $686ef4f87987f0b2$export$a07cdf6544bbd7c() {
    // Get main carrier (global for every environment)
    const registry = $686ef4f87987f0b2$export$19eade501500c6c1();
    if (registry.__SENTRY__ && registry.__SENTRY__.acs) {
        const hub = registry.__SENTRY__.acs.getCurrentHub();
        if (hub) return hub;
    }
    // Return hub that lives on a global object
    return $686ef4f87987f0b2$var$getGlobalHub(registry);
}
/**
 * Get the currently active isolation scope.
 * The isolation scope is active for the current exection context,
 * meaning that it will remain stable for the same Hub.
 */ function $686ef4f87987f0b2$export$68f3af03034c9e90() {
    // eslint-disable-next-line deprecation/deprecation
    return $686ef4f87987f0b2$export$a07cdf6544bbd7c().getIsolationScope();
}
// eslint-disable-next-line deprecation/deprecation
function $686ef4f87987f0b2$var$getGlobalHub(registry = $686ef4f87987f0b2$export$19eade501500c6c1()) {
    // If there's no hub, or its an old API, assign a new one
    if (!$686ef4f87987f0b2$var$hasHubOnCarrier(registry) || // eslint-disable-next-line deprecation/deprecation
    $686ef4f87987f0b2$export$bfa8a924a84a76b7(registry).isOlderThan($686ef4f87987f0b2$export$24a86ef7798177e4)) // eslint-disable-next-line deprecation/deprecation
    $686ef4f87987f0b2$export$849f05434e95d2f2(registry, new $686ef4f87987f0b2$export$8c41bb232f1008b1());
    // Return hub that lives on a global object
    return $686ef4f87987f0b2$export$bfa8a924a84a76b7(registry);
}
/**
 * @private Private API with no semver guarantees!
 *
 * If the carrier does not contain a hub, a new hub is created with the global hub client and scope.
 */ // eslint-disable-next-line deprecation/deprecation
function $686ef4f87987f0b2$export$236689a79f5aa020(carrier, parent = $686ef4f87987f0b2$var$getGlobalHub()) {
    // If there's no hub on current domain, or it's an old API, assign a new one
    if (!$686ef4f87987f0b2$var$hasHubOnCarrier(carrier) || // eslint-disable-next-line deprecation/deprecation
    $686ef4f87987f0b2$export$bfa8a924a84a76b7(carrier).isOlderThan($686ef4f87987f0b2$export$24a86ef7798177e4)) {
        // eslint-disable-next-line deprecation/deprecation
        const client = parent.getClient();
        // eslint-disable-next-line deprecation/deprecation
        const scope = parent.getScope();
        // eslint-disable-next-line deprecation/deprecation
        const isolationScope = parent.getIsolationScope();
        // eslint-disable-next-line deprecation/deprecation
        $686ef4f87987f0b2$export$849f05434e95d2f2(carrier, new $686ef4f87987f0b2$export$8c41bb232f1008b1(client, scope.clone(), isolationScope.clone()));
    }
}
/**
 * @private Private API with no semver guarantees!
 *
 * Sets the global async context strategy
 */ function $686ef4f87987f0b2$export$774ae0e6b6e444ca(strategy) {
    // Get main carrier (global for every environment)
    const registry = $686ef4f87987f0b2$export$19eade501500c6c1();
    registry.__SENTRY__ = registry.__SENTRY__ || {};
    registry.__SENTRY__.acs = strategy;
}
/**
 * Runs the supplied callback in its own async context. Async Context strategies are defined per SDK.
 *
 * @param callback The callback to run in its own async context
 * @param options Options to pass to the async context strategy
 * @returns The result of the callback
 */ function $686ef4f87987f0b2$export$70d775fb1f267027(callback, options = {}) {
    const registry = $686ef4f87987f0b2$export$19eade501500c6c1();
    if (registry.__SENTRY__ && registry.__SENTRY__.acs) return registry.__SENTRY__.acs.runWithAsyncContext(callback, options);
    // if there was no strategy, fallback to just calling the callback
    return callback();
}
/**
 * This will tell whether a carrier has a hub on it or not
 * @param carrier object
 */ function $686ef4f87987f0b2$var$hasHubOnCarrier(carrier) {
    return !!(carrier && carrier.__SENTRY__ && carrier.__SENTRY__.hub);
}
/**
 * This will create a new {@link Hub} and add to the passed object on
 * __SENTRY__.hub.
 * @param carrier object
 * @hidden
 */ // eslint-disable-next-line deprecation/deprecation
function $686ef4f87987f0b2$export$bfa8a924a84a76b7(carrier) {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $hi0PN.getGlobalSingleton)("hub", ()=>new $686ef4f87987f0b2$export$8c41bb232f1008b1(), carrier);
}
/**
 * This will set passed {@link Hub} on the passed object's __SENTRY__.hub attribute
 * @param carrier object
 * @param hub Hub
 * @returns A boolean indicating success or failure
 */ // eslint-disable-next-line deprecation/deprecation
function $686ef4f87987f0b2$export$849f05434e95d2f2(carrier, hub) {
    if (!carrier) return false;
    const __SENTRY__ = carrier.__SENTRY__ = carrier.__SENTRY__ || {};
    __SENTRY__.hub = hub;
    return true;
}

});
parcelRequire.register("k4vcv", function(module, exports) {

$parcel$export(module.exports, "Scope", function () { return $e9cc622d930d15cb$export$775b6bb06e53a214; });
$parcel$export(module.exports, "getGlobalScope", function () { return $e9cc622d930d15cb$export$aa55d5ab8e05984f; });

var $kTBeD = parcelRequire("kTBeD");
var $5lwZa = parcelRequire("5lwZa");
var $fi7Bg = parcelRequire("fi7Bg");
var $gYD4g = parcelRequire("gYD4g");

var $bP1fJ = parcelRequire("bP1fJ");

var $a6smX = parcelRequire("a6smX");

var $8QL9a = parcelRequire("8QL9a");
/**
 * Default value for maximum number of breadcrumbs added to an event.
 */ const $e9cc622d930d15cb$var$DEFAULT_MAX_BREADCRUMBS = 100;
/**
 * The global scope is kept in this module.
 * When accessing this via `getGlobalScope()` we'll make sure to set one if none is currently present.
 */ let $e9cc622d930d15cb$var$globalScope;
/**
 * Holds additional event information. {@link Scope.applyToEvent} will be
 * called by the client before an event will be sent.
 */ class $e9cc622d930d15cb$export$775b6bb06e53a214 {
    /** Flag if notifying is happening. */ /** Callback for client to receive scope changes. */ /** Callback list that will be called after {@link applyToEvent}. */ /** Array of breadcrumbs. */ /** User */ /** Tags */ /** Extra */ /** Contexts */ /** Attachments */ /** Propagation Context for distributed tracing */ /**
   * A place to stash data which is needed at some point in the SDK's event processing pipeline but which shouldn't get
   * sent to Sentry
   */ /** Fingerprint */ /** Severity */ // eslint-disable-next-line deprecation/deprecation
    /**
   * Transaction Name
   */ /** Span */ /** Session */ /** Request Mode Session Status */ /** The client on this scope */ // NOTE: Any field which gets added here should get added not only to the constructor but also to the `clone` method.
    constructor(){
        this._notifyingListeners = false;
        this._scopeListeners = [];
        this._eventProcessors = [];
        this._breadcrumbs = [];
        this._attachments = [];
        this._user = {};
        this._tags = {};
        this._extra = {};
        this._contexts = {};
        this._sdkProcessingMetadata = {};
        this._propagationContext = $e9cc622d930d15cb$var$generatePropagationContext();
    }
    /**
   * Inherit values from the parent scope.
   * @deprecated Use `scope.clone()` and `new Scope()` instead.
   */ static clone(scope) {
        return scope ? scope.clone() : new $e9cc622d930d15cb$export$775b6bb06e53a214();
    }
    /**
   * Clone this scope instance.
   */ clone() {
        const newScope = new $e9cc622d930d15cb$export$775b6bb06e53a214();
        newScope._breadcrumbs = [
            ...this._breadcrumbs
        ];
        newScope._tags = {
            ...this._tags
        };
        newScope._extra = {
            ...this._extra
        };
        newScope._contexts = {
            ...this._contexts
        };
        newScope._user = this._user;
        newScope._level = this._level;
        newScope._span = this._span;
        newScope._session = this._session;
        newScope._transactionName = this._transactionName;
        newScope._fingerprint = this._fingerprint;
        newScope._eventProcessors = [
            ...this._eventProcessors
        ];
        newScope._requestSession = this._requestSession;
        newScope._attachments = [
            ...this._attachments
        ];
        newScope._sdkProcessingMetadata = {
            ...this._sdkProcessingMetadata
        };
        newScope._propagationContext = {
            ...this._propagationContext
        };
        newScope._client = this._client;
        return newScope;
    }
    /** Update the client on the scope. */ setClient(client) {
        this._client = client;
    }
    /**
   * Get the client assigned to this scope.
   *
   * It is generally recommended to use the global function `Sentry.getClient()` instead, unless you know what you are doing.
   */ getClient() {
        return this._client;
    }
    /**
   * Add internal on change listener. Used for sub SDKs that need to store the scope.
   * @hidden
   */ addScopeListener(callback) {
        this._scopeListeners.push(callback);
    }
    /**
   * @inheritDoc
   */ addEventProcessor(callback) {
        this._eventProcessors.push(callback);
        return this;
    }
    /**
   * @inheritDoc
   */ setUser(user) {
        // If null is passed we want to unset everything, but still define keys,
        // so that later down in the pipeline any existing values are cleared.
        this._user = user || {
            email: undefined,
            id: undefined,
            ip_address: undefined,
            segment: undefined,
            username: undefined
        };
        if (this._session) (0, $a6smX.updateSession)(this._session, {
            user: user
        });
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ getUser() {
        return this._user;
    }
    /**
   * @inheritDoc
   */ getRequestSession() {
        return this._requestSession;
    }
    /**
   * @inheritDoc
   */ setRequestSession(requestSession) {
        this._requestSession = requestSession;
        return this;
    }
    /**
   * @inheritDoc
   */ setTags(tags) {
        this._tags = {
            ...this._tags,
            ...tags
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setTag(key, value) {
        this._tags = {
            ...this._tags,
            [key]: value
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setExtras(extras) {
        this._extra = {
            ...this._extra,
            ...extras
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setExtra(key, extra) {
        this._extra = {
            ...this._extra,
            [key]: extra
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setFingerprint(fingerprint) {
        this._fingerprint = fingerprint;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setLevel(// eslint-disable-next-line deprecation/deprecation
    level) {
        this._level = level;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the transaction name on the scope for future events.
   */ setTransactionName(name) {
        this._transactionName = name;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setContext(key, context) {
        if (context === null) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete this._contexts[key];
        else this._contexts[key] = context;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the Span on the scope.
   * @param span Span
   * @deprecated Instead of setting a span on a scope, use `startSpan()`/`startSpanManual()` instead.
   */ setSpan(span) {
        this._span = span;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Returns the `Span` if there is one.
   * @deprecated Use `getActiveSpan()` instead.
   */ getSpan() {
        return this._span;
    }
    /**
   * Returns the `Transaction` attached to the scope (if there is one).
   * @deprecated You should not rely on the transaction, but just use `startSpan()` APIs instead.
   */ getTransaction() {
        // Often, this span (if it exists at all) will be a transaction, but it's not guaranteed to be. Regardless, it will
        // have a pointer to the currently-active transaction.
        const span = this._span;
        // Cannot replace with getRootSpan because getRootSpan returns a span, not a transaction
        // Also, this method will be removed anyway.
        // eslint-disable-next-line deprecation/deprecation
        return span && span.transaction;
    }
    /**
   * @inheritDoc
   */ setSession(session) {
        if (!session) delete this._session;
        else this._session = session;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ getSession() {
        return this._session;
    }
    /**
   * @inheritDoc
   */ update(captureContext) {
        if (!captureContext) return this;
        const scopeToMerge = typeof captureContext === "function" ? captureContext(this) : captureContext;
        if (scopeToMerge instanceof $e9cc622d930d15cb$export$775b6bb06e53a214) {
            const scopeData = scopeToMerge.getScopeData();
            this._tags = {
                ...this._tags,
                ...scopeData.tags
            };
            this._extra = {
                ...this._extra,
                ...scopeData.extra
            };
            this._contexts = {
                ...this._contexts,
                ...scopeData.contexts
            };
            if (scopeData.user && Object.keys(scopeData.user).length) this._user = scopeData.user;
            if (scopeData.level) this._level = scopeData.level;
            if (scopeData.fingerprint.length) this._fingerprint = scopeData.fingerprint;
            if (scopeToMerge.getRequestSession()) this._requestSession = scopeToMerge.getRequestSession();
            if (scopeData.propagationContext) this._propagationContext = scopeData.propagationContext;
        } else if ((0, $5lwZa.isPlainObject)(scopeToMerge)) {
            const scopeContext = captureContext;
            this._tags = {
                ...this._tags,
                ...scopeContext.tags
            };
            this._extra = {
                ...this._extra,
                ...scopeContext.extra
            };
            this._contexts = {
                ...this._contexts,
                ...scopeContext.contexts
            };
            if (scopeContext.user) this._user = scopeContext.user;
            if (scopeContext.level) this._level = scopeContext.level;
            if (scopeContext.fingerprint) this._fingerprint = scopeContext.fingerprint;
            if (scopeContext.requestSession) this._requestSession = scopeContext.requestSession;
            if (scopeContext.propagationContext) this._propagationContext = scopeContext.propagationContext;
        }
        return this;
    }
    /**
   * @inheritDoc
   */ clear() {
        this._breadcrumbs = [];
        this._tags = {};
        this._extra = {};
        this._user = {};
        this._contexts = {};
        this._level = undefined;
        this._transactionName = undefined;
        this._fingerprint = undefined;
        this._requestSession = undefined;
        this._span = undefined;
        this._session = undefined;
        this._notifyScopeListeners();
        this._attachments = [];
        this._propagationContext = $e9cc622d930d15cb$var$generatePropagationContext();
        return this;
    }
    /**
   * @inheritDoc
   */ addBreadcrumb(breadcrumb, maxBreadcrumbs) {
        const maxCrumbs = typeof maxBreadcrumbs === "number" ? maxBreadcrumbs : $e9cc622d930d15cb$var$DEFAULT_MAX_BREADCRUMBS;
        // No data has been changed, so don't notify scope listeners
        if (maxCrumbs <= 0) return this;
        const mergedBreadcrumb = {
            timestamp: (0, $kTBeD.dateTimestampInSeconds)(),
            ...breadcrumb
        };
        const breadcrumbs = this._breadcrumbs;
        breadcrumbs.push(mergedBreadcrumb);
        this._breadcrumbs = breadcrumbs.length > maxCrumbs ? breadcrumbs.slice(-maxCrumbs) : breadcrumbs;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ getLastBreadcrumb() {
        return this._breadcrumbs[this._breadcrumbs.length - 1];
    }
    /**
   * @inheritDoc
   */ clearBreadcrumbs() {
        this._breadcrumbs = [];
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ addAttachment(attachment) {
        this._attachments.push(attachment);
        return this;
    }
    /**
   * @inheritDoc
   * @deprecated Use `getScopeData()` instead.
   */ getAttachments() {
        const data = this.getScopeData();
        return data.attachments;
    }
    /**
   * @inheritDoc
   */ clearAttachments() {
        this._attachments = [];
        return this;
    }
    /** @inheritDoc */ getScopeData() {
        const { _breadcrumbs: _breadcrumbs, _attachments: _attachments, _contexts: _contexts, _tags: _tags, _extra: _extra, _user: _user, _level: _level, _fingerprint: _fingerprint, _eventProcessors: _eventProcessors, _propagationContext: _propagationContext, _sdkProcessingMetadata: _sdkProcessingMetadata, _transactionName: _transactionName, _span: _span } = this;
        return {
            breadcrumbs: _breadcrumbs,
            attachments: _attachments,
            contexts: _contexts,
            tags: _tags,
            extra: _extra,
            user: _user,
            level: _level,
            fingerprint: _fingerprint || [],
            eventProcessors: _eventProcessors,
            propagationContext: _propagationContext,
            sdkProcessingMetadata: _sdkProcessingMetadata,
            transactionName: _transactionName,
            span: _span
        };
    }
    /**
   * Applies data from the scope to the event and runs all event processors on it.
   *
   * @param event Event
   * @param hint Object containing additional information about the original exception, for use by the event processors.
   * @hidden
   * @deprecated Use `applyScopeDataToEvent()` directly
   */ applyToEvent(event, hint = {}, additionalEventProcessors = []) {
        (0, $8QL9a.applyScopeDataToEvent)(event, this.getScopeData());
        // TODO (v8): Update this order to be: Global > Client > Scope
        const eventProcessors = [
            ...additionalEventProcessors,
            // eslint-disable-next-line deprecation/deprecation
            ...(0, $bP1fJ.getGlobalEventProcessors)(),
            ...this._eventProcessors
        ];
        return (0, $bP1fJ.notifyEventProcessors)(eventProcessors, event, hint);
    }
    /**
   * Add data which will be accessible during event processing but won't get sent to Sentry
   */ setSDKProcessingMetadata(newData) {
        this._sdkProcessingMetadata = {
            ...this._sdkProcessingMetadata,
            ...newData
        };
        return this;
    }
    /**
   * @inheritDoc
   */ setPropagationContext(context) {
        this._propagationContext = context;
        return this;
    }
    /**
   * @inheritDoc
   */ getPropagationContext() {
        return this._propagationContext;
    }
    /**
   * Capture an exception for this scope.
   *
   * @param exception The exception to capture.
   * @param hint Optinal additional data to attach to the Sentry event.
   * @returns the id of the captured Sentry event.
   */ captureException(exception, hint) {
        const eventId = hint && hint.event_id ? hint.event_id : (0, $gYD4g.uuid4)();
        if (!this._client) {
            (0, $fi7Bg.logger).warn("No client configured on scope - will not capture exception!");
            return eventId;
        }
        const syntheticException = new Error("Sentry syntheticException");
        this._client.captureException(exception, {
            originalException: exception,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * Capture a message for this scope.
   *
   * @param message The message to capture.
   * @param level An optional severity level to report the message with.
   * @param hint Optional additional data to attach to the Sentry event.
   * @returns the id of the captured message.
   */ captureMessage(message, level, hint) {
        const eventId = hint && hint.event_id ? hint.event_id : (0, $gYD4g.uuid4)();
        if (!this._client) {
            (0, $fi7Bg.logger).warn("No client configured on scope - will not capture message!");
            return eventId;
        }
        const syntheticException = new Error(message);
        this._client.captureMessage(message, level, {
            originalException: message,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * Captures a manually created event for this scope and sends it to Sentry.
   *
   * @param exception The event to capture.
   * @param hint Optional additional data to attach to the Sentry event.
   * @returns the id of the captured event.
   */ captureEvent(event, hint) {
        const eventId = hint && hint.event_id ? hint.event_id : (0, $gYD4g.uuid4)();
        if (!this._client) {
            (0, $fi7Bg.logger).warn("No client configured on scope - will not capture event!");
            return eventId;
        }
        this._client.captureEvent(event, {
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * This will be called on every set call.
   */ _notifyScopeListeners() {
        // We need this check for this._notifyingListeners to be able to work on scope during updates
        // If this check is not here we'll produce endless recursion when something is done with the scope
        // during the callback.
        if (!this._notifyingListeners) {
            this._notifyingListeners = true;
            this._scopeListeners.forEach((callback)=>{
                callback(this);
            });
            this._notifyingListeners = false;
        }
    }
}
/**
 * Get the global scope.
 * This scope is applied to _all_ events.
 */ function $e9cc622d930d15cb$export$aa55d5ab8e05984f() {
    if (!$e9cc622d930d15cb$var$globalScope) $e9cc622d930d15cb$var$globalScope = new $e9cc622d930d15cb$export$775b6bb06e53a214();
    return $e9cc622d930d15cb$var$globalScope;
}
/**
 * This is mainly needed for tests.
 * DO NOT USE this, as this is an internal API and subject to change.
 * @hidden
 */ function $e9cc622d930d15cb$export$c83048efd17527d6(scope) {
    $e9cc622d930d15cb$var$globalScope = scope;
}
function $e9cc622d930d15cb$var$generatePropagationContext() {
    return {
        traceId: (0, $gYD4g.uuid4)(),
        spanId: (0, $gYD4g.uuid4)().substring(16)
    };
}

});
parcelRequire.register("bP1fJ", function(module, exports) {

$parcel$export(module.exports, "getGlobalEventProcessors", function () { return $89b56de2c41b9572$export$3c4238858b85e8ac; });
$parcel$export(module.exports, "addGlobalEventProcessor", function () { return $89b56de2c41b9572$export$8e4e25f54d456511; });
$parcel$export(module.exports, "notifyEventProcessors", function () { return $89b56de2c41b9572$export$bf2a096c3e883e79; });

var $hi0PN = parcelRequire("hi0PN");
var $5lwZa = parcelRequire("5lwZa");
var $fi7Bg = parcelRequire("fi7Bg");
var $1sCez = parcelRequire("1sCez");

var $tgF2D = parcelRequire("tgF2D");
/**
 * Returns the global event processors.
 * @deprecated Global event processors will be removed in v8.
 */ function $89b56de2c41b9572$export$3c4238858b85e8ac() {
    return (0, $hi0PN.getGlobalSingleton)("globalEventProcessors", ()=>[]);
}
/**
 * Add a EventProcessor to be kept globally.
 * @deprecated Use `addEventProcessor` instead. Global event processors will be removed in v8.
 */ function $89b56de2c41b9572$export$8e4e25f54d456511(callback) {
    // eslint-disable-next-line deprecation/deprecation
    $89b56de2c41b9572$export$3c4238858b85e8ac().push(callback);
}
/**
 * Process an array of event processors, returning the processed event (or `null` if the event was dropped).
 */ function $89b56de2c41b9572$export$bf2a096c3e883e79(processors, event, hint, index = 0) {
    return new (0, $1sCez.SyncPromise)((resolve, reject)=>{
        const processor = processors[index];
        if (event === null || typeof processor !== "function") resolve(event);
        else {
            const result = processor({
                ...event
            }, hint);
            (0, $tgF2D.DEBUG_BUILD) && processor.id && result === null && (0, $fi7Bg.logger).log(`Event processor "${processor.id}" dropped event`);
            if ((0, $5lwZa.isThenable)(result)) result.then((final)=>$89b56de2c41b9572$export$bf2a096c3e883e79(processors, final, hint, index + 1).then(resolve)).then(null, reject);
            else $89b56de2c41b9572$export$bf2a096c3e883e79(processors, result, hint, index + 1).then(resolve).then(null, reject);
        }
    });
}

});
parcelRequire.register("1sCez", function(module, exports) {

$parcel$export(module.exports, "resolvedSyncPromise", function () { return $11061077578b7127$export$1fda8aa4d135f8aa; });
$parcel$export(module.exports, "SyncPromise", function () { return $11061077578b7127$export$6f292d4960313241; });
$parcel$export(module.exports, "rejectedSyncPromise", function () { return $11061077578b7127$export$78e43115b553f358; });

var $5lwZa = parcelRequire("5lwZa");
/* eslint-disable @typescript-eslint/explicit-function-return-type */ /** SyncPromise internal states */ var $11061077578b7127$var$States;
(function(States) {
    /** Pending */ const PENDING = 0;
    States[States["PENDING"] = PENDING] = "PENDING";
    /** Resolved / OK */ const RESOLVED = 1;
    States[States["RESOLVED"] = RESOLVED] = "RESOLVED";
    /** Rejected / Error */ const REJECTED = 2;
    States[States["REJECTED"] = REJECTED] = "REJECTED";
})($11061077578b7127$var$States || ($11061077578b7127$var$States = {}));
// Overloads so we can call resolvedSyncPromise without arguments and generic argument
/**
 * Creates a resolved sync promise.
 *
 * @param value the value to resolve the promise with
 * @returns the resolved sync promise
 */ function $11061077578b7127$export$1fda8aa4d135f8aa(value) {
    return new $11061077578b7127$export$6f292d4960313241((resolve)=>{
        resolve(value);
    });
}
/**
 * Creates a rejected sync promise.
 *
 * @param value the value to reject the promise with
 * @returns the rejected sync promise
 */ function $11061077578b7127$export$78e43115b553f358(reason) {
    return new $11061077578b7127$export$6f292d4960313241((_, reject)=>{
        reject(reason);
    });
}
/**
 * Thenable class that behaves like a Promise and follows it's interface
 * but is not async internally
 */ class $11061077578b7127$export$6f292d4960313241 {
    constructor(executor){
        $11061077578b7127$export$6f292d4960313241.prototype.__init.call(this);
        $11061077578b7127$export$6f292d4960313241.prototype.__init2.call(this);
        $11061077578b7127$export$6f292d4960313241.prototype.__init3.call(this);
        $11061077578b7127$export$6f292d4960313241.prototype.__init4.call(this);
        this._state = $11061077578b7127$var$States.PENDING;
        this._handlers = [];
        try {
            executor(this._resolve, this._reject);
        } catch (e) {
            this._reject(e);
        }
    }
    /** JSDoc */ then(onfulfilled, onrejected) {
        return new $11061077578b7127$export$6f292d4960313241((resolve, reject)=>{
            this._handlers.push([
                false,
                (result)=>{
                    if (!onfulfilled) // TODO: ¯\_(ツ)_/¯
                    // TODO: FIXME
                    resolve(result);
                    else try {
                        resolve(onfulfilled(result));
                    } catch (e) {
                        reject(e);
                    }
                },
                (reason)=>{
                    if (!onrejected) reject(reason);
                    else try {
                        resolve(onrejected(reason));
                    } catch (e) {
                        reject(e);
                    }
                }
            ]);
            this._executeHandlers();
        });
    }
    /** JSDoc */ catch(onrejected) {
        return this.then((val)=>val, onrejected);
    }
    /** JSDoc */ finally(onfinally) {
        return new $11061077578b7127$export$6f292d4960313241((resolve, reject)=>{
            let val;
            let isRejected;
            return this.then((value)=>{
                isRejected = false;
                val = value;
                if (onfinally) onfinally();
            }, (reason)=>{
                isRejected = true;
                val = reason;
                if (onfinally) onfinally();
            }).then(()=>{
                if (isRejected) {
                    reject(val);
                    return;
                }
                resolve(val);
            });
        });
    }
    /** JSDoc */ __init() {
        this._resolve = (value)=>{
            this._setResult($11061077578b7127$var$States.RESOLVED, value);
        };
    }
    /** JSDoc */ __init2() {
        this._reject = (reason)=>{
            this._setResult($11061077578b7127$var$States.REJECTED, reason);
        };
    }
    /** JSDoc */ __init3() {
        this._setResult = (state, value)=>{
            if (this._state !== $11061077578b7127$var$States.PENDING) return;
            if ((0, $5lwZa.isThenable)(value)) {
                value.then(this._resolve, this._reject);
                return;
            }
            this._state = state;
            this._value = value;
            this._executeHandlers();
        };
    }
    /** JSDoc */ __init4() {
        this._executeHandlers = ()=>{
            if (this._state === $11061077578b7127$var$States.PENDING) return;
            const cachedHandlers = this._handlers.slice();
            this._handlers = [];
            cachedHandlers.forEach((handler)=>{
                if (handler[0]) return;
                if (this._state === $11061077578b7127$var$States.RESOLVED) // eslint-disable-next-line @typescript-eslint/no-floating-promises
                handler[1](this._value);
                if (this._state === $11061077578b7127$var$States.REJECTED) handler[2](this._value);
                handler[0] = true;
            });
        };
    }
}

});


parcelRequire.register("a6smX", function(module, exports) {

$parcel$export(module.exports, "makeSession", function () { return $75b078798471f625$export$14a186326edbb264; });
$parcel$export(module.exports, "updateSession", function () { return $75b078798471f625$export$531818e825e774db; });
$parcel$export(module.exports, "closeSession", function () { return $75b078798471f625$export$56521d9ba90f62ee; });

var $eKFW4 = parcelRequire("eKFW4");
var $kTBeD = parcelRequire("kTBeD");
var $gYD4g = parcelRequire("gYD4g");
/**
 * Creates a new `Session` object by setting certain default parameters. If optional @param context
 * is passed, the passed properties are applied to the session object.
 *
 * @param context (optional) additional properties to be applied to the returned session object
 *
 * @returns a new `Session` object
 */ function $75b078798471f625$export$14a186326edbb264(context) {
    // Both timestamp and started are in seconds since the UNIX epoch.
    const startingTime = (0, $kTBeD.timestampInSeconds)();
    const session = {
        sid: (0, $gYD4g.uuid4)(),
        init: true,
        timestamp: startingTime,
        started: startingTime,
        duration: 0,
        status: "ok",
        errors: 0,
        ignoreDuration: false,
        toJSON: ()=>$75b078798471f625$var$sessionToJSON(session)
    };
    if (context) $75b078798471f625$export$531818e825e774db(session, context);
    return session;
}
/**
 * Updates a session object with the properties passed in the context.
 *
 * Note that this function mutates the passed object and returns void.
 * (Had to do this instead of returning a new and updated session because closing and sending a session
 * makes an update to the session after it was passed to the sending logic.
 * @see BaseClient.captureSession )
 *
 * @param session the `Session` to update
 * @param context the `SessionContext` holding the properties that should be updated in @param session
 */ // eslint-disable-next-line complexity
function $75b078798471f625$export$531818e825e774db(session, context = {}) {
    if (context.user) {
        if (!session.ipAddress && context.user.ip_address) session.ipAddress = context.user.ip_address;
        if (!session.did && !context.did) session.did = context.user.id || context.user.email || context.user.username;
    }
    session.timestamp = context.timestamp || (0, $kTBeD.timestampInSeconds)();
    if (context.abnormal_mechanism) session.abnormal_mechanism = context.abnormal_mechanism;
    if (context.ignoreDuration) session.ignoreDuration = context.ignoreDuration;
    if (context.sid) // Good enough uuid validation. — Kamil
    session.sid = context.sid.length === 32 ? context.sid : (0, $gYD4g.uuid4)();
    if (context.init !== undefined) session.init = context.init;
    if (!session.did && context.did) session.did = `${context.did}`;
    if (typeof context.started === "number") session.started = context.started;
    if (session.ignoreDuration) session.duration = undefined;
    else if (typeof context.duration === "number") session.duration = context.duration;
    else {
        const duration = session.timestamp - session.started;
        session.duration = duration >= 0 ? duration : 0;
    }
    if (context.release) session.release = context.release;
    if (context.environment) session.environment = context.environment;
    if (!session.ipAddress && context.ipAddress) session.ipAddress = context.ipAddress;
    if (!session.userAgent && context.userAgent) session.userAgent = context.userAgent;
    if (typeof context.errors === "number") session.errors = context.errors;
    if (context.status) session.status = context.status;
}
/**
 * Closes a session by setting its status and updating the session object with it.
 * Internally calls `updateSession` to update the passed session object.
 *
 * Note that this function mutates the passed session (@see updateSession for explanation).
 *
 * @param session the `Session` object to be closed
 * @param status the `SessionStatus` with which the session was closed. If you don't pass a status,
 *               this function will keep the previously set status, unless it was `'ok'` in which case
 *               it is changed to `'exited'`.
 */ function $75b078798471f625$export$56521d9ba90f62ee(session, status) {
    let context = {};
    if (status) context = {
        status: status
    };
    else if (session.status === "ok") context = {
        status: "exited"
    };
    $75b078798471f625$export$531818e825e774db(session, context);
}
/**
 * Serializes a passed session object to a JSON object with a slightly different structure.
 * This is necessary because the Sentry backend requires a slightly different schema of a session
 * than the one the JS SDKs use internally.
 *
 * @param session the session to be converted
 *
 * @returns a JSON object of the passed session
 */ function $75b078798471f625$var$sessionToJSON(session) {
    return (0, $eKFW4.dropUndefinedKeys)({
        sid: `${session.sid}`,
        init: session.init,
        // Make sure that sec is converted to ms for date constructor
        started: new Date(session.started * 1000).toISOString(),
        timestamp: new Date(session.timestamp * 1000).toISOString(),
        status: session.status,
        errors: session.errors,
        did: typeof session.did === "number" || typeof session.did === "string" ? `${session.did}` : undefined,
        duration: session.duration,
        abnormal_mechanism: session.abnormal_mechanism,
        attrs: {
            release: session.release,
            environment: session.environment,
            ip_address: session.ipAddress,
            user_agent: session.userAgent
        }
    });
}

});

parcelRequire.register("8QL9a", function(module, exports) {

$parcel$export(module.exports, "applyScopeDataToEvent", function () { return $6717c070f59bb867$export$43988bc651a80216; });
$parcel$export(module.exports, "mergeScopeData", function () { return $6717c070f59bb867$export$25ac7e259a513db4; });

var $gYD4g = parcelRequire("gYD4g");
var $eKFW4 = parcelRequire("eKFW4");

var $1amGz = parcelRequire("1amGz");

var $2b2R5 = parcelRequire("2b2R5");

var $ZS8fh = parcelRequire("ZS8fh");
/**
 * Applies data from the scope to the event and runs all event processors on it.
 */ function $6717c070f59bb867$export$43988bc651a80216(event, data) {
    const { fingerprint: fingerprint, span: span, breadcrumbs: breadcrumbs, sdkProcessingMetadata: sdkProcessingMetadata } = data;
    // Apply general data
    $6717c070f59bb867$var$applyDataToEvent(event, data);
    // We want to set the trace context for normal events only if there isn't already
    // a trace context on the event. There is a product feature in place where we link
    // errors with transaction and it relies on that.
    if (span) $6717c070f59bb867$var$applySpanToEvent(event, span);
    $6717c070f59bb867$var$applyFingerprintToEvent(event, fingerprint);
    $6717c070f59bb867$var$applyBreadcrumbsToEvent(event, breadcrumbs);
    $6717c070f59bb867$var$applySdkMetadataToEvent(event, sdkProcessingMetadata);
}
/** Merge data of two scopes together. */ function $6717c070f59bb867$export$25ac7e259a513db4(data, mergeData) {
    const { extra: extra, tags: tags, user: user, contexts: contexts, level: level, sdkProcessingMetadata: sdkProcessingMetadata, breadcrumbs: breadcrumbs, fingerprint: fingerprint, eventProcessors: eventProcessors, attachments: attachments, propagationContext: propagationContext, transactionName: // eslint-disable-next-line deprecation/deprecation
    transactionName, span: span } = mergeData;
    $6717c070f59bb867$export$b1a120a2871faa46(data, "extra", extra);
    $6717c070f59bb867$export$b1a120a2871faa46(data, "tags", tags);
    $6717c070f59bb867$export$b1a120a2871faa46(data, "user", user);
    $6717c070f59bb867$export$b1a120a2871faa46(data, "contexts", contexts);
    $6717c070f59bb867$export$b1a120a2871faa46(data, "sdkProcessingMetadata", sdkProcessingMetadata);
    if (level) data.level = level;
    if (transactionName) // eslint-disable-next-line deprecation/deprecation
    data.transactionName = transactionName;
    if (span) data.span = span;
    if (breadcrumbs.length) data.breadcrumbs = [
        ...data.breadcrumbs,
        ...breadcrumbs
    ];
    if (fingerprint.length) data.fingerprint = [
        ...data.fingerprint,
        ...fingerprint
    ];
    if (eventProcessors.length) data.eventProcessors = [
        ...data.eventProcessors,
        ...eventProcessors
    ];
    if (attachments.length) data.attachments = [
        ...data.attachments,
        ...attachments
    ];
    data.propagationContext = {
        ...data.propagationContext,
        ...propagationContext
    };
}
/**
 * Merges certain scope data. Undefined values will overwrite any existing values.
 * Exported only for tests.
 */ function $6717c070f59bb867$export$b1a120a2871faa46(data, prop, mergeVal) {
    if (mergeVal && Object.keys(mergeVal).length) {
        // Clone object
        data[prop] = {
            ...data[prop]
        };
        for(const key in mergeVal)if (Object.prototype.hasOwnProperty.call(mergeVal, key)) data[prop][key] = mergeVal[key];
    }
}
function $6717c070f59bb867$var$applyDataToEvent(event, data) {
    const { extra: extra, tags: tags, user: user, contexts: contexts, level: level, transactionName: // eslint-disable-next-line deprecation/deprecation
    transactionName } = data;
    const cleanedExtra = (0, $eKFW4.dropUndefinedKeys)(extra);
    if (cleanedExtra && Object.keys(cleanedExtra).length) event.extra = {
        ...cleanedExtra,
        ...event.extra
    };
    const cleanedTags = (0, $eKFW4.dropUndefinedKeys)(tags);
    if (cleanedTags && Object.keys(cleanedTags).length) event.tags = {
        ...cleanedTags,
        ...event.tags
    };
    const cleanedUser = (0, $eKFW4.dropUndefinedKeys)(user);
    if (cleanedUser && Object.keys(cleanedUser).length) event.user = {
        ...cleanedUser,
        ...event.user
    };
    const cleanedContexts = (0, $eKFW4.dropUndefinedKeys)(contexts);
    if (cleanedContexts && Object.keys(cleanedContexts).length) event.contexts = {
        ...cleanedContexts,
        ...event.contexts
    };
    if (level) event.level = level;
    if (transactionName) event.transaction = transactionName;
}
function $6717c070f59bb867$var$applyBreadcrumbsToEvent(event, breadcrumbs) {
    const mergedBreadcrumbs = [
        ...event.breadcrumbs || [],
        ...breadcrumbs
    ];
    event.breadcrumbs = mergedBreadcrumbs.length ? mergedBreadcrumbs : undefined;
}
function $6717c070f59bb867$var$applySdkMetadataToEvent(event, sdkProcessingMetadata) {
    event.sdkProcessingMetadata = {
        ...event.sdkProcessingMetadata,
        ...sdkProcessingMetadata
    };
}
function $6717c070f59bb867$var$applySpanToEvent(event, span) {
    event.contexts = {
        trace: (0, $ZS8fh.spanToTraceContext)(span),
        ...event.contexts
    };
    const rootSpan = (0, $2b2R5.getRootSpan)(span);
    if (rootSpan) {
        event.sdkProcessingMetadata = {
            dynamicSamplingContext: (0, $1amGz.getDynamicSamplingContextFromSpan)(span),
            ...event.sdkProcessingMetadata
        };
        const transactionName = (0, $ZS8fh.spanToJSON)(rootSpan).description;
        if (transactionName) event.tags = {
            transaction: transactionName,
            ...event.tags
        };
    }
}
/**
 * Applies fingerprint from the scope to the event if there's one,
 * uses message if there's one instead or get rid of empty fingerprint
 */ function $6717c070f59bb867$var$applyFingerprintToEvent(event, fingerprint) {
    // Make sure it's an array first and we actually have something in place
    event.fingerprint = event.fingerprint ? (0, $gYD4g.arrayify)(event.fingerprint) : [];
    // If we have something on the scope, then merge it with event
    if (fingerprint) event.fingerprint = event.fingerprint.concat(fingerprint);
    // If we have no data at all, remove empty array default
    if (event.fingerprint && !event.fingerprint.length) delete event.fingerprint;
}

});
parcelRequire.register("1amGz", function(module, exports) {

$parcel$export(module.exports, "getDynamicSamplingContextFromClient", function () { return $0d98528863ce6bf0$export$366bad00d6815eed; });
$parcel$export(module.exports, "getDynamicSamplingContextFromSpan", function () { return $0d98528863ce6bf0$export$a117f995597e25df; });

var $eKFW4 = parcelRequire("eKFW4");

var $fc74V = parcelRequire("fc74V");

var $9Dess = parcelRequire("9Dess");

var $2b2R5 = parcelRequire("2b2R5");

var $ZS8fh = parcelRequire("ZS8fh");
/**
 * Creates a dynamic sampling context from a client.
 *
 * Dispatches the `createDsc` lifecycle hook as a side effect.
 */ function $0d98528863ce6bf0$export$366bad00d6815eed(trace_id, client, scope) {
    const options = client.getOptions();
    const { publicKey: public_key } = client.getDsn() || {};
    // TODO(v8): Remove segment from User
    // eslint-disable-next-line deprecation/deprecation
    const { segment: user_segment } = scope && scope.getUser() || {};
    const dsc = (0, $eKFW4.dropUndefinedKeys)({
        environment: options.environment || (0, $fc74V.DEFAULT_ENVIRONMENT),
        release: options.release,
        user_segment: user_segment,
        public_key: public_key,
        trace_id: trace_id
    });
    client.emit && client.emit("createDsc", dsc);
    return dsc;
}
/**
 * A Span with a frozen dynamic sampling context.
 */ /**
 * Creates a dynamic sampling context from a span (and client and scope)
 *
 * @param span the span from which a few values like the root span name and sample rate are extracted.
 *
 * @returns a dynamic sampling context
 */ function $0d98528863ce6bf0$export$a117f995597e25df(span) {
    const client = (0, $9Dess.getClient)();
    if (!client) return {};
    // passing emit=false here to only emit later once the DSC is actually populated
    const dsc = $0d98528863ce6bf0$export$366bad00d6815eed((0, $ZS8fh.spanToJSON)(span).trace_id || "", client, (0, $9Dess.getCurrentScope)());
    // TODO (v8): Remove v7FrozenDsc as a Transaction will no longer have _frozenDynamicSamplingContext
    const txn = (0, $2b2R5.getRootSpan)(span);
    if (!txn) return dsc;
    // TODO (v8): Remove v7FrozenDsc as a Transaction will no longer have _frozenDynamicSamplingContext
    // For now we need to avoid breaking users who directly created a txn with a DSC, where this field is still set.
    // @see Transaction class constructor
    const v7FrozenDsc = txn && txn._frozenDynamicSamplingContext;
    if (v7FrozenDsc) return v7FrozenDsc;
    // TODO (v8): Replace txn.metadata with txn.attributes[]
    // We can't do this yet because attributes aren't always set yet.
    // eslint-disable-next-line deprecation/deprecation
    const { sampleRate: maybeSampleRate, source: source } = txn.metadata;
    if (maybeSampleRate != null) dsc.sample_rate = `${maybeSampleRate}`;
    // We don't want to have a transaction name in the DSC if the source is "url" because URLs might contain PII
    const jsonSpan = (0, $ZS8fh.spanToJSON)(txn);
    // after JSON conversion, txn.name becomes jsonSpan.description
    if (source && source !== "url") dsc.transaction = jsonSpan.description;
    dsc.sampled = String((0, $ZS8fh.spanIsSampled)(txn));
    client.emit && client.emit("createDsc", dsc);
    return dsc;
}

});
parcelRequire.register("2b2R5", function(module, exports) {

$parcel$export(module.exports, "getRootSpan", function () { return $195ed2d757c3a4d2$export$c4c6a79b1260ca1b; });
/**
 * Returns the root span of a given span.
 *
 * As long as we use `Transaction`s internally, the returned root span
 * will be a `Transaction` but be aware that this might change in the future.
 *
 * If the given span has no root span or transaction, `undefined` is returned.
 */ function $195ed2d757c3a4d2$export$c4c6a79b1260ca1b(span) {
    // TODO (v8): Remove this check and just return span
    // eslint-disable-next-line deprecation/deprecation
    return span.transaction;
}

});

parcelRequire.register("ZS8fh", function(module, exports) {

$parcel$export(module.exports, "spanToTraceContext", function () { return $0b9fb01b198c8093$export$46c6fbd1d265ebf0; });
$parcel$export(module.exports, "spanToJSON", function () { return $0b9fb01b198c8093$export$92d8c23565496537; });
$parcel$export(module.exports, "spanIsSampled", function () { return $0b9fb01b198c8093$export$5caecac1caaf3a71; });

var $eKFW4 = parcelRequire("eKFW4");
var $4BtmE = parcelRequire("4BtmE");
var $kTBeD = parcelRequire("kTBeD");
// These are aligned with OpenTelemetry trace flags
const $0b9fb01b198c8093$export$208d5b368507fb8b = 0x0;
const $0b9fb01b198c8093$export$eb571cd9b5d98de8 = 0x1;
/**
 * Convert a span to a trace context, which can be sent as the `trace` context in an event.
 */ function $0b9fb01b198c8093$export$46c6fbd1d265ebf0(span) {
    const { spanId: span_id, traceId: trace_id } = span.spanContext();
    const { data: data, op: op, parent_span_id: parent_span_id, status: status, tags: tags, origin: origin } = $0b9fb01b198c8093$export$92d8c23565496537(span);
    return (0, $eKFW4.dropUndefinedKeys)({
        data: data,
        op: op,
        parent_span_id: parent_span_id,
        span_id: span_id,
        status: status,
        tags: tags,
        trace_id: trace_id,
        origin: origin
    });
}
/**
 * Convert a Span to a Sentry trace header.
 */ function $0b9fb01b198c8093$export$7e9f8ae9e4a328ab(span) {
    const { traceId: traceId, spanId: spanId } = span.spanContext();
    const sampled = $0b9fb01b198c8093$export$5caecac1caaf3a71(span);
    return (0, $4BtmE.generateSentryTraceHeader)(traceId, spanId, sampled);
}
/**
 * Convert a span time input intp a timestamp in seconds.
 */ function $0b9fb01b198c8093$export$3f7581298f56c6d7(input) {
    if (typeof input === "number") return $0b9fb01b198c8093$var$ensureTimestampInSeconds(input);
    if (Array.isArray(input)) // See {@link HrTime} for the array-based time format
    return input[0] + input[1] / 1e9;
    if (input instanceof Date) return $0b9fb01b198c8093$var$ensureTimestampInSeconds(input.getTime());
    return (0, $kTBeD.timestampInSeconds)();
}
/**
 * Converts a timestamp to second, if it was in milliseconds, or keeps it as second.
 */ function $0b9fb01b198c8093$var$ensureTimestampInSeconds(timestamp) {
    const isMs = timestamp > 9999999999;
    return isMs ? timestamp / 1000 : timestamp;
}
/**
 * Convert a span to a JSON representation.
 * Note that all fields returned here are optional and need to be guarded against.
 *
 * Note: Because of this, we currently have a circular type dependency (which we opted out of in package.json).
 * This is not avoidable as we need `spanToJSON` in `spanUtils.ts`, which in turn is needed by `span.ts` for backwards compatibility.
 * And `spanToJSON` needs the Span class from `span.ts` to check here.
 * TODO v8: When we remove the deprecated stuff from `span.ts`, we can remove the circular dependency again.
 */ function $0b9fb01b198c8093$export$92d8c23565496537(span) {
    if ($0b9fb01b198c8093$var$spanIsSpanClass(span)) return span.getSpanJSON();
    // Fallback: We also check for `.toJSON()` here...
    // eslint-disable-next-line deprecation/deprecation
    if (typeof span.toJSON === "function") // eslint-disable-next-line deprecation/deprecation
    return span.toJSON();
    return {};
}
/**
 * Sadly, due to circular dependency checks we cannot actually import the Span class here and check for instanceof.
 * :( So instead we approximate this by checking if it has the `getSpanJSON` method.
 */ function $0b9fb01b198c8093$var$spanIsSpanClass(span) {
    return typeof span.getSpanJSON === "function";
}
/**
 * Returns true if a span is sampled.
 * In most cases, you should just use `span.isRecording()` instead.
 * However, this has a slightly different semantic, as it also returns false if the span is finished.
 * So in the case where this distinction is important, use this method.
 */ function $0b9fb01b198c8093$export$5caecac1caaf3a71(span) {
    // We align our trace flags with the ones OpenTelemetry use
    // So we also check for sampled the same way they do.
    const { traceFlags: traceFlags } = span.spanContext();
    // eslint-disable-next-line no-bitwise
    return Boolean(traceFlags & $0b9fb01b198c8093$export$eb571cd9b5d98de8);
}

});
parcelRequire.register("4BtmE", function(module, exports) {

$parcel$export(module.exports, "generateSentryTraceHeader", function () { return $35a16548299b0362$export$f35d907436da45cf; });

var $9eRqg = parcelRequire("9eRqg");

var $gYD4g = parcelRequire("gYD4g");
// eslint-disable-next-line @sentry-internal/sdk/no-regexp-constructor -- RegExp is used for readability here
const $35a16548299b0362$export$394a210812ba3012 = new RegExp("^[ \\t]*([0-9a-f]{32})?-?([0-9a-f]{16})?-?([01])?[ \\t]*$");
/**
 * Extract transaction context data from a `sentry-trace` header.
 *
 * @param traceparent Traceparent string
 *
 * @returns Object containing data from the header, or undefined if traceparent string is malformed
 */ function $35a16548299b0362$export$8e9a29865c0a1226(traceparent) {
    if (!traceparent) return undefined;
    const matches = traceparent.match($35a16548299b0362$export$394a210812ba3012);
    if (!matches) return undefined;
    let parentSampled;
    if (matches[3] === "1") parentSampled = true;
    else if (matches[3] === "0") parentSampled = false;
    return {
        traceId: matches[1],
        parentSampled: parentSampled,
        parentSpanId: matches[2]
    };
}
/**
 * Create tracing context from incoming headers.
 *
 * @deprecated Use `propagationContextFromHeaders` instead.
 */ // TODO(v8): Remove this function
function $35a16548299b0362$export$ca5c066532785b6e(sentryTrace, baggage) {
    const traceparentData = $35a16548299b0362$export$8e9a29865c0a1226(sentryTrace);
    const dynamicSamplingContext = (0, $9eRqg.baggageHeaderToDynamicSamplingContext)(baggage);
    const { traceId: traceId, parentSpanId: parentSpanId, parentSampled: parentSampled } = traceparentData || {};
    if (!traceparentData) return {
        traceparentData: traceparentData,
        dynamicSamplingContext: undefined,
        propagationContext: {
            traceId: traceId || (0, $gYD4g.uuid4)(),
            spanId: (0, $gYD4g.uuid4)().substring(16)
        }
    };
    else return {
        traceparentData: traceparentData,
        dynamicSamplingContext: dynamicSamplingContext || {},
        propagationContext: {
            traceId: traceId || (0, $gYD4g.uuid4)(),
            parentSpanId: parentSpanId || (0, $gYD4g.uuid4)().substring(16),
            spanId: (0, $gYD4g.uuid4)().substring(16),
            sampled: parentSampled,
            dsc: dynamicSamplingContext || {}
        }
    };
}
/**
 * Create a propagation context from incoming headers.
 */ function $35a16548299b0362$export$261f383d16a93e39(sentryTrace, baggage) {
    const traceparentData = $35a16548299b0362$export$8e9a29865c0a1226(sentryTrace);
    const dynamicSamplingContext = (0, $9eRqg.baggageHeaderToDynamicSamplingContext)(baggage);
    const { traceId: traceId, parentSpanId: parentSpanId, parentSampled: parentSampled } = traceparentData || {};
    if (!traceparentData) return {
        traceId: traceId || (0, $gYD4g.uuid4)(),
        spanId: (0, $gYD4g.uuid4)().substring(16)
    };
    else return {
        traceId: traceId || (0, $gYD4g.uuid4)(),
        parentSpanId: parentSpanId || (0, $gYD4g.uuid4)().substring(16),
        spanId: (0, $gYD4g.uuid4)().substring(16),
        sampled: parentSampled,
        dsc: dynamicSamplingContext || {}
    };
}
/**
 * Create sentry-trace header from span context values.
 */ function $35a16548299b0362$export$f35d907436da45cf(traceId = (0, $gYD4g.uuid4)(), spanId = (0, $gYD4g.uuid4)().substring(16), sampled) {
    let sampledString = "";
    if (sampled !== undefined) sampledString = sampled ? "-1" : "-0";
    return `${traceId}-${spanId}${sampledString}`;
}

});
parcelRequire.register("9eRqg", function(module, exports) {

$parcel$export(module.exports, "baggageHeaderToDynamicSamplingContext", function () { return $6b9edc7ab37f210c$export$5b96ee2c8421f107; });

var $7qutn = parcelRequire("7qutn");

var $5lwZa = parcelRequire("5lwZa");

var $fi7Bg = parcelRequire("fi7Bg");
const $6b9edc7ab37f210c$export$9ca9946bd449ac06 = "baggage";
const $6b9edc7ab37f210c$export$6e69537d67fa20f = "sentry-";
const $6b9edc7ab37f210c$export$eb0401070c617ea5 = /^sentry-/;
/**
 * Max length of a serialized baggage string
 *
 * https://www.w3.org/TR/baggage/#limits
 */ const $6b9edc7ab37f210c$export$bdd844ddb2def819 = 8192;
/**
 * Takes a baggage header and turns it into Dynamic Sampling Context, by extracting all the "sentry-" prefixed values
 * from it.
 *
 * @param baggageHeader A very bread definition of a baggage header as it might appear in various frameworks.
 * @returns The Dynamic Sampling Context that was found on `baggageHeader`, if there was any, `undefined` otherwise.
 */ function $6b9edc7ab37f210c$export$5b96ee2c8421f107(// Very liberal definition of what any incoming header might look like
baggageHeader) {
    if (!(0, $5lwZa.isString)(baggageHeader) && !Array.isArray(baggageHeader)) return undefined;
    // Intermediary object to store baggage key value pairs of incoming baggage headers on.
    // It is later used to read Sentry-DSC-values from.
    let baggageObject = {};
    if (Array.isArray(baggageHeader)) // Combine all baggage headers into one object containing the baggage values so we can later read the Sentry-DSC-values from it
    baggageObject = baggageHeader.reduce((acc, curr)=>{
        const currBaggageObject = $6b9edc7ab37f210c$var$baggageHeaderToObject(curr);
        for (const key of Object.keys(currBaggageObject))acc[key] = currBaggageObject[key];
        return acc;
    }, {});
    else {
        // Return undefined if baggage header is an empty string (technically an empty baggage header is not spec conform but
        // this is how we choose to handle it)
        if (!baggageHeader) return undefined;
        baggageObject = $6b9edc7ab37f210c$var$baggageHeaderToObject(baggageHeader);
    }
    // Read all "sentry-" prefixed values out of the baggage object and put it onto a dynamic sampling context object.
    const dynamicSamplingContext = Object.entries(baggageObject).reduce((acc, [key, value])=>{
        if (key.match($6b9edc7ab37f210c$export$eb0401070c617ea5)) {
            const nonPrefixedKey = key.slice($6b9edc7ab37f210c$export$6e69537d67fa20f.length);
            acc[nonPrefixedKey] = value;
        }
        return acc;
    }, {});
    // Only return a dynamic sampling context object if there are keys in it.
    // A keyless object means there were no sentry values on the header, which means that there is no DSC.
    if (Object.keys(dynamicSamplingContext).length > 0) return dynamicSamplingContext;
    else return undefined;
}
/**
 * Turns a Dynamic Sampling Object into a baggage header by prefixing all the keys on the object with "sentry-".
 *
 * @param dynamicSamplingContext The Dynamic Sampling Context to turn into a header. For convenience and compatibility
 * with the `getDynamicSamplingContext` method on the Transaction class ,this argument can also be `undefined`. If it is
 * `undefined` the function will return `undefined`.
 * @returns a baggage header, created from `dynamicSamplingContext`, or `undefined` either if `dynamicSamplingContext`
 * was `undefined`, or if `dynamicSamplingContext` didn't contain any values.
 */ function $6b9edc7ab37f210c$export$56766feef403f365(// this also takes undefined for convenience and bundle size in other places
dynamicSamplingContext) {
    if (!dynamicSamplingContext) return undefined;
    // Prefix all DSC keys with "sentry-" and put them into a new object
    const sentryPrefixedDSC = Object.entries(dynamicSamplingContext).reduce((acc, [dscKey, dscValue])=>{
        if (dscValue) acc[`${$6b9edc7ab37f210c$export$6e69537d67fa20f}${dscKey}`] = dscValue;
        return acc;
    }, {});
    return $6b9edc7ab37f210c$var$objectToBaggageHeader(sentryPrefixedDSC);
}
/**
 * Will parse a baggage header, which is a simple key-value map, into a flat object.
 *
 * @param baggageHeader The baggage header to parse.
 * @returns a flat object containing all the key-value pairs from `baggageHeader`.
 */ function $6b9edc7ab37f210c$var$baggageHeaderToObject(baggageHeader) {
    return baggageHeader.split(",").map((baggageEntry)=>baggageEntry.split("=").map((keyOrValue)=>decodeURIComponent(keyOrValue.trim()))).reduce((acc, [key, value])=>{
        acc[key] = value;
        return acc;
    }, {});
}
/**
 * Turns a flat object (key-value pairs) into a baggage header, which is also just key-value pairs.
 *
 * @param object The object to turn into a baggage header.
 * @returns a baggage header string, or `undefined` if the object didn't have any values, since an empty baggage header
 * is not spec compliant.
 */ function $6b9edc7ab37f210c$var$objectToBaggageHeader(object) {
    if (Object.keys(object).length === 0) // An empty baggage header is not spec compliant: We return undefined.
    return undefined;
    return Object.entries(object).reduce((baggageHeader, [objectKey, objectValue], currentIndex)=>{
        const baggageEntry = `${encodeURIComponent(objectKey)}=${encodeURIComponent(objectValue)}`;
        const newBaggageHeader = currentIndex === 0 ? baggageEntry : `${baggageHeader},${baggageEntry}`;
        if (newBaggageHeader.length > $6b9edc7ab37f210c$export$bdd844ddb2def819) {
            (0, $7qutn.DEBUG_BUILD) && (0, $fi7Bg.logger).warn(`Not adding key: ${objectKey} with val: ${objectValue} to baggage header due to exceeding baggage size limits.`);
            return baggageHeader;
        } else return newBaggageHeader;
    }, "");
}

});






parcelRequire.register("lFUnc", function(module, exports) {

$parcel$export(module.exports, "SDK_VERSION", function () { return $fc7927d393fd61ab$export$31499a9cd224b78c; });
const $fc7927d393fd61ab$export$31499a9cd224b78c = "7.119.1";

});


parcelRequire.register("dW8zo", function(module, exports) {

$parcel$export(module.exports, "prepareEvent", function () { return $029e4fda96c3c8d7$export$2d67fb380bd11267; });
$parcel$export(module.exports, "parseEventHintOrCaptureContext", function () { return $029e4fda96c3c8d7$export$76b5f966996d1653; });

var $gYD4g = parcelRequire("gYD4g");
var $kTBeD = parcelRequire("kTBeD");
var $hi0PN = parcelRequire("hi0PN");
var $fjuuc = parcelRequire("fjuuc");
var $2AO4R = parcelRequire("2AO4R");

var $fc74V = parcelRequire("fc74V");

var $bP1fJ = parcelRequire("bP1fJ");

var $k4vcv = parcelRequire("k4vcv");

var $8QL9a = parcelRequire("8QL9a");

var $ZS8fh = parcelRequire("ZS8fh");
/**
 * This type makes sure that we get either a CaptureContext, OR an EventHint.
 * It does not allow mixing them, which could lead to unexpected outcomes, e.g. this is disallowed:
 * { user: { id: '123' }, mechanism: { handled: false } }
 */ /**
 * Adds common information to events.
 *
 * The information includes release and environment from `options`,
 * breadcrumbs and context (extra, tags and user) from the scope.
 *
 * Information that is already present in the event is never overwritten. For
 * nested objects, such as the context, keys are merged.
 *
 * Note: This also triggers callbacks for `addGlobalEventProcessor`, but not `beforeSend`.
 *
 * @param event The original event.
 * @param hint May contain additional information about the original exception.
 * @param scope A scope containing event metadata.
 * @returns A new event with more information.
 * @hidden
 */ function $029e4fda96c3c8d7$export$2d67fb380bd11267(options, event, hint, scope, client, isolationScope) {
    const { normalizeDepth: normalizeDepth = 3, normalizeMaxBreadth: normalizeMaxBreadth = 1000 } = options;
    const prepared = {
        ...event,
        event_id: event.event_id || hint.event_id || (0, $gYD4g.uuid4)(),
        timestamp: event.timestamp || (0, $kTBeD.dateTimestampInSeconds)()
    };
    const integrations = hint.integrations || options.integrations.map((i)=>i.name);
    $029e4fda96c3c8d7$var$applyClientOptions(prepared, options);
    $029e4fda96c3c8d7$var$applyIntegrationsMetadata(prepared, integrations);
    // Only put debug IDs onto frames for error events.
    if (event.type === undefined) $029e4fda96c3c8d7$export$63042efc86f043e7(prepared, options.stackParser);
    // If we have scope given to us, use it as the base for further modifications.
    // This allows us to prevent unnecessary copying of data if `captureContext` is not provided.
    const finalScope = $029e4fda96c3c8d7$var$getFinalScope(scope, hint.captureContext);
    if (hint.mechanism) (0, $gYD4g.addExceptionMechanism)(prepared, hint.mechanism);
    const clientEventProcessors = client && client.getEventProcessors ? client.getEventProcessors() : [];
    // This should be the last thing called, since we want that
    // {@link Hub.addEventProcessor} gets the finished prepared event.
    // Merge scope data together
    const data = (0, $k4vcv.getGlobalScope)().getScopeData();
    if (isolationScope) {
        const isolationData = isolationScope.getScopeData();
        (0, $8QL9a.mergeScopeData)(data, isolationData);
    }
    if (finalScope) {
        const finalScopeData = finalScope.getScopeData();
        (0, $8QL9a.mergeScopeData)(data, finalScopeData);
    }
    const attachments = [
        ...hint.attachments || [],
        ...data.attachments
    ];
    if (attachments.length) hint.attachments = attachments;
    (0, $8QL9a.applyScopeDataToEvent)(prepared, data);
    // TODO (v8): Update this order to be: Global > Client > Scope
    const eventProcessors = [
        ...clientEventProcessors,
        // eslint-disable-next-line deprecation/deprecation
        ...(0, $bP1fJ.getGlobalEventProcessors)(),
        // Run scope event processors _after_ all other processors
        ...data.eventProcessors
    ];
    const result = (0, $bP1fJ.notifyEventProcessors)(eventProcessors, prepared, hint);
    return result.then((evt)=>{
        if (evt) // We apply the debug_meta field only after all event processors have ran, so that if any event processors modified
        // file names (e.g.the RewriteFrames integration) the filename -> debug ID relationship isn't destroyed.
        // This should not cause any PII issues, since we're only moving data that is already on the event and not adding
        // any new data
        $029e4fda96c3c8d7$export$1be657ba8ef44ff0(evt);
        if (typeof normalizeDepth === "number" && normalizeDepth > 0) return $029e4fda96c3c8d7$var$normalizeEvent(evt, normalizeDepth, normalizeMaxBreadth);
        return evt;
    });
}
/**
 *  Enhances event using the client configuration.
 *  It takes care of all "static" values like environment, release and `dist`,
 *  as well as truncating overly long values.
 * @param event event instance to be enhanced
 */ function $029e4fda96c3c8d7$var$applyClientOptions(event, options) {
    const { environment: environment, release: release, dist: dist, maxValueLength: maxValueLength = 250 } = options;
    if (!("environment" in event)) event.environment = "environment" in options ? environment : (0, $fc74V.DEFAULT_ENVIRONMENT);
    if (event.release === undefined && release !== undefined) event.release = release;
    if (event.dist === undefined && dist !== undefined) event.dist = dist;
    if (event.message) event.message = (0, $2AO4R.truncate)(event.message, maxValueLength);
    const exception = event.exception && event.exception.values && event.exception.values[0];
    if (exception && exception.value) exception.value = (0, $2AO4R.truncate)(exception.value, maxValueLength);
    const request = event.request;
    if (request && request.url) request.url = (0, $2AO4R.truncate)(request.url, maxValueLength);
}
const $029e4fda96c3c8d7$var$debugIdStackParserCache = new WeakMap();
/**
 * Puts debug IDs into the stack frames of an error event.
 */ function $029e4fda96c3c8d7$export$63042efc86f043e7(event, stackParser) {
    const debugIdMap = (0, $hi0PN.GLOBAL_OBJ)._sentryDebugIds;
    if (!debugIdMap) return;
    let debugIdStackFramesCache;
    const cachedDebugIdStackFrameCache = $029e4fda96c3c8d7$var$debugIdStackParserCache.get(stackParser);
    if (cachedDebugIdStackFrameCache) debugIdStackFramesCache = cachedDebugIdStackFrameCache;
    else {
        debugIdStackFramesCache = new Map();
        $029e4fda96c3c8d7$var$debugIdStackParserCache.set(stackParser, debugIdStackFramesCache);
    }
    // Build a map of filename -> debug_id
    const filenameDebugIdMap = Object.keys(debugIdMap).reduce((acc, debugIdStackTrace)=>{
        let parsedStack;
        const cachedParsedStack = debugIdStackFramesCache.get(debugIdStackTrace);
        if (cachedParsedStack) parsedStack = cachedParsedStack;
        else {
            parsedStack = stackParser(debugIdStackTrace);
            debugIdStackFramesCache.set(debugIdStackTrace, parsedStack);
        }
        for(let i = parsedStack.length - 1; i >= 0; i--){
            const stackFrame = parsedStack[i];
            if (stackFrame.filename) {
                acc[stackFrame.filename] = debugIdMap[debugIdStackTrace];
                break;
            }
        }
        return acc;
    }, {});
    try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        event.exception.values.forEach((exception)=>{
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            exception.stacktrace.frames.forEach((frame)=>{
                if (frame.filename) frame.debug_id = filenameDebugIdMap[frame.filename];
            });
        });
    } catch (e) {
    // To save bundle size we're just try catching here instead of checking for the existence of all the different objects.
    }
}
/**
 * Moves debug IDs from the stack frames of an error event into the debug_meta field.
 */ function $029e4fda96c3c8d7$export$1be657ba8ef44ff0(event) {
    // Extract debug IDs and filenames from the stack frames on the event.
    const filenameDebugIdMap = {};
    try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        event.exception.values.forEach((exception)=>{
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            exception.stacktrace.frames.forEach((frame)=>{
                if (frame.debug_id) {
                    if (frame.abs_path) filenameDebugIdMap[frame.abs_path] = frame.debug_id;
                    else if (frame.filename) filenameDebugIdMap[frame.filename] = frame.debug_id;
                    delete frame.debug_id;
                }
            });
        });
    } catch (e) {
    // To save bundle size we're just try catching here instead of checking for the existence of all the different objects.
    }
    if (Object.keys(filenameDebugIdMap).length === 0) return;
    // Fill debug_meta information
    event.debug_meta = event.debug_meta || {};
    event.debug_meta.images = event.debug_meta.images || [];
    const images = event.debug_meta.images;
    Object.keys(filenameDebugIdMap).forEach((filename)=>{
        images.push({
            type: "sourcemap",
            code_file: filename,
            debug_id: filenameDebugIdMap[filename]
        });
    });
}
/**
 * This function adds all used integrations to the SDK info in the event.
 * @param event The event that will be filled with all integrations.
 */ function $029e4fda96c3c8d7$var$applyIntegrationsMetadata(event, integrationNames) {
    if (integrationNames.length > 0) {
        event.sdk = event.sdk || {};
        event.sdk.integrations = [
            ...event.sdk.integrations || [],
            ...integrationNames
        ];
    }
}
/**
 * Applies `normalize` function on necessary `Event` attributes to make them safe for serialization.
 * Normalized keys:
 * - `breadcrumbs.data`
 * - `user`
 * - `contexts`
 * - `extra`
 * @param event Event
 * @returns Normalized event
 */ function $029e4fda96c3c8d7$var$normalizeEvent(event, depth, maxBreadth) {
    if (!event) return null;
    const normalized = {
        ...event,
        ...event.breadcrumbs && {
            breadcrumbs: event.breadcrumbs.map((b)=>({
                    ...b,
                    ...b.data && {
                        data: (0, $fjuuc.normalize)(b.data, depth, maxBreadth)
                    }
                }))
        },
        ...event.user && {
            user: (0, $fjuuc.normalize)(event.user, depth, maxBreadth)
        },
        ...event.contexts && {
            contexts: (0, $fjuuc.normalize)(event.contexts, depth, maxBreadth)
        },
        ...event.extra && {
            extra: (0, $fjuuc.normalize)(event.extra, depth, maxBreadth)
        }
    };
    // event.contexts.trace stores information about a Transaction. Similarly,
    // event.spans[] stores information about child Spans. Given that a
    // Transaction is conceptually a Span, normalization should apply to both
    // Transactions and Spans consistently.
    // For now the decision is to skip normalization of Transactions and Spans,
    // so this block overwrites the normalized event to add back the original
    // Transaction information prior to normalization.
    if (event.contexts && event.contexts.trace && normalized.contexts) {
        normalized.contexts.trace = event.contexts.trace;
        // event.contexts.trace.data may contain circular/dangerous data so we need to normalize it
        if (event.contexts.trace.data) normalized.contexts.trace.data = (0, $fjuuc.normalize)(event.contexts.trace.data, depth, maxBreadth);
    }
    // event.spans[].data may contain circular/dangerous data so we need to normalize it
    if (event.spans) normalized.spans = event.spans.map((span)=>{
        const data = (0, $ZS8fh.spanToJSON)(span).data;
        if (data) // This is a bit weird, as we generally have `Span` instances here, but to be safe we do not assume so
        // eslint-disable-next-line deprecation/deprecation
        span.data = (0, $fjuuc.normalize)(data, depth, maxBreadth);
        return span;
    });
    return normalized;
}
function $029e4fda96c3c8d7$var$getFinalScope(scope, captureContext) {
    if (!captureContext) return scope;
    const finalScope = scope ? scope.clone() : new (0, $k4vcv.Scope)();
    finalScope.update(captureContext);
    return finalScope;
}
/**
 * Parse either an `EventHint` directly, or convert a `CaptureContext` to an `EventHint`.
 * This is used to allow to update method signatures that used to accept a `CaptureContext` but should now accept an `EventHint`.
 */ function $029e4fda96c3c8d7$export$76b5f966996d1653(hint) {
    if (!hint) return undefined;
    // If you pass a Scope or `() => Scope` as CaptureContext, we just return this as captureContext
    if ($029e4fda96c3c8d7$var$hintIsScopeOrFunction(hint)) return {
        captureContext: hint
    };
    if ($029e4fda96c3c8d7$var$hintIsScopeContext(hint)) return {
        captureContext: hint
    };
    return hint;
}
function $029e4fda96c3c8d7$var$hintIsScopeOrFunction(hint) {
    return hint instanceof (0, $k4vcv.Scope) || typeof hint === "function";
}
const $029e4fda96c3c8d7$var$captureContextKeys = [
    "user",
    "level",
    "extra",
    "contexts",
    "tags",
    "fingerprint",
    "requestSession",
    "propagationContext"
];
function $029e4fda96c3c8d7$var$hintIsScopeContext(hint) {
    return Object.keys(hint).some((key)=>$029e4fda96c3c8d7$var$captureContextKeys.includes(key));
}

});
parcelRequire.register("fjuuc", function(module, exports) {

$parcel$export(module.exports, "normalize", function () { return $b26047403a82b17f$export$a3295358bff77e; });
$parcel$export(module.exports, "normalizeToSize", function () { return $b26047403a82b17f$export$23fbbb20bed71033; });

var $5lwZa = parcelRequire("5lwZa");

var $ieTXq = parcelRequire("ieTXq");

var $eKFW4 = parcelRequire("eKFW4");

var $9KjXB = parcelRequire("9KjXB");
/**
 * Recursively normalizes the given object.
 *
 * - Creates a copy to prevent original input mutation
 * - Skips non-enumerable properties
 * - When stringifying, calls `toJSON` if implemented
 * - Removes circular references
 * - Translates non-serializable values (`undefined`/`NaN`/functions) to serializable format
 * - Translates known global objects/classes to a string representations
 * - Takes care of `Error` object serialization
 * - Optionally limits depth of final output
 * - Optionally limits number of properties/elements included in any single object/array
 *
 * @param input The object to be normalized.
 * @param depth The max depth to which to normalize the object. (Anything deeper stringified whole.)
 * @param maxProperties The max number of elements or properties to be included in any single array or
 * object in the normallized output.
 * @returns A normalized version of the object, or `"**non-serializable**"` if any errors are thrown during normalization.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $b26047403a82b17f$export$a3295358bff77e(input, depth = 100, maxProperties = Infinity) {
    try {
        // since we're at the outermost level, we don't provide a key
        return $b26047403a82b17f$export$588732934346abbf("", input, depth, maxProperties);
    } catch (err) {
        return {
            ERROR: `**non-serializable** (${err})`
        };
    }
}
/** JSDoc */ function $b26047403a82b17f$export$23fbbb20bed71033(// eslint-disable-next-line @typescript-eslint/no-explicit-any
object, // Default Node.js REPL depth
depth = 3, // 100kB, as 200kB is max payload size, so half sounds reasonable
maxSize = 102400) {
    const normalized = $b26047403a82b17f$export$a3295358bff77e(object, depth);
    if ($b26047403a82b17f$var$jsonSize(normalized) > maxSize) return $b26047403a82b17f$export$23fbbb20bed71033(object, depth - 1, maxSize);
    return normalized;
}
/**
 * Visits a node to perform normalization on it
 *
 * @param key The key corresponding to the given node
 * @param value The node to be visited
 * @param depth Optional number indicating the maximum recursion depth
 * @param maxProperties Optional maximum number of properties/elements included in any single object/array
 * @param memo Optional Memo class handling decycling
 */ function $b26047403a82b17f$export$588732934346abbf(key, value, depth = Infinity, maxProperties = Infinity, memo = (0, $ieTXq.memoBuilder)()) {
    const [memoize, unmemoize] = memo;
    // Get the simple cases out of the way first
    if (value == null || // this matches null and undefined -> eqeq not eqeqeq
    [
        "number",
        "boolean",
        "string"
    ].includes(typeof value) && !(0, $5lwZa.isNaN)(value)) return value;
    const stringified = $b26047403a82b17f$var$stringifyValue(key, value);
    // Anything we could potentially dig into more (objects or arrays) will have come back as `"[object XXXX]"`.
    // Everything else will have already been serialized, so if we don't see that pattern, we're done.
    if (!stringified.startsWith("[object ")) return stringified;
    // From here on, we can assert that `value` is either an object or an array.
    // Do not normalize objects that we know have already been normalized. As a general rule, the
    // "__sentry_skip_normalization__" property should only be used sparingly and only should only be set on objects that
    // have already been normalized.
    if (value["__sentry_skip_normalization__"]) return value;
    // We can set `__sentry_override_normalization_depth__` on an object to ensure that from there
    // We keep a certain amount of depth.
    // This should be used sparingly, e.g. we use it for the redux integration to ensure we get a certain amount of state.
    const remainingDepth = typeof value["__sentry_override_normalization_depth__"] === "number" ? value["__sentry_override_normalization_depth__"] : depth;
    // We're also done if we've reached the max depth
    if (remainingDepth === 0) // At this point we know `serialized` is a string of the form `"[object XXXX]"`. Clean it up so it's just `"[XXXX]"`.
    return stringified.replace("object ", "");
    // If we've already visited this branch, bail out, as it's circular reference. If not, note that we're seeing it now.
    if (memoize(value)) return "[Circular ~]";
    // If the value has a `toJSON` method, we call it to extract more information
    const valueWithToJSON = value;
    if (valueWithToJSON && typeof valueWithToJSON.toJSON === "function") try {
        const jsonValue = valueWithToJSON.toJSON();
        // We need to normalize the return value of `.toJSON()` in case it has circular references
        return $b26047403a82b17f$export$588732934346abbf("", jsonValue, remainingDepth - 1, maxProperties, memo);
    } catch (err) {
    // pass (The built-in `toJSON` failed, but we can still try to do it ourselves)
    }
    // At this point we know we either have an object or an array, we haven't seen it before, and we're going to recurse
    // because we haven't yet reached the max depth. Create an accumulator to hold the results of visiting each
    // property/entry, and keep track of the number of items we add to it.
    const normalized = Array.isArray(value) ? [] : {};
    let numAdded = 0;
    // Before we begin, convert`Error` and`Event` instances into plain objects, since some of each of their relevant
    // properties are non-enumerable and otherwise would get missed.
    const visitable = (0, $eKFW4.convertToPlainObject)(value);
    for(const visitKey in visitable){
        // Avoid iterating over fields in the prototype if they've somehow been exposed to enumeration.
        if (!Object.prototype.hasOwnProperty.call(visitable, visitKey)) continue;
        if (numAdded >= maxProperties) {
            normalized[visitKey] = "[MaxProperties ~]";
            break;
        }
        // Recursively visit all the child nodes
        const visitValue = visitable[visitKey];
        normalized[visitKey] = $b26047403a82b17f$export$588732934346abbf(visitKey, visitValue, remainingDepth - 1, maxProperties, memo);
        numAdded++;
    }
    // Once we've visited all the branches, remove the parent from memo storage
    unmemoize(value);
    // Return accumulated values
    return normalized;
}
/* eslint-disable complexity */ /**
 * Stringify the given value. Handles various known special values and types.
 *
 * Not meant to be used on simple primitives which already have a string representation, as it will, for example, turn
 * the number 1231 into "[Object Number]", nor on `null`, as it will throw.
 *
 * @param value The value to stringify
 * @returns A stringified representation of the given value
 */ function $b26047403a82b17f$var$stringifyValue(key, // this type is a tiny bit of a cheat, since this function does handle NaN (which is technically a number), but for
// our internal use, it'll do
value) {
    try {
        if (key === "domain" && value && typeof value === "object" && value._events) return "[Domain]";
        if (key === "domainEmitter") return "[DomainEmitter]";
        // It's safe to use `global`, `window`, and `document` here in this manner, as we are asserting using `typeof` first
        // which won't throw if they are not present.
        if (typeof $parcel$global !== "undefined" && value === $parcel$global) return "[Global]";
        // eslint-disable-next-line no-restricted-globals
        if (typeof window !== "undefined" && value === window) return "[Window]";
        // eslint-disable-next-line no-restricted-globals
        if (typeof document !== "undefined" && value === document) return "[Document]";
        if ((0, $5lwZa.isVueViewModel)(value)) return "[VueViewModel]";
        // React's SyntheticEvent thingy
        if ((0, $5lwZa.isSyntheticEvent)(value)) return "[SyntheticEvent]";
        if (typeof value === "number" && value !== value) return "[NaN]";
        if (typeof value === "function") return `[Function: ${(0, $9KjXB.getFunctionName)(value)}]`;
        if (typeof value === "symbol") return `[${String(value)}]`;
        // stringified BigInts are indistinguishable from regular numbers, so we need to label them to avoid confusion
        if (typeof value === "bigint") return `[BigInt: ${String(value)}]`;
        // Now that we've knocked out all the special cases and the primitives, all we have left are objects. Simply casting
        // them to strings means that instances of classes which haven't defined their `toStringTag` will just come out as
        // `"[object Object]"`. If we instead look at the constructor's name (which is the same as the name of the class),
        // we can make sure that only plain objects come out that way.
        const objName = $b26047403a82b17f$var$getConstructorName(value);
        // Handle HTML Elements
        if (/^HTML(\w*)Element$/.test(objName)) return `[HTMLElement: ${objName}]`;
        return `[object ${objName}]`;
    } catch (err) {
        return `**non-serializable** (${err})`;
    }
}
/* eslint-enable complexity */ function $b26047403a82b17f$var$getConstructorName(value) {
    const prototype = Object.getPrototypeOf(value);
    return prototype ? prototype.constructor.name : "null prototype";
}
/** Calculates bytes size of input string */ function $b26047403a82b17f$var$utf8Length(value) {
    // eslint-disable-next-line no-bitwise
    return ~-encodeURI(value).split(/%..|./).length;
}
/** Calculates bytes size of input object */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $b26047403a82b17f$var$jsonSize(value) {
    return $b26047403a82b17f$var$utf8Length(JSON.stringify(value));
}
/**
 * Normalizes URLs in exceptions and stacktraces to a base path so Sentry can fingerprint
 * across platforms and working directory.
 *
 * @param url The URL to be normalized.
 * @param basePath The application base path.
 * @returns The normalized URL.
 */ function $b26047403a82b17f$export$472b29734be05be3(url, basePath) {
    const escapedBase = basePath// Backslash to forward
    .replace(/\\/g, "/")// Escape RegExp special characters
    .replace(/[|\\{}()[\]^$+*?.]/g, "\\$&");
    let newUrl = url;
    try {
        newUrl = decodeURI(url);
    } catch (_Oo) {
    // Sometime this breaks
    }
    return newUrl.replace(/\\/g, "/").replace(/webpack:\/?/g, "") // Remove intermediate base path
    // eslint-disable-next-line @sentry-internal/sdk/no-regexp-constructor
    .replace(new RegExp(`(file://)?/*${escapedBase}/*`, "ig"), "app:///");
}

});
parcelRequire.register("ieTXq", function(module, exports) {

$parcel$export(module.exports, "memoBuilder", function () { return $d474f0c7f8c14c05$export$8115b0b78e956ab3; });
/* eslint-disable @typescript-eslint/no-unsafe-member-access */ /* eslint-disable @typescript-eslint/no-explicit-any */ /**
 * Helper to decycle json objects
 */ function $d474f0c7f8c14c05$export$8115b0b78e956ab3() {
    const hasWeakSet = typeof WeakSet === "function";
    const inner = hasWeakSet ? new WeakSet() : [];
    function memoize(obj) {
        if (hasWeakSet) {
            if (inner.has(obj)) return true;
            inner.add(obj);
            return false;
        }
        // eslint-disable-next-line @typescript-eslint/prefer-for-of
        for(let i = 0; i < inner.length; i++){
            const value = inner[i];
            if (value === obj) return true;
        }
        inner.push(obj);
        return false;
    }
    function unmemoize(obj) {
        if (hasWeakSet) inner.delete(obj);
        else {
            for(let i = 0; i < inner.length; i++)if (inner[i] === obj) {
                inner.splice(i, 1);
                break;
            }
        }
    }
    return [
        memoize,
        unmemoize
    ];
}

});

parcelRequire.register("9KjXB", function(module, exports) {

$parcel$export(module.exports, "createStackParser", function () { return $7187e4a4f186af73$export$a5739666fb2d03d4; });
$parcel$export(module.exports, "stackParserFromStackParserOptions", function () { return $7187e4a4f186af73$export$1d5cf88b347146d4; });
$parcel$export(module.exports, "getFunctionName", function () { return $7187e4a4f186af73$export$aad197c7121a6651; });

var $cH9qV = parcelRequire("cH9qV");
const $7187e4a4f186af73$var$STACKTRACE_FRAME_LIMIT = 50;
// Used to sanitize webpack (error: *) wrapped stack errors
const $7187e4a4f186af73$var$WEBPACK_ERROR_REGEXP = /\(error: (.*)\)/;
const $7187e4a4f186af73$var$STRIP_FRAME_REGEXP = /captureMessage|captureException/;
/**
 * Creates a stack parser with the supplied line parsers
 *
 * StackFrames are returned in the correct order for Sentry Exception
 * frames and with Sentry SDK internal frames removed from the top and bottom
 *
 */ function $7187e4a4f186af73$export$a5739666fb2d03d4(...parsers) {
    const sortedParsers = parsers.sort((a, b)=>a[0] - b[0]).map((p)=>p[1]);
    return (stack, skipFirst = 0)=>{
        const frames = [];
        const lines = stack.split("\n");
        for(let i = skipFirst; i < lines.length; i++){
            const line = lines[i];
            // Ignore lines over 1kb as they are unlikely to be stack frames.
            // Many of the regular expressions use backtracking which results in run time that increases exponentially with
            // input size. Huge strings can result in hangs/Denial of Service:
            // https://github.com/getsentry/sentry-javascript/issues/2286
            if (line.length > 1024) continue;
            // https://github.com/getsentry/sentry-javascript/issues/5459
            // Remove webpack (error: *) wrappers
            const cleanedLine = $7187e4a4f186af73$var$WEBPACK_ERROR_REGEXP.test(line) ? line.replace($7187e4a4f186af73$var$WEBPACK_ERROR_REGEXP, "$1") : line;
            // https://github.com/getsentry/sentry-javascript/issues/7813
            // Skip Error: lines
            if (cleanedLine.match(/\S*Error: /)) continue;
            for (const parser of sortedParsers){
                const frame = parser(cleanedLine);
                if (frame) {
                    frames.push(frame);
                    break;
                }
            }
            if (frames.length >= $7187e4a4f186af73$var$STACKTRACE_FRAME_LIMIT) break;
        }
        return $7187e4a4f186af73$export$c55c24c0eeba0205(frames);
    };
}
/**
 * Gets a stack parser implementation from Options.stackParser
 * @see Options
 *
 * If options contains an array of line parsers, it is converted into a parser
 */ function $7187e4a4f186af73$export$1d5cf88b347146d4(stackParser) {
    if (Array.isArray(stackParser)) return $7187e4a4f186af73$export$a5739666fb2d03d4(...stackParser);
    return stackParser;
}
/**
 * Removes Sentry frames from the top and bottom of the stack if present and enforces a limit of max number of frames.
 * Assumes stack input is ordered from top to bottom and returns the reverse representation so call site of the
 * function that caused the crash is the last frame in the array.
 * @hidden
 */ function $7187e4a4f186af73$export$c55c24c0eeba0205(stack) {
    if (!stack.length) return [];
    const localStack = Array.from(stack);
    // If stack starts with one of our API calls, remove it (starts, meaning it's the top of the stack - aka last call)
    if (/sentryWrapped/.test(localStack[localStack.length - 1].function || "")) localStack.pop();
    // Reversing in the middle of the procedure allows us to just pop the values off the stack
    localStack.reverse();
    // If stack ends with one of our internal API calls, remove it (ends, meaning it's the bottom of the stack - aka top-most call)
    if ($7187e4a4f186af73$var$STRIP_FRAME_REGEXP.test(localStack[localStack.length - 1].function || "")) {
        localStack.pop();
        // When using synthetic events, we will have a 2 levels deep stack, as `new Error('Sentry syntheticException')`
        // is produced within the hub itself, making it:
        //
        //   Sentry.captureException()
        //   getCurrentHub().captureException()
        //
        // instead of just the top `Sentry` call itself.
        // This forces us to possibly strip an additional frame in the exact same was as above.
        if ($7187e4a4f186af73$var$STRIP_FRAME_REGEXP.test(localStack[localStack.length - 1].function || "")) localStack.pop();
    }
    return localStack.slice(0, $7187e4a4f186af73$var$STACKTRACE_FRAME_LIMIT).map((frame)=>({
            ...frame,
            filename: frame.filename || localStack[localStack.length - 1].filename,
            function: frame.function || "?"
        }));
}
const $7187e4a4f186af73$var$defaultFunctionName = "<anonymous>";
/**
 * Safely extract function name from itself
 */ function $7187e4a4f186af73$export$aad197c7121a6651(fn) {
    try {
        if (!fn || typeof fn !== "function") return $7187e4a4f186af73$var$defaultFunctionName;
        return fn.name || $7187e4a4f186af73$var$defaultFunctionName;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        return $7187e4a4f186af73$var$defaultFunctionName;
    }
}
/**
 * Node.js stack line parser
 *
 * This is in @sentry/utils so it can be used from the Electron SDK in the browser for when `nodeIntegration == true`.
 * This allows it to be used without referencing or importing any node specific code which causes bundlers to complain
 */ function $7187e4a4f186af73$export$673345a0da635a78(getModule) {
    return [
        90,
        (0, $cH9qV.node)(getModule)
    ];
}

});
parcelRequire.register("cH9qV", function(module, exports) {

$parcel$export(module.exports, "node", function () { return $93e0d17362f2ef36$export$35059013cd4a06db; });
/**
 * Does this filename look like it's part of the app code?
 */ function $93e0d17362f2ef36$export$1de92f38f4de99a8(filename, isNative = false) {
    const isInternal = isNative || filename && // It's not internal if it's an absolute linux path
    !filename.startsWith("/") && // It's not internal if it's an absolute windows path
    !filename.match(/^[A-Z]:/) && // It's not internal if the path is starting with a dot
    !filename.startsWith(".") && // It's not internal if the frame has a protocol. In node, this is usually the case if the file got pre-processed with a bundler like webpack
    !filename.match(/^[a-zA-Z]([a-zA-Z0-9.\-+])*:\/\//); // Schema from: https://stackoverflow.com/a/3641782
    // in_app is all that's not an internal Node function or a module within node_modules
    // note that isNative appears to return true even for node core libraries
    // see https://github.com/getsentry/raven-node/issues/176
    return !isInternal && filename !== undefined && !filename.includes("node_modules/");
}
/** Node Stack line parser */ // eslint-disable-next-line complexity
function $93e0d17362f2ef36$export$35059013cd4a06db(getModule) {
    const FILENAME_MATCH = /^\s*[-]{4,}$/;
    const FULL_MATCH = /at (?:async )?(?:(.+?)\s+\()?(?:(.+):(\d+):(\d+)?|([^)]+))\)?/;
    // eslint-disable-next-line complexity
    return (line)=>{
        const lineMatch = line.match(FULL_MATCH);
        if (lineMatch) {
            let object;
            let method;
            let functionName;
            let typeName;
            let methodName;
            if (lineMatch[1]) {
                functionName = lineMatch[1];
                let methodStart = functionName.lastIndexOf(".");
                if (functionName[methodStart - 1] === ".") methodStart--;
                if (methodStart > 0) {
                    object = functionName.slice(0, methodStart);
                    method = functionName.slice(methodStart + 1);
                    const objectEnd = object.indexOf(".Module");
                    if (objectEnd > 0) {
                        functionName = functionName.slice(objectEnd + 1);
                        object = object.slice(0, objectEnd);
                    }
                }
                typeName = undefined;
            }
            if (method) {
                typeName = object;
                methodName = method;
            }
            if (method === "<anonymous>") {
                methodName = undefined;
                functionName = undefined;
            }
            if (functionName === undefined) {
                methodName = methodName || "<anonymous>";
                functionName = typeName ? `${typeName}.${methodName}` : methodName;
            }
            let filename = lineMatch[2] && lineMatch[2].startsWith("file://") ? lineMatch[2].slice(7) : lineMatch[2];
            const isNative = lineMatch[5] === "native";
            // If it's a Windows path, trim the leading slash so that `/C:/foo` becomes `C:/foo`
            if (filename && filename.match(/\/[A-Z]:/)) filename = filename.slice(1);
            if (!filename && lineMatch[5] && !isNative) filename = lineMatch[5];
            return {
                filename: filename,
                module: getModule ? getModule(filename) : undefined,
                function: functionName,
                lineno: parseInt(lineMatch[3], 10) || undefined,
                colno: parseInt(lineMatch[4], 10) || undefined,
                in_app: $93e0d17362f2ef36$export$1de92f38f4de99a8(filename, isNative)
            };
        }
        if (line.match(FILENAME_MATCH)) return {
            filename: line
        };
        return undefined;
    };
}

});





parcelRequire.register("1appp", function(module, exports) {

$parcel$export(module.exports, "init", function () { return $0d9a6f47fbfd9f65$export$2cd8252107eb640b; });

var $9Dess = parcelRequire("9Dess");
var $hNldI = parcelRequire("hNldI");
var $8XTAO = parcelRequire("8XTAO");
var $dp2Cj = parcelRequire("dp2Cj");
var $5ldEo = parcelRequire("5ldEo");
var $4ygnq = parcelRequire("4ygnq");
var $gEJ4y = parcelRequire("gEJ4y");

var $iYpob = parcelRequire("iYpob");
var $fi7Bg = parcelRequire("fi7Bg");
var $9KjXB = parcelRequire("9KjXB");
var $014xT = parcelRequire("014xT");

var $i3WKM = parcelRequire("i3WKM");

var $23Gvz = parcelRequire("23Gvz");

var $gY4ad = parcelRequire("gY4ad");

var $1gJxQ = parcelRequire("1gJxQ");

var $bGs58 = parcelRequire("bGs58");

var $3xVxZ = parcelRequire("3xVxZ");

var $j4JoJ = parcelRequire("j4JoJ");

var $6FVFB = parcelRequire("6FVFB");

var $fRwqh = parcelRequire("fRwqh");

var $iNtGt = parcelRequire("iNtGt");

var $dmB5g = parcelRequire("dmB5g");

var $6DI64 = parcelRequire("6DI64");
/** @deprecated Use `getDefaultIntegrations(options)` instead. */ const $0d9a6f47fbfd9f65$export$5ef831fccfce35e5 = [
    (0, $4ygnq.inboundFiltersIntegration)(),
    (0, $hNldI.functionToStringIntegration)(),
    (0, $fRwqh.browserApiErrorsIntegration)(),
    (0, $1gJxQ.breadcrumbsIntegration)(),
    (0, $3xVxZ.globalHandlersIntegration)(),
    (0, $6FVFB.linkedErrorsIntegration)(),
    (0, $bGs58.dedupeIntegration)(),
    (0, $j4JoJ.httpContextIntegration)()
];
/** Get the default integrations for the browser SDK. */ function $0d9a6f47fbfd9f65$export$5783b2920b1d62b9(_options) {
    // We return a copy of the defaultIntegrations here to avoid mutating this
    return [
        // eslint-disable-next-line deprecation/deprecation
        ...$0d9a6f47fbfd9f65$export$5ef831fccfce35e5
    ];
}
/**
 * A magic string that build tooling can leverage in order to inject a release value into the SDK.
 */ /**
 * The Sentry Browser SDK Client.
 *
 * To use this SDK, call the {@link init} function as early as possible when
 * loading the web page. To set context information or send manual events, use
 * the provided methods.
 *
 * @example
 *
 * ```
 *
 * import { init } from '@sentry/browser';
 *
 * init({
 *   dsn: '__DSN__',
 *   // ...
 * });
 * ```
 *
 * @example
 * ```
 *
 * import { configureScope } from '@sentry/browser';
 * configureScope((scope: Scope) => {
 *   scope.setExtra({ battery: 0.7 });
 *   scope.setTag({ user_mode: 'admin' });
 *   scope.setUser({ id: '4711' });
 * });
 * ```
 *
 * @example
 * ```
 *
 * import { addBreadcrumb } from '@sentry/browser';
 * addBreadcrumb({
 *   message: 'My Breadcrumb',
 *   // ...
 * });
 * ```
 *
 * @example
 *
 * ```
 *
 * import * as Sentry from '@sentry/browser';
 * Sentry.captureMessage('Hello, world!');
 * Sentry.captureException(new Error('Good bye'));
 * Sentry.captureEvent({
 *   message: 'Manual',
 *   stacktrace: [
 *     // ...
 *   ],
 * });
 * ```
 *
 * @see {@link BrowserOptions} for documentation on configuration options.
 */ function $0d9a6f47fbfd9f65$export$2cd8252107eb640b(options = {}) {
    if (options.defaultIntegrations === undefined) options.defaultIntegrations = $0d9a6f47fbfd9f65$export$5783b2920b1d62b9();
    if (options.release === undefined) {
        // This allows build tooling to find-and-replace __SENTRY_RELEASE__ to inject a release value
        if (typeof __SENTRY_RELEASE__ === "string") options.release = __SENTRY_RELEASE__;
        // This supports the variable that sentry-webpack-plugin injects
        if ((0, $gY4ad.WINDOW).SENTRY_RELEASE && (0, $gY4ad.WINDOW).SENTRY_RELEASE.id) options.release = (0, $gY4ad.WINDOW).SENTRY_RELEASE.id;
    }
    if (options.autoSessionTracking === undefined) options.autoSessionTracking = true;
    if (options.sendClientReports === undefined) options.sendClientReports = true;
    const clientOptions = {
        ...options,
        stackParser: (0, $9KjXB.stackParserFromStackParserOptions)(options.stackParser || (0, $iNtGt.defaultStackParser)),
        integrations: (0, $dp2Cj.getIntegrationsToSetup)(options),
        transport: options.transport || ((0, $014xT.supportsFetch)() ? (0, $dmB5g.makeFetchTransport) : (0, $6DI64.makeXHRTransport))
    };
    (0, $gEJ4y.initAndBind)((0, $i3WKM.BrowserClient), clientOptions);
    if (options.autoSessionTracking) $0d9a6f47fbfd9f65$var$startSessionTracking();
}
const $0d9a6f47fbfd9f65$export$3a8fd680da42627b = (// eslint-disable-next-line deprecation/deprecation
options = {}, // eslint-disable-next-line deprecation/deprecation
hub = (0, $8XTAO.getCurrentHub)())=>{
    // doesn't work without a document (React Native)
    if (!(0, $gY4ad.WINDOW).document) {
        (0, $23Gvz.DEBUG_BUILD) && (0, $fi7Bg.logger).error("Global document not defined in showReportDialog call");
        return;
    }
    // eslint-disable-next-line deprecation/deprecation
    const { client: client, scope: scope } = hub.getStackTop();
    const dsn = options.dsn || client && client.getDsn();
    if (!dsn) {
        (0, $23Gvz.DEBUG_BUILD) && (0, $fi7Bg.logger).error("DSN not configured for showReportDialog call");
        return;
    }
    if (scope) options.user = {
        ...scope.getUser(),
        ...options.user
    };
    if (!options.eventId) // eslint-disable-next-line deprecation/deprecation
    options.eventId = hub.lastEventId();
    const script = (0, $gY4ad.WINDOW).document.createElement("script");
    script.async = true;
    script.crossOrigin = "anonymous";
    script.src = (0, $5ldEo.getReportDialogEndpoint)(dsn, options);
    if (options.onLoad) script.onload = options.onLoad;
    const { onClose: onClose } = options;
    if (onClose) {
        const reportDialogClosedMessageHandler = (event)=>{
            if (event.data === "__sentry_reportdialog_closed__") try {
                onClose();
            } finally{
                (0, $gY4ad.WINDOW).removeEventListener("message", reportDialogClosedMessageHandler);
            }
        };
        (0, $gY4ad.WINDOW).addEventListener("message", reportDialogClosedMessageHandler);
    }
    const injectionPoint = (0, $gY4ad.WINDOW).document.head || (0, $gY4ad.WINDOW).document.body;
    if (injectionPoint) injectionPoint.appendChild(script);
    else (0, $23Gvz.DEBUG_BUILD) && (0, $fi7Bg.logger).error("Not injecting report dialog. No injection point found in HTML");
};
/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */ function $0d9a6f47fbfd9f65$export$a3f323d81eede727() {
// Noop
}
/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */ function $0d9a6f47fbfd9f65$export$4e4d8b287d028b6b(callback) {
    callback();
}
/**
 * Wrap code within a try/catch block so the SDK is able to capture errors.
 *
 * @deprecated This function will be removed in v8.
 * It is not part of Sentry's official API and it's easily replaceable by using a try/catch block
 * and calling Sentry.captureException.
 *
 * @param fn A function to wrap.
 *
 * @returns The result of wrapped function call.
 */ // TODO(v8): Remove this function
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $0d9a6f47fbfd9f65$export$4997ffc0176396a6(fn) {
    return (0, $gY4ad.wrap)(fn)();
}
/**
 * Enable automatic Session Tracking for the initial page load.
 */ function $0d9a6f47fbfd9f65$var$startSessionTracking() {
    if (typeof (0, $gY4ad.WINDOW).document === "undefined") {
        (0, $23Gvz.DEBUG_BUILD) && (0, $fi7Bg.logger).warn("Session tracking in non-browser environment with @sentry/browser is not supported.");
        return;
    }
    // The session duration for browser sessions does not track a meaningful
    // concept that can be used as a metric.
    // Automatically captured sessions are akin to page views, and thus we
    // discard their duration.
    (0, $9Dess.startSession)({
        ignoreDuration: true
    });
    (0, $9Dess.captureSession)();
    // We want to create a session for every navigation as well
    (0, $iYpob.addHistoryInstrumentationHandler)(({ from: from, to: to })=>{
        // Don't create an additional session for the initial route or if the location did not change
        if (from !== undefined && from !== to) {
            (0, $9Dess.startSession)({
                ignoreDuration: true
            });
            (0, $9Dess.captureSession)();
        }
    });
}
/**
 * Captures user feedback and sends it to Sentry.
 */ function $0d9a6f47fbfd9f65$export$88cefaf72d1e58a3(feedback) {
    const client = (0, $9Dess.getClient)();
    if (client) client.captureUserFeedback(feedback);
}

});
parcelRequire.register("hNldI", function(module, exports) {

$parcel$export(module.exports, "functionToStringIntegration", function () { return $cf47792bbaca42cc$export$7918117e9202e4fb; });

var $eKFW4 = parcelRequire("eKFW4");

var $9Dess = parcelRequire("9Dess");

var $dp2Cj = parcelRequire("dp2Cj");
let $cf47792bbaca42cc$var$originalFunctionToString;
const $cf47792bbaca42cc$var$INTEGRATION_NAME = "FunctionToString";
const $cf47792bbaca42cc$var$SETUP_CLIENTS = new WeakMap();
const $cf47792bbaca42cc$var$_functionToStringIntegration = ()=>{
    return {
        name: $cf47792bbaca42cc$var$INTEGRATION_NAME,
        setupOnce () {
            // eslint-disable-next-line @typescript-eslint/unbound-method
            $cf47792bbaca42cc$var$originalFunctionToString = Function.prototype.toString;
            // intrinsics (like Function.prototype) might be immutable in some environments
            // e.g. Node with --frozen-intrinsics, XS (an embedded JavaScript engine) or SES (a JavaScript proposal)
            try {
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                Function.prototype.toString = function(...args) {
                    const originalFunction = (0, $eKFW4.getOriginalFunction)(this);
                    const context = $cf47792bbaca42cc$var$SETUP_CLIENTS.has((0, $9Dess.getClient)()) && originalFunction !== undefined ? originalFunction : this;
                    return $cf47792bbaca42cc$var$originalFunctionToString.apply(context, args);
                };
            } catch (e) {
            // ignore errors here, just don't patch this
            }
        },
        setup (client) {
            $cf47792bbaca42cc$var$SETUP_CLIENTS.set(client, true);
        }
    };
};
/**
 * Patch toString calls to return proper name for wrapped functions.
 *
 * ```js
 * Sentry.init({
 *   integrations: [
 *     functionToStringIntegration(),
 *   ],
 * });
 * ```
 */ const $cf47792bbaca42cc$export$7918117e9202e4fb = (0, $dp2Cj.defineIntegration)($cf47792bbaca42cc$var$_functionToStringIntegration);
/**
 * Patch toString calls to return proper name for wrapped functions.
 *
 * @deprecated Use `functionToStringIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $cf47792bbaca42cc$export$da4704525c20ae79 = (0, $dp2Cj.convertIntegrationFnToClass)($cf47792bbaca42cc$var$INTEGRATION_NAME, $cf47792bbaca42cc$export$7918117e9202e4fb);

});
parcelRequire.register("dp2Cj", function(module, exports) {

$parcel$export(module.exports, "getIntegrationsToSetup", function () { return $9c1fa3d85d5b2dc1$export$68bc4c01ab8ae766; });
$parcel$export(module.exports, "setupIntegrations", function () { return $9c1fa3d85d5b2dc1$export$51abed9797baa598; });
$parcel$export(module.exports, "setupIntegration", function () { return $9c1fa3d85d5b2dc1$export$e7390a03b70a6f2f; });
$parcel$export(module.exports, "afterSetupIntegrations", function () { return $9c1fa3d85d5b2dc1$export$35abcfd71227c6ca; });
$parcel$export(module.exports, "convertIntegrationFnToClass", function () { return $9c1fa3d85d5b2dc1$export$afa219bf23651160; });
$parcel$export(module.exports, "defineIntegration", function () { return $9c1fa3d85d5b2dc1$export$2323046b9414659f; });

var $gYD4g = parcelRequire("gYD4g");
var $fi7Bg = parcelRequire("fi7Bg");

var $tgF2D = parcelRequire("tgF2D");

var $bP1fJ = parcelRequire("bP1fJ");

var $9Dess = parcelRequire("9Dess");

var $8XTAO = parcelRequire("8XTAO");
const $9c1fa3d85d5b2dc1$export$b14a8888f80a0b3e = [];
/** Map of integrations assigned to a client */ /**
 * Remove duplicates from the given array, preferring the last instance of any duplicate. Not guaranteed to
 * preseve the order of integrations in the array.
 *
 * @private
 */ function $9c1fa3d85d5b2dc1$var$filterDuplicates(integrations) {
    const integrationsByName = {};
    integrations.forEach((currentInstance)=>{
        const { name: name } = currentInstance;
        const existingInstance = integrationsByName[name];
        // We want integrations later in the array to overwrite earlier ones of the same type, except that we never want a
        // default instance to overwrite an existing user instance
        if (existingInstance && !existingInstance.isDefaultInstance && currentInstance.isDefaultInstance) return;
        integrationsByName[name] = currentInstance;
    });
    return Object.keys(integrationsByName).map((k)=>integrationsByName[k]);
}
/** Gets integrations to install */ function $9c1fa3d85d5b2dc1$export$68bc4c01ab8ae766(options) {
    const defaultIntegrations = options.defaultIntegrations || [];
    const userIntegrations = options.integrations;
    // We flag default instances, so that later we can tell them apart from any user-created instances of the same class
    defaultIntegrations.forEach((integration)=>{
        integration.isDefaultInstance = true;
    });
    let integrations;
    if (Array.isArray(userIntegrations)) integrations = [
        ...defaultIntegrations,
        ...userIntegrations
    ];
    else if (typeof userIntegrations === "function") integrations = (0, $gYD4g.arrayify)(userIntegrations(defaultIntegrations));
    else integrations = defaultIntegrations;
    const finalIntegrations = $9c1fa3d85d5b2dc1$var$filterDuplicates(integrations);
    // The `Debug` integration prints copies of the `event` and `hint` which will be passed to `beforeSend` or
    // `beforeSendTransaction`. It therefore has to run after all other integrations, so that the changes of all event
    // processors will be reflected in the printed values. For lack of a more elegant way to guarantee that, we therefore
    // locate it and, assuming it exists, pop it out of its current spot and shove it onto the end of the array.
    const debugIndex = $9c1fa3d85d5b2dc1$var$findIndex(finalIntegrations, (integration)=>integration.name === "Debug");
    if (debugIndex !== -1) {
        const [debugInstance] = finalIntegrations.splice(debugIndex, 1);
        finalIntegrations.push(debugInstance);
    }
    return finalIntegrations;
}
/**
 * Given a list of integration instances this installs them all. When `withDefaults` is set to `true` then all default
 * integrations are added unless they were already provided before.
 * @param integrations array of integration instances
 * @param withDefault should enable default integrations
 */ function $9c1fa3d85d5b2dc1$export$51abed9797baa598(client, integrations) {
    const integrationIndex = {};
    integrations.forEach((integration)=>{
        // guard against empty provided integrations
        if (integration) $9c1fa3d85d5b2dc1$export$e7390a03b70a6f2f(client, integration, integrationIndex);
    });
    return integrationIndex;
}
/**
 * Execute the `afterAllSetup` hooks of the given integrations.
 */ function $9c1fa3d85d5b2dc1$export$35abcfd71227c6ca(client, integrations) {
    for (const integration of integrations)// guard against empty provided integrations
    if (integration && integration.afterAllSetup) integration.afterAllSetup(client);
}
/** Setup a single integration.  */ function $9c1fa3d85d5b2dc1$export$e7390a03b70a6f2f(client, integration, integrationIndex) {
    if (integrationIndex[integration.name]) {
        (0, $tgF2D.DEBUG_BUILD) && (0, $fi7Bg.logger).log(`Integration skipped because it was already installed: ${integration.name}`);
        return;
    }
    integrationIndex[integration.name] = integration;
    // `setupOnce` is only called the first time
    if ($9c1fa3d85d5b2dc1$export$b14a8888f80a0b3e.indexOf(integration.name) === -1) {
        // eslint-disable-next-line deprecation/deprecation
        integration.setupOnce((0, $bP1fJ.addGlobalEventProcessor), (0, $8XTAO.getCurrentHub));
        $9c1fa3d85d5b2dc1$export$b14a8888f80a0b3e.push(integration.name);
    }
    // `setup` is run for each client
    if (integration.setup && typeof integration.setup === "function") integration.setup(client);
    if (client.on && typeof integration.preprocessEvent === "function") {
        const callback = integration.preprocessEvent.bind(integration);
        client.on("preprocessEvent", (event, hint)=>callback(event, hint, client));
    }
    if (client.addEventProcessor && typeof integration.processEvent === "function") {
        const callback = integration.processEvent.bind(integration);
        const processor = Object.assign((event, hint)=>callback(event, hint, client), {
            id: integration.name
        });
        client.addEventProcessor(processor);
    }
    (0, $tgF2D.DEBUG_BUILD) && (0, $fi7Bg.logger).log(`Integration installed: ${integration.name}`);
}
/** Add an integration to the current hub's client. */ function $9c1fa3d85d5b2dc1$export$2d8f5188773bcddd(integration) {
    const client = (0, $9Dess.getClient)();
    if (!client || !client.addIntegration) {
        (0, $tgF2D.DEBUG_BUILD) && (0, $fi7Bg.logger).warn(`Cannot add integration "${integration.name}" because no SDK Client is available.`);
        return;
    }
    client.addIntegration(integration);
}
// Polyfill for Array.findIndex(), which is not supported in ES5
function $9c1fa3d85d5b2dc1$var$findIndex(arr, callback) {
    for(let i = 0; i < arr.length; i++){
        if (callback(arr[i]) === true) return i;
    }
    return -1;
}
/**
 * Convert a new integration function to the legacy class syntax.
 * In v8, we can remove this and instead export the integration functions directly.
 *
 * @deprecated This will be removed in v8!
 */ function $9c1fa3d85d5b2dc1$export$afa219bf23651160(name, fn) {
    return Object.assign(function ConvertedIntegration(...args) {
        return fn(...args);
    }, {
        id: name
    });
}
/**
 * Define an integration function that can be used to create an integration instance.
 * Note that this by design hides the implementation details of the integration, as they are considered internal.
 */ function $9c1fa3d85d5b2dc1$export$2323046b9414659f(fn) {
    return fn;
}

});


parcelRequire.register("5ldEo", function(module, exports) {

$parcel$export(module.exports, "getEnvelopeEndpointWithUrlEncodedAuth", function () { return $3e3980a4470f9bed$export$9964600bfe84e6a3; });
$parcel$export(module.exports, "getReportDialogEndpoint", function () { return $3e3980a4470f9bed$export$671c7ed8e40a7a57; });

var $1B238 = parcelRequire("1B238");
var $eKFW4 = parcelRequire("eKFW4");
const $3e3980a4470f9bed$var$SENTRY_API_VERSION = "7";
/** Returns the prefix to construct Sentry ingestion API endpoints. */ function $3e3980a4470f9bed$var$getBaseApiEndpoint(dsn) {
    const protocol = dsn.protocol ? `${dsn.protocol}:` : "";
    const port = dsn.port ? `:${dsn.port}` : "";
    return `${protocol}//${dsn.host}${port}${dsn.path ? `/${dsn.path}` : ""}/api/`;
}
/** Returns the ingest API endpoint for target. */ function $3e3980a4470f9bed$var$_getIngestEndpoint(dsn) {
    return `${$3e3980a4470f9bed$var$getBaseApiEndpoint(dsn)}${dsn.projectId}/envelope/`;
}
/** Returns a URL-encoded string with auth config suitable for a query string. */ function $3e3980a4470f9bed$var$_encodedAuth(dsn, sdkInfo) {
    return (0, $eKFW4.urlEncode)({
        // We send only the minimum set of required information. See
        // https://github.com/getsentry/sentry-javascript/issues/2572.
        sentry_key: dsn.publicKey,
        sentry_version: $3e3980a4470f9bed$var$SENTRY_API_VERSION,
        ...sdkInfo && {
            sentry_client: `${sdkInfo.name}/${sdkInfo.version}`
        }
    });
}
/**
 * Returns the envelope endpoint URL with auth in the query string.
 *
 * Sending auth as part of the query string and not as custom HTTP headers avoids CORS preflight requests.
 */ function $3e3980a4470f9bed$export$9964600bfe84e6a3(dsn, // TODO (v8): Remove `tunnelOrOptions` in favor of `options`, and use the substitute code below
// options: ClientOptions = {} as ClientOptions,
tunnelOrOptions = {}) {
    // TODO (v8): Use this code instead
    // const { tunnel, _metadata = {} } = options;
    // return tunnel ? tunnel : `${_getIngestEndpoint(dsn)}?${_encodedAuth(dsn, _metadata.sdk)}`;
    const tunnel = typeof tunnelOrOptions === "string" ? tunnelOrOptions : tunnelOrOptions.tunnel;
    const sdkInfo = typeof tunnelOrOptions === "string" || !tunnelOrOptions._metadata ? undefined : tunnelOrOptions._metadata.sdk;
    return tunnel ? tunnel : `${$3e3980a4470f9bed$var$_getIngestEndpoint(dsn)}?${$3e3980a4470f9bed$var$_encodedAuth(dsn, sdkInfo)}`;
}
/** Returns the url to the report dialog endpoint. */ function $3e3980a4470f9bed$export$671c7ed8e40a7a57(dsnLike, dialogOptions) {
    const dsn = (0, $1B238.makeDsn)(dsnLike);
    if (!dsn) return "";
    const endpoint = `${$3e3980a4470f9bed$var$getBaseApiEndpoint(dsn)}embed/error-page/`;
    let encodedOptions = `dsn=${(0, $1B238.dsnToString)(dsn)}`;
    for(const key in dialogOptions){
        if (key === "dsn") continue;
        if (key === "onClose") continue;
        if (key === "user") {
            const user = dialogOptions.user;
            if (!user) continue;
            if (user.name) encodedOptions += `&name=${encodeURIComponent(user.name)}`;
            if (user.email) encodedOptions += `&email=${encodeURIComponent(user.email)}`;
        } else encodedOptions += `&${encodeURIComponent(key)}=${encodeURIComponent(dialogOptions[key])}`;
    }
    return `${endpoint}?${encodedOptions}`;
}

});
parcelRequire.register("1B238", function(module, exports) {

$parcel$export(module.exports, "dsnToString", function () { return $129ad62ba8dd7928$export$44d472fbb931a776; });
$parcel$export(module.exports, "makeDsn", function () { return $129ad62ba8dd7928$export$128827c3562ec0cb; });

var $7qutn = parcelRequire("7qutn");

var $fi7Bg = parcelRequire("fi7Bg");
/** Regular expression used to parse a Dsn. */ const $129ad62ba8dd7928$var$DSN_REGEX = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+)?)?@)([\w.-]+)(?::(\d+))?\/(.+)/;
function $129ad62ba8dd7928$var$isValidProtocol(protocol) {
    return protocol === "http" || protocol === "https";
}
/**
 * Renders the string representation of this Dsn.
 *
 * By default, this will render the public representation without the password
 * component. To get the deprecated private representation, set `withPassword`
 * to true.
 *
 * @param withPassword When set to true, the password will be included.
 */ function $129ad62ba8dd7928$export$44d472fbb931a776(dsn, withPassword = false) {
    const { host: host, path: path, pass: pass, port: port, projectId: projectId, protocol: protocol, publicKey: publicKey } = dsn;
    return `${protocol}://${publicKey}${withPassword && pass ? `:${pass}` : ""}` + `@${host}${port ? `:${port}` : ""}/${path ? `${path}/` : path}${projectId}`;
}
/**
 * Parses a Dsn from a given string.
 *
 * @param str A Dsn as string
 * @returns Dsn as DsnComponents or undefined if @param str is not a valid DSN string
 */ function $129ad62ba8dd7928$export$b892860177f70a30(str) {
    const match = $129ad62ba8dd7928$var$DSN_REGEX.exec(str);
    if (!match) {
        // This should be logged to the console
        (0, $fi7Bg.consoleSandbox)(()=>{
            // eslint-disable-next-line no-console
            console.error(`Invalid Sentry Dsn: ${str}`);
        });
        return undefined;
    }
    const [protocol, publicKey, pass = "", host, port = "", lastPath] = match.slice(1);
    let path = "";
    let projectId = lastPath;
    const split = projectId.split("/");
    if (split.length > 1) {
        path = split.slice(0, -1).join("/");
        projectId = split.pop();
    }
    if (projectId) {
        const projectMatch = projectId.match(/^\d+/);
        if (projectMatch) projectId = projectMatch[0];
    }
    return $129ad62ba8dd7928$var$dsnFromComponents({
        host: host,
        pass: pass,
        path: path,
        projectId: projectId,
        port: port,
        protocol: protocol,
        publicKey: publicKey
    });
}
function $129ad62ba8dd7928$var$dsnFromComponents(components) {
    return {
        protocol: components.protocol,
        publicKey: components.publicKey || "",
        pass: components.pass || "",
        host: components.host,
        port: components.port || "",
        path: components.path || "",
        projectId: components.projectId
    };
}
function $129ad62ba8dd7928$var$validateDsn(dsn) {
    if (!(0, $7qutn.DEBUG_BUILD)) return true;
    const { port: port, projectId: projectId, protocol: protocol } = dsn;
    const requiredComponents = [
        "protocol",
        "publicKey",
        "host",
        "projectId"
    ];
    const hasMissingRequiredComponent = requiredComponents.find((component)=>{
        if (!dsn[component]) {
            (0, $fi7Bg.logger).error(`Invalid Sentry Dsn: ${component} missing`);
            return true;
        }
        return false;
    });
    if (hasMissingRequiredComponent) return false;
    if (!projectId.match(/^\d+$/)) {
        (0, $fi7Bg.logger).error(`Invalid Sentry Dsn: Invalid projectId ${projectId}`);
        return false;
    }
    if (!$129ad62ba8dd7928$var$isValidProtocol(protocol)) {
        (0, $fi7Bg.logger).error(`Invalid Sentry Dsn: Invalid protocol ${protocol}`);
        return false;
    }
    if (port && isNaN(parseInt(port, 10))) {
        (0, $fi7Bg.logger).error(`Invalid Sentry Dsn: Invalid port ${port}`);
        return false;
    }
    return true;
}
/**
 * Creates a valid Sentry Dsn object, identifying a Sentry instance and project.
 * @returns a valid DsnComponents object or `undefined` if @param from is an invalid DSN source
 */ function $129ad62ba8dd7928$export$128827c3562ec0cb(from) {
    const components = typeof from === "string" ? $129ad62ba8dd7928$export$b892860177f70a30(from) : $129ad62ba8dd7928$var$dsnFromComponents(from);
    if (!components || !$129ad62ba8dd7928$var$validateDsn(components)) return undefined;
    return components;
}

});


parcelRequire.register("4ygnq", function(module, exports) {

$parcel$export(module.exports, "inboundFiltersIntegration", function () { return $35070a858945ca8a$export$cb3c5c2ceb9818ba; });

var $gYD4g = parcelRequire("gYD4g");
var $fi7Bg = parcelRequire("fi7Bg");
var $2AO4R = parcelRequire("2AO4R");

var $tgF2D = parcelRequire("tgF2D");

var $dp2Cj = parcelRequire("dp2Cj");
// "Script error." is hard coded into browsers for errors that it can't read.
// this is the result of a script being pulled in from an external domain and CORS.
const $35070a858945ca8a$var$DEFAULT_IGNORE_ERRORS = [
    /^Script error\.?$/,
    /^Javascript error: Script error\.? on line 0$/,
    /^ResizeObserver loop completed with undelivered notifications.$/,
    /^Cannot redefine property: googletag$/
];
const $35070a858945ca8a$var$DEFAULT_IGNORE_TRANSACTIONS = [
    /^.*\/healthcheck$/,
    /^.*\/healthy$/,
    /^.*\/live$/,
    /^.*\/ready$/,
    /^.*\/heartbeat$/,
    /^.*\/health$/,
    /^.*\/healthz$/
];
/** Options for the InboundFilters integration */ const $35070a858945ca8a$var$INTEGRATION_NAME = "InboundFilters";
const $35070a858945ca8a$var$_inboundFiltersIntegration = (options = {})=>{
    return {
        name: $35070a858945ca8a$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        processEvent (event, _hint, client) {
            const clientOptions = client.getOptions();
            const mergedOptions = $35070a858945ca8a$var$_mergeOptions(options, clientOptions);
            return $35070a858945ca8a$var$_shouldDropEvent(event, mergedOptions) ? null : event;
        }
    };
};
const $35070a858945ca8a$export$cb3c5c2ceb9818ba = (0, $dp2Cj.defineIntegration)($35070a858945ca8a$var$_inboundFiltersIntegration);
/**
 * Inbound filters configurable by the user.
 * @deprecated Use `inboundFiltersIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $35070a858945ca8a$export$2ffbb5359dcc6be4 = (0, $dp2Cj.convertIntegrationFnToClass)($35070a858945ca8a$var$INTEGRATION_NAME, $35070a858945ca8a$export$cb3c5c2ceb9818ba);
function $35070a858945ca8a$var$_mergeOptions(internalOptions = {}, clientOptions = {}) {
    return {
        allowUrls: [
            ...internalOptions.allowUrls || [],
            ...clientOptions.allowUrls || []
        ],
        denyUrls: [
            ...internalOptions.denyUrls || [],
            ...clientOptions.denyUrls || []
        ],
        ignoreErrors: [
            ...internalOptions.ignoreErrors || [],
            ...clientOptions.ignoreErrors || [],
            ...internalOptions.disableErrorDefaults ? [] : $35070a858945ca8a$var$DEFAULT_IGNORE_ERRORS
        ],
        ignoreTransactions: [
            ...internalOptions.ignoreTransactions || [],
            ...clientOptions.ignoreTransactions || [],
            ...internalOptions.disableTransactionDefaults ? [] : $35070a858945ca8a$var$DEFAULT_IGNORE_TRANSACTIONS
        ],
        ignoreInternal: internalOptions.ignoreInternal !== undefined ? internalOptions.ignoreInternal : true
    };
}
function $35070a858945ca8a$var$_shouldDropEvent(event, options) {
    if (options.ignoreInternal && $35070a858945ca8a$var$_isSentryError(event)) {
        (0, $tgF2D.DEBUG_BUILD) && (0, $fi7Bg.logger).warn(`Event dropped due to being internal Sentry Error.\nEvent: ${(0, $gYD4g.getEventDescription)(event)}`);
        return true;
    }
    if ($35070a858945ca8a$var$_isIgnoredError(event, options.ignoreErrors)) {
        (0, $tgF2D.DEBUG_BUILD) && (0, $fi7Bg.logger).warn(`Event dropped due to being matched by \`ignoreErrors\` option.\nEvent: ${(0, $gYD4g.getEventDescription)(event)}`);
        return true;
    }
    if ($35070a858945ca8a$var$_isIgnoredTransaction(event, options.ignoreTransactions)) {
        (0, $tgF2D.DEBUG_BUILD) && (0, $fi7Bg.logger).warn(`Event dropped due to being matched by \`ignoreTransactions\` option.\nEvent: ${(0, $gYD4g.getEventDescription)(event)}`);
        return true;
    }
    if ($35070a858945ca8a$var$_isDeniedUrl(event, options.denyUrls)) {
        (0, $tgF2D.DEBUG_BUILD) && (0, $fi7Bg.logger).warn(`Event dropped due to being matched by \`denyUrls\` option.\nEvent: ${(0, $gYD4g.getEventDescription)(event)}.\nUrl: ${$35070a858945ca8a$var$_getEventFilterUrl(event)}`);
        return true;
    }
    if (!$35070a858945ca8a$var$_isAllowedUrl(event, options.allowUrls)) {
        (0, $tgF2D.DEBUG_BUILD) && (0, $fi7Bg.logger).warn(`Event dropped due to not being matched by \`allowUrls\` option.\nEvent: ${(0, $gYD4g.getEventDescription)(event)}.\nUrl: ${$35070a858945ca8a$var$_getEventFilterUrl(event)}`);
        return true;
    }
    return false;
}
function $35070a858945ca8a$var$_isIgnoredError(event, ignoreErrors) {
    // If event.type, this is not an error
    if (event.type || !ignoreErrors || !ignoreErrors.length) return false;
    return $35070a858945ca8a$var$_getPossibleEventMessages(event).some((message)=>(0, $2AO4R.stringMatchesSomePattern)(message, ignoreErrors));
}
function $35070a858945ca8a$var$_isIgnoredTransaction(event, ignoreTransactions) {
    if (event.type !== "transaction" || !ignoreTransactions || !ignoreTransactions.length) return false;
    const name = event.transaction;
    return name ? (0, $2AO4R.stringMatchesSomePattern)(name, ignoreTransactions) : false;
}
function $35070a858945ca8a$var$_isDeniedUrl(event, denyUrls) {
    // TODO: Use Glob instead?
    if (!denyUrls || !denyUrls.length) return false;
    const url = $35070a858945ca8a$var$_getEventFilterUrl(event);
    return !url ? false : (0, $2AO4R.stringMatchesSomePattern)(url, denyUrls);
}
function $35070a858945ca8a$var$_isAllowedUrl(event, allowUrls) {
    // TODO: Use Glob instead?
    if (!allowUrls || !allowUrls.length) return true;
    const url = $35070a858945ca8a$var$_getEventFilterUrl(event);
    return !url ? true : (0, $2AO4R.stringMatchesSomePattern)(url, allowUrls);
}
function $35070a858945ca8a$var$_getPossibleEventMessages(event) {
    const possibleMessages = [];
    if (event.message) possibleMessages.push(event.message);
    let lastException;
    try {
        // @ts-expect-error Try catching to save bundle size
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        lastException = event.exception.values[event.exception.values.length - 1];
    } catch (e) {
    // try catching to save bundle size checking existence of variables
    }
    if (lastException) {
        if (lastException.value) {
            possibleMessages.push(lastException.value);
            if (lastException.type) possibleMessages.push(`${lastException.type}: ${lastException.value}`);
        }
    }
    if ((0, $tgF2D.DEBUG_BUILD) && possibleMessages.length === 0) (0, $fi7Bg.logger).error(`Could not extract message for event ${(0, $gYD4g.getEventDescription)(event)}`);
    return possibleMessages;
}
function $35070a858945ca8a$var$_isSentryError(event) {
    try {
        // @ts-expect-error can't be a sentry error if undefined
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        return event.exception.values[0].type === "SentryError";
    } catch (e) {
    // ignore
    }
    return false;
}
function $35070a858945ca8a$var$_getLastValidUrl(frames = []) {
    for(let i = frames.length - 1; i >= 0; i--){
        const frame = frames[i];
        if (frame && frame.filename !== "<anonymous>" && frame.filename !== "[native code]") return frame.filename || null;
    }
    return null;
}
function $35070a858945ca8a$var$_getEventFilterUrl(event) {
    try {
        let frames;
        try {
            // @ts-expect-error we only care about frames if the whole thing here is defined
            frames = event.exception.values[0].stacktrace.frames;
        } catch (e) {
        // ignore
        }
        return frames ? $35070a858945ca8a$var$_getLastValidUrl(frames) : null;
    } catch (oO) {
        (0, $tgF2D.DEBUG_BUILD) && (0, $fi7Bg.logger).error(`Cannot extract url for event ${(0, $gYD4g.getEventDescription)(event)}`);
        return null;
    }
}

});

parcelRequire.register("gEJ4y", function(module, exports) {

$parcel$export(module.exports, "initAndBind", function () { return $c20358376225d9b7$export$5333c3f1c58d9bc1; });

var $fi7Bg = parcelRequire("fi7Bg");

var $tgF2D = parcelRequire("tgF2D");

var $9Dess = parcelRequire("9Dess");

var $8XTAO = parcelRequire("8XTAO");
/** A class object that can instantiate Client objects. */ /**
 * Internal function to create a new SDK client instance. The client is
 * installed and then bound to the current scope.
 *
 * @param clientClass The client class to instantiate.
 * @param options Options to pass to the client.
 */ function $c20358376225d9b7$export$5333c3f1c58d9bc1(clientClass, options) {
    if (options.debug === true) {
        if (0, $tgF2D.DEBUG_BUILD) (0, $fi7Bg.logger).enable();
        else // use `console.warn` rather than `logger.warn` since by non-debug bundles have all `logger.x` statements stripped
        (0, $fi7Bg.consoleSandbox)(()=>{
            // eslint-disable-next-line no-console
            console.warn("[Sentry] Cannot initialize SDK with `debug` option using a non-debug bundle.");
        });
    }
    const scope = (0, $9Dess.getCurrentScope)();
    scope.update(options.initialScope);
    const client = new clientClass(options);
    $c20358376225d9b7$export$ecb76f41d43c0e43(client);
    $c20358376225d9b7$var$initializeClient(client);
}
/**
 * Make the given client the current client.
 */ function $c20358376225d9b7$export$ecb76f41d43c0e43(client) {
    // eslint-disable-next-line deprecation/deprecation
    const hub = (0, $8XTAO.getCurrentHub)();
    // eslint-disable-next-line deprecation/deprecation
    const top = hub.getStackTop();
    top.client = client;
    top.scope.setClient(client);
}
/**
 * Initialize the client for the current scope.
 * Make sure to call this after `setCurrentClient()`.
 */ function $c20358376225d9b7$var$initializeClient(client) {
    if (client.init) client.init();
    else if (client.setupIntegrations) // eslint-disable-next-line deprecation/deprecation
    client.setupIntegrations();
}

});

parcelRequire.register("iYpob", function(module, exports) {

$parcel$export(module.exports, "addHistoryInstrumentationHandler", function () { return $dd018655eeb85e29$export$3f18c56c58114e75; });

var $eKFW4 = parcelRequire("eKFW4");



var $hi0PN = parcelRequire("hi0PN");

var $4Laog = parcelRequire("4Laog");

var $aLlYl = parcelRequire("aLlYl");
const $dd018655eeb85e29$var$WINDOW = (0, $hi0PN.GLOBAL_OBJ);
let $dd018655eeb85e29$var$lastHref;
/**
 * Add an instrumentation handler for when a fetch request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $dd018655eeb85e29$export$3f18c56c58114e75(handler) {
    const type = "history";
    (0, $aLlYl.addHandler)(type, handler);
    (0, $aLlYl.maybeInstrument)(type, $dd018655eeb85e29$var$instrumentHistory);
}
function $dd018655eeb85e29$var$instrumentHistory() {
    if (!(0, $4Laog.supportsHistory)()) return;
    const oldOnPopState = $dd018655eeb85e29$var$WINDOW.onpopstate;
    $dd018655eeb85e29$var$WINDOW.onpopstate = function(...args) {
        const to = $dd018655eeb85e29$var$WINDOW.location.href;
        // keep track of the current URL state, as we always receive only the updated state
        const from = $dd018655eeb85e29$var$lastHref;
        $dd018655eeb85e29$var$lastHref = to;
        const handlerData = {
            from: from,
            to: to
        };
        (0, $aLlYl.triggerHandlers)("history", handlerData);
        if (oldOnPopState) // Apparently this can throw in Firefox when incorrectly implemented plugin is installed.
        // https://github.com/getsentry/sentry-javascript/issues/3344
        // https://github.com/bugsnag/bugsnag-js/issues/469
        try {
            return oldOnPopState.apply(this, args);
        } catch (_oO) {
        // no-empty
        }
    };
    function historyReplacementFunction(originalHistoryFunction) {
        return function(...args) {
            const url = args.length > 2 ? args[2] : undefined;
            if (url) {
                // coerce to string (this is what pushState does)
                const from = $dd018655eeb85e29$var$lastHref;
                const to = String(url);
                // keep track of the current URL state, as we always receive only the updated state
                $dd018655eeb85e29$var$lastHref = to;
                const handlerData = {
                    from: from,
                    to: to
                };
                (0, $aLlYl.triggerHandlers)("history", handlerData);
            }
            return originalHistoryFunction.apply(this, args);
        };
    }
    (0, $eKFW4.fill)($dd018655eeb85e29$var$WINDOW.history, "pushState", historyReplacementFunction);
    (0, $eKFW4.fill)($dd018655eeb85e29$var$WINDOW.history, "replaceState", historyReplacementFunction);
}

});
parcelRequire.register("4Laog", function(module, exports) {

$parcel$export(module.exports, "supportsHistory", function () { return $37739c81b8fe4198$export$67fc34576016d6ec; });

var $hi0PN = parcelRequire("hi0PN");
// Based on https://github.com/angular/angular.js/pull/13945/files
// eslint-disable-next-line deprecation/deprecation
const $37739c81b8fe4198$var$WINDOW = (0, $hi0PN.getGlobalObject)();
/**
 * Tells whether current environment supports History API
 * {@link supportsHistory}.
 *
 * @returns Answer to the given question.
 */ function $37739c81b8fe4198$export$67fc34576016d6ec() {
    // NOTE: in Chrome App environment, touching history.pushState, *even inside
    //       a try/catch block*, will cause Chrome to output an error to console.error
    // borrowed from: https://github.com/angular/angular.js/pull/13945/files
    /* eslint-disable @typescript-eslint/no-unsafe-member-access */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const chromeVar = $37739c81b8fe4198$var$WINDOW.chrome;
    const isChromePackagedApp = chromeVar && chromeVar.app && chromeVar.app.runtime;
    /* eslint-enable @typescript-eslint/no-unsafe-member-access */ const hasHistoryApi = "history" in $37739c81b8fe4198$var$WINDOW && !!$37739c81b8fe4198$var$WINDOW.history.pushState && !!$37739c81b8fe4198$var$WINDOW.history.replaceState;
    return !isChromePackagedApp && hasHistoryApi;
}

});

parcelRequire.register("aLlYl", function(module, exports) {

$parcel$export(module.exports, "addHandler", function () { return $7d5f566ea86eff2d$export$a4e09611e30da72e; });
$parcel$export(module.exports, "maybeInstrument", function () { return $7d5f566ea86eff2d$export$e18d6c5462c01368; });
$parcel$export(module.exports, "triggerHandlers", function () { return $7d5f566ea86eff2d$export$b18c893e424d3127; });

var $7qutn = parcelRequire("7qutn");

var $fi7Bg = parcelRequire("fi7Bg");

var $9KjXB = parcelRequire("9KjXB");
// We keep the handlers globally
const $7d5f566ea86eff2d$var$handlers = {};
const $7d5f566ea86eff2d$var$instrumented = {};
/** Add a handler function. */ function $7d5f566ea86eff2d$export$a4e09611e30da72e(type, handler) {
    $7d5f566ea86eff2d$var$handlers[type] = $7d5f566ea86eff2d$var$handlers[type] || [];
    $7d5f566ea86eff2d$var$handlers[type].push(handler);
}
/**
 * Reset all instrumentation handlers.
 * This can be used by tests to ensure we have a clean slate of instrumentation handlers.
 */ function $7d5f566ea86eff2d$export$b17eab759a1cb5fe() {
    Object.keys($7d5f566ea86eff2d$var$handlers).forEach((key)=>{
        $7d5f566ea86eff2d$var$handlers[key] = undefined;
    });
}
/** Maybe run an instrumentation function, unless it was already called. */ function $7d5f566ea86eff2d$export$e18d6c5462c01368(type, instrumentFn) {
    if (!$7d5f566ea86eff2d$var$instrumented[type]) {
        instrumentFn();
        $7d5f566ea86eff2d$var$instrumented[type] = true;
    }
}
/** Trigger handlers for a given instrumentation type. */ function $7d5f566ea86eff2d$export$b18c893e424d3127(type, data) {
    const typeHandlers = type && $7d5f566ea86eff2d$var$handlers[type];
    if (!typeHandlers) return;
    for (const handler of typeHandlers)try {
        handler(data);
    } catch (e) {
        (0, $7qutn.DEBUG_BUILD) && (0, $fi7Bg.logger).error(`Error while triggering instrumentation handler.\nType: ${type}\nName: ${(0, $9KjXB.getFunctionName)(handler)}\nError:`, e);
    }
}

});


parcelRequire.register("014xT", function(module, exports) {

$parcel$export(module.exports, "supportsFetch", function () { return $00339eccd17a6d9b$export$edf3cb81fd7d2a3e; });
$parcel$export(module.exports, "isNativeFetch", function () { return $00339eccd17a6d9b$export$18cf36ed71d733e7; });
$parcel$export(module.exports, "supportsNativeFetch", function () { return $00339eccd17a6d9b$export$c82d238e23c40b21; });

var $7qutn = parcelRequire("7qutn");

var $fi7Bg = parcelRequire("fi7Bg");

var $hi0PN = parcelRequire("hi0PN");
// eslint-disable-next-line deprecation/deprecation
const $00339eccd17a6d9b$var$WINDOW = (0, $hi0PN.getGlobalObject)();
/**
 * Tells whether current environment supports ErrorEvent objects
 * {@link supportsErrorEvent}.
 *
 * @returns Answer to the given question.
 */ function $00339eccd17a6d9b$export$caa710b4d7f9cadf() {
    try {
        new ErrorEvent("");
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMError objects
 * {@link supportsDOMError}.
 *
 * @returns Answer to the given question.
 */ function $00339eccd17a6d9b$export$1c08bd1a7eb3c472() {
    try {
        // Chrome: VM89:1 Uncaught TypeError: Failed to construct 'DOMError':
        // 1 argument required, but only 0 present.
        // @ts-expect-error It really needs 1 argument, not 0.
        new DOMError("");
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMException objects
 * {@link supportsDOMException}.
 *
 * @returns Answer to the given question.
 */ function $00339eccd17a6d9b$export$ab12a5d056f1d3a() {
    try {
        new DOMException("");
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports Fetch API
 * {@link supportsFetch}.
 *
 * @returns Answer to the given question.
 */ function $00339eccd17a6d9b$export$edf3cb81fd7d2a3e() {
    if (!("fetch" in $00339eccd17a6d9b$var$WINDOW)) return false;
    try {
        new Headers();
        new Request("http://www.example.com");
        new Response();
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * isNativeFetch checks if the given function is a native implementation of fetch()
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function $00339eccd17a6d9b$export$18cf36ed71d733e7(func) {
    return func && /^function fetch\(\)\s+\{\s+\[native code\]\s+\}$/.test(func.toString());
}
/**
 * Tells whether current environment supports Fetch API natively
 * {@link supportsNativeFetch}.
 *
 * @returns true if `window.fetch` is natively implemented, false otherwise
 */ function $00339eccd17a6d9b$export$c82d238e23c40b21() {
    if (typeof EdgeRuntime === "string") return true;
    if (!$00339eccd17a6d9b$export$edf3cb81fd7d2a3e()) return false;
    // Fast path to avoid DOM I/O
    // eslint-disable-next-line @typescript-eslint/unbound-method
    if ($00339eccd17a6d9b$export$18cf36ed71d733e7($00339eccd17a6d9b$var$WINDOW.fetch)) return true;
    // window.fetch is implemented, but is polyfilled or already wrapped (e.g: by a chrome extension)
    // so create a "pure" iframe to see if that has native fetch
    let result = false;
    const doc = $00339eccd17a6d9b$var$WINDOW.document;
    // eslint-disable-next-line deprecation/deprecation
    if (doc && typeof doc.createElement === "function") try {
        const sandbox = doc.createElement("iframe");
        sandbox.hidden = true;
        doc.head.appendChild(sandbox);
        if (sandbox.contentWindow && sandbox.contentWindow.fetch) // eslint-disable-next-line @typescript-eslint/unbound-method
        result = $00339eccd17a6d9b$export$18cf36ed71d733e7(sandbox.contentWindow.fetch);
        doc.head.removeChild(sandbox);
    } catch (err) {
        (0, $7qutn.DEBUG_BUILD) && (0, $fi7Bg.logger).warn("Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ", err);
    }
    return result;
}
/**
 * Tells whether current environment supports ReportingObserver API
 * {@link supportsReportingObserver}.
 *
 * @returns Answer to the given question.
 */ function $00339eccd17a6d9b$export$531055a6c684a70a() {
    return "ReportingObserver" in $00339eccd17a6d9b$var$WINDOW;
}
/**
 * Tells whether current environment supports Referrer Policy API
 * {@link supportsReferrerPolicy}.
 *
 * @returns Answer to the given question.
 */ function $00339eccd17a6d9b$export$2d308b428295192f() {
    // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default'
    // (see https://caniuse.com/#feat=referrer-policy),
    // it doesn't. And it throws an exception instead of ignoring this parameter...
    // REF: https://github.com/getsentry/raven-js/issues/1233
    if (!$00339eccd17a6d9b$export$edf3cb81fd7d2a3e()) return false;
    try {
        new Request("_", {
            referrerPolicy: "origin"
        });
        return true;
    } catch (e) {
        return false;
    }
}

});

parcelRequire.register("i3WKM", function(module, exports) {

$parcel$export(module.exports, "BrowserClient", function () { return $d2661504bc45face$export$1df9218a526d318d; });

var $iBytQ = parcelRequire("iBytQ");
var $8M0xx = parcelRequire("8M0xx");

var $5w23n = parcelRequire("5w23n");
var $1B238 = parcelRequire("1B238");
var $3sPJl = parcelRequire("3sPJl");
var $fi7Bg = parcelRequire("fi7Bg");

var $23Gvz = parcelRequire("23Gvz");

var $kH7dV = parcelRequire("kH7dV");

var $gY4ad = parcelRequire("gY4ad");

var $dYndw = parcelRequire("dYndw");
/**
 * Configuration options for the Sentry Browser SDK.
 * @see @sentry/types Options for more information.
 */ /**
 * The Sentry Browser SDK Client.
 *
 * @see BrowserOptions for documentation on configuration options.
 * @see SentryClient for usage documentation.
 */ class $d2661504bc45face$export$1df9218a526d318d extends (0, $8M0xx.BaseClient) {
    /**
   * Creates a new Browser SDK instance.
   *
   * @param options Configuration options for this SDK.
   */ constructor(options){
        const sdkSource = (0, $gY4ad.WINDOW).SENTRY_SDK_SOURCE || (0, $3sPJl.getSDKSource)();
        (0, $iBytQ.applySdkMetadata)(options, "browser", [
            "browser"
        ], sdkSource);
        super(options);
        if (options.sendClientReports && (0, $gY4ad.WINDOW).document) (0, $gY4ad.WINDOW).document.addEventListener("visibilitychange", ()=>{
            if ((0, $gY4ad.WINDOW).document.visibilityState === "hidden") this._flushOutcomes();
        });
    }
    /**
   * @inheritDoc
   */ eventFromException(exception, hint) {
        return (0, $kH7dV.eventFromException)(this._options.stackParser, exception, hint, this._options.attachStacktrace);
    }
    /**
   * @inheritDoc
   */ eventFromMessage(message, // eslint-disable-next-line deprecation/deprecation
    level = "info", hint) {
        return (0, $kH7dV.eventFromMessage)(this._options.stackParser, message, level, hint, this._options.attachStacktrace);
    }
    /**
   * Sends user feedback to Sentry.
   */ captureUserFeedback(feedback) {
        if (!this._isEnabled()) {
            (0, $23Gvz.DEBUG_BUILD) && (0, $fi7Bg.logger).warn("SDK not enabled, will not capture user feedback.");
            return;
        }
        const envelope = (0, $dYndw.createUserFeedbackEnvelope)(feedback, {
            metadata: this.getSdkMetadata(),
            dsn: this.getDsn(),
            tunnel: this.getOptions().tunnel
        });
        // _sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this._sendEnvelope(envelope);
    }
    /**
   * @inheritDoc
   */ _prepareEvent(event, hint, scope) {
        event.platform = event.platform || "javascript";
        return super._prepareEvent(event, hint, scope);
    }
    /**
   * Sends client reports as an envelope.
   */ _flushOutcomes() {
        const outcomes = this._clearOutcomes();
        if (outcomes.length === 0) {
            (0, $23Gvz.DEBUG_BUILD) && (0, $fi7Bg.logger).log("No outcomes to send");
            return;
        }
        // This is really the only place where we want to check for a DSN and only send outcomes then
        if (!this._dsn) {
            (0, $23Gvz.DEBUG_BUILD) && (0, $fi7Bg.logger).log("No dsn provided, will not send outcomes");
            return;
        }
        (0, $23Gvz.DEBUG_BUILD) && (0, $fi7Bg.logger).log("Sending outcomes:", outcomes);
        const envelope = (0, $5w23n.createClientReportEnvelope)(outcomes, this._options.tunnel && (0, $1B238.dsnToString)(this._dsn));
        // _sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this._sendEnvelope(envelope);
    }
}

});
parcelRequire.register("iBytQ", function(module, exports) {

$parcel$export(module.exports, "applySdkMetadata", function () { return $d8b66dc4d1b10356$export$b9f95b027256052c; });

var $lFUnc = parcelRequire("lFUnc");
/**
 * A builder for the SDK metadata in the options for the SDK initialization.
 *
 * Note: This function is identical to `buildMetadata` in Remix and NextJS and SvelteKit.
 * We don't extract it for bundle size reasons.
 * @see https://github.com/getsentry/sentry-javascript/pull/7404
 * @see https://github.com/getsentry/sentry-javascript/pull/4196
 *
 * If you make changes to this function consider updating the others as well.
 *
 * @param options SDK options object that gets mutated
 * @param names list of package names
 */ function $d8b66dc4d1b10356$export$b9f95b027256052c(options, name, names = [
    name
], source = "npm") {
    const metadata = options._metadata || {};
    if (!metadata.sdk) metadata.sdk = {
        name: `sentry.javascript.${name}`,
        packages: names.map((name)=>({
                name: `${source}:@sentry/${name}`,
                version: (0, $lFUnc.SDK_VERSION)
            })),
        version: (0, $lFUnc.SDK_VERSION)
    };
    options._metadata = metadata;
}

});

parcelRequire.register("8M0xx", function(module, exports) {

$parcel$export(module.exports, "BaseClient", function () { return $663339a60a8ed15e$export$4f22f74eddb7716a; });

var $ctxTY = parcelRequire("ctxTY");
var $gYD4g = parcelRequire("gYD4g");
var $5lwZa = parcelRequire("5lwZa");
var $fi7Bg = parcelRequire("fi7Bg");
var $1B238 = parcelRequire("1B238");
var $1sCez = parcelRequire("1sCez");
var $4B0oq = parcelRequire("4B0oq");

var $5ldEo = parcelRequire("5ldEo");

var $tgF2D = parcelRequire("tgF2D");

var $7Fg0B = parcelRequire("7Fg0B");

var $9Dess = parcelRequire("9Dess");

var $8XTAO = parcelRequire("8XTAO");

var $dp2Cj = parcelRequire("dp2Cj");

var $jgG0D = parcelRequire("jgG0D");

var $a6smX = parcelRequire("a6smX");

var $1amGz = parcelRequire("1amGz");

var $dW8zo = parcelRequire("dW8zo");
const $663339a60a8ed15e$var$ALREADY_SEEN_ERROR = "Not capturing exception because it's already been captured.";
/**
 * Base implementation for all JavaScript SDK clients.
 *
 * Call the constructor with the corresponding options
 * specific to the client subclass. To access these options later, use
 * {@link Client.getOptions}.
 *
 * If a Dsn is specified in the options, it will be parsed and stored. Use
 * {@link Client.getDsn} to retrieve the Dsn at any moment. In case the Dsn is
 * invalid, the constructor will throw a {@link SentryException}. Note that
 * without a valid Dsn, the SDK will not send any events to Sentry.
 *
 * Before sending an event, it is passed through
 * {@link BaseClient._prepareEvent} to add SDK information and scope data
 * (breadcrumbs and context). To add more custom information, override this
 * method and extend the resulting prepared event.
 *
 * To issue automatically created events (e.g. via instrumentation), use
 * {@link Client.captureEvent}. It will prepare the event and pass it through
 * the callback lifecycle. To issue auto-breadcrumbs, use
 * {@link Client.addBreadcrumb}.
 *
 * @example
 * class NodeClient extends BaseClient<NodeOptions> {
 *   public constructor(options: NodeOptions) {
 *     super(options);
 *   }
 *
 *   // ...
 * }
 */ class $663339a60a8ed15e$export$4f22f74eddb7716a {
    /**
   * A reference to a metrics aggregator
   *
   * @experimental Note this is alpha API. It may experience breaking changes in the future.
   */ /** Options passed to the SDK. */ /** The client Dsn, if specified in options. Without this Dsn, the SDK will be disabled. */ /** Array of set up integrations. */ /** Indicates whether this client's integrations have been set up. */ /** Number of calls being processed */ /** Holds flushable  */ // eslint-disable-next-line @typescript-eslint/ban-types
    /**
   * Initializes this client instance.
   *
   * @param options Options for the client.
   */ constructor(options){
        this._options = options;
        this._integrations = {};
        this._integrationsInitialized = false;
        this._numProcessing = 0;
        this._outcomes = {};
        this._hooks = {};
        this._eventProcessors = [];
        if (options.dsn) this._dsn = (0, $1B238.makeDsn)(options.dsn);
        else (0, $tgF2D.DEBUG_BUILD) && (0, $fi7Bg.logger).warn("No DSN provided, client will not send events.");
        if (this._dsn) {
            const url = (0, $5ldEo.getEnvelopeEndpointWithUrlEncodedAuth)(this._dsn, options);
            this._transport = options.transport({
                tunnel: this._options.tunnel,
                recordDroppedEvent: this.recordDroppedEvent.bind(this),
                ...options.transportOptions,
                url: url
            });
        }
    }
    /**
   * @inheritDoc
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
    captureException(exception, hint, scope) {
        // ensure we haven't captured this very object before
        if ((0, $gYD4g.checkOrSetAlreadyCaught)(exception)) {
            (0, $tgF2D.DEBUG_BUILD) && (0, $fi7Bg.logger).log($663339a60a8ed15e$var$ALREADY_SEEN_ERROR);
            return;
        }
        let eventId = hint && hint.event_id;
        this._process(this.eventFromException(exception, hint).then((event)=>this._captureEvent(event, hint, scope)).then((result)=>{
            eventId = result;
        }));
        return eventId;
    }
    /**
   * @inheritDoc
   */ captureMessage(message, // eslint-disable-next-line deprecation/deprecation
    level, hint, scope) {
        let eventId = hint && hint.event_id;
        const eventMessage = (0, $5lwZa.isParameterizedString)(message) ? message : String(message);
        const promisedEvent = (0, $5lwZa.isPrimitive)(message) ? this.eventFromMessage(eventMessage, level, hint) : this.eventFromException(message, hint);
        this._process(promisedEvent.then((event)=>this._captureEvent(event, hint, scope)).then((result)=>{
            eventId = result;
        }));
        return eventId;
    }
    /**
   * @inheritDoc
   */ captureEvent(event, hint, scope) {
        // ensure we haven't captured this very object before
        if (hint && hint.originalException && (0, $gYD4g.checkOrSetAlreadyCaught)(hint.originalException)) {
            (0, $tgF2D.DEBUG_BUILD) && (0, $fi7Bg.logger).log($663339a60a8ed15e$var$ALREADY_SEEN_ERROR);
            return;
        }
        let eventId = hint && hint.event_id;
        const sdkProcessingMetadata = event.sdkProcessingMetadata || {};
        const capturedSpanScope = sdkProcessingMetadata.capturedSpanScope;
        this._process(this._captureEvent(event, hint, capturedSpanScope || scope).then((result)=>{
            eventId = result;
        }));
        return eventId;
    }
    /**
   * @inheritDoc
   */ captureSession(session) {
        if (!(typeof session.release === "string")) (0, $tgF2D.DEBUG_BUILD) && (0, $fi7Bg.logger).warn("Discarded session because of missing or non-string release");
        else {
            this.sendSession(session);
            // After sending, we set init false to indicate it's not the first occurrence
            (0, $a6smX.updateSession)(session, {
                init: false
            });
        }
    }
    /**
   * @inheritDoc
   */ getDsn() {
        return this._dsn;
    }
    /**
   * @inheritDoc
   */ getOptions() {
        return this._options;
    }
    /**
   * @see SdkMetadata in @sentry/types
   *
   * @return The metadata of the SDK
   */ getSdkMetadata() {
        return this._options._metadata;
    }
    /**
   * @inheritDoc
   */ getTransport() {
        return this._transport;
    }
    /**
   * @inheritDoc
   */ flush(timeout) {
        const transport = this._transport;
        if (transport) {
            if (this.metricsAggregator) this.metricsAggregator.flush();
            return this._isClientDoneProcessing(timeout).then((clientFinished)=>{
                return transport.flush(timeout).then((transportFlushed)=>clientFinished && transportFlushed);
            });
        } else return (0, $1sCez.resolvedSyncPromise)(true);
    }
    /**
   * @inheritDoc
   */ close(timeout) {
        return this.flush(timeout).then((result)=>{
            this.getOptions().enabled = false;
            if (this.metricsAggregator) this.metricsAggregator.close();
            return result;
        });
    }
    /** Get all installed event processors. */ getEventProcessors() {
        return this._eventProcessors;
    }
    /** @inheritDoc */ addEventProcessor(eventProcessor) {
        this._eventProcessors.push(eventProcessor);
    }
    /**
   * This is an internal function to setup all integrations that should run on the client.
   * @deprecated Use `client.init()` instead.
   */ setupIntegrations(forceInitialize) {
        if (forceInitialize && !this._integrationsInitialized || this._isEnabled() && !this._integrationsInitialized) this._setupIntegrations();
    }
    /** @inheritdoc */ init() {
        if (this._isEnabled()) this._setupIntegrations();
    }
    /**
   * Gets an installed integration by its `id`.
   *
   * @returns The installed integration or `undefined` if no integration with that `id` was installed.
   * @deprecated Use `getIntegrationByName()` instead.
   */ getIntegrationById(integrationId) {
        return this.getIntegrationByName(integrationId);
    }
    /**
   * Gets an installed integration by its name.
   *
   * @returns The installed integration or `undefined` if no integration with that `name` was installed.
   */ getIntegrationByName(integrationName) {
        return this._integrations[integrationName];
    }
    /**
   * Returns the client's instance of the given integration class, it any.
   * @deprecated Use `getIntegrationByName()` instead.
   */ getIntegration(integration) {
        try {
            return this._integrations[integration.id] || null;
        } catch (_oO) {
            (0, $tgF2D.DEBUG_BUILD) && (0, $fi7Bg.logger).warn(`Cannot retrieve integration ${integration.id} from the current Client`);
            return null;
        }
    }
    /**
   * @inheritDoc
   */ addIntegration(integration) {
        const isAlreadyInstalled = this._integrations[integration.name];
        // This hook takes care of only installing if not already installed
        (0, $dp2Cj.setupIntegration)(this, integration, this._integrations);
        // Here we need to check manually to make sure to not run this multiple times
        if (!isAlreadyInstalled) (0, $dp2Cj.afterSetupIntegrations)(this, [
            integration
        ]);
    }
    /**
   * @inheritDoc
   */ sendEvent(event, hint = {}) {
        this.emit("beforeSendEvent", event, hint);
        let env = (0, $7Fg0B.createEventEnvelope)(event, this._dsn, this._options._metadata, this._options.tunnel);
        for (const attachment of hint.attachments || [])env = (0, $ctxTY.addItemToEnvelope)(env, (0, $ctxTY.createAttachmentEnvelopeItem)(attachment, this._options.transportOptions && this._options.transportOptions.textEncoder));
        const promise = this._sendEnvelope(env);
        if (promise) promise.then((sendResponse)=>this.emit("afterSendEvent", event, sendResponse), null);
    }
    /**
   * @inheritDoc
   */ sendSession(session) {
        const env = (0, $7Fg0B.createSessionEnvelope)(session, this._dsn, this._options._metadata, this._options.tunnel);
        // _sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this._sendEnvelope(env);
    }
    /**
   * @inheritDoc
   */ recordDroppedEvent(reason, category, eventOrCount) {
        if (this._options.sendClientReports) {
            // TODO v9: We do not need the `event` passed as third argument anymore, and can possibly remove this overload
            // If event is passed as third argument, we assume this is a count of 1
            const count = typeof eventOrCount === "number" ? eventOrCount : 1;
            // We want to track each category (error, transaction, session, replay_event) separately
            // but still keep the distinction between different type of outcomes.
            // We could use nested maps, but it's much easier to read and type this way.
            // A correct type for map-based implementation if we want to go that route
            // would be `Partial<Record<SentryRequestType, Partial<Record<Outcome, number>>>>`
            // With typescript 4.1 we could even use template literal types
            const key = `${reason}:${category}`;
            (0, $tgF2D.DEBUG_BUILD) && (0, $fi7Bg.logger).log(`Recording outcome: "${key}"${count > 1 ? ` (${count} times)` : ""}`);
            this._outcomes[key] = (this._outcomes[key] || 0) + count;
        }
    }
    /**
   * @inheritDoc
   */ captureAggregateMetrics(metricBucketItems) {
        (0, $tgF2D.DEBUG_BUILD) && (0, $fi7Bg.logger).log(`Flushing aggregated metrics, number of metrics: ${metricBucketItems.length}`);
        const metricsEnvelope = (0, $jgG0D.createMetricEnvelope)(metricBucketItems, this._dsn, this._options._metadata, this._options.tunnel);
        // _sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this._sendEnvelope(metricsEnvelope);
    }
    // Keep on() & emit() signatures in sync with types' client.ts interface
    /* eslint-disable @typescript-eslint/unified-signatures */ /** @inheritdoc */ /** @inheritdoc */ on(hook, callback) {
        if (!this._hooks[hook]) this._hooks[hook] = [];
        // @ts-expect-error We assue the types are correct
        this._hooks[hook].push(callback);
    }
    /** @inheritdoc */ /** @inheritdoc */ emit(hook, ...rest) {
        if (this._hooks[hook]) this._hooks[hook].forEach((callback)=>callback(...rest));
    }
    /* eslint-enable @typescript-eslint/unified-signatures */ /** Setup integrations for this client. */ _setupIntegrations() {
        const { integrations: integrations } = this._options;
        this._integrations = (0, $dp2Cj.setupIntegrations)(this, integrations);
        (0, $dp2Cj.afterSetupIntegrations)(this, integrations);
        // TODO v8: We don't need this flag anymore
        this._integrationsInitialized = true;
    }
    /** Updates existing session based on the provided event */ _updateSessionFromEvent(session, event) {
        let crashed = false;
        let errored = false;
        const exceptions = event.exception && event.exception.values;
        if (exceptions) {
            errored = true;
            for (const ex of exceptions){
                const mechanism = ex.mechanism;
                if (mechanism && mechanism.handled === false) {
                    crashed = true;
                    break;
                }
            }
        }
        // A session is updated and that session update is sent in only one of the two following scenarios:
        // 1. Session with non terminal status and 0 errors + an error occurred -> Will set error count to 1 and send update
        // 2. Session with non terminal status and 1 error + a crash occurred -> Will set status crashed and send update
        const sessionNonTerminal = session.status === "ok";
        const shouldUpdateAndSend = sessionNonTerminal && session.errors === 0 || sessionNonTerminal && crashed;
        if (shouldUpdateAndSend) {
            (0, $a6smX.updateSession)(session, {
                ...crashed && {
                    status: "crashed"
                },
                errors: session.errors || Number(errored || crashed)
            });
            this.captureSession(session);
        }
    }
    /**
   * Determine if the client is finished processing. Returns a promise because it will wait `timeout` ms before saying
   * "no" (resolving to `false`) in order to give the client a chance to potentially finish first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the client is still busy. Passing `0` (or not
   * passing anything) will make the promise wait as long as it takes for processing to finish before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if processing is already done or finishes before the timeout, and
   * `false` otherwise
   */ _isClientDoneProcessing(timeout) {
        return new (0, $1sCez.SyncPromise)((resolve)=>{
            let ticked = 0;
            const tick = 1;
            const interval = setInterval(()=>{
                if (this._numProcessing == 0) {
                    clearInterval(interval);
                    resolve(true);
                } else {
                    ticked += tick;
                    if (timeout && ticked >= timeout) {
                        clearInterval(interval);
                        resolve(false);
                    }
                }
            }, tick);
        });
    }
    /** Determines whether this SDK is enabled and a transport is present. */ _isEnabled() {
        return this.getOptions().enabled !== false && this._transport !== undefined;
    }
    /**
   * Adds common information to events.
   *
   * The information includes release and environment from `options`,
   * breadcrumbs and context (extra, tags and user) from the scope.
   *
   * Information that is already present in the event is never overwritten. For
   * nested objects, such as the context, keys are merged.
   *
   * @param event The original event.
   * @param hint May contain additional information about the original exception.
   * @param scope A scope containing event metadata.
   * @returns A new event with more information.
   */ _prepareEvent(event, hint, scope, isolationScope = (0, $8XTAO.getIsolationScope)()) {
        const options = this.getOptions();
        const integrations = Object.keys(this._integrations);
        if (!hint.integrations && integrations.length > 0) hint.integrations = integrations;
        this.emit("preprocessEvent", event, hint);
        return (0, $dW8zo.prepareEvent)(options, event, hint, scope, this, isolationScope).then((evt)=>{
            if (evt === null) return evt;
            const propagationContext = {
                ...isolationScope.getPropagationContext(),
                ...scope ? scope.getPropagationContext() : undefined
            };
            const trace = evt.contexts && evt.contexts.trace;
            if (!trace && propagationContext) {
                const { traceId: trace_id, spanId: spanId, parentSpanId: parentSpanId, dsc: dsc } = propagationContext;
                evt.contexts = {
                    trace: {
                        trace_id: trace_id,
                        span_id: spanId,
                        parent_span_id: parentSpanId
                    },
                    ...evt.contexts
                };
                const dynamicSamplingContext = dsc ? dsc : (0, $1amGz.getDynamicSamplingContextFromClient)(trace_id, this, scope);
                evt.sdkProcessingMetadata = {
                    dynamicSamplingContext: dynamicSamplingContext,
                    ...evt.sdkProcessingMetadata
                };
            }
            return evt;
        });
    }
    /**
   * Processes the event and logs an error in case of rejection
   * @param event
   * @param hint
   * @param scope
   */ _captureEvent(event, hint = {}, scope) {
        return this._processEvent(event, hint, scope).then((finalEvent)=>{
            return finalEvent.event_id;
        }, (reason)=>{
            if (0, $tgF2D.DEBUG_BUILD) {
                // If something's gone wrong, log the error as a warning. If it's just us having used a `SentryError` for
                // control flow, log just the message (no stack) as a log-level log.
                const sentryError = reason;
                if (sentryError.logLevel === "log") (0, $fi7Bg.logger).log(sentryError.message);
                else (0, $fi7Bg.logger).warn(sentryError);
            }
            return undefined;
        });
    }
    /**
   * Processes an event (either error or message) and sends it to Sentry.
   *
   * This also adds breadcrumbs and context information to the event. However,
   * platform specific meta data (such as the User's IP address) must be added
   * by the SDK implementor.
   *
   *
   * @param event The event to send to Sentry.
   * @param hint May contain additional information about the original exception.
   * @param scope A scope containing event metadata.
   * @returns A SyncPromise that resolves with the event or rejects in case event was/will not be send.
   */ _processEvent(event, hint, scope) {
        const options = this.getOptions();
        const { sampleRate: sampleRate } = options;
        const isTransaction = $663339a60a8ed15e$var$isTransactionEvent(event);
        const isError = $663339a60a8ed15e$var$isErrorEvent(event);
        const eventType = event.type || "error";
        const beforeSendLabel = `before send for type \`${eventType}\``;
        // 1.0 === 100% events are sent
        // 0.0 === 0% events are sent
        // Sampling for transaction happens somewhere else
        if (isError && typeof sampleRate === "number" && Math.random() > sampleRate) {
            this.recordDroppedEvent("sample_rate", "error", event);
            return (0, $1sCez.rejectedSyncPromise)(new (0, $4B0oq.SentryError)(`Discarding event because it's not included in the random sample (sampling rate = ${sampleRate})`, "log"));
        }
        const dataCategory = eventType === "replay_event" ? "replay" : eventType;
        const sdkProcessingMetadata = event.sdkProcessingMetadata || {};
        const capturedSpanIsolationScope = sdkProcessingMetadata.capturedSpanIsolationScope;
        return this._prepareEvent(event, hint, scope, capturedSpanIsolationScope).then((prepared)=>{
            if (prepared === null) {
                this.recordDroppedEvent("event_processor", dataCategory, event);
                throw new (0, $4B0oq.SentryError)("An event processor returned `null`, will not send event.", "log");
            }
            const isInternalException = hint.data && hint.data.__sentry__ === true;
            if (isInternalException) return prepared;
            const result = $663339a60a8ed15e$var$processBeforeSend(options, prepared, hint);
            return $663339a60a8ed15e$var$_validateBeforeSendResult(result, beforeSendLabel);
        }).then((processedEvent)=>{
            if (processedEvent === null) {
                this.recordDroppedEvent("before_send", dataCategory, event);
                if (isTransaction) {
                    const spans = event.spans || [];
                    // the transaction itself counts as one span, plus all the child spans that are added
                    const spanCount = 1 + spans.length;
                    this.recordDroppedEvent("before_send", "span", spanCount);
                }
                throw new (0, $4B0oq.SentryError)(`${beforeSendLabel} returned \`null\`, will not send event.`, "log");
            }
            const session = scope && scope.getSession();
            if (!isTransaction && session) this._updateSessionFromEvent(session, processedEvent);
            if (isTransaction) {
                const spanCountBefore = processedEvent.sdkProcessingMetadata && processedEvent.sdkProcessingMetadata.spanCountBeforeProcessing || 0;
                const spanCountAfter = processedEvent.spans ? processedEvent.spans.length : 0;
                const droppedSpanCount = spanCountBefore - spanCountAfter;
                if (droppedSpanCount > 0) this.recordDroppedEvent("before_send", "span", droppedSpanCount);
            }
            // None of the Sentry built event processor will update transaction name,
            // so if the transaction name has been changed by an event processor, we know
            // it has to come from custom event processor added by a user
            const transactionInfo = processedEvent.transaction_info;
            if (isTransaction && transactionInfo && processedEvent.transaction !== event.transaction) {
                const source = "custom";
                processedEvent.transaction_info = {
                    ...transactionInfo,
                    source: source
                };
            }
            this.sendEvent(processedEvent, hint);
            return processedEvent;
        }).then(null, (reason)=>{
            if (reason instanceof (0, $4B0oq.SentryError)) throw reason;
            this.captureException(reason, {
                data: {
                    __sentry__: true
                },
                originalException: reason
            });
            throw new (0, $4B0oq.SentryError)(`Event processing pipeline threw an error, original event will not be sent. Details have been sent as a new event.\nReason: ${reason}`);
        });
    }
    /**
   * Occupies the client with processing and event
   */ _process(promise) {
        this._numProcessing++;
        promise.then((value)=>{
            this._numProcessing--;
            return value;
        }, (reason)=>{
            this._numProcessing--;
            return reason;
        });
    }
    /**
   * @inheritdoc
   */ _sendEnvelope(envelope) {
        this.emit("beforeEnvelope", envelope);
        if (this._isEnabled() && this._transport) return this._transport.send(envelope).then(null, (reason)=>{
            (0, $tgF2D.DEBUG_BUILD) && (0, $fi7Bg.logger).error("Error while sending event:", reason);
        });
        else (0, $tgF2D.DEBUG_BUILD) && (0, $fi7Bg.logger).error("Transport disabled");
    }
    /**
   * Clears outcomes on this client and returns them.
   */ _clearOutcomes() {
        const outcomes = this._outcomes;
        this._outcomes = {};
        return Object.keys(outcomes).map((key)=>{
            const [reason, category] = key.split(":");
            return {
                reason: reason,
                category: category,
                quantity: outcomes[key]
            };
        });
    }
}
/**
 * Verifies that return value of configured `beforeSend` or `beforeSendTransaction` is of expected type, and returns the value if so.
 */ function $663339a60a8ed15e$var$_validateBeforeSendResult(beforeSendResult, beforeSendLabel) {
    const invalidValueError = `${beforeSendLabel} must return \`null\` or a valid event.`;
    if ((0, $5lwZa.isThenable)(beforeSendResult)) return beforeSendResult.then((event)=>{
        if (!(0, $5lwZa.isPlainObject)(event) && event !== null) throw new (0, $4B0oq.SentryError)(invalidValueError);
        return event;
    }, (e)=>{
        throw new (0, $4B0oq.SentryError)(`${beforeSendLabel} rejected with ${e}`);
    });
    else if (!(0, $5lwZa.isPlainObject)(beforeSendResult) && beforeSendResult !== null) throw new (0, $4B0oq.SentryError)(invalidValueError);
    return beforeSendResult;
}
/**
 * Process the matching `beforeSendXXX` callback.
 */ function $663339a60a8ed15e$var$processBeforeSend(options, event, hint) {
    const { beforeSend: beforeSend, beforeSendTransaction: beforeSendTransaction } = options;
    if ($663339a60a8ed15e$var$isErrorEvent(event) && beforeSend) return beforeSend(event, hint);
    if ($663339a60a8ed15e$var$isTransactionEvent(event) && beforeSendTransaction) {
        if (event.spans) {
            // We store the # of spans before processing in SDK metadata,
            // so we can compare it afterwards to determine how many spans were dropped
            const spanCountBefore = event.spans.length;
            event.sdkProcessingMetadata = {
                ...event.sdkProcessingMetadata,
                spanCountBeforeProcessing: spanCountBefore
            };
        }
        return beforeSendTransaction(event, hint);
    }
    return event;
}
function $663339a60a8ed15e$var$isErrorEvent(event) {
    return event.type === undefined;
}
function $663339a60a8ed15e$var$isTransactionEvent(event) {
    return event.type === "transaction";
}
/**
 * Add an event processor to the current client.
 * This event processor will run for all events processed by this client.
 */ function $663339a60a8ed15e$export$9aac0b9f77928fbf(callback) {
    const client = (0, $9Dess.getClient)();
    if (!client || !client.addEventProcessor) return;
    client.addEventProcessor(callback);
}

});
parcelRequire.register("ctxTY", function(module, exports) {

$parcel$export(module.exports, "createEnvelope", function () { return $91527da2af54dfd0$export$f93f7f385160c44e; });
$parcel$export(module.exports, "addItemToEnvelope", function () { return $91527da2af54dfd0$export$d650323442802f6f; });
$parcel$export(module.exports, "forEachEnvelopeItem", function () { return $91527da2af54dfd0$export$c56c55acf0136fd3; });
$parcel$export(module.exports, "serializeEnvelope", function () { return $91527da2af54dfd0$export$32f9b428425aac85; });
$parcel$export(module.exports, "createAttachmentEnvelopeItem", function () { return $91527da2af54dfd0$export$d8fc80952cc31fa4; });
$parcel$export(module.exports, "envelopeItemTypeToDataCategory", function () { return $91527da2af54dfd0$export$b11169581eeaf237; });
$parcel$export(module.exports, "getSdkMetadataForEnvelopeHeader", function () { return $91527da2af54dfd0$export$d369f3b2758f6743; });
$parcel$export(module.exports, "createEventEnvelopeHeaders", function () { return $91527da2af54dfd0$export$92b6093782fe661b; });

var $1B238 = parcelRequire("1B238");

var $fjuuc = parcelRequire("fjuuc");

var $eKFW4 = parcelRequire("eKFW4");
/**
 * Creates an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */ function $91527da2af54dfd0$export$f93f7f385160c44e(headers, items = []) {
    return [
        headers,
        items
    ];
}
/**
 * Add an item to an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */ function $91527da2af54dfd0$export$d650323442802f6f(envelope, newItem) {
    const [headers, items] = envelope;
    return [
        headers,
        [
            ...items,
            newItem
        ]
    ];
}
/**
 * Convenience function to loop through the items and item types of an envelope.
 * (This function was mostly created because working with envelope types is painful at the moment)
 *
 * If the callback returns true, the rest of the items will be skipped.
 */ function $91527da2af54dfd0$export$c56c55acf0136fd3(envelope, callback) {
    const envelopeItems = envelope[1];
    for (const envelopeItem of envelopeItems){
        const envelopeItemType = envelopeItem[0].type;
        const result = callback(envelopeItem, envelopeItemType);
        if (result) return true;
    }
    return false;
}
/**
 * Returns true if the envelope contains any of the given envelope item types
 */ function $91527da2af54dfd0$export$604a45d95a155e2b(envelope, types) {
    return $91527da2af54dfd0$export$c56c55acf0136fd3(envelope, (_, type)=>types.includes(type));
}
/**
 * Encode a string to UTF8.
 */ function $91527da2af54dfd0$var$encodeUTF8(input, textEncoder) {
    const utf8 = textEncoder || new TextEncoder();
    return utf8.encode(input);
}
/**
 * Serializes an envelope.
 */ function $91527da2af54dfd0$export$32f9b428425aac85(envelope, textEncoder) {
    const [envHeaders, items] = envelope;
    // Initially we construct our envelope as a string and only convert to binary chunks if we encounter binary data
    let parts = JSON.stringify(envHeaders);
    function append(next) {
        if (typeof parts === "string") parts = typeof next === "string" ? parts + next : [
            $91527da2af54dfd0$var$encodeUTF8(parts, textEncoder),
            next
        ];
        else parts.push(typeof next === "string" ? $91527da2af54dfd0$var$encodeUTF8(next, textEncoder) : next);
    }
    for (const item of items){
        const [itemHeaders, payload] = item;
        append(`\n${JSON.stringify(itemHeaders)}\n`);
        if (typeof payload === "string" || payload instanceof Uint8Array) append(payload);
        else {
            let stringifiedPayload;
            try {
                stringifiedPayload = JSON.stringify(payload);
            } catch (e) {
                // In case, despite all our efforts to keep `payload` circular-dependency-free, `JSON.strinify()` still
                // fails, we try again after normalizing it again with infinite normalization depth. This of course has a
                // performance impact but in this case a performance hit is better than throwing.
                stringifiedPayload = JSON.stringify((0, $fjuuc.normalize)(payload));
            }
            append(stringifiedPayload);
        }
    }
    return typeof parts === "string" ? parts : $91527da2af54dfd0$var$concatBuffers(parts);
}
function $91527da2af54dfd0$var$concatBuffers(buffers) {
    const totalLength = buffers.reduce((acc, buf)=>acc + buf.length, 0);
    const merged = new Uint8Array(totalLength);
    let offset = 0;
    for (const buffer of buffers){
        merged.set(buffer, offset);
        offset += buffer.length;
    }
    return merged;
}
/**
 * Parses an envelope
 */ function $91527da2af54dfd0$export$3338d0c7b6e17a2b(env, textEncoder, textDecoder) {
    let buffer = typeof env === "string" ? textEncoder.encode(env) : env;
    function readBinary(length) {
        const bin = buffer.subarray(0, length);
        // Replace the buffer with the remaining data excluding trailing newline
        buffer = buffer.subarray(length + 1);
        return bin;
    }
    function readJson() {
        let i = buffer.indexOf(0xa);
        // If we couldn't find a newline, we must have found the end of the buffer
        if (i < 0) i = buffer.length;
        return JSON.parse(textDecoder.decode(readBinary(i)));
    }
    const envelopeHeader = readJson();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const items = [];
    while(buffer.length){
        const itemHeader = readJson();
        const binaryLength = typeof itemHeader.length === "number" ? itemHeader.length : undefined;
        items.push([
            itemHeader,
            binaryLength ? readBinary(binaryLength) : readJson()
        ]);
    }
    return [
        envelopeHeader,
        items
    ];
}
/**
 * Creates attachment envelope items
 */ function $91527da2af54dfd0$export$d8fc80952cc31fa4(attachment, textEncoder) {
    const buffer = typeof attachment.data === "string" ? $91527da2af54dfd0$var$encodeUTF8(attachment.data, textEncoder) : attachment.data;
    return [
        (0, $eKFW4.dropUndefinedKeys)({
            type: "attachment",
            length: buffer.length,
            filename: attachment.filename,
            content_type: attachment.contentType,
            attachment_type: attachment.attachmentType
        }),
        buffer
    ];
}
const $91527da2af54dfd0$var$ITEM_TYPE_TO_DATA_CATEGORY_MAP = {
    session: "session",
    sessions: "session",
    attachment: "attachment",
    transaction: "transaction",
    event: "error",
    client_report: "internal",
    user_report: "default",
    profile: "profile",
    replay_event: "replay",
    replay_recording: "replay",
    check_in: "monitor",
    feedback: "feedback",
    span: "span",
    statsd: "metric_bucket"
};
/**
 * Maps the type of an envelope item to a data category.
 */ function $91527da2af54dfd0$export$b11169581eeaf237(type) {
    return $91527da2af54dfd0$var$ITEM_TYPE_TO_DATA_CATEGORY_MAP[type];
}
/** Extracts the minimal SDK info from the metadata or an events */ function $91527da2af54dfd0$export$d369f3b2758f6743(metadataOrEvent) {
    if (!metadataOrEvent || !metadataOrEvent.sdk) return;
    const { name: name, version: version } = metadataOrEvent.sdk;
    return {
        name: name,
        version: version
    };
}
/**
 * Creates event envelope headers, based on event, sdk info and tunnel
 * Note: This function was extracted from the core package to make it available in Replay
 */ function $91527da2af54dfd0$export$92b6093782fe661b(event, sdkInfo, tunnel, dsn) {
    const dynamicSamplingContext = event.sdkProcessingMetadata && event.sdkProcessingMetadata.dynamicSamplingContext;
    return {
        event_id: event.event_id,
        sent_at: new Date().toISOString(),
        ...sdkInfo && {
            sdk: sdkInfo
        },
        ...!!tunnel && dsn && {
            dsn: (0, $1B238.dsnToString)(dsn)
        },
        ...dynamicSamplingContext && {
            trace: (0, $eKFW4.dropUndefinedKeys)({
                ...dynamicSamplingContext
            })
        }
    };
}

});

parcelRequire.register("4B0oq", function(module, exports) {

$parcel$export(module.exports, "SentryError", function () { return $358aec2d1a072202$export$5949942ba2a7c0e2; });
/** An error emitted by Sentry SDKs and related utilities. */ class $358aec2d1a072202$export$5949942ba2a7c0e2 extends Error {
    /** Display name of this error instance. */ constructor(message, logLevel = "warn"){
        super(message);
        this.message = message;
        this.name = new.target.prototype.constructor.name;
        // This sets the prototype to be `Error`, not `SentryError`. It's unclear why we do this, but commenting this line
        // out causes various (seemingly totally unrelated) playwright tests consistently time out. FYI, this makes
        // instances of `SentryError` fail `obj instanceof SentryError` checks.
        Object.setPrototypeOf(this, new.target.prototype);
        this.logLevel = logLevel;
    }
}

});

parcelRequire.register("7Fg0B", function(module, exports) {

$parcel$export(module.exports, "createSessionEnvelope", function () { return $5948c7bf9409951e$export$124b03c077baa2f3; });
$parcel$export(module.exports, "createEventEnvelope", function () { return $5948c7bf9409951e$export$c31057337a18010f; });

var $ctxTY = parcelRequire("ctxTY");
var $1B238 = parcelRequire("1B238");
/**
 * Apply SdkInfo (name, version, packages, integrations) to the corresponding event key.
 * Merge with existing data if any.
 **/ function $5948c7bf9409951e$var$enhanceEventWithSdkInfo(event, sdkInfo) {
    if (!sdkInfo) return event;
    event.sdk = event.sdk || {};
    event.sdk.name = event.sdk.name || sdkInfo.name;
    event.sdk.version = event.sdk.version || sdkInfo.version;
    event.sdk.integrations = [
        ...event.sdk.integrations || [],
        ...sdkInfo.integrations || []
    ];
    event.sdk.packages = [
        ...event.sdk.packages || [],
        ...sdkInfo.packages || []
    ];
    return event;
}
/** Creates an envelope from a Session */ function $5948c7bf9409951e$export$124b03c077baa2f3(session, dsn, metadata, tunnel) {
    const sdkInfo = (0, $ctxTY.getSdkMetadataForEnvelopeHeader)(metadata);
    const envelopeHeaders = {
        sent_at: new Date().toISOString(),
        ...sdkInfo && {
            sdk: sdkInfo
        },
        ...!!tunnel && dsn && {
            dsn: (0, $1B238.dsnToString)(dsn)
        }
    };
    const envelopeItem = "aggregates" in session ? [
        {
            type: "sessions"
        },
        session
    ] : [
        {
            type: "session"
        },
        session.toJSON()
    ];
    return (0, $ctxTY.createEnvelope)(envelopeHeaders, [
        envelopeItem
    ]);
}
/**
 * Create an Envelope from an event.
 */ function $5948c7bf9409951e$export$c31057337a18010f(event, dsn, metadata, tunnel) {
    const sdkInfo = (0, $ctxTY.getSdkMetadataForEnvelopeHeader)(metadata);
    /*
    Note: Due to TS, event.type may be `replay_event`, theoretically.
    In practice, we never call `createEventEnvelope` with `replay_event` type,
    and we'd have to adjut a looot of types to make this work properly.
    We want to avoid casting this around, as that could lead to bugs (e.g. when we add another type)
    So the safe choice is to really guard against the replay_event type here.
  */ const eventType = event.type && event.type !== "replay_event" ? event.type : "event";
    $5948c7bf9409951e$var$enhanceEventWithSdkInfo(event, metadata && metadata.sdk);
    const envelopeHeaders = (0, $ctxTY.createEventEnvelopeHeaders)(event, sdkInfo, tunnel, dsn);
    // Prevent this data (which, if it exists, was used in earlier steps in the processing pipeline) from being sent to
    // sentry. (Note: Our use of this property comes and goes with whatever we might be debugging, whatever hacks we may
    // have temporarily added, etc. Even if we don't happen to be using it at some point in the future, let's not get rid
    // of this `delete`, lest we miss putting it back in the next time the property is in use.)
    delete event.sdkProcessingMetadata;
    const eventItem = [
        {
            type: eventType
        },
        event
    ];
    return (0, $ctxTY.createEnvelope)(envelopeHeaders, [
        eventItem
    ]);
}

});

parcelRequire.register("jgG0D", function(module, exports) {

$parcel$export(module.exports, "createMetricEnvelope", function () { return $e070191e8108c18a$export$f23eb96e33154901; });

var $ctxTY = parcelRequire("ctxTY");
var $1B238 = parcelRequire("1B238");

var $8SkT4 = parcelRequire("8SkT4");
/**
 * Create envelope from a metric aggregate.
 */ function $e070191e8108c18a$export$f23eb96e33154901(metricBucketItems, dsn, metadata, tunnel) {
    const headers = {
        sent_at: new Date().toISOString()
    };
    if (metadata && metadata.sdk) headers.sdk = {
        name: metadata.sdk.name,
        version: metadata.sdk.version
    };
    if (!!tunnel && dsn) headers.dsn = (0, $1B238.dsnToString)(dsn);
    const item = $e070191e8108c18a$var$createMetricEnvelopeItem(metricBucketItems);
    return (0, $ctxTY.createEnvelope)(headers, [
        item
    ]);
}
function $e070191e8108c18a$var$createMetricEnvelopeItem(metricBucketItems) {
    const payload = (0, $8SkT4.serializeMetricBuckets)(metricBucketItems);
    const metricHeaders = {
        type: "statsd",
        length: payload.length
    };
    return [
        metricHeaders,
        payload
    ];
}

});
parcelRequire.register("8SkT4", function(module, exports) {

$parcel$export(module.exports, "serializeMetricBuckets", function () { return $676391a83cb6d2aa$export$66decd709db01dc8; });

var $eKFW4 = parcelRequire("eKFW4");
/**
 * Generate bucket key from metric properties.
 */ function $676391a83cb6d2aa$export$b8bd8c4dffa5aa2d(metricType, name, unit, tags) {
    const stringifiedTags = Object.entries((0, $eKFW4.dropUndefinedKeys)(tags)).sort((a, b)=>a[0].localeCompare(b[0]));
    return `${metricType}${name}${unit}${stringifiedTags}`;
}
/* eslint-disable no-bitwise */ /**
 * Simple hash function for strings.
 */ function $676391a83cb6d2aa$export$b211ce59c0ea1cfb(s) {
    let rv = 0;
    for(let i = 0; i < s.length; i++){
        const c = s.charCodeAt(i);
        rv = (rv << 5) - rv + c;
        rv &= rv;
    }
    return rv >>> 0;
}
/* eslint-enable no-bitwise */ /**
 * Serialize metrics buckets into a string based on statsd format.
 *
 * Example of format:
 * metric.name@second:1:1.2|d|#a:value,b:anothervalue|T12345677
 * Segments:
 * name: metric.name
 * unit: second
 * value: [1, 1.2]
 * type of metric: d (distribution)
 * tags: { a: value, b: anothervalue }
 * timestamp: 12345677
 */ function $676391a83cb6d2aa$export$66decd709db01dc8(metricBucketItems) {
    let out = "";
    for (const item of metricBucketItems){
        const tagEntries = Object.entries(item.tags);
        const maybeTags = tagEntries.length > 0 ? `|#${tagEntries.map(([key, value])=>`${key}:${value}`).join(",")}` : "";
        out += `${item.name}@${item.unit}:${item.metric}|${item.metricType}${maybeTags}|T${item.timestamp}\n`;
    }
    return out;
}
/** Sanitizes units */ function $676391a83cb6d2aa$export$2d8c9911396bbf5f(unit) {
    return unit.replace(/[^\w]+/gi, "_");
}
/** Sanitizes metric keys */ function $676391a83cb6d2aa$export$d3b3167f2ebbcecc(key) {
    return key.replace(/[^\w\-.]+/gi, "_");
}
function $676391a83cb6d2aa$var$sanitizeTagKey(key) {
    return key.replace(/[^\w\-./]+/gi, "");
}
const $676391a83cb6d2aa$var$tagValueReplacements = [
    [
        "\n",
        "\\n"
    ],
    [
        "\r",
        "\\r"
    ],
    [
        "	",
        "\\t"
    ],
    [
        "\\",
        "\\\\"
    ],
    [
        "|",
        "\\u{7c}"
    ],
    [
        ",",
        "\\u{2c}"
    ]
];
function $676391a83cb6d2aa$var$getCharOrReplacement(input) {
    for (const [search, replacement] of $676391a83cb6d2aa$var$tagValueReplacements){
        if (input === search) return replacement;
    }
    return input;
}
function $676391a83cb6d2aa$var$sanitizeTagValue(value) {
    return [
        ...value
    ].reduce((acc, char)=>acc + $676391a83cb6d2aa$var$getCharOrReplacement(char), "");
}
/**
 * Sanitizes tags.
 */ function $676391a83cb6d2aa$export$ae49af12dbdf2477(unsanitizedTags) {
    const tags = {};
    for(const key in unsanitizedTags)if (Object.prototype.hasOwnProperty.call(unsanitizedTags, key)) {
        const sanitizedKey = $676391a83cb6d2aa$var$sanitizeTagKey(key);
        tags[sanitizedKey] = $676391a83cb6d2aa$var$sanitizeTagValue(String(unsanitizedTags[key]));
    }
    return tags;
}

});



parcelRequire.register("5w23n", function(module, exports) {

$parcel$export(module.exports, "createClientReportEnvelope", function () { return $404188b51edfb447$export$f3b9ed77c03eeb00; });

var $ctxTY = parcelRequire("ctxTY");

var $kTBeD = parcelRequire("kTBeD");
/**
 * Creates client report envelope
 * @param discarded_events An array of discard events
 * @param dsn A DSN that can be set on the header. Optional.
 */ function $404188b51edfb447$export$f3b9ed77c03eeb00(discarded_events, dsn, timestamp) {
    const clientReportItem = [
        {
            type: "client_report"
        },
        {
            timestamp: timestamp || (0, $kTBeD.dateTimestampInSeconds)(),
            discarded_events: discarded_events
        }
    ];
    return (0, $ctxTY.createEnvelope)(dsn ? {
        dsn: dsn
    } : {}, [
        clientReportItem
    ]);
}

});

parcelRequire.register("3sPJl", function(module, exports) {

$parcel$export(module.exports, "getSDKSource", function () { return $285c1d34255bbb76$export$8ad33f488b1ab046; });
/*
 * This module exists for optimizations in the build process through rollup and terser.  We define some global
 * constants, which can be overridden during build. By guarding certain pieces of code with functions that return these
 * constants, we can control whether or not they appear in the final bundle. (Any code guarded by a false condition will
 * never run, and will hence be dropped during treeshaking.) The two primary uses for this are stripping out calls to
 * `logger` and preventing node-related code from appearing in browser bundles.
 *
 * Attention:
 * This file should not be used to define constants/flags that are intended to be used for tree-shaking conducted by
 * users. These flags should live in their respective packages, as we identified user tooling (specifically webpack)
 * having issues tree-shaking these constants across package boundaries.
 * An example for this is the __SENTRY_DEBUG__ constant. It is declared in each package individually because we want
 * users to be able to shake away expressions that it guards.
 */ /**
 * Figures out if we're building a browser bundle.
 *
 * @returns true if this is a browser bundle build.
 */ function $285c1d34255bbb76$export$2928c40372e623c0() {
    return typeof __SENTRY_BROWSER_BUNDLE__ !== "undefined" && !!__SENTRY_BROWSER_BUNDLE__;
}
/**
 * Get source of SDK.
 */ function $285c1d34255bbb76$export$8ad33f488b1ab046() {
    // @ts-expect-error "npm" is injected by rollup during build process
    return "npm";
}

});

parcelRequire.register("23Gvz", function(module, exports) {

$parcel$export(module.exports, "DEBUG_BUILD", function () { return $17fcd5ce37d83954$export$16a28057038b10ef; });
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $17fcd5ce37d83954$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__;

});

parcelRequire.register("kH7dV", function(module, exports) {

$parcel$export(module.exports, "exceptionFromError", function () { return $f10d6d3dd3f1c281$export$a6c2d27607295951; });
$parcel$export(module.exports, "eventFromException", function () { return $f10d6d3dd3f1c281$export$ea3ec7e569b823fc; });
$parcel$export(module.exports, "eventFromUnknownInput", function () { return $f10d6d3dd3f1c281$export$9dd56ed1ef0c3420; });
$parcel$export(module.exports, "eventFromMessage", function () { return $f10d6d3dd3f1c281$export$5425b53185d13d6c; });

var $9Dess = parcelRequire("9Dess");

var $gYD4g = parcelRequire("gYD4g");
var $eKFW4 = parcelRequire("eKFW4");
var $5lwZa = parcelRequire("5lwZa");
var $fjuuc = parcelRequire("fjuuc");
var $1sCez = parcelRequire("1sCez");
/**
 * This function creates an exception from a JavaScript Error
 */ function $f10d6d3dd3f1c281$export$a6c2d27607295951(stackParser, ex) {
    // Get the frames first since Opera can lose the stack if we touch anything else first
    const frames = $f10d6d3dd3f1c281$export$d478b2c12fbcfdda(stackParser, ex);
    const exception = {
        type: ex && ex.name,
        value: $f10d6d3dd3f1c281$var$extractMessage(ex)
    };
    if (frames.length) exception.stacktrace = {
        frames: frames
    };
    if (exception.type === undefined && exception.value === "") exception.value = "Unrecoverable error caught";
    return exception;
}
/**
 * @hidden
 */ function $f10d6d3dd3f1c281$export$a6a5dd73e489caf(stackParser, exception, syntheticException, isUnhandledRejection) {
    const client = (0, $9Dess.getClient)();
    const normalizeDepth = client && client.getOptions().normalizeDepth;
    const event = {
        exception: {
            values: [
                {
                    type: (0, $5lwZa.isEvent)(exception) ? exception.constructor.name : isUnhandledRejection ? "UnhandledRejection" : "Error",
                    value: $f10d6d3dd3f1c281$var$getNonErrorObjectExceptionValue(exception, {
                        isUnhandledRejection: isUnhandledRejection
                    })
                }
            ]
        },
        extra: {
            __serialized__: (0, $fjuuc.normalizeToSize)(exception, normalizeDepth)
        }
    };
    if (syntheticException) {
        const frames = $f10d6d3dd3f1c281$export$d478b2c12fbcfdda(stackParser, syntheticException);
        if (frames.length) // event.exception.values[0] has been set above
        event.exception.values[0].stacktrace = {
            frames: frames
        };
    }
    return event;
}
/**
 * @hidden
 */ function $f10d6d3dd3f1c281$export$73fbea5a0a5234af(stackParser, ex) {
    return {
        exception: {
            values: [
                $f10d6d3dd3f1c281$export$a6c2d27607295951(stackParser, ex)
            ]
        }
    };
}
/** Parses stack frames from an error */ function $f10d6d3dd3f1c281$export$d478b2c12fbcfdda(stackParser, ex) {
    // Access and store the stacktrace property before doing ANYTHING
    // else to it because Opera is not very good at providing it
    // reliably in other circumstances.
    const stacktrace = ex.stacktrace || ex.stack || "";
    const popSize = $f10d6d3dd3f1c281$var$getPopSize(ex);
    try {
        return stackParser(stacktrace, popSize);
    } catch (e) {
    // no-empty
    }
    return [];
}
// Based on our own mapping pattern - https://github.com/getsentry/sentry/blob/9f08305e09866c8bd6d0c24f5b0aabdd7dd6c59c/src/sentry/lang/javascript/errormapping.py#L83-L108
const $f10d6d3dd3f1c281$var$reactMinifiedRegexp = /Minified React error #\d+;/i;
function $f10d6d3dd3f1c281$var$getPopSize(ex) {
    if (ex) {
        if (typeof ex.framesToPop === "number") return ex.framesToPop;
        if ($f10d6d3dd3f1c281$var$reactMinifiedRegexp.test(ex.message)) return 1;
    }
    return 0;
}
/**
 * There are cases where stacktrace.message is an Event object
 * https://github.com/getsentry/sentry-javascript/issues/1949
 * In this specific case we try to extract stacktrace.message.error.message
 */ function $f10d6d3dd3f1c281$var$extractMessage(ex) {
    const message = ex && ex.message;
    if (!message) return "No error message";
    if (message.error && typeof message.error.message === "string") return message.error.message;
    return message;
}
/**
 * Creates an {@link Event} from all inputs to `captureException` and non-primitive inputs to `captureMessage`.
 * @hidden
 */ function $f10d6d3dd3f1c281$export$ea3ec7e569b823fc(stackParser, exception, hint, attachStacktrace) {
    const syntheticException = hint && hint.syntheticException || undefined;
    const event = $f10d6d3dd3f1c281$export$9dd56ed1ef0c3420(stackParser, exception, syntheticException, attachStacktrace);
    (0, $gYD4g.addExceptionMechanism)(event); // defaults to { type: 'generic', handled: true }
    event.level = "error";
    if (hint && hint.event_id) event.event_id = hint.event_id;
    return (0, $1sCez.resolvedSyncPromise)(event);
}
/**
 * Builds and Event from a Message
 * @hidden
 */ function $f10d6d3dd3f1c281$export$5425b53185d13d6c(stackParser, message, // eslint-disable-next-line deprecation/deprecation
level = "info", hint, attachStacktrace) {
    const syntheticException = hint && hint.syntheticException || undefined;
    const event = $f10d6d3dd3f1c281$export$47d86ae4b3c9994(stackParser, message, syntheticException, attachStacktrace);
    event.level = level;
    if (hint && hint.event_id) event.event_id = hint.event_id;
    return (0, $1sCez.resolvedSyncPromise)(event);
}
/**
 * @hidden
 */ function $f10d6d3dd3f1c281$export$9dd56ed1ef0c3420(stackParser, exception, syntheticException, attachStacktrace, isUnhandledRejection) {
    let event;
    if ((0, $5lwZa.isErrorEvent)(exception) && exception.error) {
        // If it is an ErrorEvent with `error` property, extract it to get actual Error
        const errorEvent = exception;
        return $f10d6d3dd3f1c281$export$73fbea5a0a5234af(stackParser, errorEvent.error);
    }
    // If it is a `DOMError` (which is a legacy API, but still supported in some browsers) then we just extract the name
    // and message, as it doesn't provide anything else. According to the spec, all `DOMExceptions` should also be
    // `Error`s, but that's not the case in IE11, so in that case we treat it the same as we do a `DOMError`.
    //
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMError
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMException
    // https://webidl.spec.whatwg.org/#es-DOMException-specialness
    if ((0, $5lwZa.isDOMError)(exception) || (0, $5lwZa.isDOMException)(exception)) {
        const domException = exception;
        if ("stack" in exception) event = $f10d6d3dd3f1c281$export$73fbea5a0a5234af(stackParser, exception);
        else {
            const name = domException.name || ((0, $5lwZa.isDOMError)(domException) ? "DOMError" : "DOMException");
            const message = domException.message ? `${name}: ${domException.message}` : name;
            event = $f10d6d3dd3f1c281$export$47d86ae4b3c9994(stackParser, message, syntheticException, attachStacktrace);
            (0, $gYD4g.addExceptionTypeValue)(event, message);
        }
        if ("code" in domException) // eslint-disable-next-line deprecation/deprecation
        event.tags = {
            ...event.tags,
            "DOMException.code": `${domException.code}`
        };
        return event;
    }
    if ((0, $5lwZa.isError)(exception)) // we have a real Error object, do nothing
    return $f10d6d3dd3f1c281$export$73fbea5a0a5234af(stackParser, exception);
    if ((0, $5lwZa.isPlainObject)(exception) || (0, $5lwZa.isEvent)(exception)) {
        // If it's a plain object or an instance of `Event` (the built-in JS kind, not this SDK's `Event` type), serialize
        // it manually. This will allow us to group events based on top-level keys which is much better than creating a new
        // group on any key/value change.
        const objectException = exception;
        event = $f10d6d3dd3f1c281$export$a6a5dd73e489caf(stackParser, objectException, syntheticException, isUnhandledRejection);
        (0, $gYD4g.addExceptionMechanism)(event, {
            synthetic: true
        });
        return event;
    }
    // If none of previous checks were valid, then it means that it's not:
    // - an instance of DOMError
    // - an instance of DOMException
    // - an instance of Event
    // - an instance of Error
    // - a valid ErrorEvent (one with an error property)
    // - a plain Object
    //
    // So bail out and capture it as a simple message:
    event = $f10d6d3dd3f1c281$export$47d86ae4b3c9994(stackParser, exception, syntheticException, attachStacktrace);
    (0, $gYD4g.addExceptionTypeValue)(event, `${exception}`, undefined);
    (0, $gYD4g.addExceptionMechanism)(event, {
        synthetic: true
    });
    return event;
}
/**
 * @hidden
 */ function $f10d6d3dd3f1c281$export$47d86ae4b3c9994(stackParser, message, syntheticException, attachStacktrace) {
    const event = {};
    if (attachStacktrace && syntheticException) {
        const frames = $f10d6d3dd3f1c281$export$d478b2c12fbcfdda(stackParser, syntheticException);
        if (frames.length) event.exception = {
            values: [
                {
                    value: message,
                    stacktrace: {
                        frames: frames
                    }
                }
            ]
        };
    }
    if ((0, $5lwZa.isParameterizedString)(message)) {
        const { __sentry_template_string__: __sentry_template_string__, __sentry_template_values__: __sentry_template_values__ } = message;
        event.logentry = {
            message: __sentry_template_string__,
            params: __sentry_template_values__
        };
        return event;
    }
    event.message = message;
    return event;
}
function $f10d6d3dd3f1c281$var$getNonErrorObjectExceptionValue(exception, { isUnhandledRejection: isUnhandledRejection }) {
    const keys = (0, $eKFW4.extractExceptionKeysForMessage)(exception);
    const captureType = isUnhandledRejection ? "promise rejection" : "exception";
    // Some ErrorEvent instances do not have an `error` property, which is why they are not handled before
    // We still want to try to get a decent message for these cases
    if ((0, $5lwZa.isErrorEvent)(exception)) return `Event \`ErrorEvent\` captured as ${captureType} with message \`${exception.message}\``;
    if ((0, $5lwZa.isEvent)(exception)) {
        const className = $f10d6d3dd3f1c281$var$getObjectClassName(exception);
        return `Event \`${className}\` (type=${exception.type}) captured as ${captureType}`;
    }
    return `Object captured as ${captureType} with keys: ${keys}`;
}
function $f10d6d3dd3f1c281$var$getObjectClassName(obj) {
    try {
        const prototype = Object.getPrototypeOf(obj);
        return prototype ? prototype.constructor.name : undefined;
    } catch (e) {
    // ignore errors here
    }
}

});

parcelRequire.register("gY4ad", function(module, exports) {

$parcel$export(module.exports, "WINDOW", function () { return $c5a57ac77044071c$export$56d8a8a25bd48b81; });
$parcel$export(module.exports, "shouldIgnoreOnError", function () { return $c5a57ac77044071c$export$b79738ab10c590b2; });
$parcel$export(module.exports, "wrap", function () { return $c5a57ac77044071c$export$4997ffc0176396a6; });


var $9Dess = parcelRequire("9Dess");

var $gYD4g = parcelRequire("gYD4g");
var $eKFW4 = parcelRequire("eKFW4");
var $hi0PN = parcelRequire("hi0PN");
const $c5a57ac77044071c$export$56d8a8a25bd48b81 = (0, $hi0PN.GLOBAL_OBJ);
let $c5a57ac77044071c$var$ignoreOnError = 0;
/**
 * @hidden
 */ function $c5a57ac77044071c$export$b79738ab10c590b2() {
    return $c5a57ac77044071c$var$ignoreOnError > 0;
}
/**
 * @hidden
 */ function $c5a57ac77044071c$export$1265a142ff5ba165() {
    // onerror should trigger before setTimeout
    $c5a57ac77044071c$var$ignoreOnError++;
    setTimeout(()=>{
        $c5a57ac77044071c$var$ignoreOnError--;
    });
}
/**
 * Instruments the given function and sends an event to Sentry every time the
 * function throws an exception.
 *
 * @param fn A function to wrap. It is generally safe to pass an unbound function, because the returned wrapper always
 * has a correct `this` context.
 * @returns The wrapped function.
 * @hidden
 */ function $c5a57ac77044071c$export$4997ffc0176396a6(fn, options = {}, before) {
    // for future readers what this does is wrap a function and then create
    // a bi-directional wrapping between them.
    //
    // example: wrapped = wrap(original);
    //  original.__sentry_wrapped__ -> wrapped
    //  wrapped.__sentry_original__ -> original
    if (typeof fn !== "function") return fn;
    try {
        // if we're dealing with a function that was previously wrapped, return
        // the original wrapper.
        const wrapper = fn.__sentry_wrapped__;
        if (wrapper) {
            if (typeof wrapper === "function") return wrapper;
            else // If we find that the `__sentry_wrapped__` function is not a function at the time of accessing it, it means
            // that something messed with it. In that case we want to return the originally passed function.
            return fn;
        }
        // We don't wanna wrap it twice
        if ((0, $eKFW4.getOriginalFunction)(fn)) return fn;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        // Bail on wrapping and return the function as-is (defers to window.onerror).
        return fn;
    }
    /* eslint-disable prefer-rest-params */ // It is important that `sentryWrapped` is not an arrow function to preserve the context of `this`
    const sentryWrapped = function() {
        const args = Array.prototype.slice.call(arguments);
        try {
            if (before && typeof before === "function") before.apply(this, arguments);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
            const wrappedArguments = args.map((arg)=>$c5a57ac77044071c$export$4997ffc0176396a6(arg, options));
            // Attempt to invoke user-land function
            // NOTE: If you are a Sentry user, and you are seeing this stack frame, it
            //       means the sentry.javascript SDK caught an error invoking your application code. This
            //       is expected behavior and NOT indicative of a bug with sentry.javascript.
            return fn.apply(this, wrappedArguments);
        } catch (ex) {
            $c5a57ac77044071c$export$1265a142ff5ba165();
            (0, $9Dess.withScope)((scope)=>{
                scope.addEventProcessor((event)=>{
                    if (options.mechanism) {
                        (0, $gYD4g.addExceptionTypeValue)(event, undefined, undefined);
                        (0, $gYD4g.addExceptionMechanism)(event, options.mechanism);
                    }
                    event.extra = {
                        ...event.extra,
                        arguments: args
                    };
                    return event;
                });
                (0, $9Dess.captureException)(ex);
            });
            throw ex;
        }
    };
    /* eslint-enable prefer-rest-params */ // Accessing some objects may throw
    // ref: https://github.com/getsentry/sentry-javascript/issues/1168
    try {
        for(const property in fn)if (Object.prototype.hasOwnProperty.call(fn, property)) sentryWrapped[property] = fn[property];
    } catch (_oO) {} // eslint-disable-line no-empty
    // Signal that this function has been wrapped/filled already
    // for both debugging and to prevent it to being wrapped/filled twice
    (0, $eKFW4.markFunctionWrapped)(sentryWrapped, fn);
    (0, $eKFW4.addNonEnumerableProperty)(fn, "__sentry_wrapped__", sentryWrapped);
    // Restore original function name (not all browsers allow that)
    try {
        const descriptor = Object.getOwnPropertyDescriptor(sentryWrapped, "name");
        if (descriptor.configurable) Object.defineProperty(sentryWrapped, "name", {
            get () {
                return fn.name;
            }
        });
    // eslint-disable-next-line no-empty
    } catch (_oO) {}
    return sentryWrapped;
}

});

parcelRequire.register("dYndw", function(module, exports) {

$parcel$export(module.exports, "createUserFeedbackEnvelope", function () { return $a2c2e36023feb9bf$export$24a4dfcb686ee5bf; });

var $ctxTY = parcelRequire("ctxTY");
var $1B238 = parcelRequire("1B238");
/**
 * Creates an envelope from a user feedback.
 */ function $a2c2e36023feb9bf$export$24a4dfcb686ee5bf(feedback, { metadata: metadata, tunnel: tunnel, dsn: dsn }) {
    const headers = {
        event_id: feedback.event_id,
        sent_at: new Date().toISOString(),
        ...metadata && metadata.sdk && {
            sdk: {
                name: metadata.sdk.name,
                version: metadata.sdk.version
            }
        },
        ...!!tunnel && !!dsn && {
            dsn: (0, $1B238.dsnToString)(dsn)
        }
    };
    const item = $a2c2e36023feb9bf$var$createUserFeedbackEnvelopeItem(feedback);
    return (0, $ctxTY.createEnvelope)(headers, [
        item
    ]);
}
function $a2c2e36023feb9bf$var$createUserFeedbackEnvelopeItem(feedback) {
    const feedbackHeaders = {
        type: "user_report"
    };
    return [
        feedbackHeaders,
        feedback
    ];
}

});


parcelRequire.register("1gJxQ", function(module, exports) {

$parcel$export(module.exports, "breadcrumbsIntegration", function () { return $0eca9d59d86c0010$export$c079d904b326663a; });

var $9Dess = parcelRequire("9Dess");
var $dp2Cj = parcelRequire("dp2Cj");

var $6Mx2b = parcelRequire("6Mx2b");
var $kRzdA = parcelRequire("kRzdA");
var $cFhJf = parcelRequire("cFhJf");
var $iYpob = parcelRequire("iYpob");
var $29jHe = parcelRequire("29jHe");
var $ffqzi = parcelRequire("ffqzi");
var $gYD4g = parcelRequire("gYD4g");
var $fi7Bg = parcelRequire("fi7Bg");
var $bqFJd = parcelRequire("bqFJd");
var $2AO4R = parcelRequire("2AO4R");
var $8wVim = parcelRequire("8wVim");

var $23Gvz = parcelRequire("23Gvz");

var $gY4ad = parcelRequire("gY4ad");
/* eslint-disable max-lines */ /** maxStringLength gets capped to prevent 100 breadcrumbs exceeding 1MB event payload size */ const $0eca9d59d86c0010$var$MAX_ALLOWED_STRING_LENGTH = 1024;
const $0eca9d59d86c0010$var$INTEGRATION_NAME = "Breadcrumbs";
const $0eca9d59d86c0010$var$_breadcrumbsIntegration = (options = {})=>{
    const _options = {
        console: true,
        dom: true,
        fetch: true,
        history: true,
        sentry: true,
        xhr: true,
        ...options
    };
    return {
        name: $0eca9d59d86c0010$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        setup (client) {
            if (_options.console) (0, $kRzdA.addConsoleInstrumentationHandler)($0eca9d59d86c0010$var$_getConsoleBreadcrumbHandler(client));
            if (_options.dom) (0, $6Mx2b.addClickKeypressInstrumentationHandler)($0eca9d59d86c0010$var$_getDomBreadcrumbHandler(client, _options.dom));
            if (_options.xhr) (0, $29jHe.addXhrInstrumentationHandler)($0eca9d59d86c0010$var$_getXhrBreadcrumbHandler(client));
            if (_options.fetch) (0, $cFhJf.addFetchInstrumentationHandler)($0eca9d59d86c0010$var$_getFetchBreadcrumbHandler(client));
            if (_options.history) (0, $iYpob.addHistoryInstrumentationHandler)($0eca9d59d86c0010$var$_getHistoryBreadcrumbHandler(client));
            if (_options.sentry && client.on) client.on("beforeSendEvent", $0eca9d59d86c0010$var$_getSentryBreadcrumbHandler(client));
        }
    };
};
const $0eca9d59d86c0010$export$c079d904b326663a = (0, $dp2Cj.defineIntegration)($0eca9d59d86c0010$var$_breadcrumbsIntegration);
/**
 * Default Breadcrumbs instrumentations
 *
 * @deprecated Use `breadcrumbsIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $0eca9d59d86c0010$export$2dc68d50d56fbbd = (0, $dp2Cj.convertIntegrationFnToClass)($0eca9d59d86c0010$var$INTEGRATION_NAME, $0eca9d59d86c0010$export$c079d904b326663a);
/**
 * Adds a breadcrumb for Sentry events or transactions if this option is enabled.
 */ function $0eca9d59d86c0010$var$_getSentryBreadcrumbHandler(client) {
    return function addSentryBreadcrumb(event) {
        if ((0, $9Dess.getClient)() !== client) return;
        (0, $9Dess.addBreadcrumb)({
            category: `sentry.${event.type === "transaction" ? "transaction" : "event"}`,
            event_id: event.event_id,
            level: event.level,
            message: (0, $gYD4g.getEventDescription)(event)
        }, {
            event: event
        });
    };
}
/**
 * A HOC that creaes a function that creates breadcrumbs from DOM API calls.
 * This is a HOC so that we get access to dom options in the closure.
 */ function $0eca9d59d86c0010$var$_getDomBreadcrumbHandler(client, dom) {
    return function _innerDomBreadcrumb(handlerData) {
        if ((0, $9Dess.getClient)() !== client) return;
        let target;
        let componentName;
        let keyAttrs = typeof dom === "object" ? dom.serializeAttribute : undefined;
        let maxStringLength = typeof dom === "object" && typeof dom.maxStringLength === "number" ? dom.maxStringLength : undefined;
        if (maxStringLength && maxStringLength > $0eca9d59d86c0010$var$MAX_ALLOWED_STRING_LENGTH) {
            (0, $23Gvz.DEBUG_BUILD) && (0, $fi7Bg.logger).warn(`\`dom.maxStringLength\` cannot exceed ${$0eca9d59d86c0010$var$MAX_ALLOWED_STRING_LENGTH}, but a value of ${maxStringLength} was configured. Sentry will use ${$0eca9d59d86c0010$var$MAX_ALLOWED_STRING_LENGTH} instead.`);
            maxStringLength = $0eca9d59d86c0010$var$MAX_ALLOWED_STRING_LENGTH;
        }
        if (typeof keyAttrs === "string") keyAttrs = [
            keyAttrs
        ];
        // Accessing event.target can throw (see getsentry/raven-js#838, #768)
        try {
            const event = handlerData.event;
            const element = $0eca9d59d86c0010$var$_isEvent(event) ? event.target : event;
            target = (0, $ffqzi.htmlTreeAsString)(element, {
                keyAttrs: keyAttrs,
                maxStringLength: maxStringLength
            });
            componentName = (0, $ffqzi.getComponentName)(element);
        } catch (e) {
            target = "<unknown>";
        }
        if (target.length === 0) return;
        const breadcrumb = {
            category: `ui.${handlerData.name}`,
            message: target
        };
        if (componentName) breadcrumb.data = {
            "ui.component_name": componentName
        };
        (0, $9Dess.addBreadcrumb)(breadcrumb, {
            event: handlerData.event,
            name: handlerData.name,
            global: handlerData.global
        });
    };
}
/**
 * Creates breadcrumbs from console API calls
 */ function $0eca9d59d86c0010$var$_getConsoleBreadcrumbHandler(client) {
    return function _consoleBreadcrumb(handlerData) {
        if ((0, $9Dess.getClient)() !== client) return;
        const breadcrumb = {
            category: "console",
            data: {
                arguments: handlerData.args,
                logger: "console"
            },
            level: (0, $8wVim.severityLevelFromString)(handlerData.level),
            message: (0, $2AO4R.safeJoin)(handlerData.args, " ")
        };
        if (handlerData.level === "assert") {
            if (handlerData.args[0] === false) {
                breadcrumb.message = `Assertion failed: ${(0, $2AO4R.safeJoin)(handlerData.args.slice(1), " ") || "console.assert"}`;
                breadcrumb.data.arguments = handlerData.args.slice(1);
            } else // Don't capture a breadcrumb for passed assertions
            return;
        }
        (0, $9Dess.addBreadcrumb)(breadcrumb, {
            input: handlerData.args,
            level: handlerData.level
        });
    };
}
/**
 * Creates breadcrumbs from XHR API calls
 */ function $0eca9d59d86c0010$var$_getXhrBreadcrumbHandler(client) {
    return function _xhrBreadcrumb(handlerData) {
        if ((0, $9Dess.getClient)() !== client) return;
        const { startTimestamp: startTimestamp, endTimestamp: endTimestamp } = handlerData;
        const sentryXhrData = handlerData.xhr[0, $29jHe.SENTRY_XHR_DATA_KEY];
        // We only capture complete, non-sentry requests
        if (!startTimestamp || !endTimestamp || !sentryXhrData) return;
        const { method: method, url: url, status_code: status_code, body: body } = sentryXhrData;
        const data = {
            method: method,
            url: url,
            status_code: status_code
        };
        const hint = {
            xhr: handlerData.xhr,
            input: body,
            startTimestamp: startTimestamp,
            endTimestamp: endTimestamp
        };
        (0, $9Dess.addBreadcrumb)({
            category: "xhr",
            data: data,
            type: "http"
        }, hint);
    };
}
/**
 * Creates breadcrumbs from fetch API calls
 */ function $0eca9d59d86c0010$var$_getFetchBreadcrumbHandler(client) {
    return function _fetchBreadcrumb(handlerData) {
        if ((0, $9Dess.getClient)() !== client) return;
        const { startTimestamp: startTimestamp, endTimestamp: endTimestamp } = handlerData;
        // We only capture complete fetch requests
        if (!endTimestamp) return;
        if (handlerData.fetchData.url.match(/sentry_key/) && handlerData.fetchData.method === "POST") // We will not create breadcrumbs for fetch requests that contain `sentry_key` (internal sentry requests)
        return;
        if (handlerData.error) {
            const data = handlerData.fetchData;
            const hint = {
                data: handlerData.error,
                input: handlerData.args,
                startTimestamp: startTimestamp,
                endTimestamp: endTimestamp
            };
            (0, $9Dess.addBreadcrumb)({
                category: "fetch",
                data: data,
                level: "error",
                type: "http"
            }, hint);
        } else {
            const response = handlerData.response;
            const data = {
                ...handlerData.fetchData,
                status_code: response && response.status
            };
            const hint = {
                input: handlerData.args,
                response: response,
                startTimestamp: startTimestamp,
                endTimestamp: endTimestamp
            };
            (0, $9Dess.addBreadcrumb)({
                category: "fetch",
                data: data,
                type: "http"
            }, hint);
        }
    };
}
/**
 * Creates breadcrumbs from history API calls
 */ function $0eca9d59d86c0010$var$_getHistoryBreadcrumbHandler(client) {
    return function _historyBreadcrumb(handlerData) {
        if ((0, $9Dess.getClient)() !== client) return;
        let from = handlerData.from;
        let to = handlerData.to;
        const parsedLoc = (0, $bqFJd.parseUrl)((0, $gY4ad.WINDOW).location.href);
        let parsedFrom = from ? (0, $bqFJd.parseUrl)(from) : undefined;
        const parsedTo = (0, $bqFJd.parseUrl)(to);
        // Initial pushState doesn't provide `from` information
        if (!parsedFrom || !parsedFrom.path) parsedFrom = parsedLoc;
        // Use only the path component of the URL if the URL matches the current
        // document (almost all the time when using pushState)
        if (parsedLoc.protocol === parsedTo.protocol && parsedLoc.host === parsedTo.host) to = parsedTo.relative;
        if (parsedLoc.protocol === parsedFrom.protocol && parsedLoc.host === parsedFrom.host) from = parsedFrom.relative;
        (0, $9Dess.addBreadcrumb)({
            category: "navigation",
            data: {
                from: from,
                to: to
            }
        });
    };
}
function $0eca9d59d86c0010$var$_isEvent(event) {
    return !!event && !!event.target;
}

});
parcelRequire.register("6Mx2b", function(module, exports) {

$parcel$export(module.exports, "addClickKeypressInstrumentationHandler", function () { return $4f00d9b11fecae4f$export$5aeffd3db2cf9df7; });

var $gYD4g = parcelRequire("gYD4g");

var $eKFW4 = parcelRequire("eKFW4");

var $hi0PN = parcelRequire("hi0PN");

var $aLlYl = parcelRequire("aLlYl");
const $4f00d9b11fecae4f$var$WINDOW = (0, $hi0PN.GLOBAL_OBJ);
const $4f00d9b11fecae4f$var$DEBOUNCE_DURATION = 1000;
let $4f00d9b11fecae4f$var$debounceTimerID;
let $4f00d9b11fecae4f$var$lastCapturedEventType;
let $4f00d9b11fecae4f$var$lastCapturedEventTargetId;
/**
 * Add an instrumentation handler for when a click or a keypress happens.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $4f00d9b11fecae4f$export$5aeffd3db2cf9df7(handler) {
    const type = "dom";
    (0, $aLlYl.addHandler)(type, handler);
    (0, $aLlYl.maybeInstrument)(type, $4f00d9b11fecae4f$export$3014bbf0af0e1d4a);
}
/** Exported for tests only. */ function $4f00d9b11fecae4f$export$3014bbf0af0e1d4a() {
    if (!$4f00d9b11fecae4f$var$WINDOW.document) return;
    // Make it so that any click or keypress that is unhandled / bubbled up all the way to the document triggers our dom
    // handlers. (Normally we have only one, which captures a breadcrumb for each click or keypress.) Do this before
    // we instrument `addEventListener` so that we don't end up attaching this handler twice.
    const triggerDOMHandler = (0, $aLlYl.triggerHandlers).bind(null, "dom");
    const globalDOMEventHandler = $4f00d9b11fecae4f$var$makeDOMEventHandler(triggerDOMHandler, true);
    $4f00d9b11fecae4f$var$WINDOW.document.addEventListener("click", globalDOMEventHandler, false);
    $4f00d9b11fecae4f$var$WINDOW.document.addEventListener("keypress", globalDOMEventHandler, false);
    // After hooking into click and keypress events bubbled up to `document`, we also hook into user-handled
    // clicks & keypresses, by adding an event listener of our own to any element to which they add a listener. That
    // way, whenever one of their handlers is triggered, ours will be, too. (This is needed because their handler
    // could potentially prevent the event from bubbling up to our global listeners. This way, our handler are still
    // guaranteed to fire at least once.)
    [
        "EventTarget",
        "Node"
    ].forEach((target)=>{
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        const proto = $4f00d9b11fecae4f$var$WINDOW[target] && $4f00d9b11fecae4f$var$WINDOW[target].prototype;
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, no-prototype-builtins
        if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty("addEventListener")) return;
        (0, $eKFW4.fill)(proto, "addEventListener", function(originalAddEventListener) {
            return function(type, listener, options) {
                if (type === "click" || type == "keypress") try {
                    const el = this;
                    const handlers = el.__sentry_instrumentation_handlers__ = el.__sentry_instrumentation_handlers__ || {};
                    const handlerForType = handlers[type] = handlers[type] || {
                        refCount: 0
                    };
                    if (!handlerForType.handler) {
                        const handler = $4f00d9b11fecae4f$var$makeDOMEventHandler(triggerDOMHandler);
                        handlerForType.handler = handler;
                        originalAddEventListener.call(this, type, handler, options);
                    }
                    handlerForType.refCount++;
                } catch (e) {
                // Accessing dom properties is always fragile.
                // Also allows us to skip `addEventListenrs` calls with no proper `this` context.
                }
                return originalAddEventListener.call(this, type, listener, options);
            };
        });
        (0, $eKFW4.fill)(proto, "removeEventListener", function(originalRemoveEventListener) {
            return function(type, listener, options) {
                if (type === "click" || type == "keypress") try {
                    const el = this;
                    const handlers = el.__sentry_instrumentation_handlers__ || {};
                    const handlerForType = handlers[type];
                    if (handlerForType) {
                        handlerForType.refCount--;
                        // If there are no longer any custom handlers of the current type on this element, we can remove ours, too.
                        if (handlerForType.refCount <= 0) {
                            originalRemoveEventListener.call(this, type, handlerForType.handler, options);
                            handlerForType.handler = undefined;
                            delete handlers[type]; // eslint-disable-line @typescript-eslint/no-dynamic-delete
                        }
                        // If there are no longer any custom handlers of any type on this element, cleanup everything.
                        if (Object.keys(handlers).length === 0) delete el.__sentry_instrumentation_handlers__;
                    }
                } catch (e) {
                // Accessing dom properties is always fragile.
                // Also allows us to skip `addEventListenrs` calls with no proper `this` context.
                }
                return originalRemoveEventListener.call(this, type, listener, options);
            };
        });
    });
}
/**
 * Check whether the event is similar to the last captured one. For example, two click events on the same button.
 */ function $4f00d9b11fecae4f$var$isSimilarToLastCapturedEvent(event) {
    // If both events have different type, then user definitely performed two separate actions. e.g. click + keypress.
    if (event.type !== $4f00d9b11fecae4f$var$lastCapturedEventType) return false;
    try {
        // If both events have the same type, it's still possible that actions were performed on different targets.
        // e.g. 2 clicks on different buttons.
        if (!event.target || event.target._sentryId !== $4f00d9b11fecae4f$var$lastCapturedEventTargetId) return false;
    } catch (e) {
    // just accessing `target` property can throw an exception in some rare circumstances
    // see: https://github.com/getsentry/sentry-javascript/issues/838
    }
    // If both events have the same type _and_ same `target` (an element which triggered an event, _not necessarily_
    // to which an event listener was attached), we treat them as the same action, as we want to capture
    // only one breadcrumb. e.g. multiple clicks on the same button, or typing inside a user input box.
    return true;
}
/**
 * Decide whether an event should be captured.
 * @param event event to be captured
 */ function $4f00d9b11fecae4f$var$shouldSkipDOMEvent(eventType, target) {
    // We are only interested in filtering `keypress` events for now.
    if (eventType !== "keypress") return false;
    if (!target || !target.tagName) return true;
    // Only consider keypress events on actual input elements. This will disregard keypresses targeting body
    // e.g.tabbing through elements, hotkeys, etc.
    if (target.tagName === "INPUT" || target.tagName === "TEXTAREA" || target.isContentEditable) return false;
    return true;
}
/**
 * Wraps addEventListener to capture UI breadcrumbs
 */ function $4f00d9b11fecae4f$var$makeDOMEventHandler(handler, globalListener = false) {
    return (event)=>{
        // It's possible this handler might trigger multiple times for the same
        // event (e.g. event propagation through node ancestors).
        // Ignore if we've already captured that event.
        if (!event || event["_sentryCaptured"]) return;
        const target = $4f00d9b11fecae4f$var$getEventTarget(event);
        // We always want to skip _some_ events.
        if ($4f00d9b11fecae4f$var$shouldSkipDOMEvent(event.type, target)) return;
        // Mark event as "seen"
        (0, $eKFW4.addNonEnumerableProperty)(event, "_sentryCaptured", true);
        if (target && !target._sentryId) // Add UUID to event target so we can identify if
        (0, $eKFW4.addNonEnumerableProperty)(target, "_sentryId", (0, $gYD4g.uuid4)());
        const name = event.type === "keypress" ? "input" : event.type;
        // If there is no last captured event, it means that we can safely capture the new event and store it for future comparisons.
        // If there is a last captured event, see if the new event is different enough to treat it as a unique one.
        // If that's the case, emit the previous event and store locally the newly-captured DOM event.
        if (!$4f00d9b11fecae4f$var$isSimilarToLastCapturedEvent(event)) {
            const handlerData = {
                event: event,
                name: name,
                global: globalListener
            };
            handler(handlerData);
            $4f00d9b11fecae4f$var$lastCapturedEventType = event.type;
            $4f00d9b11fecae4f$var$lastCapturedEventTargetId = target ? target._sentryId : undefined;
        }
        // Start a new debounce timer that will prevent us from capturing multiple events that should be grouped together.
        clearTimeout($4f00d9b11fecae4f$var$debounceTimerID);
        $4f00d9b11fecae4f$var$debounceTimerID = $4f00d9b11fecae4f$var$WINDOW.setTimeout(()=>{
            $4f00d9b11fecae4f$var$lastCapturedEventTargetId = undefined;
            $4f00d9b11fecae4f$var$lastCapturedEventType = undefined;
        }, $4f00d9b11fecae4f$var$DEBOUNCE_DURATION);
    };
}
function $4f00d9b11fecae4f$var$getEventTarget(event) {
    try {
        return event.target;
    } catch (e) {
        // just accessing `target` property can throw an exception in some rare circumstances
        // see: https://github.com/getsentry/sentry-javascript/issues/838
        return null;
    }
}

});

parcelRequire.register("kRzdA", function(module, exports) {

$parcel$export(module.exports, "addConsoleInstrumentationHandler", function () { return $f304137d2d209a7a$export$1d6e0d073f9e6723; });

var $fi7Bg = parcelRequire("fi7Bg");

var $eKFW4 = parcelRequire("eKFW4");

var $hi0PN = parcelRequire("hi0PN");

var $aLlYl = parcelRequire("aLlYl");
/**
 * Add an instrumentation handler for when a console.xxx method is called.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $f304137d2d209a7a$export$1d6e0d073f9e6723(handler) {
    const type = "console";
    (0, $aLlYl.addHandler)(type, handler);
    (0, $aLlYl.maybeInstrument)(type, $f304137d2d209a7a$var$instrumentConsole);
}
function $f304137d2d209a7a$var$instrumentConsole() {
    if (!("console" in (0, $hi0PN.GLOBAL_OBJ))) return;
    (0, $fi7Bg.CONSOLE_LEVELS).forEach(function(level) {
        if (!(level in (0, $hi0PN.GLOBAL_OBJ).console)) return;
        (0, $eKFW4.fill)((0, $hi0PN.GLOBAL_OBJ).console, level, function(originalConsoleMethod) {
            (0, $fi7Bg.originalConsoleMethods)[level] = originalConsoleMethod;
            return function(...args) {
                const handlerData = {
                    args: args,
                    level: level
                };
                (0, $aLlYl.triggerHandlers)("console", handlerData);
                const log = (0, $fi7Bg.originalConsoleMethods)[level];
                log && log.apply((0, $hi0PN.GLOBAL_OBJ).console, args);
            };
        });
    });
}

});

parcelRequire.register("cFhJf", function(module, exports) {

$parcel$export(module.exports, "addFetchInstrumentationHandler", function () { return $938710f33d2c8b5c$export$f75d3c772c923df0; });

var $eKFW4 = parcelRequire("eKFW4");

var $014xT = parcelRequire("014xT");

var $hi0PN = parcelRequire("hi0PN");

var $aLlYl = parcelRequire("aLlYl");
/**
 * Add an instrumentation handler for when a fetch request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $938710f33d2c8b5c$export$f75d3c772c923df0(handler) {
    const type = "fetch";
    (0, $aLlYl.addHandler)(type, handler);
    (0, $aLlYl.maybeInstrument)(type, $938710f33d2c8b5c$var$instrumentFetch);
}
function $938710f33d2c8b5c$var$instrumentFetch() {
    if (!(0, $014xT.supportsNativeFetch)()) return;
    (0, $eKFW4.fill)((0, $hi0PN.GLOBAL_OBJ), "fetch", function(originalFetch) {
        return function(...args) {
            const { method: method, url: url } = $938710f33d2c8b5c$export$f7a71163cc309d9a(args);
            const handlerData = {
                args: args,
                fetchData: {
                    method: method,
                    url: url
                },
                startTimestamp: Date.now()
            };
            (0, $aLlYl.triggerHandlers)("fetch", {
                ...handlerData
            });
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            return originalFetch.apply((0, $hi0PN.GLOBAL_OBJ), args).then((response)=>{
                const finishedHandlerData = {
                    ...handlerData,
                    endTimestamp: Date.now(),
                    response: response
                };
                (0, $aLlYl.triggerHandlers)("fetch", finishedHandlerData);
                return response;
            }, (error)=>{
                const erroredHandlerData = {
                    ...handlerData,
                    endTimestamp: Date.now(),
                    error: error
                };
                (0, $aLlYl.triggerHandlers)("fetch", erroredHandlerData);
                // NOTE: If you are a Sentry user, and you are seeing this stack frame,
                //       it means the sentry.javascript SDK caught an error invoking your application code.
                //       This is expected behavior and NOT indicative of a bug with sentry.javascript.
                throw error;
            });
        };
    });
}
function $938710f33d2c8b5c$var$hasProp(obj, prop) {
    return !!obj && typeof obj === "object" && !!obj[prop];
}
function $938710f33d2c8b5c$var$getUrlFromResource(resource) {
    if (typeof resource === "string") return resource;
    if (!resource) return "";
    if ($938710f33d2c8b5c$var$hasProp(resource, "url")) return resource.url;
    if (resource.toString) return resource.toString();
    return "";
}
/**
 * Parses the fetch arguments to find the used Http method and the url of the request.
 * Exported for tests only.
 */ function $938710f33d2c8b5c$export$f7a71163cc309d9a(fetchArgs) {
    if (fetchArgs.length === 0) return {
        method: "GET",
        url: ""
    };
    if (fetchArgs.length === 2) {
        const [url, options] = fetchArgs;
        return {
            url: $938710f33d2c8b5c$var$getUrlFromResource(url),
            method: $938710f33d2c8b5c$var$hasProp(options, "method") ? String(options.method).toUpperCase() : "GET"
        };
    }
    const arg = fetchArgs[0];
    return {
        url: $938710f33d2c8b5c$var$getUrlFromResource(arg),
        method: $938710f33d2c8b5c$var$hasProp(arg, "method") ? String(arg.method).toUpperCase() : "GET"
    };
}

});

parcelRequire.register("29jHe", function(module, exports) {

$parcel$export(module.exports, "SENTRY_XHR_DATA_KEY", function () { return $190bb34a2d3cfa6e$export$55b6bb1e45c6cf59; });
$parcel$export(module.exports, "addXhrInstrumentationHandler", function () { return $190bb34a2d3cfa6e$export$26ace48dd54c9aea; });

var $5lwZa = parcelRequire("5lwZa");

var $eKFW4 = parcelRequire("eKFW4");

var $hi0PN = parcelRequire("hi0PN");

var $aLlYl = parcelRequire("aLlYl");
const $190bb34a2d3cfa6e$var$WINDOW = (0, $hi0PN.GLOBAL_OBJ);
const $190bb34a2d3cfa6e$export$55b6bb1e45c6cf59 = "__sentry_xhr_v3__";
/**
 * Add an instrumentation handler for when an XHR request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $190bb34a2d3cfa6e$export$26ace48dd54c9aea(handler) {
    const type = "xhr";
    (0, $aLlYl.addHandler)(type, handler);
    (0, $aLlYl.maybeInstrument)(type, $190bb34a2d3cfa6e$export$c67d533bf77cbf54);
}
/** Exported only for tests. */ function $190bb34a2d3cfa6e$export$c67d533bf77cbf54() {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    if (!$190bb34a2d3cfa6e$var$WINDOW.XMLHttpRequest) return;
    const xhrproto = XMLHttpRequest.prototype;
    (0, $eKFW4.fill)(xhrproto, "open", function(originalOpen) {
        return function(...args) {
            const startTimestamp = Date.now();
            // open() should always be called with two or more arguments
            // But to be on the safe side, we actually validate this and bail out if we don't have a method & url
            const method = (0, $5lwZa.isString)(args[0]) ? args[0].toUpperCase() : undefined;
            const url = $190bb34a2d3cfa6e$var$parseUrl(args[1]);
            if (!method || !url) return originalOpen.apply(this, args);
            this[$190bb34a2d3cfa6e$export$55b6bb1e45c6cf59] = {
                method: method,
                url: url,
                request_headers: {}
            };
            // if Sentry key appears in URL, don't capture it as a request
            if (method === "POST" && url.match(/sentry_key/)) this.__sentry_own_request__ = true;
            const onreadystatechangeHandler = ()=>{
                // For whatever reason, this is not the same instance here as from the outer method
                const xhrInfo = this[$190bb34a2d3cfa6e$export$55b6bb1e45c6cf59];
                if (!xhrInfo) return;
                if (this.readyState === 4) {
                    try {
                        // touching statusCode in some platforms throws
                        // an exception
                        xhrInfo.status_code = this.status;
                    } catch (e) {
                    /* do nothing */ }
                    const handlerData = {
                        args: [
                            method,
                            url
                        ],
                        endTimestamp: Date.now(),
                        startTimestamp: startTimestamp,
                        xhr: this
                    };
                    (0, $aLlYl.triggerHandlers)("xhr", handlerData);
                }
            };
            if ("onreadystatechange" in this && typeof this.onreadystatechange === "function") (0, $eKFW4.fill)(this, "onreadystatechange", function(original) {
                return function(...readyStateArgs) {
                    onreadystatechangeHandler();
                    return original.apply(this, readyStateArgs);
                };
            });
            else this.addEventListener("readystatechange", onreadystatechangeHandler);
            // Intercepting `setRequestHeader` to access the request headers of XHR instance.
            // This will only work for user/library defined headers, not for the default/browser-assigned headers.
            // Request cookies are also unavailable for XHR, as `Cookie` header can't be defined by `setRequestHeader`.
            (0, $eKFW4.fill)(this, "setRequestHeader", function(original) {
                return function(...setRequestHeaderArgs) {
                    const [header, value] = setRequestHeaderArgs;
                    const xhrInfo = this[$190bb34a2d3cfa6e$export$55b6bb1e45c6cf59];
                    if (xhrInfo && (0, $5lwZa.isString)(header) && (0, $5lwZa.isString)(value)) xhrInfo.request_headers[header.toLowerCase()] = value;
                    return original.apply(this, setRequestHeaderArgs);
                };
            });
            return originalOpen.apply(this, args);
        };
    });
    (0, $eKFW4.fill)(xhrproto, "send", function(originalSend) {
        return function(...args) {
            const sentryXhrData = this[$190bb34a2d3cfa6e$export$55b6bb1e45c6cf59];
            if (!sentryXhrData) return originalSend.apply(this, args);
            if (args[0] !== undefined) sentryXhrData.body = args[0];
            const handlerData = {
                args: [
                    sentryXhrData.method,
                    sentryXhrData.url
                ],
                startTimestamp: Date.now(),
                xhr: this
            };
            (0, $aLlYl.triggerHandlers)("xhr", handlerData);
            return originalSend.apply(this, args);
        };
    });
}
function $190bb34a2d3cfa6e$var$parseUrl(url) {
    if ((0, $5lwZa.isString)(url)) return url;
    try {
        // url can be a string or URL
        // but since URL is not available in IE11, we do not check for it,
        // but simply assume it is an URL and return `toString()` from it (which returns the full URL)
        // If that fails, we just return undefined
        return url.toString();
    } catch (e2) {} // eslint-disable-line no-empty
    return undefined;
}

});

parcelRequire.register("bqFJd", function(module, exports) {

$parcel$export(module.exports, "parseUrl", function () { return $85227dc818e9df53$export$7a5253c0f62e0150; });
/**
 * Parses string form of URL into an object
 * // borrowed from https://tools.ietf.org/html/rfc3986#appendix-B
 * // intentionally using regex and not <a/> href parsing trick because React Native and other
 * // environments where DOM might not be available
 * @returns parsed URL object
 */ function $85227dc818e9df53$export$7a5253c0f62e0150(url) {
    if (!url) return {};
    const match = url.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
    if (!match) return {};
    // coerce to undefined values to empty string so we don't get 'undefined'
    const query = match[6] || "";
    const fragment = match[8] || "";
    return {
        host: match[4],
        path: match[5],
        protocol: match[2],
        search: query,
        hash: fragment,
        relative: match[5] + query + fragment
    };
}
/**
 * Strip the query string and fragment off of a given URL or path (if present)
 *
 * @param urlPath Full URL or path, including possible query string and/or fragment
 * @returns URL or path without query string or fragment
 */ function $85227dc818e9df53$export$ce084c78234bd35(urlPath) {
    // eslint-disable-next-line no-useless-escape
    return urlPath.split(/[\?#]/, 1)[0];
}
/**
 * Returns number of URL segments of a passed string URL.
 */ function $85227dc818e9df53$export$69dd85280a8d374c(url) {
    // split at '/' or at '\/' to split regex urls correctly
    return url.split(/\\?\//).filter((s)=>s.length > 0 && s !== ",").length;
}
/**
 * Takes a URL object and returns a sanitized string which is safe to use as span description
 * see: https://develop.sentry.dev/sdk/data-handling/#structuring-data
 */ function $85227dc818e9df53$export$e0ba26c9e23e1fe0(url) {
    const { protocol: protocol, host: host, path: path } = url;
    const filteredHost = host && host// Always filter out authority
    .replace(/^.*@/, "[filtered]:[filtered]@")// Don't show standard :80 (http) and :443 (https) ports to reduce the noise
    // TODO: Use new URL global if it exists
    .replace(/(:80)$/, "").replace(/(:443)$/, "") || "";
    return `${protocol ? `${protocol}://` : ""}${filteredHost}${path}`;
}

});

parcelRequire.register("8wVim", function(module, exports) {

$parcel$export(module.exports, "severityLevelFromString", function () { return $635dc1859f7cef86$export$d771ef054122c30a; });
// Note: Ideally the `SeverityLevel` type would be derived from `validSeverityLevels`, but that would mean either
//
// a) moving `validSeverityLevels` to `@sentry/types`,
// b) moving the`SeverityLevel` type here, or
// c) importing `validSeverityLevels` from here into `@sentry/types`.
//
// Option A would make `@sentry/types` a runtime dependency of `@sentry/utils` (not good), and options B and C would
// create a circular dependency between `@sentry/types` and `@sentry/utils` (also not good). So a TODO accompanying the
// type, reminding anyone who changes it to change this list also, will have to do.
const $635dc1859f7cef86$export$411d0ffdba845b6c = [
    "fatal",
    "error",
    "warning",
    "log",
    "info",
    "debug"
];
/**
 * Converts a string-based level into a member of the deprecated {@link Severity} enum.
 *
 * @deprecated `severityFromString` is deprecated. Please use `severityLevelFromString` instead.
 *
 * @param level String representation of Severity
 * @returns Severity
 */ function $635dc1859f7cef86$export$e01cef29b4327697(level) {
    return $635dc1859f7cef86$export$d771ef054122c30a(level);
}
/**
 * Converts a string-based level into a `SeverityLevel`, normalizing it along the way.
 *
 * @param level String representation of desired `SeverityLevel`.
 * @returns The `SeverityLevel` corresponding to the given string, or 'log' if the string isn't a valid level.
 */ function $635dc1859f7cef86$export$d771ef054122c30a(level) {
    return level === "warn" ? "warning" : $635dc1859f7cef86$export$411d0ffdba845b6c.includes(level) ? level : "log";
}

});


parcelRequire.register("bGs58", function(module, exports) {

$parcel$export(module.exports, "dedupeIntegration", function () { return $881966648bdbf51f$export$6d39aa44cd0c7567; });

var $dp2Cj = parcelRequire("dp2Cj");

var $fi7Bg = parcelRequire("fi7Bg");

var $23Gvz = parcelRequire("23Gvz");
const $881966648bdbf51f$var$INTEGRATION_NAME = "Dedupe";
const $881966648bdbf51f$var$_dedupeIntegration = ()=>{
    let previousEvent;
    return {
        name: $881966648bdbf51f$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        processEvent (currentEvent) {
            // We want to ignore any non-error type events, e.g. transactions or replays
            // These should never be deduped, and also not be compared against as _previousEvent.
            if (currentEvent.type) return currentEvent;
            // Juuust in case something goes wrong
            try {
                if ($881966648bdbf51f$var$_shouldDropEvent(currentEvent, previousEvent)) {
                    (0, $23Gvz.DEBUG_BUILD) && (0, $fi7Bg.logger).warn("Event dropped due to being a duplicate of previously captured event.");
                    return null;
                }
            } catch (_oO) {} // eslint-disable-line no-empty
            return previousEvent = currentEvent;
        }
    };
};
const $881966648bdbf51f$export$6d39aa44cd0c7567 = (0, $dp2Cj.defineIntegration)($881966648bdbf51f$var$_dedupeIntegration);
/**
 * Deduplication filter.
 * @deprecated Use `dedupeIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $881966648bdbf51f$export$688d98c249d31ad3 = (0, $dp2Cj.convertIntegrationFnToClass)($881966648bdbf51f$var$INTEGRATION_NAME, $881966648bdbf51f$export$6d39aa44cd0c7567);
function $881966648bdbf51f$var$_shouldDropEvent(currentEvent, previousEvent) {
    if (!previousEvent) return false;
    if ($881966648bdbf51f$var$_isSameMessageEvent(currentEvent, previousEvent)) return true;
    if ($881966648bdbf51f$var$_isSameExceptionEvent(currentEvent, previousEvent)) return true;
    return false;
}
function $881966648bdbf51f$var$_isSameMessageEvent(currentEvent, previousEvent) {
    const currentMessage = currentEvent.message;
    const previousMessage = previousEvent.message;
    // If neither event has a message property, they were both exceptions, so bail out
    if (!currentMessage && !previousMessage) return false;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentMessage && !previousMessage || !currentMessage && previousMessage) return false;
    if (currentMessage !== previousMessage) return false;
    if (!$881966648bdbf51f$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$881966648bdbf51f$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
function $881966648bdbf51f$var$_isSameExceptionEvent(currentEvent, previousEvent) {
    const previousException = $881966648bdbf51f$var$_getExceptionFromEvent(previousEvent);
    const currentException = $881966648bdbf51f$var$_getExceptionFromEvent(currentEvent);
    if (!previousException || !currentException) return false;
    if (previousException.type !== currentException.type || previousException.value !== currentException.value) return false;
    if (!$881966648bdbf51f$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$881966648bdbf51f$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
function $881966648bdbf51f$var$_isSameStacktrace(currentEvent, previousEvent) {
    let currentFrames = $881966648bdbf51f$var$_getFramesFromEvent(currentEvent);
    let previousFrames = $881966648bdbf51f$var$_getFramesFromEvent(previousEvent);
    // If neither event has a stacktrace, they are assumed to be the same
    if (!currentFrames && !previousFrames) return true;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentFrames && !previousFrames || !currentFrames && previousFrames) return false;
    currentFrames;
    previousFrames;
    // If number of frames differ, they are not the same
    if (previousFrames.length !== currentFrames.length) return false;
    // Otherwise, compare the two
    for(let i = 0; i < previousFrames.length; i++){
        const frameA = previousFrames[i];
        const frameB = currentFrames[i];
        if (frameA.filename !== frameB.filename || frameA.lineno !== frameB.lineno || frameA.colno !== frameB.colno || frameA.function !== frameB.function) return false;
    }
    return true;
}
function $881966648bdbf51f$var$_isSameFingerprint(currentEvent, previousEvent) {
    let currentFingerprint = currentEvent.fingerprint;
    let previousFingerprint = previousEvent.fingerprint;
    // If neither event has a fingerprint, they are assumed to be the same
    if (!currentFingerprint && !previousFingerprint) return true;
    // If only one event has a fingerprint, but not the other one, they are not the same
    if (currentFingerprint && !previousFingerprint || !currentFingerprint && previousFingerprint) return false;
    currentFingerprint;
    previousFingerprint;
    // Otherwise, compare the two
    try {
        return !!(currentFingerprint.join("") === previousFingerprint.join(""));
    } catch (_oO) {
        return false;
    }
}
function $881966648bdbf51f$var$_getExceptionFromEvent(event) {
    return event.exception && event.exception.values && event.exception.values[0];
}
function $881966648bdbf51f$var$_getFramesFromEvent(event) {
    const exception = event.exception;
    if (exception) try {
        // @ts-expect-error Object could be undefined
        return exception.values[0].stacktrace.frames;
    } catch (_oO) {
        return undefined;
    }
    return undefined;
}

});

parcelRequire.register("3xVxZ", function(module, exports) {

$parcel$export(module.exports, "globalHandlersIntegration", function () { return $295117d6ce1b9698$export$66acc70e8cf2b71a; });

var $9Dess = parcelRequire("9Dess");
var $dp2Cj = parcelRequire("dp2Cj");

var $fPS2N = parcelRequire("fPS2N");
var $bOZFJ = parcelRequire("bOZFJ");
var $ffqzi = parcelRequire("ffqzi");
var $5lwZa = parcelRequire("5lwZa");
var $fi7Bg = parcelRequire("fi7Bg");

var $23Gvz = parcelRequire("23Gvz");

var $kH7dV = parcelRequire("kH7dV");

var $gY4ad = parcelRequire("gY4ad");
/* eslint-disable @typescript-eslint/no-unsafe-member-access */ const $295117d6ce1b9698$var$INTEGRATION_NAME = "GlobalHandlers";
const $295117d6ce1b9698$var$_globalHandlersIntegration = (options = {})=>{
    const _options = {
        onerror: true,
        onunhandledrejection: true,
        ...options
    };
    return {
        name: $295117d6ce1b9698$var$INTEGRATION_NAME,
        setupOnce () {
            Error.stackTraceLimit = 50;
        },
        setup (client) {
            if (_options.onerror) {
                $295117d6ce1b9698$var$_installGlobalOnErrorHandler(client);
                $295117d6ce1b9698$var$globalHandlerLog("onerror");
            }
            if (_options.onunhandledrejection) {
                $295117d6ce1b9698$var$_installGlobalOnUnhandledRejectionHandler(client);
                $295117d6ce1b9698$var$globalHandlerLog("onunhandledrejection");
            }
        }
    };
};
const $295117d6ce1b9698$export$66acc70e8cf2b71a = (0, $dp2Cj.defineIntegration)($295117d6ce1b9698$var$_globalHandlersIntegration);
/**
 * Global handlers.
 * @deprecated Use `globalHandlersIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $295117d6ce1b9698$export$204155decbc90e5a = (0, $dp2Cj.convertIntegrationFnToClass)($295117d6ce1b9698$var$INTEGRATION_NAME, $295117d6ce1b9698$export$66acc70e8cf2b71a);
function $295117d6ce1b9698$var$_installGlobalOnErrorHandler(client) {
    (0, $fPS2N.addGlobalErrorInstrumentationHandler)((data)=>{
        const { stackParser: stackParser, attachStacktrace: attachStacktrace } = $295117d6ce1b9698$var$getOptions();
        if ((0, $9Dess.getClient)() !== client || (0, $gY4ad.shouldIgnoreOnError)()) return;
        const { msg: msg, url: url, line: line, column: column, error: error } = data;
        const event = error === undefined && (0, $5lwZa.isString)(msg) ? $295117d6ce1b9698$var$_eventFromIncompleteOnError(msg, url, line, column) : $295117d6ce1b9698$var$_enhanceEventWithInitialFrame((0, $kH7dV.eventFromUnknownInput)(stackParser, error || msg, undefined, attachStacktrace, false), url, line, column);
        event.level = "error";
        (0, $9Dess.captureEvent)(event, {
            originalException: error,
            mechanism: {
                handled: false,
                type: "onerror"
            }
        });
    });
}
function $295117d6ce1b9698$var$_installGlobalOnUnhandledRejectionHandler(client) {
    (0, $bOZFJ.addGlobalUnhandledRejectionInstrumentationHandler)((e)=>{
        const { stackParser: stackParser, attachStacktrace: attachStacktrace } = $295117d6ce1b9698$var$getOptions();
        if ((0, $9Dess.getClient)() !== client || (0, $gY4ad.shouldIgnoreOnError)()) return;
        const error = $295117d6ce1b9698$var$_getUnhandledRejectionError(e);
        const event = (0, $5lwZa.isPrimitive)(error) ? $295117d6ce1b9698$var$_eventFromRejectionWithPrimitive(error) : (0, $kH7dV.eventFromUnknownInput)(stackParser, error, undefined, attachStacktrace, true);
        event.level = "error";
        (0, $9Dess.captureEvent)(event, {
            originalException: error,
            mechanism: {
                handled: false,
                type: "onunhandledrejection"
            }
        });
    });
}
function $295117d6ce1b9698$var$_getUnhandledRejectionError(error) {
    if ((0, $5lwZa.isPrimitive)(error)) return error;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const e = error;
    // dig the object of the rejection out of known event types
    try {
        // PromiseRejectionEvents store the object of the rejection under 'reason'
        // see https://developer.mozilla.org/en-US/docs/Web/API/PromiseRejectionEvent
        if ("reason" in e) return e.reason;
        else if ("detail" in e && "reason" in e.detail) return e.detail.reason;
    } catch (e2) {} // eslint-disable-line no-empty
    return error;
}
/**
 * Create an event from a promise rejection where the `reason` is a primitive.
 *
 * @param reason: The `reason` property of the promise rejection
 * @returns An Event object with an appropriate `exception` value
 */ function $295117d6ce1b9698$var$_eventFromRejectionWithPrimitive(reason) {
    return {
        exception: {
            values: [
                {
                    type: "UnhandledRejection",
                    // String() is needed because the Primitive type includes symbols (which can't be automatically stringified)
                    value: `Non-Error promise rejection captured with value: ${String(reason)}`
                }
            ]
        }
    };
}
/**
 * This function creates a stack from an old, error-less onerror handler.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $295117d6ce1b9698$var$_eventFromIncompleteOnError(msg, url, line, column) {
    const ERROR_TYPES_RE = /^(?:[Uu]ncaught (?:exception: )?)?(?:((?:Eval|Internal|Range|Reference|Syntax|Type|URI|)Error): )?(.*)$/i;
    // If 'message' is ErrorEvent, get real message from inside
    let message = (0, $5lwZa.isErrorEvent)(msg) ? msg.message : msg;
    let name = "Error";
    const groups = message.match(ERROR_TYPES_RE);
    if (groups) {
        name = groups[1];
        message = groups[2];
    }
    const event = {
        exception: {
            values: [
                {
                    type: name,
                    value: message
                }
            ]
        }
    };
    return $295117d6ce1b9698$var$_enhanceEventWithInitialFrame(event, url, line, column);
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $295117d6ce1b9698$var$_enhanceEventWithInitialFrame(event, url, line, column) {
    // event.exception
    const e = event.exception = event.exception || {};
    // event.exception.values
    const ev = e.values = e.values || [];
    // event.exception.values[0]
    const ev0 = ev[0] = ev[0] || {};
    // event.exception.values[0].stacktrace
    const ev0s = ev0.stacktrace = ev0.stacktrace || {};
    // event.exception.values[0].stacktrace.frames
    const ev0sf = ev0s.frames = ev0s.frames || [];
    const colno = isNaN(parseInt(column, 10)) ? undefined : column;
    const lineno = isNaN(parseInt(line, 10)) ? undefined : line;
    const filename = (0, $5lwZa.isString)(url) && url.length > 0 ? url : (0, $ffqzi.getLocationHref)();
    // event.exception.values[0].stacktrace.frames
    if (ev0sf.length === 0) ev0sf.push({
        colno: colno,
        filename: filename,
        function: "?",
        in_app: true,
        lineno: lineno
    });
    return event;
}
function $295117d6ce1b9698$var$globalHandlerLog(type) {
    (0, $23Gvz.DEBUG_BUILD) && (0, $fi7Bg.logger).log(`Global Handler attached: ${type}`);
}
function $295117d6ce1b9698$var$getOptions() {
    const client = (0, $9Dess.getClient)();
    const options = client && client.getOptions() || {
        stackParser: ()=>[],
        attachStacktrace: false
    };
    return options;
}

});
parcelRequire.register("fPS2N", function(module, exports) {

$parcel$export(module.exports, "addGlobalErrorInstrumentationHandler", function () { return $b8758a75bde23aac$export$55b5c3ba2194f0c6; });

var $hi0PN = parcelRequire("hi0PN");

var $aLlYl = parcelRequire("aLlYl");
let $b8758a75bde23aac$var$_oldOnErrorHandler = null;
/**
 * Add an instrumentation handler for when an error is captured by the global error handler.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $b8758a75bde23aac$export$55b5c3ba2194f0c6(handler) {
    const type = "error";
    (0, $aLlYl.addHandler)(type, handler);
    (0, $aLlYl.maybeInstrument)(type, $b8758a75bde23aac$var$instrumentError);
}
function $b8758a75bde23aac$var$instrumentError() {
    $b8758a75bde23aac$var$_oldOnErrorHandler = (0, $hi0PN.GLOBAL_OBJ).onerror;
    (0, $hi0PN.GLOBAL_OBJ).onerror = function(msg, url, line, column, error) {
        const handlerData = {
            column: column,
            error: error,
            line: line,
            msg: msg,
            url: url
        };
        (0, $aLlYl.triggerHandlers)("error", handlerData);
        if ($b8758a75bde23aac$var$_oldOnErrorHandler && !$b8758a75bde23aac$var$_oldOnErrorHandler.__SENTRY_LOADER__) // eslint-disable-next-line prefer-rest-params
        return $b8758a75bde23aac$var$_oldOnErrorHandler.apply(this, arguments);
        return false;
    };
    (0, $hi0PN.GLOBAL_OBJ).onerror.__SENTRY_INSTRUMENTED__ = true;
}

});

parcelRequire.register("bOZFJ", function(module, exports) {

$parcel$export(module.exports, "addGlobalUnhandledRejectionInstrumentationHandler", function () { return $89b43409c1e86f2a$export$8bf4fc6858821a4e; });

var $hi0PN = parcelRequire("hi0PN");

var $aLlYl = parcelRequire("aLlYl");
let $89b43409c1e86f2a$var$_oldOnUnhandledRejectionHandler = null;
/**
 * Add an instrumentation handler for when an unhandled promise rejection is captured.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $89b43409c1e86f2a$export$8bf4fc6858821a4e(handler) {
    const type = "unhandledrejection";
    (0, $aLlYl.addHandler)(type, handler);
    (0, $aLlYl.maybeInstrument)(type, $89b43409c1e86f2a$var$instrumentUnhandledRejection);
}
function $89b43409c1e86f2a$var$instrumentUnhandledRejection() {
    $89b43409c1e86f2a$var$_oldOnUnhandledRejectionHandler = (0, $hi0PN.GLOBAL_OBJ).onunhandledrejection;
    (0, $hi0PN.GLOBAL_OBJ).onunhandledrejection = function(e) {
        const handlerData = e;
        (0, $aLlYl.triggerHandlers)("unhandledrejection", handlerData);
        if ($89b43409c1e86f2a$var$_oldOnUnhandledRejectionHandler && !$89b43409c1e86f2a$var$_oldOnUnhandledRejectionHandler.__SENTRY_LOADER__) // eslint-disable-next-line prefer-rest-params
        return $89b43409c1e86f2a$var$_oldOnUnhandledRejectionHandler.apply(this, arguments);
        return true;
    };
    (0, $hi0PN.GLOBAL_OBJ).onunhandledrejection.__SENTRY_INSTRUMENTED__ = true;
}

});


parcelRequire.register("j4JoJ", function(module, exports) {

$parcel$export(module.exports, "httpContextIntegration", function () { return $de319b2413638d6f$export$1378794447170364; });

var $dp2Cj = parcelRequire("dp2Cj");

var $gY4ad = parcelRequire("gY4ad");
const $de319b2413638d6f$var$INTEGRATION_NAME = "HttpContext";
const $de319b2413638d6f$var$_httpContextIntegration = ()=>{
    return {
        name: $de319b2413638d6f$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        preprocessEvent (event) {
            // if none of the information we want exists, don't bother
            if (!(0, $gY4ad.WINDOW).navigator && !(0, $gY4ad.WINDOW).location && !(0, $gY4ad.WINDOW).document) return;
            // grab as much info as exists and add it to the event
            const url = event.request && event.request.url || (0, $gY4ad.WINDOW).location && (0, $gY4ad.WINDOW).location.href;
            const { referrer: referrer } = (0, $gY4ad.WINDOW).document || {};
            const { userAgent: userAgent } = (0, $gY4ad.WINDOW).navigator || {};
            const headers = {
                ...event.request && event.request.headers,
                ...referrer && {
                    Referer: referrer
                },
                ...userAgent && {
                    "User-Agent": userAgent
                }
            };
            const request = {
                ...event.request,
                ...url && {
                    url: url
                },
                headers: headers
            };
            event.request = request;
        }
    };
};
const $de319b2413638d6f$export$1378794447170364 = (0, $dp2Cj.defineIntegration)($de319b2413638d6f$var$_httpContextIntegration);
/**
 * HttpContext integration collects information about HTTP request headers.
 * @deprecated Use `httpContextIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $de319b2413638d6f$export$5d2ee9a544b09a94 = (0, $dp2Cj.convertIntegrationFnToClass)($de319b2413638d6f$var$INTEGRATION_NAME, $de319b2413638d6f$export$1378794447170364);

});

parcelRequire.register("6FVFB", function(module, exports) {

$parcel$export(module.exports, "linkedErrorsIntegration", function () { return $4dc34e7fc07809d1$export$ebabb00eb7f3a395; });

var $dp2Cj = parcelRequire("dp2Cj");

var $6osUS = parcelRequire("6osUS");

var $kH7dV = parcelRequire("kH7dV");
const $4dc34e7fc07809d1$var$DEFAULT_KEY = "cause";
const $4dc34e7fc07809d1$var$DEFAULT_LIMIT = 5;
const $4dc34e7fc07809d1$var$INTEGRATION_NAME = "LinkedErrors";
const $4dc34e7fc07809d1$var$_linkedErrorsIntegration = (options = {})=>{
    const limit = options.limit || $4dc34e7fc07809d1$var$DEFAULT_LIMIT;
    const key = options.key || $4dc34e7fc07809d1$var$DEFAULT_KEY;
    return {
        name: $4dc34e7fc07809d1$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        preprocessEvent (event, hint, client) {
            const options = client.getOptions();
            (0, $6osUS.applyAggregateErrorsToEvent)(// This differs from the LinkedErrors integration in core by using a different exceptionFromError function
            (0, $kH7dV.exceptionFromError), options.stackParser, options.maxValueLength, key, limit, event, hint);
        }
    };
};
const $4dc34e7fc07809d1$export$ebabb00eb7f3a395 = (0, $dp2Cj.defineIntegration)($4dc34e7fc07809d1$var$_linkedErrorsIntegration);
/**
 * Aggregrate linked errors in an event.
 * @deprecated Use `linkedErrorsIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $4dc34e7fc07809d1$export$8d1e60aaf616fb4f = (0, $dp2Cj.convertIntegrationFnToClass)($4dc34e7fc07809d1$var$INTEGRATION_NAME, $4dc34e7fc07809d1$export$ebabb00eb7f3a395);

});
parcelRequire.register("6osUS", function(module, exports) {

$parcel$export(module.exports, "applyAggregateErrorsToEvent", function () { return $4a7b6a27c7a15d9d$export$b91c38ed7d8ae9b2; });

var $5lwZa = parcelRequire("5lwZa");

var $2AO4R = parcelRequire("2AO4R");
/**
 * Creates exceptions inside `event.exception.values` for errors that are nested on properties based on the `key` parameter.
 */ function $4a7b6a27c7a15d9d$export$b91c38ed7d8ae9b2(exceptionFromErrorImplementation, parser, maxValueLimit = 250, key, limit, event, hint) {
    if (!event.exception || !event.exception.values || !hint || !(0, $5lwZa.isInstanceOf)(hint.originalException, Error)) return;
    // Generally speaking the last item in `event.exception.values` is the exception originating from the original Error
    const originalException = event.exception.values.length > 0 ? event.exception.values[event.exception.values.length - 1] : undefined;
    // We only create exception grouping if there is an exception in the event.
    if (originalException) event.exception.values = $4a7b6a27c7a15d9d$var$truncateAggregateExceptions($4a7b6a27c7a15d9d$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, hint.originalException, key, event.exception.values, originalException, 0), maxValueLimit);
}
function $4a7b6a27c7a15d9d$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, error, key, prevExceptions, exception, exceptionId) {
    if (prevExceptions.length >= limit + 1) return prevExceptions;
    let newExceptions = [
        ...prevExceptions
    ];
    // Recursively call this function in order to walk down a chain of errors
    if ((0, $5lwZa.isInstanceOf)(error[key], Error)) {
        $4a7b6a27c7a15d9d$var$applyExceptionGroupFieldsForParentException(exception, exceptionId);
        const newException = exceptionFromErrorImplementation(parser, error[key]);
        const newExceptionId = newExceptions.length;
        $4a7b6a27c7a15d9d$var$applyExceptionGroupFieldsForChildException(newException, key, newExceptionId, exceptionId);
        newExceptions = $4a7b6a27c7a15d9d$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, error[key], key, [
            newException,
            ...newExceptions
        ], newException, newExceptionId);
    }
    // This will create exception grouping for AggregateErrors
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/AggregateError
    if (Array.isArray(error.errors)) error.errors.forEach((childError, i)=>{
        if ((0, $5lwZa.isInstanceOf)(childError, Error)) {
            $4a7b6a27c7a15d9d$var$applyExceptionGroupFieldsForParentException(exception, exceptionId);
            const newException = exceptionFromErrorImplementation(parser, childError);
            const newExceptionId = newExceptions.length;
            $4a7b6a27c7a15d9d$var$applyExceptionGroupFieldsForChildException(newException, `errors[${i}]`, newExceptionId, exceptionId);
            newExceptions = $4a7b6a27c7a15d9d$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, childError, key, [
                newException,
                ...newExceptions
            ], newException, newExceptionId);
        }
    });
    return newExceptions;
}
function $4a7b6a27c7a15d9d$var$applyExceptionGroupFieldsForParentException(exception, exceptionId) {
    // Don't know if this default makes sense. The protocol requires us to set these values so we pick *some* default.
    exception.mechanism = exception.mechanism || {
        type: "generic",
        handled: true
    };
    exception.mechanism = {
        ...exception.mechanism,
        ...exception.type === "AggregateError" && {
            is_exception_group: true
        },
        exception_id: exceptionId
    };
}
function $4a7b6a27c7a15d9d$var$applyExceptionGroupFieldsForChildException(exception, source, exceptionId, parentId) {
    // Don't know if this default makes sense. The protocol requires us to set these values so we pick *some* default.
    exception.mechanism = exception.mechanism || {
        type: "generic",
        handled: true
    };
    exception.mechanism = {
        ...exception.mechanism,
        type: "chained",
        source: source,
        exception_id: exceptionId,
        parent_id: parentId
    };
}
/**
 * Truncate the message (exception.value) of all exceptions in the event.
 * Because this event processor is ran after `applyClientOptions`,
 * we need to truncate the message of the added exceptions here.
 */ function $4a7b6a27c7a15d9d$var$truncateAggregateExceptions(exceptions, maxValueLength) {
    return exceptions.map((exception)=>{
        if (exception.value) exception.value = (0, $2AO4R.truncate)(exception.value, maxValueLength);
        return exception;
    });
}

});


parcelRequire.register("fRwqh", function(module, exports) {

$parcel$export(module.exports, "browserApiErrorsIntegration", function () { return $b8c4f4bf038257a8$export$59bfe9f1c76150e; });

var $dp2Cj = parcelRequire("dp2Cj");

var $eKFW4 = parcelRequire("eKFW4");
var $9KjXB = parcelRequire("9KjXB");

var $gY4ad = parcelRequire("gY4ad");
const $b8c4f4bf038257a8$var$DEFAULT_EVENT_TARGET = [
    "EventTarget",
    "Window",
    "Node",
    "ApplicationCache",
    "AudioTrackList",
    "BroadcastChannel",
    "ChannelMergerNode",
    "CryptoOperation",
    "EventSource",
    "FileReader",
    "HTMLUnknownElement",
    "IDBDatabase",
    "IDBRequest",
    "IDBTransaction",
    "KeyOperation",
    "MediaController",
    "MessagePort",
    "ModalWindow",
    "Notification",
    "SVGElementInstance",
    "Screen",
    "SharedWorker",
    "TextTrack",
    "TextTrackCue",
    "TextTrackList",
    "WebSocket",
    "WebSocketWorker",
    "Worker",
    "XMLHttpRequest",
    "XMLHttpRequestEventTarget",
    "XMLHttpRequestUpload"
];
const $b8c4f4bf038257a8$var$INTEGRATION_NAME = "TryCatch";
const $b8c4f4bf038257a8$var$_browserApiErrorsIntegration = (options = {})=>{
    const _options = {
        XMLHttpRequest: true,
        eventTarget: true,
        requestAnimationFrame: true,
        setInterval: true,
        setTimeout: true,
        ...options
    };
    return {
        name: $b8c4f4bf038257a8$var$INTEGRATION_NAME,
        // TODO: This currently only works for the first client this is setup
        // We may want to adjust this to check for client etc.
        setupOnce () {
            if (_options.setTimeout) (0, $eKFW4.fill)((0, $gY4ad.WINDOW), "setTimeout", $b8c4f4bf038257a8$var$_wrapTimeFunction);
            if (_options.setInterval) (0, $eKFW4.fill)((0, $gY4ad.WINDOW), "setInterval", $b8c4f4bf038257a8$var$_wrapTimeFunction);
            if (_options.requestAnimationFrame) (0, $eKFW4.fill)((0, $gY4ad.WINDOW), "requestAnimationFrame", $b8c4f4bf038257a8$var$_wrapRAF);
            if (_options.XMLHttpRequest && "XMLHttpRequest" in (0, $gY4ad.WINDOW)) (0, $eKFW4.fill)(XMLHttpRequest.prototype, "send", $b8c4f4bf038257a8$var$_wrapXHR);
            const eventTargetOption = _options.eventTarget;
            if (eventTargetOption) {
                const eventTarget = Array.isArray(eventTargetOption) ? eventTargetOption : $b8c4f4bf038257a8$var$DEFAULT_EVENT_TARGET;
                eventTarget.forEach($b8c4f4bf038257a8$var$_wrapEventTarget);
            }
        }
    };
};
const $b8c4f4bf038257a8$export$59bfe9f1c76150e = (0, $dp2Cj.defineIntegration)($b8c4f4bf038257a8$var$_browserApiErrorsIntegration);
/**
 * Wrap timer functions and event targets to catch errors and provide better meta data.
 * @deprecated Use `browserApiErrorsIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $b8c4f4bf038257a8$export$f1a018517668e6d3 = (0, $dp2Cj.convertIntegrationFnToClass)($b8c4f4bf038257a8$var$INTEGRATION_NAME, $b8c4f4bf038257a8$export$59bfe9f1c76150e);
function $b8c4f4bf038257a8$var$_wrapTimeFunction(original) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function(...args) {
        const originalCallback = args[0];
        args[0] = (0, $gY4ad.wrap)(originalCallback, {
            mechanism: {
                data: {
                    function: (0, $9KjXB.getFunctionName)(original)
                },
                handled: false,
                type: "instrument"
            }
        });
        return original.apply(this, args);
    };
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $b8c4f4bf038257a8$var$_wrapRAF(original) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function(callback) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        return original.apply(this, [
            (0, $gY4ad.wrap)(callback, {
                mechanism: {
                    data: {
                        function: "requestAnimationFrame",
                        handler: (0, $9KjXB.getFunctionName)(original)
                    },
                    handled: false,
                    type: "instrument"
                }
            })
        ]);
    };
}
function $b8c4f4bf038257a8$var$_wrapXHR(originalSend) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function(...args) {
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const xhr = this;
        const xmlHttpRequestProps = [
            "onload",
            "onerror",
            "onprogress",
            "onreadystatechange"
        ];
        xmlHttpRequestProps.forEach((prop)=>{
            if (prop in xhr && typeof xhr[prop] === "function") // eslint-disable-next-line @typescript-eslint/no-explicit-any
            (0, $eKFW4.fill)(xhr, prop, function(original) {
                const wrapOptions = {
                    mechanism: {
                        data: {
                            function: prop,
                            handler: (0, $9KjXB.getFunctionName)(original)
                        },
                        handled: false,
                        type: "instrument"
                    }
                };
                // If Instrument integration has been called before TryCatch, get the name of original function
                const originalFunction = (0, $eKFW4.getOriginalFunction)(original);
                if (originalFunction) wrapOptions.mechanism.data.handler = (0, $9KjXB.getFunctionName)(originalFunction);
                // Otherwise wrap directly
                return (0, $gY4ad.wrap)(original, wrapOptions);
            });
        });
        return originalSend.apply(this, args);
    };
}
function $b8c4f4bf038257a8$var$_wrapEventTarget(target) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const globalObject = (0, $gY4ad.WINDOW);
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    const proto = globalObject[target] && globalObject[target].prototype;
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, no-prototype-builtins
    if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty("addEventListener")) return;
    (0, $eKFW4.fill)(proto, "addEventListener", function(original) {
        return function(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        eventName, fn, options) {
            try {
                if (typeof fn.handleEvent === "function") // ESlint disable explanation:
                //  First, it is generally safe to call `wrap` with an unbound function. Furthermore, using `.bind()` would
                //  introduce a bug here, because bind returns a new function that doesn't have our
                //  flags(like __sentry_original__) attached. `wrap` checks for those flags to avoid unnecessary wrapping.
                //  Without those flags, every call to addEventListener wraps the function again, causing a memory leak.
                // eslint-disable-next-line @typescript-eslint/unbound-method
                fn.handleEvent = (0, $gY4ad.wrap)(fn.handleEvent, {
                    mechanism: {
                        data: {
                            function: "handleEvent",
                            handler: (0, $9KjXB.getFunctionName)(fn),
                            target: target
                        },
                        handled: false,
                        type: "instrument"
                    }
                });
            } catch (err) {
            // can sometimes get 'Permission denied to access property "handle Event'
            }
            return original.apply(this, [
                eventName,
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                (0, $gY4ad.wrap)(fn, {
                    mechanism: {
                        data: {
                            function: "addEventListener",
                            handler: (0, $9KjXB.getFunctionName)(fn),
                            target: target
                        },
                        handled: false,
                        type: "instrument"
                    }
                }),
                options
            ]);
        };
    });
    (0, $eKFW4.fill)(proto, "removeEventListener", function(originalRemoveEventListener) {
        return function(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        eventName, fn, options) {
            /**
         * There are 2 possible scenarios here:
         *
         * 1. Someone passes a callback, which was attached prior to Sentry initialization, or by using unmodified
         * method, eg. `document.addEventListener.call(el, name, handler). In this case, we treat this function
         * as a pass-through, and call original `removeEventListener` with it.
         *
         * 2. Someone passes a callback, which was attached after Sentry was initialized, which means that it was using
         * our wrapped version of `addEventListener`, which internally calls `wrap` helper.
         * This helper "wraps" whole callback inside a try/catch statement, and attached appropriate metadata to it,
         * in order for us to make a distinction between wrapped/non-wrapped functions possible.
         * If a function was wrapped, it has additional property of `__sentry_wrapped__`, holding the handler.
         *
         * When someone adds a handler prior to initialization, and then do it again, but after,
         * then we have to detach both of them. Otherwise, if we'd detach only wrapped one, it'd be impossible
         * to get rid of the initial handler and it'd stick there forever.
         */ const wrappedEventHandler = fn;
            try {
                const originalEventHandler = wrappedEventHandler && wrappedEventHandler.__sentry_wrapped__;
                if (originalEventHandler) originalRemoveEventListener.call(this, eventName, originalEventHandler, options);
            } catch (e) {
            // ignore, accessing __sentry_wrapped__ will throw in some Selenium environments
            }
            return originalRemoveEventListener.call(this, eventName, wrappedEventHandler, options);
        };
    });
}

});

parcelRequire.register("iNtGt", function(module, exports) {

$parcel$export(module.exports, "defaultStackParser", function () { return $daf3d436f747c86a$export$2b2b997d81bf3907; });

var $9KjXB = parcelRequire("9KjXB");
// global reference to slice
const $daf3d436f747c86a$var$UNKNOWN_FUNCTION = "?";
const $daf3d436f747c86a$var$OPERA10_PRIORITY = 10;
const $daf3d436f747c86a$var$OPERA11_PRIORITY = 20;
const $daf3d436f747c86a$var$CHROME_PRIORITY = 30;
const $daf3d436f747c86a$var$WINJS_PRIORITY = 40;
const $daf3d436f747c86a$var$GECKO_PRIORITY = 50;
function $daf3d436f747c86a$var$createFrame(filename, func, lineno, colno) {
    const frame = {
        filename: filename,
        function: func,
        in_app: true
    };
    if (lineno !== undefined) frame.lineno = lineno;
    if (colno !== undefined) frame.colno = colno;
    return frame;
}
// Chromium based browsers: Chrome, Brave, new Opera, new Edge
const $daf3d436f747c86a$var$chromeRegex = /^\s*at (?:(.+?\)(?: \[.+\])?|.*?) ?\((?:address at )?)?(?:async )?((?:<anonymous>|[-a-z]+:|.*bundle|\/)?.*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i;
const $daf3d436f747c86a$var$chromeEvalRegex = /\((\S*)(?::(\d+))(?::(\d+))\)/;
// We cannot call this variable `chrome` because it can conflict with global `chrome` variable in certain environments
// See: https://github.com/getsentry/sentry-javascript/issues/6880
const $daf3d436f747c86a$var$chromeStackParserFn = (line)=>{
    const parts = $daf3d436f747c86a$var$chromeRegex.exec(line);
    if (parts) {
        const isEval = parts[2] && parts[2].indexOf("eval") === 0; // start of line
        if (isEval) {
            const subMatch = $daf3d436f747c86a$var$chromeEvalRegex.exec(parts[2]);
            if (subMatch) {
                // throw out eval line/column and use top-most line/column number
                parts[2] = subMatch[1]; // url
                parts[3] = subMatch[2]; // line
                parts[4] = subMatch[3]; // column
            }
        }
        // Kamil: One more hack won't hurt us right? Understanding and adding more rules on top of these regexps right now
        // would be way too time consuming. (TODO: Rewrite whole RegExp to be more readable)
        const [func, filename] = $daf3d436f747c86a$var$extractSafariExtensionDetails(parts[1] || $daf3d436f747c86a$var$UNKNOWN_FUNCTION, parts[2]);
        return $daf3d436f747c86a$var$createFrame(filename, func, parts[3] ? +parts[3] : undefined, parts[4] ? +parts[4] : undefined);
    }
    return;
};
const $daf3d436f747c86a$export$263a749fff749872 = [
    $daf3d436f747c86a$var$CHROME_PRIORITY,
    $daf3d436f747c86a$var$chromeStackParserFn
];
// gecko regex: `(?:bundle|\d+\.js)`: `bundle` is for react native, `\d+\.js` also but specifically for ram bundles because it
// generates filenames without a prefix like `file://` the filenames in the stacktrace are just 42.js
// We need this specific case for now because we want no other regex to match.
const $daf3d436f747c86a$var$geckoREgex = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:[-a-z]+)?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js)|\/[\w\-. /=]+)(?::(\d+))?(?::(\d+))?\s*$/i;
const $daf3d436f747c86a$var$geckoEvalRegex = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;
const $daf3d436f747c86a$var$gecko = (line)=>{
    const parts = $daf3d436f747c86a$var$geckoREgex.exec(line);
    if (parts) {
        const isEval = parts[3] && parts[3].indexOf(" > eval") > -1;
        if (isEval) {
            const subMatch = $daf3d436f747c86a$var$geckoEvalRegex.exec(parts[3]);
            if (subMatch) {
                // throw out eval line/column and use top-most line number
                parts[1] = parts[1] || "eval";
                parts[3] = subMatch[1];
                parts[4] = subMatch[2];
                parts[5] = ""; // no column when eval
            }
        }
        let filename = parts[3];
        let func = parts[1] || $daf3d436f747c86a$var$UNKNOWN_FUNCTION;
        [func, filename] = $daf3d436f747c86a$var$extractSafariExtensionDetails(func, filename);
        return $daf3d436f747c86a$var$createFrame(filename, func, parts[4] ? +parts[4] : undefined, parts[5] ? +parts[5] : undefined);
    }
    return;
};
const $daf3d436f747c86a$export$cdba47a5dd2804d = [
    $daf3d436f747c86a$var$GECKO_PRIORITY,
    $daf3d436f747c86a$var$gecko
];
const $daf3d436f747c86a$var$winjsRegex = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:[-a-z]+):.*?):(\d+)(?::(\d+))?\)?\s*$/i;
const $daf3d436f747c86a$var$winjs = (line)=>{
    const parts = $daf3d436f747c86a$var$winjsRegex.exec(line);
    return parts ? $daf3d436f747c86a$var$createFrame(parts[2], parts[1] || $daf3d436f747c86a$var$UNKNOWN_FUNCTION, +parts[3], parts[4] ? +parts[4] : undefined) : undefined;
};
const $daf3d436f747c86a$export$179460296da408e8 = [
    $daf3d436f747c86a$var$WINJS_PRIORITY,
    $daf3d436f747c86a$var$winjs
];
const $daf3d436f747c86a$var$opera10Regex = / line (\d+).*script (?:in )?(\S+)(?:: in function (\S+))?$/i;
const $daf3d436f747c86a$var$opera10 = (line)=>{
    const parts = $daf3d436f747c86a$var$opera10Regex.exec(line);
    return parts ? $daf3d436f747c86a$var$createFrame(parts[2], parts[3] || $daf3d436f747c86a$var$UNKNOWN_FUNCTION, +parts[1]) : undefined;
};
const $daf3d436f747c86a$export$f892b52c880ffc7a = [
    $daf3d436f747c86a$var$OPERA10_PRIORITY,
    $daf3d436f747c86a$var$opera10
];
const $daf3d436f747c86a$var$opera11Regex = / line (\d+), column (\d+)\s*(?:in (?:<anonymous function: ([^>]+)>|([^)]+))\(.*\))? in (.*):\s*$/i;
const $daf3d436f747c86a$var$opera11 = (line)=>{
    const parts = $daf3d436f747c86a$var$opera11Regex.exec(line);
    return parts ? $daf3d436f747c86a$var$createFrame(parts[5], parts[3] || parts[4] || $daf3d436f747c86a$var$UNKNOWN_FUNCTION, +parts[1], +parts[2]) : undefined;
};
const $daf3d436f747c86a$export$af11af13f09fb0dc = [
    $daf3d436f747c86a$var$OPERA11_PRIORITY,
    $daf3d436f747c86a$var$opera11
];
const $daf3d436f747c86a$export$7197c0fe6554c079 = [
    $daf3d436f747c86a$export$263a749fff749872,
    $daf3d436f747c86a$export$cdba47a5dd2804d,
    $daf3d436f747c86a$export$179460296da408e8
];
const $daf3d436f747c86a$export$2b2b997d81bf3907 = (0, $9KjXB.createStackParser)(...$daf3d436f747c86a$export$7197c0fe6554c079);
/**
 * Safari web extensions, starting version unknown, can produce "frames-only" stacktraces.
 * What it means, is that instead of format like:
 *
 * Error: wat
 *   at function@url:row:col
 *   at function@url:row:col
 *   at function@url:row:col
 *
 * it produces something like:
 *
 *   function@url:row:col
 *   function@url:row:col
 *   function@url:row:col
 *
 * Because of that, it won't be captured by `chrome` RegExp and will fall into `Gecko` branch.
 * This function is extracted so that we can use it in both places without duplicating the logic.
 * Unfortunately "just" changing RegExp is too complicated now and making it pass all tests
 * and fix this case seems like an impossible, or at least way too time-consuming task.
 */ const $daf3d436f747c86a$var$extractSafariExtensionDetails = (func, filename)=>{
    const isSafariExtension = func.indexOf("safari-extension") !== -1;
    const isSafariWebExtension = func.indexOf("safari-web-extension") !== -1;
    return isSafariExtension || isSafariWebExtension ? [
        func.indexOf("@") !== -1 ? func.split("@")[0] : $daf3d436f747c86a$var$UNKNOWN_FUNCTION,
        isSafariExtension ? `safari-extension:${filename}` : `safari-web-extension:${filename}`
    ] : [
        func,
        filename
    ];
};

});

parcelRequire.register("dmB5g", function(module, exports) {

$parcel$export(module.exports, "makeFetchTransport", function () { return $9baa18829166f51f$export$b2311068c46d7cc8; });

var $l40HA = parcelRequire("l40HA");

var $1sCez = parcelRequire("1sCez");

var $7Mfk0 = parcelRequire("7Mfk0");
/**
 * Creates a Transport that uses the Fetch API to send events to Sentry.
 */ function $9baa18829166f51f$export$b2311068c46d7cc8(options, nativeFetch = (0, $7Mfk0.getNativeFetchImplementation)()) {
    let pendingBodySize = 0;
    let pendingCount = 0;
    function makeRequest(request) {
        const requestSize = request.body.length;
        pendingBodySize += requestSize;
        pendingCount++;
        const requestOptions = {
            body: request.body,
            method: "POST",
            referrerPolicy: "origin",
            headers: options.headers,
            // Outgoing requests are usually cancelled when navigating to a different page, causing a "TypeError: Failed to
            // fetch" error and sending a "network_error" client-outcome - in Chrome, the request status shows "(cancelled)".
            // The `keepalive` flag keeps outgoing requests alive, even when switching pages. We want this since we're
            // frequently sending events right before the user is switching pages (eg. whenfinishing navigation transactions).
            // Gotchas:
            // - `keepalive` isn't supported by Firefox
            // - As per spec (https://fetch.spec.whatwg.org/#http-network-or-cache-fetch):
            //   If the sum of contentLength and inflightKeepaliveBytes is greater than 64 kibibytes, then return a network error.
            //   We will therefore only activate the flag when we're below that limit.
            // There is also a limit of requests that can be open at the same time, so we also limit this to 15
            // See https://github.com/getsentry/sentry-javascript/pull/7553 for details
            keepalive: pendingBodySize <= 60000 && pendingCount < 15,
            ...options.fetchOptions
        };
        try {
            return nativeFetch(options.url, requestOptions).then((response)=>{
                pendingBodySize -= requestSize;
                pendingCount--;
                return {
                    statusCode: response.status,
                    headers: {
                        "x-sentry-rate-limits": response.headers.get("X-Sentry-Rate-Limits"),
                        "retry-after": response.headers.get("Retry-After")
                    }
                };
            });
        } catch (e) {
            (0, $7Mfk0.clearCachedFetchImplementation)();
            pendingBodySize -= requestSize;
            pendingCount--;
            return (0, $1sCez.rejectedSyncPromise)(e);
        }
    }
    return (0, $l40HA.createTransport)(options, makeRequest);
}

});
parcelRequire.register("l40HA", function(module, exports) {

$parcel$export(module.exports, "createTransport", function () { return $f55a841391dd39f4$export$d09f50d9ab7f7b69; });

var $ctxTY = parcelRequire("ctxTY");
var $79S5K = parcelRequire("79S5K");
var $fi7Bg = parcelRequire("fi7Bg");
var $k4kHP = parcelRequire("k4kHP");
var $1sCez = parcelRequire("1sCez");
var $4B0oq = parcelRequire("4B0oq");

var $tgF2D = parcelRequire("tgF2D");
const $f55a841391dd39f4$export$e515cf6dfd2f98b8 = 30;
/**
 * Creates an instance of a Sentry `Transport`
 *
 * @param options
 * @param makeRequest
 */ function $f55a841391dd39f4$export$d09f50d9ab7f7b69(options, makeRequest, buffer = (0, $k4kHP.makePromiseBuffer)(options.bufferSize || $f55a841391dd39f4$export$e515cf6dfd2f98b8)) {
    let rateLimits = {};
    const flush = (timeout)=>buffer.drain(timeout);
    function send(envelope) {
        const filteredEnvelopeItems = [];
        // Drop rate limited items from envelope
        (0, $ctxTY.forEachEnvelopeItem)(envelope, (item, type)=>{
            const dataCategory = (0, $ctxTY.envelopeItemTypeToDataCategory)(type);
            if ((0, $79S5K.isRateLimited)(rateLimits, dataCategory)) {
                const event = $f55a841391dd39f4$var$getEventForEnvelopeItem(item, type);
                options.recordDroppedEvent("ratelimit_backoff", dataCategory, event);
            } else filteredEnvelopeItems.push(item);
        });
        // Skip sending if envelope is empty after filtering out rate limited events
        if (filteredEnvelopeItems.length === 0) return (0, $1sCez.resolvedSyncPromise)();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const filteredEnvelope = (0, $ctxTY.createEnvelope)(envelope[0], filteredEnvelopeItems);
        // Creates client report for each item in an envelope
        const recordEnvelopeLoss = (reason)=>{
            (0, $ctxTY.forEachEnvelopeItem)(filteredEnvelope, (item, type)=>{
                const event = $f55a841391dd39f4$var$getEventForEnvelopeItem(item, type);
                options.recordDroppedEvent(reason, (0, $ctxTY.envelopeItemTypeToDataCategory)(type), event);
            });
        };
        const requestTask = ()=>makeRequest({
                body: (0, $ctxTY.serializeEnvelope)(filteredEnvelope, options.textEncoder)
            }).then((response)=>{
                // We don't want to throw on NOK responses, but we want to at least log them
                if (response.statusCode !== undefined && (response.statusCode < 200 || response.statusCode >= 300)) (0, $tgF2D.DEBUG_BUILD) && (0, $fi7Bg.logger).warn(`Sentry responded with status code ${response.statusCode} to sent event.`);
                rateLimits = (0, $79S5K.updateRateLimits)(rateLimits, response);
                return response;
            }, (error)=>{
                recordEnvelopeLoss("network_error");
                throw error;
            });
        return buffer.add(requestTask).then((result)=>result, (error)=>{
            if (error instanceof (0, $4B0oq.SentryError)) {
                (0, $tgF2D.DEBUG_BUILD) && (0, $fi7Bg.logger).error("Skipped sending event because buffer is full.");
                recordEnvelopeLoss("queue_overflow");
                return (0, $1sCez.resolvedSyncPromise)();
            } else throw error;
        });
    }
    // We use this to identifify if the transport is the base transport
    // TODO (v8): Remove this again as we'll no longer need it
    send.__sentry__baseTransport__ = true;
    return {
        send: send,
        flush: flush
    };
}
function $f55a841391dd39f4$var$getEventForEnvelopeItem(item, type) {
    if (type !== "event" && type !== "transaction") return undefined;
    return Array.isArray(item) ? item[1] : undefined;
}

});
parcelRequire.register("79S5K", function(module, exports) {

$parcel$export(module.exports, "isRateLimited", function () { return $5363552a04da5ad5$export$6c91fec22056810a; });
$parcel$export(module.exports, "updateRateLimits", function () { return $5363552a04da5ad5$export$699aff705e0d49d4; });
// Intentionally keeping the key broad, as we don't know for sure what rate limit headers get returned from backend
const $5363552a04da5ad5$export$b09ce39faaeb1e7c = 60000; // 60 seconds
/**
 * Extracts Retry-After value from the request header or returns default value
 * @param header string representation of 'Retry-After' header
 * @param now current unix timestamp
 *
 */ function $5363552a04da5ad5$export$615352e17ed7741(header, now = Date.now()) {
    const headerDelay = parseInt(`${header}`, 10);
    if (!isNaN(headerDelay)) return headerDelay * 1000;
    const headerDate = Date.parse(`${header}`);
    if (!isNaN(headerDate)) return headerDate - now;
    return $5363552a04da5ad5$export$b09ce39faaeb1e7c;
}
/**
 * Gets the time that the given category is disabled until for rate limiting.
 * In case no category-specific limit is set but a general rate limit across all categories is active,
 * that time is returned.
 *
 * @return the time in ms that the category is disabled until or 0 if there's no active rate limit.
 */ function $5363552a04da5ad5$export$b89fc7b2e4c799e7(limits, dataCategory) {
    return limits[dataCategory] || limits.all || 0;
}
/**
 * Checks if a category is rate limited
 */ function $5363552a04da5ad5$export$6c91fec22056810a(limits, dataCategory, now = Date.now()) {
    return $5363552a04da5ad5$export$b89fc7b2e4c799e7(limits, dataCategory) > now;
}
/**
 * Update ratelimits from incoming headers.
 *
 * @return the updated RateLimits object.
 */ function $5363552a04da5ad5$export$699aff705e0d49d4(limits, { statusCode: statusCode, headers: headers }, now = Date.now()) {
    const updatedRateLimits = {
        ...limits
    };
    // "The name is case-insensitive."
    // https://developer.mozilla.org/en-US/docs/Web/API/Headers/get
    const rateLimitHeader = headers && headers["x-sentry-rate-limits"];
    const retryAfterHeader = headers && headers["retry-after"];
    if (rateLimitHeader) /**
     * rate limit headers are of the form
     *     <header>,<header>,..
     * where each <header> is of the form
     *     <retry_after>: <categories>: <scope>: <reason_code>: <namespaces>
     * where
     *     <retry_after> is a delay in seconds
     *     <categories> is the event type(s) (error, transaction, etc) being rate limited and is of the form
     *         <category>;<category>;...
     *     <scope> is what's being limited (org, project, or key) - ignored by SDK
     *     <reason_code> is an arbitrary string like "org_quota" - ignored by SDK
     *     <namespaces> Semicolon-separated list of metric namespace identifiers. Defines which namespace(s) will be affected.
     *         Only present if rate limit applies to the metric_bucket data category.
     */ for (const limit of rateLimitHeader.trim().split(",")){
        const [retryAfter, categories, , , namespaces] = limit.split(":", 5);
        const headerDelay = parseInt(retryAfter, 10);
        const delay = (!isNaN(headerDelay) ? headerDelay : 60) * 1000; // 60sec default
        if (!categories) updatedRateLimits.all = now + delay;
        else for (const category of categories.split(";")){
            if (category === "metric_bucket") // namespaces will be present when category === 'metric_bucket'
            {
                if (!namespaces || namespaces.split(";").includes("custom")) updatedRateLimits[category] = now + delay;
            } else updatedRateLimits[category] = now + delay;
        }
    }
    else if (retryAfterHeader) updatedRateLimits.all = now + $5363552a04da5ad5$export$615352e17ed7741(retryAfterHeader, now);
    else if (statusCode === 429) updatedRateLimits.all = now + 60000;
    return updatedRateLimits;
}

});

parcelRequire.register("k4kHP", function(module, exports) {

$parcel$export(module.exports, "makePromiseBuffer", function () { return $e9c43e1b7a8f3b68$export$85a4f67f852183e6; });

var $4B0oq = parcelRequire("4B0oq");

var $1sCez = parcelRequire("1sCez");
/**
 * Creates an new PromiseBuffer object with the specified limit
 * @param limit max number of promises that can be stored in the buffer
 */ function $e9c43e1b7a8f3b68$export$85a4f67f852183e6(limit) {
    const buffer = [];
    function isReady() {
        return limit === undefined || buffer.length < limit;
    }
    /**
   * Remove a promise from the queue.
   *
   * @param task Can be any PromiseLike<T>
   * @returns Removed promise.
   */ function remove(task) {
        return buffer.splice(buffer.indexOf(task), 1)[0];
    }
    /**
   * Add a promise (representing an in-flight action) to the queue, and set it to remove itself on fulfillment.
   *
   * @param taskProducer A function producing any PromiseLike<T>; In previous versions this used to be `task:
   *        PromiseLike<T>`, but under that model, Promises were instantly created on the call-site and their executor
   *        functions therefore ran immediately. Thus, even if the buffer was full, the action still happened. By
   *        requiring the promise to be wrapped in a function, we can defer promise creation until after the buffer
   *        limit check.
   * @returns The original promise.
   */ function add(taskProducer) {
        if (!isReady()) return (0, $1sCez.rejectedSyncPromise)(new (0, $4B0oq.SentryError)("Not adding Promise because buffer limit was reached."));
        // start the task and add its promise to the queue
        const task = taskProducer();
        if (buffer.indexOf(task) === -1) buffer.push(task);
        task.then(()=>remove(task))// Use `then(null, rejectionHandler)` rather than `catch(rejectionHandler)` so that we can use `PromiseLike`
        // rather than `Promise`. `PromiseLike` doesn't have a `.catch` method, making its polyfill smaller. (ES5 didn't
        // have promises, so TS has to polyfill when down-compiling.)
        .then(null, ()=>remove(task).then(null, ()=>{
            // We have to add another catch here because `remove()` starts a new promise chain.
            }));
        return task;
    }
    /**
   * Wait for all promises in the queue to resolve or for timeout to expire, whichever comes first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the queue is still non-empty. Passing `0` (or
   * not passing anything) will make the promise wait as long as it takes for the queue to drain before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if the queue is already empty or drains before the timeout, and
   * `false` otherwise
   */ function drain(timeout) {
        return new (0, $1sCez.SyncPromise)((resolve, reject)=>{
            let counter = buffer.length;
            if (!counter) return resolve(true);
            // wait for `timeout` ms and then resolve to `false` (if not cancelled first)
            const capturedSetTimeout = setTimeout(()=>{
                if (timeout && timeout > 0) resolve(false);
            }, timeout);
            // if all promises resolve in time, cancel the timer and resolve to `true`
            buffer.forEach((item)=>{
                (0, $1sCez.resolvedSyncPromise)(item).then(()=>{
                    if (!--counter) {
                        clearTimeout(capturedSetTimeout);
                        resolve(true);
                    }
                }, reject);
            });
        });
    }
    return {
        $: buffer,
        add: add,
        drain: drain
    };
}

});


parcelRequire.register("7Mfk0", function(module, exports) {

$parcel$export(module.exports, "getNativeFetchImplementation", function () { return $5a98e6afc5c190c3$export$8be2119ce08e3379; });
$parcel$export(module.exports, "clearCachedFetchImplementation", function () { return $5a98e6afc5c190c3$export$d499686d2dd738c6; });

var $014xT = parcelRequire("014xT");
var $fi7Bg = parcelRequire("fi7Bg");

var $23Gvz = parcelRequire("23Gvz");

var $gY4ad = parcelRequire("gY4ad");
let $5a98e6afc5c190c3$var$cachedFetchImpl = undefined;
/**
 * A special usecase for incorrectly wrapped Fetch APIs in conjunction with ad-blockers.
 * Whenever someone wraps the Fetch API and returns the wrong promise chain,
 * this chain becomes orphaned and there is no possible way to capture it's rejections
 * other than allowing it bubble up to this very handler. eg.
 *
 * const f = window.fetch;
 * window.fetch = function () {
 *   const p = f.apply(this, arguments);
 *
 *   p.then(function() {
 *     console.log('hi.');
 *   });
 *
 *   return p;
 * }
 *
 * `p.then(function () { ... })` is producing a completely separate promise chain,
 * however, what's returned is `p` - the result of original `fetch` call.
 *
 * This mean, that whenever we use the Fetch API to send our own requests, _and_
 * some ad-blocker blocks it, this orphaned chain will _always_ reject,
 * effectively causing another event to be captured.
 * This makes a whole process become an infinite loop, which we need to somehow
 * deal with, and break it in one way or another.
 *
 * To deal with this issue, we are making sure that we _always_ use the real
 * browser Fetch API, instead of relying on what `window.fetch` exposes.
 * The only downside to this would be missing our own requests as breadcrumbs,
 * but because we are already not doing this, it should be just fine.
 *
 * Possible failed fetch error messages per-browser:
 *
 * Chrome:  Failed to fetch
 * Edge:    Failed to Fetch
 * Firefox: NetworkError when attempting to fetch resource
 * Safari:  resource blocked by content blocker
 */ function $5a98e6afc5c190c3$export$8be2119ce08e3379() {
    if ($5a98e6afc5c190c3$var$cachedFetchImpl) return $5a98e6afc5c190c3$var$cachedFetchImpl;
    /* eslint-disable @typescript-eslint/unbound-method */ // Fast path to avoid DOM I/O
    if ((0, $014xT.isNativeFetch)((0, $gY4ad.WINDOW).fetch)) return $5a98e6afc5c190c3$var$cachedFetchImpl = (0, $gY4ad.WINDOW).fetch.bind((0, $gY4ad.WINDOW));
    const document = (0, $gY4ad.WINDOW).document;
    let fetchImpl = (0, $gY4ad.WINDOW).fetch;
    // eslint-disable-next-line deprecation/deprecation
    if (document && typeof document.createElement === "function") try {
        const sandbox = document.createElement("iframe");
        sandbox.hidden = true;
        document.head.appendChild(sandbox);
        const contentWindow = sandbox.contentWindow;
        if (contentWindow && contentWindow.fetch) fetchImpl = contentWindow.fetch;
        document.head.removeChild(sandbox);
    } catch (e) {
        (0, $23Gvz.DEBUG_BUILD) && (0, $fi7Bg.logger).warn("Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ", e);
    }
    return $5a98e6afc5c190c3$var$cachedFetchImpl = fetchImpl.bind((0, $gY4ad.WINDOW));
/* eslint-enable @typescript-eslint/unbound-method */ }
/** Clears cached fetch impl */ function $5a98e6afc5c190c3$export$d499686d2dd738c6() {
    $5a98e6afc5c190c3$var$cachedFetchImpl = undefined;
}

});


parcelRequire.register("6DI64", function(module, exports) {

$parcel$export(module.exports, "makeXHRTransport", function () { return $4d5897572458a919$export$5e1441cee30d5a39; });

var $l40HA = parcelRequire("l40HA");

var $1sCez = parcelRequire("1sCez");
/**
 * The DONE ready state for XmlHttpRequest
 *
 * Defining it here as a constant b/c XMLHttpRequest.DONE is not always defined
 * (e.g. during testing, it is `undefined`)
 *
 * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/readyState}
 */ const $4d5897572458a919$var$XHR_READYSTATE_DONE = 4;
/**
 * Creates a Transport that uses the XMLHttpRequest API to send events to Sentry.
 */ function $4d5897572458a919$export$5e1441cee30d5a39(options) {
    function makeRequest(request) {
        return new (0, $1sCez.SyncPromise)((resolve, reject)=>{
            const xhr = new XMLHttpRequest();
            xhr.onerror = reject;
            xhr.onreadystatechange = ()=>{
                if (xhr.readyState === $4d5897572458a919$var$XHR_READYSTATE_DONE) resolve({
                    statusCode: xhr.status,
                    headers: {
                        "x-sentry-rate-limits": xhr.getResponseHeader("X-Sentry-Rate-Limits"),
                        "retry-after": xhr.getResponseHeader("Retry-After")
                    }
                });
            };
            xhr.open("POST", options.url);
            for(const header in options.headers)if (Object.prototype.hasOwnProperty.call(options.headers, header)) xhr.setRequestHeader(header, options.headers[header]);
            xhr.send(request.body);
        });
    }
    return (0, $l40HA.createTransport)(options, makeRequest);
}

});


parcelRequire.register("2eEP7", function(module, exports) {

$parcel$export(module.exports, "langs", function () { return $1a0c8e4c31f56148$export$359be4c8544d6fb1; });
$parcel$export(module.exports, "getLanguage", function () { return $1a0c8e4c31f56148$export$64783e31db14f0ba; });
$parcel$export(module.exports, "setLanguage", function () { return $1a0c8e4c31f56148$export$4b6bf64406ec64af; });
const $1a0c8e4c31f56148$export$359be4c8544d6fb1 = {
    en: {
        paymentDetails: "Payment details",
        shippingAddress: "Shipping address",
        personalInformation: "Personal details",
        debtAmount: "Payment amount",
        code: "Payment code",
        city: "City",
        country: "Country",
        address: "Address",
        postalCode: "Postal Code",
        prefecture: "County",
        cardHolderName: "Card holder name",
        phone: "Phone number",
        email: "Email",
        terms: "Acceptance of terms of electronic transactions",
        payment: "Payment",
        paymentCodeInvalid: "The payment code that you input, does not correspond to an active counter",
        enaInfo: "The minimum activation amount of HERON EN.A is 100€.",
        cardholderNameInvalid: "The field only accepts English characters, lowercase and uppercase, space and the symbols: /:_().,+",
        participation: "Participation amount",
        technicalErrorTitle: "Technical Error",
        technicalErrorMessage: "Unfortunately an error occured",
        recurringInfo: "In order to setup the direct debit payment and confirm your card details, the bank will perform a zero-amount transaction.",
        continue: "Continue",
        bankRedirection: "Continue in a safe bank environment"
    },
    el: {
        paymentDetails: "Στοιχεία πληρωμής",
        shippingAddress: "Διεύθυνση αποστολής",
        personalInformation: "Προσωπικά στοιχεία",
        debtAmount: "Ποσό οφειλής",
        code: "Kωδικός πληρωμής",
        city: "Πόλη",
        country: "Χώρα",
        address: "Διεύθυνση",
        postalCode: "Ταχυδρομικός κώδικας",
        prefecture: "Νομός",
        cardHolderName: "Όνομα ιδιοκτήτη κάρτας",
        phone: "Τηλέφωνο",
        email: "Email",
        terms: "Αποδοχή όρων ηλεκτρονικών συναλλαγών",
        payment: "Πληρωμή",
        paymentCodeInvalid: "Ο κωδικός πληρωμής που εισήγαγες δεν αντιστοιχεί σε ενεργό μετρητή.",
        enaInfo: "Το ελάχιστο ποσό ενεργοποίησης του ΗΡΩΝ ΕΝ.Α είναι 100€.",
        cardholderNameInvalid: "Το πεδίο δέχεται μόνο αγγλικούς χαρακτήρες, πεζούς και κεφαλαίους, κενό και τα σύμβολα: /:_().,+-",
        participation: "Ποσό συμμετοχής",
        technicalErrorTitle: "Τεχνικό πρόβλημα",
        technicalErrorMessage: "Δυστυχώς προέκυψε κάποιο πρόβλημα.",
        recurringInfo: "Για την επιβεβαίωση των στοιχείων της νέας κάρτας σου, θα πραγματοποιηθεί μία μηδενική συναλλαγή από την τράπεζα.",
        continue: "Συνέχεια",
        bankRedirection: "Συνέχεια σε ασφαλές περιβάλλον τράπεζας"
    }
};
function $1a0c8e4c31f56148$export$64783e31db14f0ba() {
    return (window.location?.href || "").indexOf("lang=en") > -1 ? "en" : "el";
}
function $1a0c8e4c31f56148$export$4b6bf64406ec64af(isRecurring = false) {
    // Find out the language
    const lang = $1a0c8e4c31f56148$export$64783e31db14f0ba();
    document.getElementById("shipping-address-title").innerHTML = $1a0c8e4c31f56148$export$359be4c8544d6fb1[lang].shippingAddress;
    document.getElementById("personal-information-title").innerHTML = $1a0c8e4c31f56148$export$359be4c8544d6fb1[lang].personalInformation;
    const cardholderInvalidParagraph = document.getElementById("cardholder_invalid");
    if (!!cardholderInvalidParagraph) cardholderInvalidParagraph.innerHTML = $1a0c8e4c31f56148$export$359be4c8544d6fb1[lang].cardholderNameInvalid;
    document.getElementById("terms").nextElementSibling.innerHTML = $1a0c8e4c31f56148$export$359be4c8544d6fb1[lang].terms;
    document.querySelector("a#terms_link").href = `${"https://my.heron.gr"}/${lang}/terms/online-payment-terms`;
    document.querySelector('label[for="BillAddrCity"]').innerHTML = $1a0c8e4c31f56148$export$359be4c8544d6fb1[lang].city;
    document.querySelector('label[for="BillAddrCountry"]').innerHTML = $1a0c8e4c31f56148$export$359be4c8544d6fb1[lang].country;
    document.querySelector('label[for="BillAddrLine1"]').innerHTML = $1a0c8e4c31f56148$export$359be4c8544d6fb1[lang].address;
    document.querySelector('label[for="BillAddrPostCode"]').innerHTML = $1a0c8e4c31f56148$export$359be4c8544d6fb1[lang].postalCode;
    document.querySelector('label[for="BillAddrState"]').innerHTML = $1a0c8e4c31f56148$export$359be4c8544d6fb1[lang].prefecture;
    const cardholderLabel = document.querySelector('label[for="CardholderName"]');
    if (!!cardholderLabel) cardholderLabel.innerHTML = $1a0c8e4c31f56148$export$359be4c8544d6fb1[lang].cardHolderName;
    document.querySelector('label[for="HomePhone"]').innerHTML = $1a0c8e4c31f56148$export$359be4c8544d6fb1[lang].phone;
    document.querySelector('label[for="Email"]').innerHTML = $1a0c8e4c31f56148$export$359be4c8544d6fb1[lang].email;
    document.querySelector(".error-description h4").innerHTML = $1a0c8e4c31f56148$export$359be4c8544d6fb1[lang].technicalErrorTitle;
    document.querySelector(".error-description p").innerHTML = $1a0c8e4c31f56148$export$359be4c8544d6fb1[lang].technicalErrorMessage;
    document.querySelector(".bank-redirection-dialog p").innerHTML = $1a0c8e4c31f56148$export$359be4c8544d6fb1[lang].bankRedirection;
    if (isRecurring) $1a0c8e4c31f56148$var$setRecurringPaymentTranslations(lang);
    else $1a0c8e4c31f56148$var$setPaymentTranslations(lang);
}
function $1a0c8e4c31f56148$var$setPaymentTranslations(lang) {
    document.getElementById("payment-details-title").innerHTML = $1a0c8e4c31f56148$export$359be4c8544d6fb1[lang].paymentDetails;
    document.getElementById("payment_code_invalid").innerHTML = $1a0c8e4c31f56148$export$359be4c8544d6fb1[lang].paymentCodeInvalid;
    document.getElementById("ena_info").innerHTML = $1a0c8e4c31f56148$export$359be4c8544d6fb1[lang].enaInfo;
    document.querySelector('label[for="Amount"]').innerHTML = $1a0c8e4c31f56148$export$359be4c8544d6fb1[lang].debtAmount;
    document.querySelector('label[for="PaymentCode"]').innerHTML = $1a0c8e4c31f56148$export$359be4c8544d6fb1[lang].code;
    document.querySelector("button#send span").innerHTML = $1a0c8e4c31f56148$export$359be4c8544d6fb1[lang].payment;
}
function $1a0c8e4c31f56148$var$setRecurringPaymentTranslations(lang) {
    document.getElementById("recurring_msg").innerHTML = $1a0c8e4c31f56148$export$359be4c8544d6fb1[lang].recurringInfo;
    document.querySelector("button#send span").innerHTML = $1a0c8e4c31f56148$export$359be4c8544d6fb1[lang].continue;
}

});

parcelRequire.register("5oSvy", function(module, exports) {

$parcel$export(module.exports, "populateStatesSelect", function () { return $3ee979cb1cbbd71e$export$bfc608beb596b761; });
const $3ee979cb1cbbd71e$export$b782dad1d219cf26 = [
    "ΑΙΤΩΛΟΚΑΡΝΑΝΙΑΣ",
    "ΑΡΓΟΛΙΔΑΣ",
    "ΑΡΚΑΔΙΑΣ",
    "ΑΡΤΑΣ",
    "ΑΤΤΙΚΗΣ",
    "ΑΧΑΙΑΣ",
    "ΒΟΙΩΤΙΑΣ",
    "ΓΡΕΒΕΝΩΝ",
    "ΔΡΑΜΑΣ",
    "ΔΩΔΕΚΑΝΗΣΟΥ",
    "ΕΒΡΟΥ",
    "ΕΥΒΟΙΑΣ",
    "ΕΥΡΥΤΑΝΙΑΣ",
    "ΖΑΚΥΝΘΟΥ",
    "ΗΛΕΙΑΣ",
    "ΗΜΑΘΙΑΣ",
    "ΗΡΑΚΛΕΙΟΥ",
    "ΘΕΣΠΡΩΤΙΑΣ",
    "ΘΕΣΣΑΛΟΝΙΚΗΣ",
    "ΙΩΑΝΝΙΝΩΝ",
    "ΚΑΒΑΛΑΣ",
    "ΚΑΡΔΙΤΣΑΣ",
    "ΚΑΣΤΟΡΙΑΣ",
    "ΚΕΡΚΥΡΑΣ",
    "ΚΕΦΑΛΛΗΝΙΑΣ",
    "ΚΙΛΚΙΣ",
    "ΚΟΖΑΝΗΣ",
    "ΚΟΡΙΝΘΙΑΣ",
    "ΚΥΚΛΑΔΩΝ",
    "ΛΑΚΩΝΙΑΣ",
    "ΛΑΡΙΣΑΣ",
    "ΛΑΣΙΘΙΟΥ",
    "ΛΕΣΒΟΥ",
    "ΛΕΥΚΑΔΑΣ",
    "ΜΑΓΝΗΣΙΑΣ",
    "ΜΕΣΣΗΝΙΑΣ",
    "ΞΑΝΘΗΣ",
    "ΠΕΛΛΗΣ",
    "ΠΙΕΡΙΑΣ",
    "ΠΡΕΒΕΖΑΣ",
    "ΡΕΘΥΜΝΗΣ",
    "ΡΟΔΟΠΗΣ",
    "ΣΑΜΟΥ",
    "ΣΕΡΡΩΝ",
    "ΤΡΙΚΑΛΩΝ",
    "ΦΘΙΩΤΙΔΑΣ",
    "ΦΛΩΡΙΝΑΣ",
    "ΦΩΚΙΔΑΣ",
    "ΧΑΛΚΙΔΙΚΗΣ",
    "ΧΑΝΙΩΝ",
    "ΧΙΟΥ"
];
function $3ee979cb1cbbd71e$export$bfc608beb596b761() {
    const selectElem = document.getElementById("BillAddrState");
    $3ee979cb1cbbd71e$export$b782dad1d219cf26.forEach((x)=>{
        var option = document.createElement("option");
        option.text = x;
        option.value = x;
        selectElem.add(option);
    });
}

});

parcelRequire.register("F5GHR", function(module, exports) {

$parcel$export(module.exports, "validateForm", function () { return $07b83dee66fa83a6$export$ed692cabb252e59b; });
$parcel$export(module.exports, "getAmountWithCurrency", function () { return $07b83dee66fa83a6$export$189beea9aecda815; });
$parcel$export(module.exports, "getAmount", function () { return $07b83dee66fa83a6$export$cebae140e1862c6c; });
$parcel$export(module.exports, "getPhone", function () { return $07b83dee66fa83a6$export$6bc97fd71a5fa8b7; });
$parcel$export(module.exports, "populatePaymentKeys", function () { return $07b83dee66fa83a6$export$93246d5df4d13714; });
$parcel$export(module.exports, "populateRecurringPaymentKeys", function () { return $07b83dee66fa83a6$export$64233c126c40cdd5; });

var $56qEH = parcelRequire("56qEH");

var $7SNu6 = parcelRequire("7SNu6");

var $2DGCP = parcelRequire("2DGCP");
const $07b83dee66fa83a6$export$ed692cabb252e59b = (formFields, isRecurring = false)=>{
    const errorFields = [];
    if (!isRecurring) {
        if (!(0, $7SNu6.validateAmountTwoDecimalsFormat)(formFields.Amount)) errorFields.push("Amount");
        if ((0, $7SNu6.isNullOrWhitespace)(formFields.PaymentCode)) errorFields.push("PaymentCode");
    }
    if (!(0, $7SNu6.validateAddress)(formFields.BillAddrLine1)) errorFields.push("BillAddrLine1");
    if (!(0, $7SNu6.validatePostalCode)(formFields.BillAddrPostCode)) errorFields.push("BillAddrPostCode");
    if (!(0, $7SNu6.validateCity)(formFields.BillAddrCity)) errorFields.push("BillAddrCity");
    if ((0, $7SNu6.isNullOrWhitespace)(formFields.BillAddrState)) errorFields.push("BillAddrState");
    if (isRecurring && !(0, $7SNu6.validateCardHolderName)(formFields.CardholderName)) errorFields.push("CardholderName");
    if (!(0, $7SNu6.validateGreekPhone)(formFields.HomePhone)) errorFields.push("HomePhone");
    if (!(0, $7SNu6.validateEmail)(formFields.Email)) errorFields.push("Email");
    return errorFields;
};
const $07b83dee66fa83a6$export$189beea9aecda815 = (amount)=>amount ? `${new (0, (/*@__PURE__*/$parcel$interopDefault($56qEH)))(amount).toFixed(2)}€`.replace(".", ",") : "";
const $07b83dee66fa83a6$export$cebae140e1862c6c = (amount)=>new (0, (/*@__PURE__*/$parcel$interopDefault($56qEH)))(amount?.replace(",", ".").replace("€", "")).toNumber();
const $07b83dee66fa83a6$export$6bc97fd71a5fa8b7 = (homePhone)=>`30-${homePhone.indexOf("+30") === 0 ? homePhone.substring(3) : homePhone.indexOf("0030") === 0 ? homePhone.substring(4) : homePhone}`;
const $07b83dee66fa83a6$export$93246d5df4d13714 = (merchantRef, commodity)=>{
    document.querySelector("input[name=MerchantReference]").value = merchantRef;
    document.querySelector("input[name=AcquirerId]").value = "14";
    document.querySelector("input[name=MerchantId]").value = commodity === (0, $2DGCP.commodities).gas ? "142838747" : commodity === (0, $2DGCP.commodities).energy ? "142838739" : "";
    document.querySelector("input[name=PosId]").value = commodity === (0, $2DGCP.commodities).gas ? "81838740" : commodity === (0, $2DGCP.commodities).energy ? "81838730" : "";
    document.querySelector("input[name=User]").value = "IR944095";
};
const $07b83dee66fa83a6$export$64233c126c40cdd5 = (merchantRef, commodity)=>{
    document.querySelector("input[name=MerchantReference]").value = merchantRef;
    document.querySelector("input[name=AcquirerId]").value = "14";
    document.querySelector("input[name=MerchantId]").value = commodity === (0, $2DGCP.commodities).gas ? "143034270" : commodity === (0, $2DGCP.commodities).energy ? "140239757" : "";
    document.querySelector("input[name=PosId]").value = commodity === (0, $2DGCP.commodities).gas ? "81034270" : commodity === (0, $2DGCP.commodities).energy ? "81239750" : "";
    document.querySelector("input[name=User]").value = "IR944095";
};

});
parcelRequire.register("56qEH", function(module, exports) {
(function(GLOBAL) {
    "use strict";
    var Big, /************************************** EDITABLE DEFAULTS *****************************************/ // The default values below must be integers within the stated ranges.
    /*
     * The maximum number of decimal places (DP) of the results of operations involving division:
     * div and sqrt, and pow with negative exponents.
     */ DP = 20, /*
     * The rounding mode (RM) used when rounding to the above decimal places.
     *
     *  0  Towards zero (i.e. truncate, no rounding).       (ROUND_DOWN)
     *  1  To nearest neighbour. If equidistant, round up.  (ROUND_HALF_UP)
     *  2  To nearest neighbour. If equidistant, to even.   (ROUND_HALF_EVEN)
     *  3  Away from zero.                                  (ROUND_UP)
     */ RM = 1, // The maximum value of DP and Big.DP.
    MAX_DP = 1E6, // The maximum magnitude of the exponent argument to the pow method.
    MAX_POWER = 1E6, /*
     * The negative exponent (NE) at and beneath which toString returns exponential notation.
     * (JavaScript numbers: -7)
     * -1000000 is the minimum recommended exponent value of a Big.
     */ NE = -7, /*
     * The positive exponent (PE) at and above which toString returns exponential notation.
     * (JavaScript numbers: 21)
     * 1000000 is the maximum recommended exponent value of a Big, but this limit is not enforced.
     */ PE = 21, /*
     * When true, an error will be thrown if a primitive number is passed to the Big constructor,
     * or if valueOf is called, or if toNumber is called on a Big which cannot be converted to a
     * primitive number without a loss of precision.
     */ STRICT = false, /**************************************************************************************************/ // Error messages.
    NAME = "[big.js] ", INVALID = NAME + "Invalid ", INVALID_DP = INVALID + "decimal places", INVALID_RM = INVALID + "rounding mode", DIV_BY_ZERO = NAME + "Division by zero", // The shared prototype object.
    P = {}, UNDEFINED = void 0, NUMERIC = /^-?(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?$/i;
    /*
   * Create and return a Big constructor.
   */ function _Big_() {
        /*
     * The Big constructor and exported function.
     * Create and return a new instance of a Big number object.
     *
     * n {number|string|Big} A numeric value.
     */ function Big(n) {
            var x = this;
            // Enable constructor usage without new.
            if (!(x instanceof Big)) return n === UNDEFINED ? _Big_() : new Big(n);
            // Duplicate.
            if (n instanceof Big) {
                x.s = n.s;
                x.e = n.e;
                x.c = n.c.slice();
            } else {
                if (typeof n !== "string") {
                    if (Big.strict === true && typeof n !== "bigint") throw TypeError(INVALID + "value");
                    // Minus zero?
                    n = n === 0 && 1 / n < 0 ? "-0" : String(n);
                }
                parse(x, n);
            }
            // Retain a reference to this Big constructor.
            // Shadow Big.prototype.constructor which points to Object.
            x.constructor = Big;
        }
        Big.prototype = P;
        Big.DP = DP;
        Big.RM = RM;
        Big.NE = NE;
        Big.PE = PE;
        Big.strict = STRICT;
        Big.roundDown = 0;
        Big.roundHalfUp = 1;
        Big.roundHalfEven = 2;
        Big.roundUp = 3;
        return Big;
    }
    /*
   * Parse the number or string value passed to a Big constructor.
   *
   * x {Big} A Big number instance.
   * n {number|string} A numeric value.
   */ function parse(x, n) {
        var e, i, nl;
        if (!NUMERIC.test(n)) throw Error(INVALID + "number");
        // Determine sign.
        x.s = n.charAt(0) == "-" ? (n = n.slice(1), -1) : 1;
        // Decimal point?
        if ((e = n.indexOf(".")) > -1) n = n.replace(".", "");
        // Exponential form?
        if ((i = n.search(/e/i)) > 0) {
            // Determine exponent.
            if (e < 0) e = i;
            e += +n.slice(i + 1);
            n = n.substring(0, i);
        } else if (e < 0) // Integer.
        e = n.length;
        nl = n.length;
        // Determine leading zeros.
        for(i = 0; i < nl && n.charAt(i) == "0";)++i;
        if (i == nl) // Zero.
        x.c = [
            x.e = 0
        ];
        else {
            // Determine trailing zeros.
            for(; nl > 0 && n.charAt(--nl) == "0";);
            x.e = e - i - 1;
            x.c = [];
            // Convert string to array of digits without leading/trailing zeros.
            for(e = 0; i <= nl;)x.c[e++] = +n.charAt(i++);
        }
        return x;
    }
    /*
   * Round Big x to a maximum of sd significant digits using rounding mode rm.
   *
   * x {Big} The Big to round.
   * sd {number} Significant digits: integer, 0 to MAX_DP inclusive.
   * rm {number} Rounding mode: 0 (down), 1 (half-up), 2 (half-even) or 3 (up).
   * [more] {boolean} Whether the result of division was truncated.
   */ function round(x, sd, rm, more) {
        var xc = x.c;
        if (rm === UNDEFINED) rm = x.constructor.RM;
        if (rm !== 0 && rm !== 1 && rm !== 2 && rm !== 3) throw Error(INVALID_RM);
        if (sd < 1) {
            more = rm === 3 && (more || !!xc[0]) || sd === 0 && (rm === 1 && xc[0] >= 5 || rm === 2 && (xc[0] > 5 || xc[0] === 5 && (more || xc[1] !== UNDEFINED)));
            xc.length = 1;
            if (more) {
                // 1, 0.1, 0.01, 0.001, 0.0001 etc.
                x.e = x.e - sd + 1;
                xc[0] = 1;
            } else // Zero.
            xc[0] = x.e = 0;
        } else if (sd < xc.length) {
            // xc[sd] is the digit after the digit that may be rounded up.
            more = rm === 1 && xc[sd] >= 5 || rm === 2 && (xc[sd] > 5 || xc[sd] === 5 && (more || xc[sd + 1] !== UNDEFINED || xc[sd - 1] & 1)) || rm === 3 && (more || !!xc[0]);
            // Remove any digits after the required precision.
            xc.length = sd;
            // Round up?
            if (more) // Rounding up may mean the previous digit has to be rounded up.
            for(; ++xc[--sd] > 9;){
                xc[sd] = 0;
                if (sd === 0) {
                    ++x.e;
                    xc.unshift(1);
                    break;
                }
            }
            // Remove trailing zeros.
            for(sd = xc.length; !xc[--sd];)xc.pop();
        }
        return x;
    }
    /*
   * Return a string representing the value of Big x in normal or exponential notation.
   * Handles P.toExponential, P.toFixed, P.toJSON, P.toPrecision, P.toString and P.valueOf.
   */ function stringify(x, doExponential, isNonzero) {
        var e = x.e, s = x.c.join(""), n = s.length;
        // Exponential notation?
        if (doExponential) s = s.charAt(0) + (n > 1 ? "." + s.slice(1) : "") + (e < 0 ? "e" : "e+") + e;
        else if (e < 0) {
            for(; ++e;)s = "0" + s;
            s = "0." + s;
        } else if (e > 0) {
            if (++e > n) for(e -= n; e--;)s += "0";
            else if (e < n) s = s.slice(0, e) + "." + s.slice(e);
        } else if (n > 1) s = s.charAt(0) + "." + s.slice(1);
        return x.s < 0 && isNonzero ? "-" + s : s;
    }
    // Prototype/instance methods
    /*
   * Return a new Big whose value is the absolute value of this Big.
   */ P.abs = function() {
        var x = new this.constructor(this);
        x.s = 1;
        return x;
    };
    /*
   * Return 1 if the value of this Big is greater than the value of Big y,
   *       -1 if the value of this Big is less than the value of Big y, or
   *        0 if they have the same value.
   */ P.cmp = function(y) {
        var isneg, x = this, xc = x.c, yc = (y = new x.constructor(y)).c, i = x.s, j = y.s, k = x.e, l = y.e;
        // Either zero?
        if (!xc[0] || !yc[0]) return !xc[0] ? !yc[0] ? 0 : -j : i;
        // Signs differ?
        if (i != j) return i;
        isneg = i < 0;
        // Compare exponents.
        if (k != l) return k > l ^ isneg ? 1 : -1;
        j = (k = xc.length) < (l = yc.length) ? k : l;
        // Compare digit by digit.
        for(i = -1; ++i < j;){
            if (xc[i] != yc[i]) return xc[i] > yc[i] ^ isneg ? 1 : -1;
        }
        // Compare lengths.
        return k == l ? 0 : k > l ^ isneg ? 1 : -1;
    };
    /*
   * Return a new Big whose value is the value of this Big divided by the value of Big y, rounded,
   * if necessary, to a maximum of Big.DP decimal places using rounding mode Big.RM.
   */ P.div = function(y) {
        var x = this, Big = x.constructor, a = x.c, b = (y = new Big(y)).c, k = x.s == y.s ? 1 : -1, dp = Big.DP;
        if (dp !== ~~dp || dp < 0 || dp > MAX_DP) throw Error(INVALID_DP);
        // Divisor is zero?
        if (!b[0]) throw Error(DIV_BY_ZERO);
        // Dividend is 0? Return +-0.
        if (!a[0]) {
            y.s = k;
            y.c = [
                y.e = 0
            ];
            return y;
        }
        var bl, bt, n, cmp, ri, bz = b.slice(), ai = bl = b.length, al = a.length, r = a.slice(0, bl), rl = r.length, q = y, qc = q.c = [], qi = 0, p = dp + (q.e = x.e - y.e) + 1; // precision of the result
        q.s = k;
        k = p < 0 ? 0 : p;
        // Create version of divisor with leading zero.
        bz.unshift(0);
        // Add zeros to make remainder as long as divisor.
        for(; rl++ < bl;)r.push(0);
        do {
            // n is how many times the divisor goes into current remainder.
            for(n = 0; n < 10; n++){
                // Compare divisor and remainder.
                if (bl != (rl = r.length)) cmp = bl > rl ? 1 : -1;
                else {
                    for(ri = -1, cmp = 0; ++ri < bl;)if (b[ri] != r[ri]) {
                        cmp = b[ri] > r[ri] ? 1 : -1;
                        break;
                    }
                }
                // If divisor < remainder, subtract divisor from remainder.
                if (cmp < 0) {
                    // Remainder can't be more than 1 digit longer than divisor.
                    // Equalise lengths using divisor with extra leading zero?
                    for(bt = rl == bl ? b : bz; rl;){
                        if (r[--rl] < bt[rl]) {
                            ri = rl;
                            for(; ri && !r[--ri];)r[ri] = 9;
                            --r[ri];
                            r[rl] += 10;
                        }
                        r[rl] -= bt[rl];
                    }
                    for(; !r[0];)r.shift();
                } else break;
            }
            // Add the digit n to the result array.
            qc[qi++] = cmp ? n : ++n;
            // Update the remainder.
            if (r[0] && cmp) r[rl] = a[ai] || 0;
            else r = [
                a[ai]
            ];
        }while ((ai++ < al || r[0] !== UNDEFINED) && k--);
        // Leading zero? Do not remove if result is simply zero (qi == 1).
        if (!qc[0] && qi != 1) {
            // There can't be more than one zero.
            qc.shift();
            q.e--;
            p--;
        }
        // Round?
        if (qi > p) round(q, p, Big.RM, r[0] !== UNDEFINED);
        return q;
    };
    /*
   * Return true if the value of this Big is equal to the value of Big y, otherwise return false.
   */ P.eq = function(y) {
        return this.cmp(y) === 0;
    };
    /*
   * Return true if the value of this Big is greater than the value of Big y, otherwise return
   * false.
   */ P.gt = function(y) {
        return this.cmp(y) > 0;
    };
    /*
   * Return true if the value of this Big is greater than or equal to the value of Big y, otherwise
   * return false.
   */ P.gte = function(y) {
        return this.cmp(y) > -1;
    };
    /*
   * Return true if the value of this Big is less than the value of Big y, otherwise return false.
   */ P.lt = function(y) {
        return this.cmp(y) < 0;
    };
    /*
   * Return true if the value of this Big is less than or equal to the value of Big y, otherwise
   * return false.
   */ P.lte = function(y) {
        return this.cmp(y) < 1;
    };
    /*
   * Return a new Big whose value is the value of this Big minus the value of Big y.
   */ P.minus = P.sub = function(y) {
        var i, j, t, xlty, x = this, Big = x.constructor, a = x.s, b = (y = new Big(y)).s;
        // Signs differ?
        if (a != b) {
            y.s = -b;
            return x.plus(y);
        }
        var xc = x.c.slice(), xe = x.e, yc = y.c, ye = y.e;
        // Either zero?
        if (!xc[0] || !yc[0]) {
            if (yc[0]) y.s = -b;
            else if (xc[0]) y = new Big(x);
            else y.s = 1;
            return y;
        }
        // Determine which is the bigger number. Prepend zeros to equalise exponents.
        if (a = xe - ye) {
            if (xlty = a < 0) {
                a = -a;
                t = xc;
            } else {
                ye = xe;
                t = yc;
            }
            t.reverse();
            for(b = a; b--;)t.push(0);
            t.reverse();
        } else {
            // Exponents equal. Check digit by digit.
            j = ((xlty = xc.length < yc.length) ? xc : yc).length;
            for(a = b = 0; b < j; b++)if (xc[b] != yc[b]) {
                xlty = xc[b] < yc[b];
                break;
            }
        }
        // x < y? Point xc to the array of the bigger number.
        if (xlty) {
            t = xc;
            xc = yc;
            yc = t;
            y.s = -y.s;
        }
        /*
     * Append zeros to xc if shorter. No need to add zeros to yc if shorter as subtraction only
     * needs to start at yc.length.
     */ if ((b = (j = yc.length) - (i = xc.length)) > 0) for(; b--;)xc[i++] = 0;
        // Subtract yc from xc.
        for(b = i; j > a;){
            if (xc[--j] < yc[j]) {
                for(i = j; i && !xc[--i];)xc[i] = 9;
                --xc[i];
                xc[j] += 10;
            }
            xc[j] -= yc[j];
        }
        // Remove trailing zeros.
        for(; xc[--b] === 0;)xc.pop();
        // Remove leading zeros and adjust exponent accordingly.
        for(; xc[0] === 0;){
            xc.shift();
            --ye;
        }
        if (!xc[0]) {
            // n - n = +0
            y.s = 1;
            // Result must be zero.
            xc = [
                ye = 0
            ];
        }
        y.c = xc;
        y.e = ye;
        return y;
    };
    /*
   * Return a new Big whose value is the value of this Big modulo the value of Big y.
   */ P.mod = function(y) {
        var ygtx, x = this, Big = x.constructor, a = x.s, b = (y = new Big(y)).s;
        if (!y.c[0]) throw Error(DIV_BY_ZERO);
        x.s = y.s = 1;
        ygtx = y.cmp(x) == 1;
        x.s = a;
        y.s = b;
        if (ygtx) return new Big(x);
        a = Big.DP;
        b = Big.RM;
        Big.DP = Big.RM = 0;
        x = x.div(y);
        Big.DP = a;
        Big.RM = b;
        return this.minus(x.times(y));
    };
    /*
   * Return a new Big whose value is the value of this Big negated.
   */ P.neg = function() {
        var x = new this.constructor(this);
        x.s = -x.s;
        return x;
    };
    /*
   * Return a new Big whose value is the value of this Big plus the value of Big y.
   */ P.plus = P.add = function(y) {
        var e, k, t, x = this, Big = x.constructor;
        y = new Big(y);
        // Signs differ?
        if (x.s != y.s) {
            y.s = -y.s;
            return x.minus(y);
        }
        var xe = x.e, xc = x.c, ye = y.e, yc = y.c;
        // Either zero?
        if (!xc[0] || !yc[0]) {
            if (!yc[0]) {
                if (xc[0]) y = new Big(x);
                else y.s = x.s;
            }
            return y;
        }
        xc = xc.slice();
        // Prepend zeros to equalise exponents.
        // Note: reverse faster than unshifts.
        if (e = xe - ye) {
            if (e > 0) {
                ye = xe;
                t = yc;
            } else {
                e = -e;
                t = xc;
            }
            t.reverse();
            for(; e--;)t.push(0);
            t.reverse();
        }
        // Point xc to the longer array.
        if (xc.length - yc.length < 0) {
            t = yc;
            yc = xc;
            xc = t;
        }
        e = yc.length;
        // Only start adding at yc.length - 1 as the further digits of xc can be left as they are.
        for(k = 0; e; xc[e] %= 10)k = (xc[--e] = xc[e] + yc[e] + k) / 10 | 0;
        // No need to check for zero, as +x + +y != 0 && -x + -y != 0
        if (k) {
            xc.unshift(k);
            ++ye;
        }
        // Remove trailing zeros.
        for(e = xc.length; xc[--e] === 0;)xc.pop();
        y.c = xc;
        y.e = ye;
        return y;
    };
    /*
   * Return a Big whose value is the value of this Big raised to the power n.
   * If n is negative, round to a maximum of Big.DP decimal places using rounding
   * mode Big.RM.
   *
   * n {number} Integer, -MAX_POWER to MAX_POWER inclusive.
   */ P.pow = function(n) {
        var x = this, one = new x.constructor("1"), y = one, isneg = n < 0;
        if (n !== ~~n || n < -MAX_POWER || n > MAX_POWER) throw Error(INVALID + "exponent");
        if (isneg) n = -n;
        for(;;){
            if (n & 1) y = y.times(x);
            n >>= 1;
            if (!n) break;
            x = x.times(x);
        }
        return isneg ? one.div(y) : y;
    };
    /*
   * Return a new Big whose value is the value of this Big rounded to a maximum precision of sd
   * significant digits using rounding mode rm, or Big.RM if rm is not specified.
   *
   * sd {number} Significant digits: integer, 1 to MAX_DP inclusive.
   * rm? {number} Rounding mode: 0 (down), 1 (half-up), 2 (half-even) or 3 (up).
   */ P.prec = function(sd, rm) {
        if (sd !== ~~sd || sd < 1 || sd > MAX_DP) throw Error(INVALID + "precision");
        return round(new this.constructor(this), sd, rm);
    };
    /*
   * Return a new Big whose value is the value of this Big rounded to a maximum of dp decimal places
   * using rounding mode rm, or Big.RM if rm is not specified.
   * If dp is negative, round to an integer which is a multiple of 10**-dp.
   * If dp is not specified, round to 0 decimal places.
   *
   * dp? {number} Integer, -MAX_DP to MAX_DP inclusive.
   * rm? {number} Rounding mode: 0 (down), 1 (half-up), 2 (half-even) or 3 (up).
   */ P.round = function(dp, rm) {
        if (dp === UNDEFINED) dp = 0;
        else if (dp !== ~~dp || dp < -MAX_DP || dp > MAX_DP) throw Error(INVALID_DP);
        return round(new this.constructor(this), dp + this.e + 1, rm);
    };
    /*
   * Return a new Big whose value is the square root of the value of this Big, rounded, if
   * necessary, to a maximum of Big.DP decimal places using rounding mode Big.RM.
   */ P.sqrt = function() {
        var r, c, t, x = this, Big = x.constructor, s = x.s, e = x.e, half = new Big("0.5");
        // Zero?
        if (!x.c[0]) return new Big(x);
        // Negative?
        if (s < 0) throw Error(NAME + "No square root");
        // Estimate.
        s = Math.sqrt(x + "");
        // Math.sqrt underflow/overflow?
        // Re-estimate: pass x coefficient to Math.sqrt as integer, then adjust the result exponent.
        if (s === 0 || s === 1 / 0) {
            c = x.c.join("");
            if (!(c.length + e & 1)) c += "0";
            s = Math.sqrt(c);
            e = ((e + 1) / 2 | 0) - (e < 0 || e & 1);
            r = new Big((s == 1 / 0 ? "5e" : (s = s.toExponential()).slice(0, s.indexOf("e") + 1)) + e);
        } else r = new Big(s + "");
        e = r.e + (Big.DP += 4);
        // Newton-Raphson iteration.
        do {
            t = r;
            r = half.times(t.plus(x.div(t)));
        }while (t.c.slice(0, e).join("") !== r.c.slice(0, e).join(""));
        return round(r, (Big.DP -= 4) + r.e + 1, Big.RM);
    };
    /*
   * Return a new Big whose value is the value of this Big times the value of Big y.
   */ P.times = P.mul = function(y) {
        var c, x = this, Big = x.constructor, xc = x.c, yc = (y = new Big(y)).c, a = xc.length, b = yc.length, i = x.e, j = y.e;
        // Determine sign of result.
        y.s = x.s == y.s ? 1 : -1;
        // Return signed 0 if either 0.
        if (!xc[0] || !yc[0]) {
            y.c = [
                y.e = 0
            ];
            return y;
        }
        // Initialise exponent of result as x.e + y.e.
        y.e = i + j;
        // If array xc has fewer digits than yc, swap xc and yc, and lengths.
        if (a < b) {
            c = xc;
            xc = yc;
            yc = c;
            j = a;
            a = b;
            b = j;
        }
        // Initialise coefficient array of result with zeros.
        for(c = new Array(j = a + b); j--;)c[j] = 0;
        // Multiply.
        // i is initially xc.length.
        for(i = b; i--;){
            b = 0;
            // a is yc.length.
            for(j = a + i; j > i;){
                // Current sum of products at this digit position, plus carry.
                b = c[j] + yc[i] * xc[j - i - 1] + b;
                c[j--] = b % 10;
                // carry
                b = b / 10 | 0;
            }
            c[j] = b;
        }
        // Increment result exponent if there is a final carry, otherwise remove leading zero.
        if (b) ++y.e;
        else c.shift();
        // Remove trailing zeros.
        for(i = c.length; !c[--i];)c.pop();
        y.c = c;
        return y;
    };
    /*
   * Return a string representing the value of this Big in exponential notation rounded to dp fixed
   * decimal places using rounding mode rm, or Big.RM if rm is not specified.
   *
   * dp? {number} Decimal places: integer, 0 to MAX_DP inclusive.
   * rm? {number} Rounding mode: 0 (down), 1 (half-up), 2 (half-even) or 3 (up).
   */ P.toExponential = function(dp, rm) {
        var x = this, n = x.c[0];
        if (dp !== UNDEFINED) {
            if (dp !== ~~dp || dp < 0 || dp > MAX_DP) throw Error(INVALID_DP);
            x = round(new x.constructor(x), ++dp, rm);
            for(; x.c.length < dp;)x.c.push(0);
        }
        return stringify(x, true, !!n);
    };
    /*
   * Return a string representing the value of this Big in normal notation rounded to dp fixed
   * decimal places using rounding mode rm, or Big.RM if rm is not specified.
   *
   * dp? {number} Decimal places: integer, 0 to MAX_DP inclusive.
   * rm? {number} Rounding mode: 0 (down), 1 (half-up), 2 (half-even) or 3 (up).
   *
   * (-0).toFixed(0) is '0', but (-0.1).toFixed(0) is '-0'.
   * (-0).toFixed(1) is '0.0', but (-0.01).toFixed(1) is '-0.0'.
   */ P.toFixed = function(dp, rm) {
        var x = this, n = x.c[0];
        if (dp !== UNDEFINED) {
            if (dp !== ~~dp || dp < 0 || dp > MAX_DP) throw Error(INVALID_DP);
            x = round(new x.constructor(x), dp + x.e + 1, rm);
            // x.e may have changed if the value is rounded up.
            for(dp = dp + x.e + 1; x.c.length < dp;)x.c.push(0);
        }
        return stringify(x, false, !!n);
    };
    /*
   * Return a string representing the value of this Big.
   * Return exponential notation if this Big has a positive exponent equal to or greater than
   * Big.PE, or a negative exponent equal to or less than Big.NE.
   * Omit the sign for negative zero.
   */ P.toJSON = P.toString = function() {
        var x = this, Big = x.constructor;
        return stringify(x, x.e <= Big.NE || x.e >= Big.PE, !!x.c[0]);
    };
    /*
   * Return the value of this Big as a primitve number.
   */ P.toNumber = function() {
        var n = Number(stringify(this, true, true));
        if (this.constructor.strict === true && !this.eq(n.toString())) throw Error(NAME + "Imprecise conversion");
        return n;
    };
    /*
   * Return a string representing the value of this Big rounded to sd significant digits using
   * rounding mode rm, or Big.RM if rm is not specified.
   * Use exponential notation if sd is less than the number of digits necessary to represent
   * the integer part of the value in normal notation.
   *
   * sd {number} Significant digits: integer, 1 to MAX_DP inclusive.
   * rm? {number} Rounding mode: 0 (down), 1 (half-up), 2 (half-even) or 3 (up).
   */ P.toPrecision = function(sd, rm) {
        var x = this, Big = x.constructor, n = x.c[0];
        if (sd !== UNDEFINED) {
            if (sd !== ~~sd || sd < 1 || sd > MAX_DP) throw Error(INVALID + "precision");
            x = round(new Big(x), sd, rm);
            for(; x.c.length < sd;)x.c.push(0);
        }
        return stringify(x, sd <= x.e || x.e <= Big.NE || x.e >= Big.PE, !!n);
    };
    /*
   * Return a string representing the value of this Big.
   * Return exponential notation if this Big has a positive exponent equal to or greater than
   * Big.PE, or a negative exponent equal to or less than Big.NE.
   * Include the sign for negative zero.
   */ P.valueOf = function() {
        var x = this, Big = x.constructor;
        if (Big.strict === true) throw Error(NAME + "valueOf disallowed");
        return stringify(x, x.e <= Big.NE || x.e >= Big.PE, true);
    };
    // Export
    Big = _Big_();
    Big["default"] = Big.Big = Big;
    //AMD.
    if (typeof define === "function" && define.amd) define(function() {
        return Big;
    });
    else if (0, module.exports) module.exports = Big;
    else GLOBAL.Big = Big;
})(module.exports);

});

parcelRequire.register("7SNu6", function(module, exports) {

$parcel$export(module.exports, "validateEmail", function () { return $5bd3f62b6bdcf08e$export$18148d12c805c5b0; });
$parcel$export(module.exports, "validateGreekPhone", function () { return $5bd3f62b6bdcf08e$export$d4d479386b2cff6b; });
$parcel$export(module.exports, "validateAmountTwoDecimalsFormat", function () { return $5bd3f62b6bdcf08e$export$6a4d98c28d3dd118; });
$parcel$export(module.exports, "validatePostalCode", function () { return $5bd3f62b6bdcf08e$export$815da5de8966867b; });
$parcel$export(module.exports, "validateAddress", function () { return $5bd3f62b6bdcf08e$export$f78173835dcde49f; });
$parcel$export(module.exports, "validateCity", function () { return $5bd3f62b6bdcf08e$export$8e0e3fe6ebe44386; });
$parcel$export(module.exports, "validateCardHolderName", function () { return $5bd3f62b6bdcf08e$export$e78746577fa9c075; });
$parcel$export(module.exports, "isNullOrWhitespace", function () { return $5bd3f62b6bdcf08e$export$4ffae9b5c3c1b7fc; });
$parcel$export(module.exports, "isAllowedUrl", function () { return $5bd3f62b6bdcf08e$export$d000f621f70b6dec; });
const $5bd3f62b6bdcf08e$export$18148d12c805c5b0 = (value)=>value && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
const $5bd3f62b6bdcf08e$export$2def9029062ff2e3 = (value)=>value && /^(\+30|0030)?69\d{8}$/.test(value);
const $5bd3f62b6bdcf08e$export$2d54b11637fc6119 = (value)=>value && /^(\+30|0030)?(2)\d{9}$/.test(value);
const $5bd3f62b6bdcf08e$export$d4d479386b2cff6b = (value)=>$5bd3f62b6bdcf08e$export$2def9029062ff2e3(value) || $5bd3f62b6bdcf08e$export$2d54b11637fc6119(value);
const $5bd3f62b6bdcf08e$export$6a4d98c28d3dd118 = (value)=>value && /^\d+((\.{1}|,{1})\d{1,2})?[€]?$/.test(value);
const $5bd3f62b6bdcf08e$export$815da5de8966867b = (value)=>value && value.length <= 16;
const $5bd3f62b6bdcf08e$export$f78173835dcde49f = (value)=>value && /^[a-zα-ωίϊΐόάέύϋΰήώ0-9\s/:_().,+-]+$/i.test(value);
const $5bd3f62b6bdcf08e$export$8e0e3fe6ebe44386 = (value)=>value && /^[a-zα-ωίϊΐόάέύϋΰήώ\s/:_().,+-]+$/i.test(value);
const $5bd3f62b6bdcf08e$export$e78746577fa9c075 = (value)=>value && /^[a-z\s/:_().,+-]+$/i.test(value);
const $5bd3f62b6bdcf08e$export$4ffae9b5c3c1b7fc = (value)=>!value || value.trim().length === 0;
const $5bd3f62b6bdcf08e$export$d000f621f70b6dec = (value)=>{
    if (value.indexOf("my.heron.gr") > -1 || value.indexOf("https://mypayment.heron.gr") > -1) return true;
    const patterns = [
        /https:\/\/gray-forest-05a16c203\.azurestaticapps\.net/,
        /https:\/\/gray-forest-05a16c203(?:-\d+)?\.westeurope\.azurestaticapps\.net/,
        /https:\/\/delightful-sea-0641b9b03\.azurestaticapps\.net/,
        /https:\/\/delightful-sea-0641b9b03(?:-\d+)?\.westeurope\.azurestaticapps\.net/,
        /https:\/\/witty-island-0d5649403\.azurestaticapps\.net/,
        /https:\/\/witty-island-0d5649403(?:-\d+)?\.westeurope\.azurestaticapps\.net/,
        /http:\/\/localhost(?:-\d+)?/
    ];
    const matchingUrl = patterns.filter((pattern)=>pattern.test(value));
    return matchingUrl.length > 0;
};

});

parcelRequire.register("2DGCP", function(module, exports) {

$parcel$export(module.exports, "commodities", function () { return $1ec049c49de5c345$export$83e2e7916da485de; });
const $1ec049c49de5c345$export$83e2e7916da485de = {
    gas: 1,
    energy: 2,
    energyGas: 3
};

});


parcelRequire.register("kkp0U", function(module, exports) {

$parcel$export(module.exports, "handleErrorClassOnChange", function () { return $ecc914144c71d688$export$3c4ba2476b76aa9d; });
$parcel$export(module.exports, "enableInputs", function () { return $ecc914144c71d688$export$2fb309a006517be; });
$parcel$export(module.exports, "getInputFields", function () { return $ecc914144c71d688$export$663d9469ed03eb84; });
$parcel$export(module.exports, "togglePageLoader", function () { return $ecc914144c71d688$export$7b60d536d3f99202; });
$parcel$export(module.exports, "toggleButtonLoader", function () { return $ecc914144c71d688$export$4335bb8f978f9324; });
$parcel$export(module.exports, "removeErrors", function () { return $ecc914144c71d688$export$f20e084b81e0aacf; });
$parcel$export(module.exports, "addErrorToFields", function () { return $ecc914144c71d688$export$23b39c87420cfc5a; });
$parcel$export(module.exports, "fillForm", function () { return $ecc914144c71d688$export$4adf888661cc299f; });
$parcel$export(module.exports, "showErrorBox", function () { return $ecc914144c71d688$export$cda3738d7097dee4; });
$parcel$export(module.exports, "removeErrorBox", function () { return $ecc914144c71d688$export$4c032154b71312ff; });
$parcel$export(module.exports, "showDelayAndRemoveBankRedirectionDialog", function () { return $ecc914144c71d688$export$2f50db01cef29f31; });
const $ecc914144c71d688$var$removeKeyupListener = (elem)=>{
    elem.removeEventListener("keyup", $ecc914144c71d688$var$removeErrorClasses);
};
const $ecc914144c71d688$var$removeErrorClasses = (event)=>{
    event.currentTarget.classList.remove("error");
    document.querySelector(`label[for="${event.currentTarget.id}"]`).classList.remove("error");
    $ecc914144c71d688$var$removeKeyupListener(event.currentTarget);
};
const $ecc914144c71d688$export$3c4ba2476b76aa9d = (elem)=>{
    elem.addEventListener("keyup", $ecc914144c71d688$var$removeErrorClasses);
};
const $ecc914144c71d688$export$2fb309a006517be = ()=>{
    const inputs = $ecc914144c71d688$export$663d9469ed03eb84();
    inputs.forEach((input)=>{
        if (input.disabled !== true) input.disabled = false;
    });
};
const $ecc914144c71d688$export$7b60d536d3f99202 = (show)=>{
    if (show) document.getElementById("page_loader").style.display = "flex";
    else document.getElementById("page_loader").style.display = "none";
};
const $ecc914144c71d688$export$4335bb8f978f9324 = (show)=>{
    if (show) {
        document.querySelector("button#send span").style.display = "none";
        document.querySelector("button#send div").style.display = "flex";
        document.querySelector("button#send").disabled = true;
    } else {
        document.querySelector("button#send span").style.display = "block";
        document.querySelector("button#send div").style.display = "none";
        document.querySelector("button#send").disabled = false;
    }
};
const $ecc914144c71d688$export$f20e084b81e0aacf = (inputsArr, isRecurring = false)=>{
    inputsArr.forEach((x)=>{
        x.classList.remove("error");
        document.querySelector(`label[for="${x.id}"]`).classList.remove("error");
    });
    if (!isRecurring) document.getElementById("payment_code_invalid").style.display = "none";
    const cardholderInvalidParagraph = document.getElementById("cardholder_invalid");
    if (!!cardholderInvalidParagraph) cardholderInvalidParagraph.style.display = "none";
};
const $ecc914144c71d688$export$23b39c87420cfc5a = (errorFields)=>{
    errorFields.forEach((x)=>{
        const elem = document.querySelector(`[name="${x}"]`);
        if (elem) {
            elem.classList.add("error");
            $ecc914144c71d688$export$3c4ba2476b76aa9d(elem);
        }
        const labelElem = document.querySelector(`label[for="${x}"]`);
        if (labelElem) labelElem.classList.add("error");
        if (x === "PaymentCode") document.getElementById("payment_code_invalid").style.display = "block";
        const cardholderInvalidParagraph = document.getElementById("cardholder_invalid");
        if (x === "CardholderName" && !!cardholderInvalidParagraph) cardholderInvalidParagraph.style.display = "block";
        $ecc914144c71d688$export$3f99968195accfaf(0, 0);
    });
};
const $ecc914144c71d688$export$4adf888661cc299f = (formData)=>{
    document.querySelector("#BillAddrCity").value = (formData.BillAddrCity ?? "").trim();
    document.querySelector("#BillAddrCountry").value = (formData.BillAddrCountry ?? "").trim();
    document.querySelector("#BillAddrLine1").value = (formData.BillAddrLine1 ?? "").trim();
    document.querySelector("#BillAddrState").value = (formData.BillAddrState ?? "").trim();
    document.querySelector("#BillAddrPostCode").value = (formData.BillAddrPostCode ?? "").trim();
    // document.querySelector("#CardholderName").value = (
    //   formData.CardholderName ?? ""
    // ).trim();
    document.querySelector("#HomePhone").value = (formData.HomePhone ?? "").trim();
    document.querySelector("#Email").value = (formData.Email ?? "").trim();
};
const $ecc914144c71d688$export$663d9469ed03eb84 = ()=>{
    const inputs = document.querySelectorAll(".form-input input, .form-input select");
    return inputs;
};
const $ecc914144c71d688$export$3f99968195accfaf = (top = 0, left = 0, element, behavior = "smooth")=>{
    const scrollElement = element && typeof element.scrollTo === "function" ? element : window;
    if (scrollElement) {
        const isSmoothScrollSupported = "scrollBehavior" in document.documentElement.style;
        if (isSmoothScrollSupported) scrollElement.scrollTo({
            top: top,
            left: left,
            behavior: behavior
        });
        else scrollElement.scrollTo(top, left);
    }
};
const $ecc914144c71d688$export$cda3738d7097dee4 = ()=>{
    document.querySelector(".error-box").style.display = "flex";
    $ecc914144c71d688$export$3f99968195accfaf(0, 0);
};
const $ecc914144c71d688$export$4c032154b71312ff = ()=>{
    document.querySelector(".error-box").style.display = "none";
};
const $ecc914144c71d688$export$71bece062f7db3ca = ()=>{
    document.querySelector(".bank-redirection-dialog-overlay").style.display = "block";
    document.querySelector(".bank-redirection-dialog").style.display = "flex";
};
const $ecc914144c71d688$export$5dc28b3278500800 = ()=>{
    document.querySelector(".bank-redirection-dialog-overlay").style.display = "none";
    document.querySelector(".bank-redirection-dialog").style.display = "none";
};
const $ecc914144c71d688$export$2f50db01cef29f31 = (callback = ()=>{})=>{
    $ecc914144c71d688$export$3f99968195accfaf(200, 0);
    $ecc914144c71d688$export$71bece062f7db3ca();
    setTimeout(()=>{
        $ecc914144c71d688$export$5dc28b3278500800();
        callback();
    }, 2000);
};

});

parcelRequire.register("T3ldG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return (parcelRequire("8dOLt")).default; });

var $8dOLt = parcelRequire("8dOLt");
// This module is intended to unwrap Axios default export as named.
// Keep top-level export same with static properties
// so that it can keep same with es module or cjs
const { Axios: $0a57baac1a3c1ea9$export$1c00760e9e5a4e95, AxiosError: $0a57baac1a3c1ea9$export$c1fbed17c2f6a328, CanceledError: $0a57baac1a3c1ea9$export$1ab0c6b20d94fa14, isCancel: $0a57baac1a3c1ea9$export$3b22524397b493c6, CancelToken: $0a57baac1a3c1ea9$export$fd08e3cb425f0d61, VERSION: $0a57baac1a3c1ea9$export$a4ad2735b021c132, all: $0a57baac1a3c1ea9$export$84bf76cd7afc7469, Cancel: $0a57baac1a3c1ea9$export$848c9b7ead0df967, isAxiosError: $0a57baac1a3c1ea9$export$fbafdbe06a5b5a9a, spread: $0a57baac1a3c1ea9$export$3ae0fd4797ed47c8, toFormData: $0a57baac1a3c1ea9$export$10ae0d317ea97f8b, AxiosHeaders: $0a57baac1a3c1ea9$export$4e7d6ff0f3e6520, HttpStatusCode: $0a57baac1a3c1ea9$export$a972f69c851492b3, formToJSON: $0a57baac1a3c1ea9$export$86d7c59254d6a2c9, getAdapter: $0a57baac1a3c1ea9$export$17ddc20a97d669e2, mergeConfig: $0a57baac1a3c1ea9$export$7ec1ebcfa9d8bd6a } = (0, $8dOLt.default);

});
parcelRequire.register("8dOLt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5fc6ea71ff7e4227$export$2e2bcd8739ae039; });

var $fIemp = parcelRequire("fIemp");

var $bR3x9 = parcelRequire("bR3x9");

var $5BAGh = parcelRequire("5BAGh");

var $cu9jP = parcelRequire("cu9jP");

var $5i1l4 = parcelRequire("5i1l4");

var $kxhCw = parcelRequire("kxhCw");

var $bqef3 = parcelRequire("bqef3");

var $ev6QT = parcelRequire("ev6QT");

var $f71qq = parcelRequire("f71qq");

var $1lg8r = parcelRequire("1lg8r");

var $h77YL = parcelRequire("h77YL");

var $ax9gu = parcelRequire("ax9gu");

var $f9iLS = parcelRequire("f9iLS");

var $7RWFS = parcelRequire("7RWFS");

var $9VBYq = parcelRequire("9VBYq");

var $i5deJ = parcelRequire("i5deJ");

var $aGTas = parcelRequire("aGTas");
"use strict";
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 *
 * @returns {Axios} A new instance of Axios
 */ function $5fc6ea71ff7e4227$var$createInstance(defaultConfig) {
    const context = new (0, $5BAGh.default)(defaultConfig);
    const instance = (0, $bR3x9.default)((0, $5BAGh.default).prototype.request, context);
    // Copy axios.prototype to instance
    (0, $fIemp.default).extend(instance, (0, $5BAGh.default).prototype, context, {
        allOwnKeys: true
    });
    // Copy context to instance
    (0, $fIemp.default).extend(instance, context, null, {
        allOwnKeys: true
    });
    // Factory for creating new instances
    instance.create = function create(instanceConfig) {
        return $5fc6ea71ff7e4227$var$createInstance((0, $cu9jP.default)(defaultConfig, instanceConfig));
    };
    return instance;
}
// Create the default instance to be exported
const $5fc6ea71ff7e4227$var$axios = $5fc6ea71ff7e4227$var$createInstance((0, $5i1l4.default));
// Expose Axios class to allow class inheritance
$5fc6ea71ff7e4227$var$axios.Axios = (0, $5BAGh.default);
// Expose Cancel & CancelToken
$5fc6ea71ff7e4227$var$axios.CanceledError = (0, $bqef3.default);
$5fc6ea71ff7e4227$var$axios.CancelToken = (0, $ev6QT.default);
$5fc6ea71ff7e4227$var$axios.isCancel = (0, $f71qq.default);
$5fc6ea71ff7e4227$var$axios.VERSION = (0, $1lg8r.VERSION);
$5fc6ea71ff7e4227$var$axios.toFormData = (0, $h77YL.default);
// Expose AxiosError class
$5fc6ea71ff7e4227$var$axios.AxiosError = (0, $ax9gu.default);
// alias for CanceledError for backward compatibility
$5fc6ea71ff7e4227$var$axios.Cancel = $5fc6ea71ff7e4227$var$axios.CanceledError;
// Expose all/spread
$5fc6ea71ff7e4227$var$axios.all = function all(promises) {
    return Promise.all(promises);
};
$5fc6ea71ff7e4227$var$axios.spread = (0, $f9iLS.default);
// Expose isAxiosError
$5fc6ea71ff7e4227$var$axios.isAxiosError = (0, $7RWFS.default);
// Expose mergeConfig
$5fc6ea71ff7e4227$var$axios.mergeConfig = (0, $cu9jP.default);
$5fc6ea71ff7e4227$var$axios.AxiosHeaders = (0, $9VBYq.default);
$5fc6ea71ff7e4227$var$axios.formToJSON = (thing)=>(0, $kxhCw.default)((0, $fIemp.default).isHTMLForm(thing) ? new FormData(thing) : thing);
$5fc6ea71ff7e4227$var$axios.getAdapter = (0, $i5deJ.default).getAdapter;
$5fc6ea71ff7e4227$var$axios.HttpStatusCode = (0, $aGTas.default);
$5fc6ea71ff7e4227$var$axios.default = $5fc6ea71ff7e4227$var$axios;
var // this module should only have a default export
$5fc6ea71ff7e4227$export$2e2bcd8739ae039 = $5fc6ea71ff7e4227$var$axios;

});
parcelRequire.register("fIemp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b7061ac3b7093a79$export$2e2bcd8739ae039; });

var $bR3x9 = parcelRequire("bR3x9");

var $hmuqp = parcelRequire("hmuqp");
"use strict";
// utils is a library of generic helper functions non-specific to axios
const { toString: $b7061ac3b7093a79$var$toString } = Object.prototype;
const { getPrototypeOf: $b7061ac3b7093a79$var$getPrototypeOf } = Object;
const { iterator: $b7061ac3b7093a79$var$iterator, toStringTag: $b7061ac3b7093a79$var$toStringTag } = Symbol;
const $b7061ac3b7093a79$var$kindOf = ((cache)=>(thing)=>{
        const str = $b7061ac3b7093a79$var$toString.call(thing);
        return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
    })(Object.create(null));
const $b7061ac3b7093a79$var$kindOfTest = (type)=>{
    type = type.toLowerCase();
    return (thing)=>$b7061ac3b7093a79$var$kindOf(thing) === type;
};
const $b7061ac3b7093a79$var$typeOfTest = (type)=>(thing)=>typeof thing === type;
/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 *
 * @returns {boolean} True if value is an Array, otherwise false
 */ const { isArray: $b7061ac3b7093a79$var$isArray } = Array;
/**
 * Determine if a value is undefined
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if the value is undefined, otherwise false
 */ const $b7061ac3b7093a79$var$isUndefined = $b7061ac3b7093a79$var$typeOfTest("undefined");
/**
 * Determine if a value is a Buffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $b7061ac3b7093a79$var$isBuffer(val) {
    return val !== null && !$b7061ac3b7093a79$var$isUndefined(val) && val.constructor !== null && !$b7061ac3b7093a79$var$isUndefined(val.constructor) && $b7061ac3b7093a79$var$isFunction(val.constructor.isBuffer) && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ const $b7061ac3b7093a79$var$isArrayBuffer = $b7061ac3b7093a79$var$kindOfTest("ArrayBuffer");
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $b7061ac3b7093a79$var$isArrayBufferView(val) {
    let result;
    if (typeof ArrayBuffer !== "undefined" && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && $b7061ac3b7093a79$var$isArrayBuffer(val.buffer);
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a String, otherwise false
 */ const $b7061ac3b7093a79$var$isString = $b7061ac3b7093a79$var$typeOfTest("string");
/**
 * Determine if a value is a Function
 *
 * @param {*} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ const $b7061ac3b7093a79$var$isFunction = $b7061ac3b7093a79$var$typeOfTest("function");
/**
 * Determine if a value is a Number
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Number, otherwise false
 */ const $b7061ac3b7093a79$var$isNumber = $b7061ac3b7093a79$var$typeOfTest("number");
/**
 * Determine if a value is an Object
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an Object, otherwise false
 */ const $b7061ac3b7093a79$var$isObject = (thing)=>thing !== null && typeof thing === "object";
/**
 * Determine if a value is a Boolean
 *
 * @param {*} thing The value to test
 * @returns {boolean} True if value is a Boolean, otherwise false
 */ const $b7061ac3b7093a79$var$isBoolean = (thing)=>thing === true || thing === false;
/**
 * Determine if a value is a plain Object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a plain Object, otherwise false
 */ const $b7061ac3b7093a79$var$isPlainObject = (val)=>{
    if ($b7061ac3b7093a79$var$kindOf(val) !== "object") return false;
    const prototype = $b7061ac3b7093a79$var$getPrototypeOf(val);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !($b7061ac3b7093a79$var$toStringTag in val) && !($b7061ac3b7093a79$var$iterator in val);
};
/**
 * Determine if a value is an empty object (safely handles Buffers)
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an empty object, otherwise false
 */ const $b7061ac3b7093a79$var$isEmptyObject = (val)=>{
    // Early return for non-objects or Buffers to prevent RangeError
    if (!$b7061ac3b7093a79$var$isObject(val) || $b7061ac3b7093a79$var$isBuffer(val)) return false;
    try {
        return Object.keys(val).length === 0 && Object.getPrototypeOf(val) === Object.prototype;
    } catch (e) {
        // Fallback for any other objects that might cause RangeError with Object.keys()
        return false;
    }
};
/**
 * Determine if a value is a Date
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Date, otherwise false
 */ const $b7061ac3b7093a79$var$isDate = $b7061ac3b7093a79$var$kindOfTest("Date");
/**
 * Determine if a value is a File
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $b7061ac3b7093a79$var$isFile = $b7061ac3b7093a79$var$kindOfTest("File");
/**
 * Determine if a value is a Blob
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Blob, otherwise false
 */ const $b7061ac3b7093a79$var$isBlob = $b7061ac3b7093a79$var$kindOfTest("Blob");
/**
 * Determine if a value is a FileList
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $b7061ac3b7093a79$var$isFileList = $b7061ac3b7093a79$var$kindOfTest("FileList");
/**
 * Determine if a value is a Stream
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Stream, otherwise false
 */ const $b7061ac3b7093a79$var$isStream = (val)=>$b7061ac3b7093a79$var$isObject(val) && $b7061ac3b7093a79$var$isFunction(val.pipe);
/**
 * Determine if a value is a FormData
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an FormData, otherwise false
 */ const $b7061ac3b7093a79$var$isFormData = (thing)=>{
    let kind;
    return thing && (typeof FormData === "function" && thing instanceof FormData || $b7061ac3b7093a79$var$isFunction(thing.append) && ((kind = $b7061ac3b7093a79$var$kindOf(thing)) === "formdata" || // detect form-data instance
    kind === "object" && $b7061ac3b7093a79$var$isFunction(thing.toString) && thing.toString() === "[object FormData]"));
};
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ const $b7061ac3b7093a79$var$isURLSearchParams = $b7061ac3b7093a79$var$kindOfTest("URLSearchParams");
const [$b7061ac3b7093a79$var$isReadableStream, $b7061ac3b7093a79$var$isRequest, $b7061ac3b7093a79$var$isResponse, $b7061ac3b7093a79$var$isHeaders] = [
    "ReadableStream",
    "Request",
    "Response",
    "Headers"
].map($b7061ac3b7093a79$var$kindOfTest);
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 *
 * @returns {String} The String freed of excess whitespace
 */ const $b7061ac3b7093a79$var$trim = (str)=>str.trim ? str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 *
 * @param {Boolean} [allOwnKeys = false]
 * @returns {any}
 */ function $b7061ac3b7093a79$var$forEach(obj, fn, { allOwnKeys: allOwnKeys = false } = {}) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === "undefined") return;
    let i;
    let l;
    // Force an array if not already something iterable
    if (typeof obj !== "object") /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($b7061ac3b7093a79$var$isArray(obj)) // Iterate over array values
    for(i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Buffer check
        if ($b7061ac3b7093a79$var$isBuffer(obj)) return;
        // Iterate over object keys
        const keys = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
        const len = keys.length;
        let key;
        for(i = 0; i < len; i++){
            key = keys[i];
            fn.call(null, obj[key], key, obj);
        }
    }
}
function $b7061ac3b7093a79$var$findKey(obj, key) {
    if ($b7061ac3b7093a79$var$isBuffer(obj)) return null;
    key = key.toLowerCase();
    const keys = Object.keys(obj);
    let i = keys.length;
    let _key;
    while(i-- > 0){
        _key = keys[i];
        if (key === _key.toLowerCase()) return _key;
    }
    return null;
}
const $b7061ac3b7093a79$var$_global = (()=>{
    /*eslint no-undef:0*/ if (typeof globalThis !== "undefined") return globalThis;
    return typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : $parcel$global;
})();
const $b7061ac3b7093a79$var$isContextDefined = (context)=>!$b7061ac3b7093a79$var$isUndefined(context) && context !== $b7061ac3b7093a79$var$_global;
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 *
 * @returns {Object} Result of all merge properties
 */ function $b7061ac3b7093a79$var$merge() {
    const { caseless: caseless, skipUndefined: skipUndefined } = $b7061ac3b7093a79$var$isContextDefined(this) && this || {};
    const result = {};
    const assignValue = (val, key)=>{
        const targetKey = caseless && $b7061ac3b7093a79$var$findKey(result, key) || key;
        if ($b7061ac3b7093a79$var$isPlainObject(result[targetKey]) && $b7061ac3b7093a79$var$isPlainObject(val)) result[targetKey] = $b7061ac3b7093a79$var$merge(result[targetKey], val);
        else if ($b7061ac3b7093a79$var$isPlainObject(val)) result[targetKey] = $b7061ac3b7093a79$var$merge({}, val);
        else if ($b7061ac3b7093a79$var$isArray(val)) result[targetKey] = val.slice();
        else if (!skipUndefined || !$b7061ac3b7093a79$var$isUndefined(val)) result[targetKey] = val;
    };
    for(let i = 0, l = arguments.length; i < l; i++)arguments[i] && $b7061ac3b7093a79$var$forEach(arguments[i], assignValue);
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 *
 * @param {Boolean} [allOwnKeys]
 * @returns {Object} The resulting value of object a
 */ const $b7061ac3b7093a79$var$extend = (a, b, thisArg, { allOwnKeys: allOwnKeys } = {})=>{
    $b7061ac3b7093a79$var$forEach(b, (val, key)=>{
        if (thisArg && $b7061ac3b7093a79$var$isFunction(val)) a[key] = (0, $bR3x9.default)(val, thisArg);
        else a[key] = val;
    }, {
        allOwnKeys: allOwnKeys
    });
    return a;
};
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 *
 * @returns {string} content value without BOM
 */ const $b7061ac3b7093a79$var$stripBOM = (content)=>{
    if (content.charCodeAt(0) === 0xFEFF) content = content.slice(1);
    return content;
};
/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 *
 * @returns {void}
 */ const $b7061ac3b7093a79$var$inherits = (constructor, superConstructor, props, descriptors)=>{
    constructor.prototype = Object.create(superConstructor.prototype, descriptors);
    constructor.prototype.constructor = constructor;
    Object.defineProperty(constructor, "super", {
        value: superConstructor.prototype
    });
    props && Object.assign(constructor.prototype, props);
};
/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function|Boolean} [filter]
 * @param {Function} [propFilter]
 *
 * @returns {Object}
 */ const $b7061ac3b7093a79$var$toFlatObject = (sourceObj, destObj, filter, propFilter)=>{
    let props;
    let i;
    let prop;
    const merged = {};
    destObj = destObj || {};
    // eslint-disable-next-line no-eq-null,eqeqeq
    if (sourceObj == null) return destObj;
    do {
        props = Object.getOwnPropertyNames(sourceObj);
        i = props.length;
        while(i-- > 0){
            prop = props[i];
            if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
                destObj[prop] = sourceObj[prop];
                merged[prop] = true;
            }
        }
        sourceObj = filter !== false && $b7061ac3b7093a79$var$getPrototypeOf(sourceObj);
    }while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);
    return destObj;
};
/**
 * Determines whether a string ends with the characters of a specified string
 *
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 *
 * @returns {boolean}
 */ const $b7061ac3b7093a79$var$endsWith = (str, searchString, position)=>{
    str = String(str);
    if (position === undefined || position > str.length) position = str.length;
    position -= searchString.length;
    const lastIndex = str.indexOf(searchString, position);
    return lastIndex !== -1 && lastIndex === position;
};
/**
 * Returns new array from array like object or null if failed
 *
 * @param {*} [thing]
 *
 * @returns {?Array}
 */ const $b7061ac3b7093a79$var$toArray = (thing)=>{
    if (!thing) return null;
    if ($b7061ac3b7093a79$var$isArray(thing)) return thing;
    let i = thing.length;
    if (!$b7061ac3b7093a79$var$isNumber(i)) return null;
    const arr = new Array(i);
    while(i-- > 0)arr[i] = thing[i];
    return arr;
};
/**
 * Checking if the Uint8Array exists and if it does, it returns a function that checks if the
 * thing passed in is an instance of Uint8Array
 *
 * @param {TypedArray}
 *
 * @returns {Array}
 */ // eslint-disable-next-line func-names
const $b7061ac3b7093a79$var$isTypedArray = ((TypedArray)=>{
    // eslint-disable-next-line func-names
    return (thing)=>{
        return TypedArray && thing instanceof TypedArray;
    };
})(typeof Uint8Array !== "undefined" && $b7061ac3b7093a79$var$getPrototypeOf(Uint8Array));
/**
 * For each entry in the object, call the function with the key and value.
 *
 * @param {Object<any, any>} obj - The object to iterate over.
 * @param {Function} fn - The function to call for each entry.
 *
 * @returns {void}
 */ const $b7061ac3b7093a79$var$forEachEntry = (obj, fn)=>{
    const generator = obj && obj[$b7061ac3b7093a79$var$iterator];
    const _iterator = generator.call(obj);
    let result;
    while((result = _iterator.next()) && !result.done){
        const pair = result.value;
        fn.call(obj, pair[0], pair[1]);
    }
};
/**
 * It takes a regular expression and a string, and returns an array of all the matches
 *
 * @param {string} regExp - The regular expression to match against.
 * @param {string} str - The string to search.
 *
 * @returns {Array<boolean>}
 */ const $b7061ac3b7093a79$var$matchAll = (regExp, str)=>{
    let matches;
    const arr = [];
    while((matches = regExp.exec(str)) !== null)arr.push(matches);
    return arr;
};
/* Checking if the kindOfTest function returns true when passed an HTMLFormElement. */ const $b7061ac3b7093a79$var$isHTMLForm = $b7061ac3b7093a79$var$kindOfTest("HTMLFormElement");
const $b7061ac3b7093a79$var$toCamelCase = (str)=>{
    return str.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function replacer(m, p1, p2) {
        return p1.toUpperCase() + p2;
    });
};
/* Creating a function that will check if an object has a property. */ const $b7061ac3b7093a79$var$hasOwnProperty = (({ hasOwnProperty: hasOwnProperty })=>(obj, prop)=>hasOwnProperty.call(obj, prop))(Object.prototype);
/**
 * Determine if a value is a RegExp object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a RegExp object, otherwise false
 */ const $b7061ac3b7093a79$var$isRegExp = $b7061ac3b7093a79$var$kindOfTest("RegExp");
const $b7061ac3b7093a79$var$reduceDescriptors = (obj, reducer)=>{
    const descriptors = Object.getOwnPropertyDescriptors(obj);
    const reducedDescriptors = {};
    $b7061ac3b7093a79$var$forEach(descriptors, (descriptor, name)=>{
        let ret;
        if ((ret = reducer(descriptor, name, obj)) !== false) reducedDescriptors[name] = ret || descriptor;
    });
    Object.defineProperties(obj, reducedDescriptors);
};
/**
 * Makes all methods read-only
 * @param {Object} obj
 */ const $b7061ac3b7093a79$var$freezeMethods = (obj)=>{
    $b7061ac3b7093a79$var$reduceDescriptors(obj, (descriptor, name)=>{
        // skip restricted props in strict mode
        if ($b7061ac3b7093a79$var$isFunction(obj) && [
            "arguments",
            "caller",
            "callee"
        ].indexOf(name) !== -1) return false;
        const value = obj[name];
        if (!$b7061ac3b7093a79$var$isFunction(value)) return;
        descriptor.enumerable = false;
        if ("writable" in descriptor) {
            descriptor.writable = false;
            return;
        }
        if (!descriptor.set) descriptor.set = ()=>{
            throw Error("Can not rewrite read-only method '" + name + "'");
        };
    });
};
const $b7061ac3b7093a79$var$toObjectSet = (arrayOrString, delimiter)=>{
    const obj = {};
    const define = (arr)=>{
        arr.forEach((value)=>{
            obj[value] = true;
        });
    };
    $b7061ac3b7093a79$var$isArray(arrayOrString) ? define(arrayOrString) : define(String(arrayOrString).split(delimiter));
    return obj;
};
const $b7061ac3b7093a79$var$noop = ()=>{};
const $b7061ac3b7093a79$var$toFiniteNumber = (value, defaultValue)=>{
    return value != null && Number.isFinite(value = +value) ? value : defaultValue;
};
/**
 * If the thing is a FormData object, return true, otherwise return false.
 *
 * @param {unknown} thing - The thing to check.
 *
 * @returns {boolean}
 */ function $b7061ac3b7093a79$var$isSpecCompliantForm(thing) {
    return !!(thing && $b7061ac3b7093a79$var$isFunction(thing.append) && thing[$b7061ac3b7093a79$var$toStringTag] === "FormData" && thing[$b7061ac3b7093a79$var$iterator]);
}
const $b7061ac3b7093a79$var$toJSONObject = (obj)=>{
    const stack = new Array(10);
    const visit = (source, i)=>{
        if ($b7061ac3b7093a79$var$isObject(source)) {
            if (stack.indexOf(source) >= 0) return;
            //Buffer check
            if ($b7061ac3b7093a79$var$isBuffer(source)) return source;
            if (!("toJSON" in source)) {
                stack[i] = source;
                const target = $b7061ac3b7093a79$var$isArray(source) ? [] : {};
                $b7061ac3b7093a79$var$forEach(source, (value, key)=>{
                    const reducedValue = visit(value, i + 1);
                    !$b7061ac3b7093a79$var$isUndefined(reducedValue) && (target[key] = reducedValue);
                });
                stack[i] = undefined;
                return target;
            }
        }
        return source;
    };
    return visit(obj, 0);
};
const $b7061ac3b7093a79$var$isAsyncFn = $b7061ac3b7093a79$var$kindOfTest("AsyncFunction");
const $b7061ac3b7093a79$var$isThenable = (thing)=>thing && ($b7061ac3b7093a79$var$isObject(thing) || $b7061ac3b7093a79$var$isFunction(thing)) && $b7061ac3b7093a79$var$isFunction(thing.then) && $b7061ac3b7093a79$var$isFunction(thing.catch);
// original code
// https://github.com/DigitalBrainJS/AxiosPromise/blob/16deab13710ec09779922131f3fa5954320f83ab/lib/utils.js#L11-L34
const $b7061ac3b7093a79$var$_setImmediate = ((setImmediateSupported, postMessageSupported)=>{
    if (setImmediateSupported) return setImmediate;
    return postMessageSupported ? ((token, callbacks)=>{
        $b7061ac3b7093a79$var$_global.addEventListener("message", ({ source: source, data: data })=>{
            if (source === $b7061ac3b7093a79$var$_global && data === token) callbacks.length && callbacks.shift()();
        }, false);
        return (cb)=>{
            callbacks.push(cb);
            $b7061ac3b7093a79$var$_global.postMessage(token, "*");
        };
    })(`axios@${Math.random()}`, []) : (cb)=>setTimeout(cb);
})(typeof setImmediate === "function", $b7061ac3b7093a79$var$isFunction($b7061ac3b7093a79$var$_global.postMessage));
const $b7061ac3b7093a79$var$asap = typeof queueMicrotask !== "undefined" ? queueMicrotask.bind($b7061ac3b7093a79$var$_global) : typeof $hmuqp !== "undefined" && $hmuqp.nextTick || $b7061ac3b7093a79$var$_setImmediate;
// *********************
const $b7061ac3b7093a79$var$isIterable = (thing)=>thing != null && $b7061ac3b7093a79$var$isFunction(thing[$b7061ac3b7093a79$var$iterator]);
var $b7061ac3b7093a79$export$2e2bcd8739ae039 = {
    isArray: $b7061ac3b7093a79$var$isArray,
    isArrayBuffer: $b7061ac3b7093a79$var$isArrayBuffer,
    isBuffer: $b7061ac3b7093a79$var$isBuffer,
    isFormData: $b7061ac3b7093a79$var$isFormData,
    isArrayBufferView: $b7061ac3b7093a79$var$isArrayBufferView,
    isString: $b7061ac3b7093a79$var$isString,
    isNumber: $b7061ac3b7093a79$var$isNumber,
    isBoolean: $b7061ac3b7093a79$var$isBoolean,
    isObject: $b7061ac3b7093a79$var$isObject,
    isPlainObject: $b7061ac3b7093a79$var$isPlainObject,
    isEmptyObject: $b7061ac3b7093a79$var$isEmptyObject,
    isReadableStream: $b7061ac3b7093a79$var$isReadableStream,
    isRequest: $b7061ac3b7093a79$var$isRequest,
    isResponse: $b7061ac3b7093a79$var$isResponse,
    isHeaders: $b7061ac3b7093a79$var$isHeaders,
    isUndefined: $b7061ac3b7093a79$var$isUndefined,
    isDate: $b7061ac3b7093a79$var$isDate,
    isFile: $b7061ac3b7093a79$var$isFile,
    isBlob: $b7061ac3b7093a79$var$isBlob,
    isRegExp: $b7061ac3b7093a79$var$isRegExp,
    isFunction: $b7061ac3b7093a79$var$isFunction,
    isStream: $b7061ac3b7093a79$var$isStream,
    isURLSearchParams: $b7061ac3b7093a79$var$isURLSearchParams,
    isTypedArray: $b7061ac3b7093a79$var$isTypedArray,
    isFileList: $b7061ac3b7093a79$var$isFileList,
    forEach: $b7061ac3b7093a79$var$forEach,
    merge: $b7061ac3b7093a79$var$merge,
    extend: $b7061ac3b7093a79$var$extend,
    trim: $b7061ac3b7093a79$var$trim,
    stripBOM: $b7061ac3b7093a79$var$stripBOM,
    inherits: $b7061ac3b7093a79$var$inherits,
    toFlatObject: $b7061ac3b7093a79$var$toFlatObject,
    kindOf: $b7061ac3b7093a79$var$kindOf,
    kindOfTest: $b7061ac3b7093a79$var$kindOfTest,
    endsWith: $b7061ac3b7093a79$var$endsWith,
    toArray: $b7061ac3b7093a79$var$toArray,
    forEachEntry: $b7061ac3b7093a79$var$forEachEntry,
    matchAll: $b7061ac3b7093a79$var$matchAll,
    isHTMLForm: $b7061ac3b7093a79$var$isHTMLForm,
    hasOwnProperty: $b7061ac3b7093a79$var$hasOwnProperty,
    hasOwnProp: $b7061ac3b7093a79$var$hasOwnProperty,
    reduceDescriptors: $b7061ac3b7093a79$var$reduceDescriptors,
    freezeMethods: $b7061ac3b7093a79$var$freezeMethods,
    toObjectSet: $b7061ac3b7093a79$var$toObjectSet,
    toCamelCase: $b7061ac3b7093a79$var$toCamelCase,
    noop: $b7061ac3b7093a79$var$noop,
    toFiniteNumber: $b7061ac3b7093a79$var$toFiniteNumber,
    findKey: $b7061ac3b7093a79$var$findKey,
    global: $b7061ac3b7093a79$var$_global,
    isContextDefined: $b7061ac3b7093a79$var$isContextDefined,
    isSpecCompliantForm: $b7061ac3b7093a79$var$isSpecCompliantForm,
    toJSONObject: $b7061ac3b7093a79$var$toJSONObject,
    isAsyncFn: $b7061ac3b7093a79$var$isAsyncFn,
    isThenable: $b7061ac3b7093a79$var$isThenable,
    setImmediate: $b7061ac3b7093a79$var$_setImmediate,
    asap: $b7061ac3b7093a79$var$asap,
    isIterable: $b7061ac3b7093a79$var$isIterable
};

});
parcelRequire.register("bR3x9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8a1762a40a3089e2$export$2e2bcd8739ae039; });
"use strict";
function $8a1762a40a3089e2$export$2e2bcd8739ae039(fn, thisArg) {
    return function wrap() {
        return fn.apply(thisArg, arguments);
    };
}

});

parcelRequire.register("hmuqp", function(module, exports) {
// shim for using process in browser
var $ca3c177f30e1096b$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $ca3c177f30e1096b$var$cachedSetTimeout;
var $ca3c177f30e1096b$var$cachedClearTimeout;
function $ca3c177f30e1096b$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $ca3c177f30e1096b$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $ca3c177f30e1096b$var$cachedSetTimeout = setTimeout;
        else $ca3c177f30e1096b$var$cachedSetTimeout = $ca3c177f30e1096b$var$defaultSetTimout;
    } catch (e) {
        $ca3c177f30e1096b$var$cachedSetTimeout = $ca3c177f30e1096b$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $ca3c177f30e1096b$var$cachedClearTimeout = clearTimeout;
        else $ca3c177f30e1096b$var$cachedClearTimeout = $ca3c177f30e1096b$var$defaultClearTimeout;
    } catch (e) {
        $ca3c177f30e1096b$var$cachedClearTimeout = $ca3c177f30e1096b$var$defaultClearTimeout;
    }
})();
function $ca3c177f30e1096b$var$runTimeout(fun) {
    if ($ca3c177f30e1096b$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($ca3c177f30e1096b$var$cachedSetTimeout === $ca3c177f30e1096b$var$defaultSetTimout || !$ca3c177f30e1096b$var$cachedSetTimeout) && setTimeout) {
        $ca3c177f30e1096b$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $ca3c177f30e1096b$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $ca3c177f30e1096b$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $ca3c177f30e1096b$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $ca3c177f30e1096b$var$runClearTimeout(marker) {
    if ($ca3c177f30e1096b$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($ca3c177f30e1096b$var$cachedClearTimeout === $ca3c177f30e1096b$var$defaultClearTimeout || !$ca3c177f30e1096b$var$cachedClearTimeout) && clearTimeout) {
        $ca3c177f30e1096b$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $ca3c177f30e1096b$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $ca3c177f30e1096b$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $ca3c177f30e1096b$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $ca3c177f30e1096b$var$queue = [];
var $ca3c177f30e1096b$var$draining = false;
var $ca3c177f30e1096b$var$currentQueue;
var $ca3c177f30e1096b$var$queueIndex = -1;
function $ca3c177f30e1096b$var$cleanUpNextTick() {
    if (!$ca3c177f30e1096b$var$draining || !$ca3c177f30e1096b$var$currentQueue) return;
    $ca3c177f30e1096b$var$draining = false;
    if ($ca3c177f30e1096b$var$currentQueue.length) $ca3c177f30e1096b$var$queue = $ca3c177f30e1096b$var$currentQueue.concat($ca3c177f30e1096b$var$queue);
    else $ca3c177f30e1096b$var$queueIndex = -1;
    if ($ca3c177f30e1096b$var$queue.length) $ca3c177f30e1096b$var$drainQueue();
}
function $ca3c177f30e1096b$var$drainQueue() {
    if ($ca3c177f30e1096b$var$draining) return;
    var timeout = $ca3c177f30e1096b$var$runTimeout($ca3c177f30e1096b$var$cleanUpNextTick);
    $ca3c177f30e1096b$var$draining = true;
    var len = $ca3c177f30e1096b$var$queue.length;
    while(len){
        $ca3c177f30e1096b$var$currentQueue = $ca3c177f30e1096b$var$queue;
        $ca3c177f30e1096b$var$queue = [];
        while(++$ca3c177f30e1096b$var$queueIndex < len)if ($ca3c177f30e1096b$var$currentQueue) $ca3c177f30e1096b$var$currentQueue[$ca3c177f30e1096b$var$queueIndex].run();
        $ca3c177f30e1096b$var$queueIndex = -1;
        len = $ca3c177f30e1096b$var$queue.length;
    }
    $ca3c177f30e1096b$var$currentQueue = null;
    $ca3c177f30e1096b$var$draining = false;
    $ca3c177f30e1096b$var$runClearTimeout(timeout);
}
$ca3c177f30e1096b$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $ca3c177f30e1096b$var$queue.push(new $ca3c177f30e1096b$var$Item(fun, args));
    if ($ca3c177f30e1096b$var$queue.length === 1 && !$ca3c177f30e1096b$var$draining) $ca3c177f30e1096b$var$runTimeout($ca3c177f30e1096b$var$drainQueue);
};
// v8 likes predictible objects
function $ca3c177f30e1096b$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$ca3c177f30e1096b$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$ca3c177f30e1096b$var$process.title = "browser";
$ca3c177f30e1096b$var$process.browser = true;
$ca3c177f30e1096b$var$process.env = {};
$ca3c177f30e1096b$var$process.argv = [];
$ca3c177f30e1096b$var$process.version = ""; // empty string to avoid regexp issues
$ca3c177f30e1096b$var$process.versions = {};
function $ca3c177f30e1096b$var$noop() {}
$ca3c177f30e1096b$var$process.on = $ca3c177f30e1096b$var$noop;
$ca3c177f30e1096b$var$process.addListener = $ca3c177f30e1096b$var$noop;
$ca3c177f30e1096b$var$process.once = $ca3c177f30e1096b$var$noop;
$ca3c177f30e1096b$var$process.off = $ca3c177f30e1096b$var$noop;
$ca3c177f30e1096b$var$process.removeListener = $ca3c177f30e1096b$var$noop;
$ca3c177f30e1096b$var$process.removeAllListeners = $ca3c177f30e1096b$var$noop;
$ca3c177f30e1096b$var$process.emit = $ca3c177f30e1096b$var$noop;
$ca3c177f30e1096b$var$process.prependListener = $ca3c177f30e1096b$var$noop;
$ca3c177f30e1096b$var$process.prependOnceListener = $ca3c177f30e1096b$var$noop;
$ca3c177f30e1096b$var$process.listeners = function(name) {
    return [];
};
$ca3c177f30e1096b$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$ca3c177f30e1096b$var$process.cwd = function() {
    return "/";
};
$ca3c177f30e1096b$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$ca3c177f30e1096b$var$process.umask = function() {
    return 0;
};

});


parcelRequire.register("5BAGh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $414cdc836f45d38a$export$2e2bcd8739ae039; });

var $fIemp = parcelRequire("fIemp");

var $l0mFf = parcelRequire("l0mFf");

var $2YtlN = parcelRequire("2YtlN");

var $fYPHb = parcelRequire("fYPHb");

var $cu9jP = parcelRequire("cu9jP");

var $d9L4R = parcelRequire("d9L4R");

var $bCA7M = parcelRequire("bCA7M");

var $9VBYq = parcelRequire("9VBYq");
"use strict";
const $414cdc836f45d38a$var$validators = (0, $bCA7M.default).validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 *
 * @return {Axios} A new instance of Axios
 */ class $414cdc836f45d38a$var$Axios {
    constructor(instanceConfig){
        this.defaults = instanceConfig || {};
        this.interceptors = {
            request: new (0, $2YtlN.default)(),
            response: new (0, $2YtlN.default)()
        };
    }
    /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */ async request(configOrUrl, config) {
        try {
            return await this._request(configOrUrl, config);
        } catch (err) {
            if (err instanceof Error) {
                let dummy = {};
                Error.captureStackTrace ? Error.captureStackTrace(dummy) : dummy = new Error();
                // slice off the Error: ... line
                const stack = dummy.stack ? dummy.stack.replace(/^.+\n/, "") : "";
                try {
                    if (!err.stack) err.stack = stack;
                    else if (stack && !String(err.stack).endsWith(stack.replace(/^.+\n.+\n/, ""))) err.stack += "\n" + stack;
                } catch (e) {
                // ignore the case where "stack" is an un-writable property
                }
            }
            throw err;
        }
    }
    _request(configOrUrl, config) {
        /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
        if (typeof configOrUrl === "string") {
            config = config || {};
            config.url = configOrUrl;
        } else config = configOrUrl || {};
        config = (0, $cu9jP.default)(this.defaults, config);
        const { transitional: transitional, paramsSerializer: paramsSerializer, headers: headers } = config;
        if (transitional !== undefined) (0, $bCA7M.default).assertOptions(transitional, {
            silentJSONParsing: $414cdc836f45d38a$var$validators.transitional($414cdc836f45d38a$var$validators.boolean),
            forcedJSONParsing: $414cdc836f45d38a$var$validators.transitional($414cdc836f45d38a$var$validators.boolean),
            clarifyTimeoutError: $414cdc836f45d38a$var$validators.transitional($414cdc836f45d38a$var$validators.boolean)
        }, false);
        if (paramsSerializer != null) {
            if ((0, $fIemp.default).isFunction(paramsSerializer)) config.paramsSerializer = {
                serialize: paramsSerializer
            };
            else (0, $bCA7M.default).assertOptions(paramsSerializer, {
                encode: $414cdc836f45d38a$var$validators.function,
                serialize: $414cdc836f45d38a$var$validators.function
            }, true);
        }
        // Set config.allowAbsoluteUrls
        if (config.allowAbsoluteUrls !== undefined) ;
        else if (this.defaults.allowAbsoluteUrls !== undefined) config.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls;
        else config.allowAbsoluteUrls = true;
        (0, $bCA7M.default).assertOptions(config, {
            baseUrl: $414cdc836f45d38a$var$validators.spelling("baseURL"),
            withXsrfToken: $414cdc836f45d38a$var$validators.spelling("withXSRFToken")
        }, true);
        // Set config.method
        config.method = (config.method || this.defaults.method || "get").toLowerCase();
        // Flatten headers
        let contextHeaders = headers && (0, $fIemp.default).merge(headers.common, headers[config.method]);
        headers && (0, $fIemp.default).forEach([
            "delete",
            "get",
            "head",
            "post",
            "put",
            "patch",
            "common"
        ], (method)=>{
            delete headers[method];
        });
        config.headers = (0, $9VBYq.default).concat(contextHeaders, headers);
        // filter out skipped interceptors
        const requestInterceptorChain = [];
        let synchronousRequestInterceptors = true;
        this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
            if (typeof interceptor.runWhen === "function" && interceptor.runWhen(config) === false) return;
            synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
            requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
        });
        const responseInterceptorChain = [];
        this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
            responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
        });
        let promise;
        let i = 0;
        let len;
        if (!synchronousRequestInterceptors) {
            const chain = [
                (0, $fYPHb.default).bind(this),
                undefined
            ];
            chain.unshift(...requestInterceptorChain);
            chain.push(...responseInterceptorChain);
            len = chain.length;
            promise = Promise.resolve(config);
            while(i < len)promise = promise.then(chain[i++], chain[i++]);
            return promise;
        }
        len = requestInterceptorChain.length;
        let newConfig = config;
        i = 0;
        while(i < len){
            const onFulfilled = requestInterceptorChain[i++];
            const onRejected = requestInterceptorChain[i++];
            try {
                newConfig = onFulfilled(newConfig);
            } catch (error) {
                onRejected.call(this, error);
                break;
            }
        }
        try {
            promise = (0, $fYPHb.default).call(this, newConfig);
        } catch (error) {
            return Promise.reject(error);
        }
        i = 0;
        len = responseInterceptorChain.length;
        while(i < len)promise = promise.then(responseInterceptorChain[i++], responseInterceptorChain[i++]);
        return promise;
    }
    getUri(config) {
        config = (0, $cu9jP.default)(this.defaults, config);
        const fullPath = (0, $d9L4R.default)(config.baseURL, config.url, config.allowAbsoluteUrls);
        return (0, $l0mFf.default)(fullPath, config.params, config.paramsSerializer);
    }
}
// Provide aliases for supported request methods
(0, $fIemp.default).forEach([
    "delete",
    "get",
    "head",
    "options"
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $414cdc836f45d38a$var$Axios.prototype[method] = function(url, config) {
        return this.request((0, $cu9jP.default)(config || {}, {
            method: method,
            url: url,
            data: (config || {}).data
        }));
    };
});
(0, $fIemp.default).forEach([
    "post",
    "put",
    "patch"
], function forEachMethodWithData(method) {
    /*eslint func-names:0*/ function generateHTTPMethod(isForm) {
        return function httpMethod(url, data, config) {
            return this.request((0, $cu9jP.default)(config || {}, {
                method: method,
                headers: isForm ? {
                    "Content-Type": "multipart/form-data"
                } : {},
                url: url,
                data: data
            }));
        };
    }
    $414cdc836f45d38a$var$Axios.prototype[method] = generateHTTPMethod();
    $414cdc836f45d38a$var$Axios.prototype[method + "Form"] = generateHTTPMethod(true);
});
var $414cdc836f45d38a$export$2e2bcd8739ae039 = $414cdc836f45d38a$var$Axios;

});
parcelRequire.register("l0mFf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f4ab2dbd2f6fe52c$export$2e2bcd8739ae039; });

var $fIemp = parcelRequire("fIemp");

var $gMBoJ = parcelRequire("gMBoJ");
"use strict";
/**
 * It replaces all instances of the characters `:`, `$`, `,`, `+`, `[`, and `]` with their
 * URI encoded counterparts
 *
 * @param {string} val The value to be encoded.
 *
 * @returns {string} The encoded value.
 */ function $f4ab2dbd2f6fe52c$var$encode(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+");
}
function $f4ab2dbd2f6fe52c$export$2e2bcd8739ae039(url, params, options) {
    /*eslint no-param-reassign:0*/ if (!params) return url;
    const _encode = options && options.encode || $f4ab2dbd2f6fe52c$var$encode;
    if ((0, $fIemp.default).isFunction(options)) options = {
        serialize: options
    };
    const serializeFn = options && options.serialize;
    let serializedParams;
    if (serializeFn) serializedParams = serializeFn(params, options);
    else serializedParams = (0, $fIemp.default).isURLSearchParams(params) ? params.toString() : new (0, $gMBoJ.default)(params, options).toString(_encode);
    if (serializedParams) {
        const hashmarkIndex = url.indexOf("#");
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf("?") === -1 ? "?" : "&") + serializedParams;
    }
    return url;
}

});
parcelRequire.register("gMBoJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c37e237bb4445bcf$export$2e2bcd8739ae039; });

var $h77YL = parcelRequire("h77YL");
"use strict";
/**
 * It encodes a string by replacing all characters that are not in the unreserved set with
 * their percent-encoded equivalents
 *
 * @param {string} str - The string to encode.
 *
 * @returns {string} The encoded string.
 */ function $c37e237bb4445bcf$var$encode(str) {
    const charMap = {
        "!": "%21",
        "'": "%27",
        "(": "%28",
        ")": "%29",
        "~": "%7E",
        "%20": "+",
        "%00": "\x00"
    };
    return encodeURIComponent(str).replace(/[!'()~]|%20|%00/g, function replacer(match) {
        return charMap[match];
    });
}
/**
 * It takes a params object and converts it to a FormData object
 *
 * @param {Object<string, any>} params - The parameters to be converted to a FormData object.
 * @param {Object<string, any>} options - The options object passed to the Axios constructor.
 *
 * @returns {void}
 */ function $c37e237bb4445bcf$var$AxiosURLSearchParams(params, options) {
    this._pairs = [];
    params && (0, $h77YL.default)(params, this, options);
}
const $c37e237bb4445bcf$var$prototype = $c37e237bb4445bcf$var$AxiosURLSearchParams.prototype;
$c37e237bb4445bcf$var$prototype.append = function append(name, value) {
    this._pairs.push([
        name,
        value
    ]);
};
$c37e237bb4445bcf$var$prototype.toString = function toString(encoder) {
    const _encode = encoder ? function(value) {
        return encoder.call(this, value, $c37e237bb4445bcf$var$encode);
    } : $c37e237bb4445bcf$var$encode;
    return this._pairs.map(function each(pair) {
        return _encode(pair[0]) + "=" + _encode(pair[1]);
    }, "").join("&");
};
var $c37e237bb4445bcf$export$2e2bcd8739ae039 = $c37e237bb4445bcf$var$AxiosURLSearchParams;

});
parcelRequire.register("h77YL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c759479609e81bcc$export$2e2bcd8739ae039; });

var $fIemp = parcelRequire("fIemp");

var $ax9gu = parcelRequire("ax9gu");

var $lHd6w = parcelRequire("lHd6w");

var $28VtE = parcelRequire("28VtE");
var $c759479609e81bcc$require$Buffer = $28VtE.Buffer;
"use strict";
/**
 * Determines if the given thing is a array or js object.
 *
 * @param {string} thing - The object or array to be visited.
 *
 * @returns {boolean}
 */ function $c759479609e81bcc$var$isVisitable(thing) {
    return (0, $fIemp.default).isPlainObject(thing) || (0, $fIemp.default).isArray(thing);
}
/**
 * It removes the brackets from the end of a string
 *
 * @param {string} key - The key of the parameter.
 *
 * @returns {string} the key without the brackets.
 */ function $c759479609e81bcc$var$removeBrackets(key) {
    return (0, $fIemp.default).endsWith(key, "[]") ? key.slice(0, -2) : key;
}
/**
 * It takes a path, a key, and a boolean, and returns a string
 *
 * @param {string} path - The path to the current key.
 * @param {string} key - The key of the current object being iterated over.
 * @param {string} dots - If true, the key will be rendered with dots instead of brackets.
 *
 * @returns {string} The path to the current key.
 */ function $c759479609e81bcc$var$renderKey(path, key, dots) {
    if (!path) return key;
    return path.concat(key).map(function each(token, i) {
        // eslint-disable-next-line no-param-reassign
        token = $c759479609e81bcc$var$removeBrackets(token);
        return !dots && i ? "[" + token + "]" : token;
    }).join(dots ? "." : "");
}
/**
 * If the array is an array and none of its elements are visitable, then it's a flat array.
 *
 * @param {Array<any>} arr - The array to check
 *
 * @returns {boolean}
 */ function $c759479609e81bcc$var$isFlatArray(arr) {
    return (0, $fIemp.default).isArray(arr) && !arr.some($c759479609e81bcc$var$isVisitable);
}
const $c759479609e81bcc$var$predicates = (0, $fIemp.default).toFlatObject((0, $fIemp.default), {}, null, function filter(prop) {
    return /^is[A-Z]/.test(prop);
});
/**
 * Convert a data object to FormData
 *
 * @param {Object} obj
 * @param {?Object} [formData]
 * @param {?Object} [options]
 * @param {Function} [options.visitor]
 * @param {Boolean} [options.metaTokens = true]
 * @param {Boolean} [options.dots = false]
 * @param {?Boolean} [options.indexes = false]
 *
 * @returns {Object}
 **/ /**
 * It converts an object into a FormData object
 *
 * @param {Object<any, any>} obj - The object to convert to form data.
 * @param {string} formData - The FormData object to append to.
 * @param {Object<string, any>} options
 *
 * @returns
 */ function $c759479609e81bcc$var$toFormData(obj, formData, options) {
    if (!(0, $fIemp.default).isObject(obj)) throw new TypeError("target must be an object");
    // eslint-disable-next-line no-param-reassign
    formData = formData || new ((0, $lHd6w.default) || FormData)();
    // eslint-disable-next-line no-param-reassign
    options = (0, $fIemp.default).toFlatObject(options, {
        metaTokens: true,
        dots: false,
        indexes: false
    }, false, function defined(option, source) {
        // eslint-disable-next-line no-eq-null,eqeqeq
        return !(0, $fIemp.default).isUndefined(source[option]);
    });
    const metaTokens = options.metaTokens;
    // eslint-disable-next-line no-use-before-define
    const visitor = options.visitor || defaultVisitor;
    const dots = options.dots;
    const indexes = options.indexes;
    const _Blob = options.Blob || typeof Blob !== "undefined" && Blob;
    const useBlob = _Blob && (0, $fIemp.default).isSpecCompliantForm(formData);
    if (!(0, $fIemp.default).isFunction(visitor)) throw new TypeError("visitor must be a function");
    function convertValue(value) {
        if (value === null) return "";
        if ((0, $fIemp.default).isDate(value)) return value.toISOString();
        if ((0, $fIemp.default).isBoolean(value)) return value.toString();
        if (!useBlob && (0, $fIemp.default).isBlob(value)) throw new (0, $ax9gu.default)("Blob is not supported. Use a Buffer instead.");
        if ((0, $fIemp.default).isArrayBuffer(value) || (0, $fIemp.default).isTypedArray(value)) return useBlob && typeof Blob === "function" ? new Blob([
            value
        ]) : $c759479609e81bcc$require$Buffer.from(value);
        return value;
    }
    /**
   * Default visitor.
   *
   * @param {*} value
   * @param {String|Number} key
   * @param {Array<String|Number>} path
   * @this {FormData}
   *
   * @returns {boolean} return true to visit the each prop of the value recursively
   */ function defaultVisitor(value, key, path) {
        let arr = value;
        if (value && !path && typeof value === "object") {
            if ((0, $fIemp.default).endsWith(key, "{}")) {
                // eslint-disable-next-line no-param-reassign
                key = metaTokens ? key : key.slice(0, -2);
                // eslint-disable-next-line no-param-reassign
                value = JSON.stringify(value);
            } else if ((0, $fIemp.default).isArray(value) && $c759479609e81bcc$var$isFlatArray(value) || ((0, $fIemp.default).isFileList(value) || (0, $fIemp.default).endsWith(key, "[]")) && (arr = (0, $fIemp.default).toArray(value))) {
                // eslint-disable-next-line no-param-reassign
                key = $c759479609e81bcc$var$removeBrackets(key);
                arr.forEach(function each(el, index) {
                    !((0, $fIemp.default).isUndefined(el) || el === null) && formData.append(// eslint-disable-next-line no-nested-ternary
                    indexes === true ? $c759479609e81bcc$var$renderKey([
                        key
                    ], index, dots) : indexes === null ? key : key + "[]", convertValue(el));
                });
                return false;
            }
        }
        if ($c759479609e81bcc$var$isVisitable(value)) return true;
        formData.append($c759479609e81bcc$var$renderKey(path, key, dots), convertValue(value));
        return false;
    }
    const stack = [];
    const exposedHelpers = Object.assign($c759479609e81bcc$var$predicates, {
        defaultVisitor: defaultVisitor,
        convertValue: convertValue,
        isVisitable: $c759479609e81bcc$var$isVisitable
    });
    function build(value, path) {
        if ((0, $fIemp.default).isUndefined(value)) return;
        if (stack.indexOf(value) !== -1) throw Error("Circular reference detected in " + path.join("."));
        stack.push(value);
        (0, $fIemp.default).forEach(value, function each(el, key) {
            const result = !((0, $fIemp.default).isUndefined(el) || el === null) && visitor.call(formData, el, (0, $fIemp.default).isString(key) ? key.trim() : key, path, exposedHelpers);
            if (result === true) build(el, path ? path.concat(key) : [
                key
            ]);
        });
        stack.pop();
    }
    if (!(0, $fIemp.default).isObject(obj)) throw new TypeError("data must be an object");
    build(obj);
    return formData;
}
var $c759479609e81bcc$export$2e2bcd8739ae039 = $c759479609e81bcc$var$toFormData;

});
parcelRequire.register("ax9gu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7ab42c49102ea301$export$2e2bcd8739ae039; });

var $fIemp = parcelRequire("fIemp");
"use strict";
/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [config] The config.
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 *
 * @returns {Error} The created error.
 */ function $7ab42c49102ea301$var$AxiosError(message, code, config, request, response) {
    Error.call(this);
    if (Error.captureStackTrace) Error.captureStackTrace(this, this.constructor);
    else this.stack = new Error().stack;
    this.message = message;
    this.name = "AxiosError";
    code && (this.code = code);
    config && (this.config = config);
    request && (this.request = request);
    if (response) {
        this.response = response;
        this.status = response.status ? response.status : null;
    }
}
(0, $fIemp.default).inherits($7ab42c49102ea301$var$AxiosError, Error, {
    toJSON: function toJSON() {
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: (0, $fIemp.default).toJSONObject(this.config),
            code: this.code,
            status: this.status
        };
    }
});
const $7ab42c49102ea301$var$prototype = $7ab42c49102ea301$var$AxiosError.prototype;
const $7ab42c49102ea301$var$descriptors = {};
[
    "ERR_BAD_OPTION_VALUE",
    "ERR_BAD_OPTION",
    "ECONNABORTED",
    "ETIMEDOUT",
    "ERR_NETWORK",
    "ERR_FR_TOO_MANY_REDIRECTS",
    "ERR_DEPRECATED",
    "ERR_BAD_RESPONSE",
    "ERR_BAD_REQUEST",
    "ERR_CANCELED",
    "ERR_NOT_SUPPORT",
    "ERR_INVALID_URL"
].forEach((code)=>{
    $7ab42c49102ea301$var$descriptors[code] = {
        value: code
    };
});
Object.defineProperties($7ab42c49102ea301$var$AxiosError, $7ab42c49102ea301$var$descriptors);
Object.defineProperty($7ab42c49102ea301$var$prototype, "isAxiosError", {
    value: true
});
// eslint-disable-next-line func-names
$7ab42c49102ea301$var$AxiosError.from = (error, code, config, request, response, customProps)=>{
    const axiosError = Object.create($7ab42c49102ea301$var$prototype);
    (0, $fIemp.default).toFlatObject(error, axiosError, function filter(obj) {
        return obj !== Error.prototype;
    }, (prop)=>{
        return prop !== "isAxiosError";
    });
    const msg = error && error.message ? error.message : "Error";
    // Prefer explicit code; otherwise copy the low-level error's code (e.g. ECONNREFUSED)
    const errCode = code == null && error ? error.code : code;
    $7ab42c49102ea301$var$AxiosError.call(axiosError, msg, errCode, config, request, response);
    // Chain the original error on the standard field; non-enumerable to avoid JSON noise
    if (error && axiosError.cause == null) Object.defineProperty(axiosError, "cause", {
        value: error,
        configurable: true
    });
    axiosError.name = error && error.name || "Error";
    customProps && Object.assign(axiosError, customProps);
    return axiosError;
};
var $7ab42c49102ea301$export$2e2bcd8739ae039 = $7ab42c49102ea301$var$AxiosError;

});

parcelRequire.register("lHd6w", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fcb7c75bf100fa25$export$2e2bcd8739ae039; });
// eslint-disable-next-line strict
var $fcb7c75bf100fa25$export$2e2bcd8739ae039 = null;

});

parcelRequire.register("28VtE", function(module, exports) {

$parcel$export(module.exports, "Buffer", function () { return $18f8e9e4cd720744$export$a143d493d941bafc; }, function (v) { return $18f8e9e4cd720744$export$a143d493d941bafc = v; });
$parcel$export(module.exports, "INSPECT_MAX_BYTES", function () { return $18f8e9e4cd720744$export$f99ded8fe4b79145; }, function (v) { return $18f8e9e4cd720744$export$f99ded8fe4b79145 = v; });
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $18f8e9e4cd720744$export$a143d493d941bafc;
var $18f8e9e4cd720744$export$e4cf37d7f6fb9e0a;
var $18f8e9e4cd720744$export$f99ded8fe4b79145;
var $18f8e9e4cd720744$export$599f31c3813fae4d;
"use strict";

var $kr5lq = parcelRequire("kr5lq");

var $gKZj9 = parcelRequire("gKZj9");
const $18f8e9e4cd720744$var$customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" // eslint-disable-line dot-notation
 ? Symbol["for"]("nodejs.util.inspect.custom") // eslint-disable-line dot-notation
 : null;
$18f8e9e4cd720744$export$a143d493d941bafc = $18f8e9e4cd720744$var$Buffer;
$18f8e9e4cd720744$export$e4cf37d7f6fb9e0a = $18f8e9e4cd720744$var$SlowBuffer;
$18f8e9e4cd720744$export$f99ded8fe4b79145 = 50;
const $18f8e9e4cd720744$var$K_MAX_LENGTH = 0x7fffffff;
$18f8e9e4cd720744$export$599f31c3813fae4d = $18f8e9e4cd720744$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $18f8e9e4cd720744$var$Buffer.TYPED_ARRAY_SUPPORT = $18f8e9e4cd720744$var$typedArraySupport();
if (!$18f8e9e4cd720744$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $18f8e9e4cd720744$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($18f8e9e4cd720744$var$Buffer.prototype, "parent", {
    enumerable: true,
    get: function() {
        if (!$18f8e9e4cd720744$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($18f8e9e4cd720744$var$Buffer.prototype, "offset", {
    enumerable: true,
    get: function() {
        if (!$18f8e9e4cd720744$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $18f8e9e4cd720744$var$createBuffer(length) {
    if (length > $18f8e9e4cd720744$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $18f8e9e4cd720744$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $18f8e9e4cd720744$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
        return $18f8e9e4cd720744$var$allocUnsafe(arg);
    }
    return $18f8e9e4cd720744$var$from(arg, encodingOrOffset, length);
}
$18f8e9e4cd720744$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $18f8e9e4cd720744$var$from(value, encodingOrOffset, length) {
    if (typeof value === "string") return $18f8e9e4cd720744$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $18f8e9e4cd720744$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($18f8e9e4cd720744$var$isInstance(value, ArrayBuffer) || value && $18f8e9e4cd720744$var$isInstance(value.buffer, ArrayBuffer)) return $18f8e9e4cd720744$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== "undefined" && ($18f8e9e4cd720744$var$isInstance(value, SharedArrayBuffer) || value && $18f8e9e4cd720744$var$isInstance(value.buffer, SharedArrayBuffer))) return $18f8e9e4cd720744$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $18f8e9e4cd720744$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $18f8e9e4cd720744$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return $18f8e9e4cd720744$var$Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $18f8e9e4cd720744$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $18f8e9e4cd720744$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($18f8e9e4cd720744$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($18f8e9e4cd720744$var$Buffer, Uint8Array);
function $18f8e9e4cd720744$var$assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $18f8e9e4cd720744$var$alloc(size, fill, encoding) {
    $18f8e9e4cd720744$var$assertSize(size);
    if (size <= 0) return $18f8e9e4cd720744$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === "string" ? $18f8e9e4cd720744$var$createBuffer(size).fill(fill, encoding) : $18f8e9e4cd720744$var$createBuffer(size).fill(fill);
    return $18f8e9e4cd720744$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $18f8e9e4cd720744$var$Buffer.alloc = function(size, fill, encoding) {
    return $18f8e9e4cd720744$var$alloc(size, fill, encoding);
};
function $18f8e9e4cd720744$var$allocUnsafe(size) {
    $18f8e9e4cd720744$var$assertSize(size);
    return $18f8e9e4cd720744$var$createBuffer(size < 0 ? 0 : $18f8e9e4cd720744$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $18f8e9e4cd720744$var$Buffer.allocUnsafe = function(size) {
    return $18f8e9e4cd720744$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $18f8e9e4cd720744$var$Buffer.allocUnsafeSlow = function(size) {
    return $18f8e9e4cd720744$var$allocUnsafe(size);
};
function $18f8e9e4cd720744$var$fromString(string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!$18f8e9e4cd720744$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    const length = $18f8e9e4cd720744$var$byteLength(string, encoding) | 0;
    let buf = $18f8e9e4cd720744$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $18f8e9e4cd720744$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $18f8e9e4cd720744$var$checked(array.length) | 0;
    const buf = $18f8e9e4cd720744$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $18f8e9e4cd720744$var$fromArrayView(arrayView) {
    if ($18f8e9e4cd720744$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $18f8e9e4cd720744$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $18f8e9e4cd720744$var$fromArrayLike(arrayView);
}
function $18f8e9e4cd720744$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $18f8e9e4cd720744$var$Buffer.prototype);
    return buf;
}
function $18f8e9e4cd720744$var$fromObject(obj) {
    if ($18f8e9e4cd720744$var$Buffer.isBuffer(obj)) {
        const len = $18f8e9e4cd720744$var$checked(obj.length) | 0;
        const buf = $18f8e9e4cd720744$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== "number" || $18f8e9e4cd720744$var$numberIsNaN(obj.length)) return $18f8e9e4cd720744$var$createBuffer(0);
        return $18f8e9e4cd720744$var$fromArrayLike(obj);
    }
    if (obj.type === "Buffer" && Array.isArray(obj.data)) return $18f8e9e4cd720744$var$fromArrayLike(obj.data);
}
function $18f8e9e4cd720744$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $18f8e9e4cd720744$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $18f8e9e4cd720744$var$K_MAX_LENGTH.toString(16) + " bytes");
    return length | 0;
}
function $18f8e9e4cd720744$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $18f8e9e4cd720744$var$Buffer.alloc(+length);
}
$18f8e9e4cd720744$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $18f8e9e4cd720744$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$18f8e9e4cd720744$var$Buffer.compare = function compare(a, b) {
    if ($18f8e9e4cd720744$var$isInstance(a, Uint8Array)) a = $18f8e9e4cd720744$var$Buffer.from(a, a.offset, a.byteLength);
    if ($18f8e9e4cd720744$var$isInstance(b, Uint8Array)) b = $18f8e9e4cd720744$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$18f8e9e4cd720744$var$Buffer.isBuffer(a) || !$18f8e9e4cd720744$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$18f8e9e4cd720744$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
$18f8e9e4cd720744$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $18f8e9e4cd720744$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $18f8e9e4cd720744$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($18f8e9e4cd720744$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$18f8e9e4cd720744$var$Buffer.isBuffer(buf)) buf = $18f8e9e4cd720744$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$18f8e9e4cd720744$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $18f8e9e4cd720744$var$byteLength(string, encoding) {
    if ($18f8e9e4cd720744$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $18f8e9e4cd720744$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
            return $18f8e9e4cd720744$var$utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return $18f8e9e4cd720744$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $18f8e9e4cd720744$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
$18f8e9e4cd720744$var$Buffer.byteLength = $18f8e9e4cd720744$var$byteLength;
function $18f8e9e4cd720744$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return $18f8e9e4cd720744$var$hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return $18f8e9e4cd720744$var$utf8Slice(this, start, end);
        case "ascii":
            return $18f8e9e4cd720744$var$asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return $18f8e9e4cd720744$var$latin1Slice(this, start, end);
        case "base64":
            return $18f8e9e4cd720744$var$base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $18f8e9e4cd720744$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$18f8e9e4cd720744$var$Buffer.prototype._isBuffer = true;
function $18f8e9e4cd720744$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$18f8e9e4cd720744$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(let i = 0; i < len; i += 2)$18f8e9e4cd720744$var$swap(this, i, i + 1);
    return this;
};
$18f8e9e4cd720744$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(let i = 0; i < len; i += 4){
        $18f8e9e4cd720744$var$swap(this, i, i + 3);
        $18f8e9e4cd720744$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$18f8e9e4cd720744$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(let i = 0; i < len; i += 8){
        $18f8e9e4cd720744$var$swap(this, i, i + 7);
        $18f8e9e4cd720744$var$swap(this, i + 1, i + 6);
        $18f8e9e4cd720744$var$swap(this, i + 2, i + 5);
        $18f8e9e4cd720744$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$18f8e9e4cd720744$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return "";
    if (arguments.length === 0) return $18f8e9e4cd720744$var$utf8Slice(this, 0, length);
    return $18f8e9e4cd720744$var$slowToString.apply(this, arguments);
};
$18f8e9e4cd720744$var$Buffer.prototype.toLocaleString = $18f8e9e4cd720744$var$Buffer.prototype.toString;
$18f8e9e4cd720744$var$Buffer.prototype.equals = function equals(b) {
    if (!$18f8e9e4cd720744$var$Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return $18f8e9e4cd720744$var$Buffer.compare(this, b) === 0;
};
$18f8e9e4cd720744$var$Buffer.prototype.inspect = function inspect() {
    let str = "";
    const max = $18f8e9e4cd720744$export$f99ded8fe4b79145;
    str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
    if (this.length > max) str += " ... ";
    return "<Buffer " + str + ">";
};
if ($18f8e9e4cd720744$var$customInspectSymbol) $18f8e9e4cd720744$var$Buffer.prototype[$18f8e9e4cd720744$var$customInspectSymbol] = $18f8e9e4cd720744$var$Buffer.prototype.inspect;
$18f8e9e4cd720744$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($18f8e9e4cd720744$var$isInstance(target, Uint8Array)) target = $18f8e9e4cd720744$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$18f8e9e4cd720744$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $18f8e9e4cd720744$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($18f8e9e4cd720744$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = $18f8e9e4cd720744$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($18f8e9e4cd720744$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $18f8e9e4cd720744$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $18f8e9e4cd720744$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function $18f8e9e4cd720744$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$18f8e9e4cd720744$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$18f8e9e4cd720744$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $18f8e9e4cd720744$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$18f8e9e4cd720744$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $18f8e9e4cd720744$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $18f8e9e4cd720744$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($18f8e9e4cd720744$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $18f8e9e4cd720744$var$utf8Write(buf, string, offset, length) {
    return $18f8e9e4cd720744$var$blitBuffer($18f8e9e4cd720744$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $18f8e9e4cd720744$var$asciiWrite(buf, string, offset, length) {
    return $18f8e9e4cd720744$var$blitBuffer($18f8e9e4cd720744$var$asciiToBytes(string), buf, offset, length);
}
function $18f8e9e4cd720744$var$base64Write(buf, string, offset, length) {
    return $18f8e9e4cd720744$var$blitBuffer($18f8e9e4cd720744$var$base64ToBytes(string), buf, offset, length);
}
function $18f8e9e4cd720744$var$ucs2Write(buf, string, offset, length) {
    return $18f8e9e4cd720744$var$blitBuffer($18f8e9e4cd720744$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$18f8e9e4cd720744$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    let loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return $18f8e9e4cd720744$var$hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return $18f8e9e4cd720744$var$utf8Write(this, string, offset, length);
        case "ascii":
        case "latin1":
        case "binary":
            return $18f8e9e4cd720744$var$asciiWrite(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return $18f8e9e4cd720744$var$base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $18f8e9e4cd720744$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
$18f8e9e4cd720744$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $18f8e9e4cd720744$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $kr5lq.fromByteArray(buf);
    else return $kr5lq.fromByteArray(buf.slice(start, end));
}
function $18f8e9e4cd720744$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $18f8e9e4cd720744$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $18f8e9e4cd720744$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $18f8e9e4cd720744$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $18f8e9e4cd720744$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = "";
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $18f8e9e4cd720744$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $18f8e9e4cd720744$var$asciiSlice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $18f8e9e4cd720744$var$latin1Slice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $18f8e9e4cd720744$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = "";
    for(let i = start; i < end; ++i)out += $18f8e9e4cd720744$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $18f8e9e4cd720744$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = "";
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$18f8e9e4cd720744$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $18f8e9e4cd720744$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $18f8e9e4cd720744$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
$18f8e9e4cd720744$var$Buffer.prototype.readUintLE = $18f8e9e4cd720744$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $18f8e9e4cd720744$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$18f8e9e4cd720744$var$Buffer.prototype.readUintBE = $18f8e9e4cd720744$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $18f8e9e4cd720744$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$18f8e9e4cd720744$var$Buffer.prototype.readUint8 = $18f8e9e4cd720744$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $18f8e9e4cd720744$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$18f8e9e4cd720744$var$Buffer.prototype.readUint16LE = $18f8e9e4cd720744$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $18f8e9e4cd720744$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$18f8e9e4cd720744$var$Buffer.prototype.readUint16BE = $18f8e9e4cd720744$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $18f8e9e4cd720744$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$18f8e9e4cd720744$var$Buffer.prototype.readUint32LE = $18f8e9e4cd720744$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $18f8e9e4cd720744$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$18f8e9e4cd720744$var$Buffer.prototype.readUint32BE = $18f8e9e4cd720744$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $18f8e9e4cd720744$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$18f8e9e4cd720744$var$Buffer.prototype.readBigUInt64LE = $18f8e9e4cd720744$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $18f8e9e4cd720744$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $18f8e9e4cd720744$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$18f8e9e4cd720744$var$Buffer.prototype.readBigUInt64BE = $18f8e9e4cd720744$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $18f8e9e4cd720744$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $18f8e9e4cd720744$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$18f8e9e4cd720744$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $18f8e9e4cd720744$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$18f8e9e4cd720744$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $18f8e9e4cd720744$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$18f8e9e4cd720744$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $18f8e9e4cd720744$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$18f8e9e4cd720744$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $18f8e9e4cd720744$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$18f8e9e4cd720744$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $18f8e9e4cd720744$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$18f8e9e4cd720744$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $18f8e9e4cd720744$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$18f8e9e4cd720744$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $18f8e9e4cd720744$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$18f8e9e4cd720744$var$Buffer.prototype.readBigInt64LE = $18f8e9e4cd720744$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $18f8e9e4cd720744$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $18f8e9e4cd720744$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$18f8e9e4cd720744$var$Buffer.prototype.readBigInt64BE = $18f8e9e4cd720744$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $18f8e9e4cd720744$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $18f8e9e4cd720744$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$18f8e9e4cd720744$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $18f8e9e4cd720744$var$checkOffset(offset, 4, this.length);
    return $gKZj9.read(this, offset, true, 23, 4);
};
$18f8e9e4cd720744$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $18f8e9e4cd720744$var$checkOffset(offset, 4, this.length);
    return $gKZj9.read(this, offset, false, 23, 4);
};
$18f8e9e4cd720744$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $18f8e9e4cd720744$var$checkOffset(offset, 8, this.length);
    return $gKZj9.read(this, offset, true, 52, 8);
};
$18f8e9e4cd720744$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $18f8e9e4cd720744$var$checkOffset(offset, 8, this.length);
    return $gKZj9.read(this, offset, false, 52, 8);
};
function $18f8e9e4cd720744$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$18f8e9e4cd720744$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
$18f8e9e4cd720744$var$Buffer.prototype.writeUintLE = $18f8e9e4cd720744$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $18f8e9e4cd720744$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$18f8e9e4cd720744$var$Buffer.prototype.writeUintBE = $18f8e9e4cd720744$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $18f8e9e4cd720744$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$18f8e9e4cd720744$var$Buffer.prototype.writeUint8 = $18f8e9e4cd720744$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $18f8e9e4cd720744$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$18f8e9e4cd720744$var$Buffer.prototype.writeUint16LE = $18f8e9e4cd720744$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $18f8e9e4cd720744$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$18f8e9e4cd720744$var$Buffer.prototype.writeUint16BE = $18f8e9e4cd720744$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $18f8e9e4cd720744$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$18f8e9e4cd720744$var$Buffer.prototype.writeUint32LE = $18f8e9e4cd720744$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $18f8e9e4cd720744$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$18f8e9e4cd720744$var$Buffer.prototype.writeUint32BE = $18f8e9e4cd720744$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $18f8e9e4cd720744$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $18f8e9e4cd720744$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $18f8e9e4cd720744$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $18f8e9e4cd720744$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $18f8e9e4cd720744$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$18f8e9e4cd720744$var$Buffer.prototype.writeBigUInt64LE = $18f8e9e4cd720744$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $18f8e9e4cd720744$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$18f8e9e4cd720744$var$Buffer.prototype.writeBigUInt64BE = $18f8e9e4cd720744$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $18f8e9e4cd720744$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$18f8e9e4cd720744$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $18f8e9e4cd720744$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$18f8e9e4cd720744$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $18f8e9e4cd720744$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$18f8e9e4cd720744$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $18f8e9e4cd720744$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$18f8e9e4cd720744$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $18f8e9e4cd720744$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$18f8e9e4cd720744$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $18f8e9e4cd720744$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$18f8e9e4cd720744$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $18f8e9e4cd720744$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$18f8e9e4cd720744$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $18f8e9e4cd720744$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$18f8e9e4cd720744$var$Buffer.prototype.writeBigInt64LE = $18f8e9e4cd720744$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $18f8e9e4cd720744$var$wrtBigUInt64LE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
$18f8e9e4cd720744$var$Buffer.prototype.writeBigInt64BE = $18f8e9e4cd720744$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $18f8e9e4cd720744$var$wrtBigUInt64BE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
function $18f8e9e4cd720744$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function $18f8e9e4cd720744$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $18f8e9e4cd720744$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $gKZj9.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$18f8e9e4cd720744$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $18f8e9e4cd720744$var$writeFloat(this, value, offset, true, noAssert);
};
$18f8e9e4cd720744$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $18f8e9e4cd720744$var$writeFloat(this, value, offset, false, noAssert);
};
function $18f8e9e4cd720744$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $18f8e9e4cd720744$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $gKZj9.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$18f8e9e4cd720744$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $18f8e9e4cd720744$var$writeDouble(this, value, offset, true, noAssert);
};
$18f8e9e4cd720744$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $18f8e9e4cd720744$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$18f8e9e4cd720744$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$18f8e9e4cd720744$var$Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === "function") // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$18f8e9e4cd720744$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !$18f8e9e4cd720744$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === "utf8" && code < 128 || encoding === "latin1") // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === "number") val = val & 255;
    else if (typeof val === "boolean") val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $18f8e9e4cd720744$var$Buffer.isBuffer(val) ? val : $18f8e9e4cd720744$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $18f8e9e4cd720744$var$errors = {};
function $18f8e9e4cd720744$var$E(sym, getMessage, Base) {
    $18f8e9e4cd720744$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, "message", {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, "code", {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$18f8e9e4cd720744$var$E("ERR_BUFFER_OUT_OF_BOUNDS", function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return "Attempt to access memory outside buffer bounds";
}, RangeError);
$18f8e9e4cd720744$var$E("ERR_INVALID_ARG_TYPE", function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$18f8e9e4cd720744$var$E("ERR_OUT_OF_RANGE", function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $18f8e9e4cd720744$var$addNumericalSeparator(String(input));
    else if (typeof input === "bigint") {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $18f8e9e4cd720744$var$addNumericalSeparator(received);
        received += "n";
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $18f8e9e4cd720744$var$addNumericalSeparator(val) {
    let res = "";
    let i = val.length;
    const start = val[0] === "-" ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $18f8e9e4cd720744$var$checkBounds(buf, offset, byteLength) {
    $18f8e9e4cd720744$var$validateNumber(offset, "offset");
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $18f8e9e4cd720744$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $18f8e9e4cd720744$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === "bigint" ? "n" : "";
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $18f8e9e4cd720744$var$errors.ERR_OUT_OF_RANGE("value", range, value);
    }
    $18f8e9e4cd720744$var$checkBounds(buf, offset, byteLength);
}
function $18f8e9e4cd720744$var$validateNumber(value, name) {
    if (typeof value !== "number") throw new $18f8e9e4cd720744$var$errors.ERR_INVALID_ARG_TYPE(name, "number", value);
}
function $18f8e9e4cd720744$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $18f8e9e4cd720744$var$validateNumber(value, type);
        throw new $18f8e9e4cd720744$var$errors.ERR_OUT_OF_RANGE(type || "offset", "an integer", value);
    }
    if (length < 0) throw new $18f8e9e4cd720744$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $18f8e9e4cd720744$var$errors.ERR_OUT_OF_RANGE(type || "offset", `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $18f8e9e4cd720744$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $18f8e9e4cd720744$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split("=")[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($18f8e9e4cd720744$var$INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function $18f8e9e4cd720744$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function $18f8e9e4cd720744$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $18f8e9e4cd720744$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $18f8e9e4cd720744$var$base64ToBytes(str) {
    return $kr5lq.toByteArray($18f8e9e4cd720744$var$base64clean(str));
}
function $18f8e9e4cd720744$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $18f8e9e4cd720744$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $18f8e9e4cd720744$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $18f8e9e4cd720744$var$hexSliceLookupTable = function() {
    const alphabet = "0123456789abcdef";
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $18f8e9e4cd720744$var$defineBigIntMethod(fn) {
    return typeof BigInt === "undefined" ? $18f8e9e4cd720744$var$BufferBigIntNotDefined : fn;
}
function $18f8e9e4cd720744$var$BufferBigIntNotDefined() {
    throw new Error("BigInt not supported");
}

});
parcelRequire.register("kr5lq", function(module, exports) {

$parcel$export(module.exports, "toByteArray", function () { return $ee0a7996b54daec3$export$d622b2ad8d90c771; }, function (v) { return $ee0a7996b54daec3$export$d622b2ad8d90c771 = v; });
$parcel$export(module.exports, "fromByteArray", function () { return $ee0a7996b54daec3$export$6100ba28696e12de; }, function (v) { return $ee0a7996b54daec3$export$6100ba28696e12de = v; });
var $ee0a7996b54daec3$export$a48f0734ac7c2329;
var $ee0a7996b54daec3$export$d622b2ad8d90c771;
var $ee0a7996b54daec3$export$6100ba28696e12de;
"use strict";
$ee0a7996b54daec3$export$a48f0734ac7c2329 = $ee0a7996b54daec3$var$byteLength;
$ee0a7996b54daec3$export$d622b2ad8d90c771 = $ee0a7996b54daec3$var$toByteArray;
$ee0a7996b54daec3$export$6100ba28696e12de = $ee0a7996b54daec3$var$fromByteArray;
var $ee0a7996b54daec3$var$lookup = [];
var $ee0a7996b54daec3$var$revLookup = [];
var $ee0a7996b54daec3$var$Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
var $ee0a7996b54daec3$var$code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for(var $ee0a7996b54daec3$var$i = 0, $ee0a7996b54daec3$var$len = $ee0a7996b54daec3$var$code.length; $ee0a7996b54daec3$var$i < $ee0a7996b54daec3$var$len; ++$ee0a7996b54daec3$var$i){
    $ee0a7996b54daec3$var$lookup[$ee0a7996b54daec3$var$i] = $ee0a7996b54daec3$var$code[$ee0a7996b54daec3$var$i];
    $ee0a7996b54daec3$var$revLookup[$ee0a7996b54daec3$var$code.charCodeAt($ee0a7996b54daec3$var$i)] = $ee0a7996b54daec3$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$ee0a7996b54daec3$var$revLookup["-".charCodeAt(0)] = 62;
$ee0a7996b54daec3$var$revLookup["_".charCodeAt(0)] = 63;
function $ee0a7996b54daec3$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf("=");
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $ee0a7996b54daec3$var$byteLength(b64) {
    var lens = $ee0a7996b54daec3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $ee0a7996b54daec3$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $ee0a7996b54daec3$var$toByteArray(b64) {
    var tmp;
    var lens = $ee0a7996b54daec3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $ee0a7996b54daec3$var$Arr($ee0a7996b54daec3$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $ee0a7996b54daec3$var$revLookup[b64.charCodeAt(i)] << 18 | $ee0a7996b54daec3$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $ee0a7996b54daec3$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $ee0a7996b54daec3$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $ee0a7996b54daec3$var$revLookup[b64.charCodeAt(i)] << 2 | $ee0a7996b54daec3$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $ee0a7996b54daec3$var$revLookup[b64.charCodeAt(i)] << 10 | $ee0a7996b54daec3$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $ee0a7996b54daec3$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $ee0a7996b54daec3$var$tripletToBase64(num) {
    return $ee0a7996b54daec3$var$lookup[num >> 18 & 0x3F] + $ee0a7996b54daec3$var$lookup[num >> 12 & 0x3F] + $ee0a7996b54daec3$var$lookup[num >> 6 & 0x3F] + $ee0a7996b54daec3$var$lookup[num & 0x3F];
}
function $ee0a7996b54daec3$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($ee0a7996b54daec3$var$tripletToBase64(tmp));
    }
    return output.join("");
}
function $ee0a7996b54daec3$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($ee0a7996b54daec3$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($ee0a7996b54daec3$var$lookup[tmp >> 2] + $ee0a7996b54daec3$var$lookup[tmp << 4 & 0x3F] + "==");
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($ee0a7996b54daec3$var$lookup[tmp >> 10] + $ee0a7996b54daec3$var$lookup[tmp >> 4 & 0x3F] + $ee0a7996b54daec3$var$lookup[tmp << 2 & 0x3F] + "=");
    }
    return parts.join("");
}

});

parcelRequire.register("gKZj9", function(module, exports) {

$parcel$export(module.exports, "read", function () { return $c3307fb60cee41a0$export$aafa59e2e03f2942; }, function (v) { return $c3307fb60cee41a0$export$aafa59e2e03f2942 = v; });
$parcel$export(module.exports, "write", function () { return $c3307fb60cee41a0$export$68d8715fc104d294; }, function (v) { return $c3307fb60cee41a0$export$68d8715fc104d294 = v; });
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $c3307fb60cee41a0$export$aafa59e2e03f2942;
var $c3307fb60cee41a0$export$68d8715fc104d294;
$c3307fb60cee41a0$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$c3307fb60cee41a0$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});





parcelRequire.register("2YtlN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $22a7f3c8f2a9d568$export$2e2bcd8739ae039; });

var $fIemp = parcelRequire("fIemp");
"use strict";
class $22a7f3c8f2a9d568$var$InterceptorManager {
    constructor(){
        this.handlers = [];
    }
    /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */ use(fulfilled, rejected, options) {
        this.handlers.push({
            fulfilled: fulfilled,
            rejected: rejected,
            synchronous: options ? options.synchronous : false,
            runWhen: options ? options.runWhen : null
        });
        return this.handlers.length - 1;
    }
    /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */ eject(id) {
        if (this.handlers[id]) this.handlers[id] = null;
    }
    /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */ clear() {
        if (this.handlers) this.handlers = [];
    }
    /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */ forEach(fn) {
        (0, $fIemp.default).forEach(this.handlers, function forEachHandler(h) {
            if (h !== null) fn(h);
        });
    }
}
var $22a7f3c8f2a9d568$export$2e2bcd8739ae039 = $22a7f3c8f2a9d568$var$InterceptorManager;

});

parcelRequire.register("fYPHb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ba248f4293f46266$export$2e2bcd8739ae039; });

var $j4SWD = parcelRequire("j4SWD");

var $f71qq = parcelRequire("f71qq");

var $5i1l4 = parcelRequire("5i1l4");

var $bqef3 = parcelRequire("bqef3");

var $9VBYq = parcelRequire("9VBYq");

var $i5deJ = parcelRequire("i5deJ");
"use strict";
/**
 * Throws a `CanceledError` if cancellation has been requested.
 *
 * @param {Object} config The config that is to be used for the request
 *
 * @returns {void}
 */ function $ba248f4293f46266$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
    if (config.signal && config.signal.aborted) throw new (0, $bqef3.default)(null, config);
}
function $ba248f4293f46266$export$2e2bcd8739ae039(config) {
    $ba248f4293f46266$var$throwIfCancellationRequested(config);
    config.headers = (0, $9VBYq.default).from(config.headers);
    // Transform request data
    config.data = (0, $j4SWD.default).call(config, config.transformRequest);
    if ([
        "post",
        "put",
        "patch"
    ].indexOf(config.method) !== -1) config.headers.setContentType("application/x-www-form-urlencoded", false);
    const adapter = (0, $i5deJ.default).getAdapter(config.adapter || (0, $5i1l4.default).adapter, config);
    return adapter(config).then(function onAdapterResolution(response) {
        $ba248f4293f46266$var$throwIfCancellationRequested(config);
        // Transform response data
        response.data = (0, $j4SWD.default).call(config, config.transformResponse, response);
        response.headers = (0, $9VBYq.default).from(response.headers);
        return response;
    }, function onAdapterRejection(reason) {
        if (!(0, $f71qq.default)(reason)) {
            $ba248f4293f46266$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) {
                reason.response.data = (0, $j4SWD.default).call(config, config.transformResponse, reason.response);
                reason.response.headers = (0, $9VBYq.default).from(reason.response.headers);
            }
        }
        return Promise.reject(reason);
    });
}

});
parcelRequire.register("j4SWD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $de3902e80d307ea2$export$2e2bcd8739ae039; });

var $fIemp = parcelRequire("fIemp");

var $5i1l4 = parcelRequire("5i1l4");

var $9VBYq = parcelRequire("9VBYq");
"use strict";
function $de3902e80d307ea2$export$2e2bcd8739ae039(fns, response) {
    const config = this || (0, $5i1l4.default);
    const context = response || config;
    const headers = (0, $9VBYq.default).from(context.headers);
    let data = context.data;
    (0, $fIemp.default).forEach(fns, function transform(fn) {
        data = fn.call(config, data, headers.normalize(), response ? response.status : undefined);
    });
    headers.normalize();
    return data;
}

});
parcelRequire.register("5i1l4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3d9fac124246bbde$export$2e2bcd8739ae039; });

var $fIemp = parcelRequire("fIemp");

var $ax9gu = parcelRequire("ax9gu");

var $anZjS = parcelRequire("anZjS");

var $h77YL = parcelRequire("h77YL");

var $hH1Kn = parcelRequire("hH1Kn");

var $7vFM9 = parcelRequire("7vFM9");

var $kxhCw = parcelRequire("kxhCw");
"use strict";
/**
 * It takes a string, tries to parse it, and if it fails, it returns the stringified version
 * of the input
 *
 * @param {any} rawValue - The value to be stringified.
 * @param {Function} parser - A function that parses a string into a JavaScript object.
 * @param {Function} encoder - A function that takes a value and returns a string.
 *
 * @returns {string} A stringified version of the rawValue.
 */ function $3d9fac124246bbde$var$stringifySafely(rawValue, parser, encoder) {
    if ((0, $fIemp.default).isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return (0, $fIemp.default).trim(rawValue);
    } catch (e) {
        if (e.name !== "SyntaxError") throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}
const $3d9fac124246bbde$var$defaults = {
    transitional: (0, $anZjS.default),
    adapter: [
        "xhr",
        "http",
        "fetch"
    ],
    transformRequest: [
        function transformRequest(data, headers) {
            const contentType = headers.getContentType() || "";
            const hasJSONContentType = contentType.indexOf("application/json") > -1;
            const isObjectPayload = (0, $fIemp.default).isObject(data);
            if (isObjectPayload && (0, $fIemp.default).isHTMLForm(data)) data = new FormData(data);
            const isFormData = (0, $fIemp.default).isFormData(data);
            if (isFormData) return hasJSONContentType ? JSON.stringify((0, $kxhCw.default)(data)) : data;
            if ((0, $fIemp.default).isArrayBuffer(data) || (0, $fIemp.default).isBuffer(data) || (0, $fIemp.default).isStream(data) || (0, $fIemp.default).isFile(data) || (0, $fIemp.default).isBlob(data) || (0, $fIemp.default).isReadableStream(data)) return data;
            if ((0, $fIemp.default).isArrayBufferView(data)) return data.buffer;
            if ((0, $fIemp.default).isURLSearchParams(data)) {
                headers.setContentType("application/x-www-form-urlencoded;charset=utf-8", false);
                return data.toString();
            }
            let isFileList;
            if (isObjectPayload) {
                if (contentType.indexOf("application/x-www-form-urlencoded") > -1) return (0, $hH1Kn.default)(data, this.formSerializer).toString();
                if ((isFileList = (0, $fIemp.default).isFileList(data)) || contentType.indexOf("multipart/form-data") > -1) {
                    const _FormData = this.env && this.env.FormData;
                    return (0, $h77YL.default)(isFileList ? {
                        "files[]": data
                    } : data, _FormData && new _FormData(), this.formSerializer);
                }
            }
            if (isObjectPayload || hasJSONContentType) {
                headers.setContentType("application/json", false);
                return $3d9fac124246bbde$var$stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            const transitional = this.transitional || $3d9fac124246bbde$var$defaults.transitional;
            const forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            const JSONRequested = this.responseType === "json";
            if ((0, $fIemp.default).isResponse(data) || (0, $fIemp.default).isReadableStream(data)) return data;
            if (data && (0, $fIemp.default).isString(data) && (forcedJSONParsing && !this.responseType || JSONRequested)) {
                const silentJSONParsing = transitional && transitional.silentJSONParsing;
                const strictJSONParsing = !silentJSONParsing && JSONRequested;
                try {
                    return JSON.parse(data, this.parseReviver);
                } catch (e) {
                    if (strictJSONParsing) {
                        if (e.name === "SyntaxError") throw (0, $ax9gu.default).from(e, (0, $ax9gu.default).ERR_BAD_RESPONSE, this, null, this.response);
                        throw e;
                    }
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: "XSRF-TOKEN",
    xsrfHeaderName: "X-XSRF-TOKEN",
    maxContentLength: -1,
    maxBodyLength: -1,
    env: {
        FormData: (0, $7vFM9.default).classes.FormData,
        Blob: (0, $7vFM9.default).classes.Blob
    },
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    },
    headers: {
        common: {
            "Accept": "application/json, text/plain, */*",
            "Content-Type": undefined
        }
    }
};
(0, $fIemp.default).forEach([
    "delete",
    "get",
    "head",
    "post",
    "put",
    "patch"
], (method)=>{
    $3d9fac124246bbde$var$defaults.headers[method] = {};
});
var $3d9fac124246bbde$export$2e2bcd8739ae039 = $3d9fac124246bbde$var$defaults;

});
parcelRequire.register("anZjS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $78fb9e28b36b53dc$export$2e2bcd8739ae039; });
"use strict";
var $78fb9e28b36b53dc$export$2e2bcd8739ae039 = {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false
};

});

parcelRequire.register("hH1Kn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ce17cebecb2b492f$export$2e2bcd8739ae039; });

var $fIemp = parcelRequire("fIemp");

var $h77YL = parcelRequire("h77YL");

var $7vFM9 = parcelRequire("7vFM9");
"use strict";
function $ce17cebecb2b492f$export$2e2bcd8739ae039(data, options) {
    return (0, $h77YL.default)(data, new (0, $7vFM9.default).classes.URLSearchParams(), {
        visitor: function(value, key, path, helpers) {
            if ((0, $7vFM9.default).isNode && (0, $fIemp.default).isBuffer(value)) {
                this.append(key, value.toString("base64"));
                return false;
            }
            return helpers.defaultVisitor.apply(this, arguments);
        },
        ...options
    });
}

});
parcelRequire.register("7vFM9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $577bd56b57a88144$export$2e2bcd8739ae039; });

var $1Lcge = parcelRequire("1Lcge");

var $eglnC = parcelRequire("eglnC");
var $577bd56b57a88144$export$2e2bcd8739ae039 = {
    ...$eglnC,
    ...(0, $1Lcge.default)
};

});
parcelRequire.register("1Lcge", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1483b0f67a335227$export$2e2bcd8739ae039; });

var $k8ZOX = parcelRequire("k8ZOX");

var $cRk0t = parcelRequire("cRk0t");

var $3zGmq = parcelRequire("3zGmq");
var $1483b0f67a335227$export$2e2bcd8739ae039 = {
    isBrowser: true,
    classes: {
        URLSearchParams: $k8ZOX.default,
        FormData: $cRk0t.default,
        Blob: $3zGmq.default
    },
    protocols: [
        "http",
        "https",
        "file",
        "blob",
        "url",
        "data"
    ]
};

});
parcelRequire.register("k8ZOX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $eaa482563c88572c$export$2e2bcd8739ae039; });

var $gMBoJ = parcelRequire("gMBoJ");
"use strict";
var $eaa482563c88572c$export$2e2bcd8739ae039 = typeof URLSearchParams !== "undefined" ? URLSearchParams : (0, $gMBoJ.default);

});

parcelRequire.register("cRk0t", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $95c9f42d51ee5c11$export$2e2bcd8739ae039; });
"use strict";
var $95c9f42d51ee5c11$export$2e2bcd8739ae039 = typeof FormData !== "undefined" ? FormData : null;

});

parcelRequire.register("3zGmq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $29a57ff0b7ee4a13$export$2e2bcd8739ae039; });
"use strict";
var $29a57ff0b7ee4a13$export$2e2bcd8739ae039 = typeof Blob !== "undefined" ? Blob : null;

});


parcelRequire.register("eglnC", function(module, exports) {

$parcel$export(module.exports, "hasBrowserEnv", function () { return $a62324f22d41b864$export$c4996c4b7b93b0bf; });
$parcel$export(module.exports, "navigator", function () { return $a62324f22d41b864$export$ec7c8efa7f5790ae; });
$parcel$export(module.exports, "hasStandardBrowserEnv", function () { return $a62324f22d41b864$export$c0bcc9250309d66; });
$parcel$export(module.exports, "hasStandardBrowserWebWorkerEnv", function () { return $a62324f22d41b864$export$c81692cf5af97dac; });
$parcel$export(module.exports, "origin", function () { return $a62324f22d41b864$export$f710a83a91838a36; });
const $a62324f22d41b864$export$c4996c4b7b93b0bf = typeof window !== "undefined" && typeof document !== "undefined";
const $a62324f22d41b864$export$ec7c8efa7f5790ae = typeof navigator === "object" && navigator || undefined;
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 *
 * @returns {boolean}
 */ const $a62324f22d41b864$export$c0bcc9250309d66 = $a62324f22d41b864$export$c4996c4b7b93b0bf && (!$a62324f22d41b864$export$ec7c8efa7f5790ae || [
    "ReactNative",
    "NativeScript",
    "NS"
].indexOf($a62324f22d41b864$export$ec7c8efa7f5790ae.product) < 0);
/**
 * Determine if we're running in a standard browser webWorker environment
 *
 * Although the `isStandardBrowserEnv` method indicates that
 * `allows axios to run in a web worker`, the WebWorker will still be
 * filtered out due to its judgment standard
 * `typeof window !== 'undefined' && typeof document !== 'undefined'`.
 * This leads to a problem when axios post `FormData` in webWorker
 */ const $a62324f22d41b864$export$c81692cf5af97dac = (()=>{
    return typeof WorkerGlobalScope !== "undefined" && // eslint-disable-next-line no-undef
    self instanceof WorkerGlobalScope && typeof self.importScripts === "function";
})();
const $a62324f22d41b864$export$f710a83a91838a36 = $a62324f22d41b864$export$c4996c4b7b93b0bf && window.location.href || "http://localhost";

});



parcelRequire.register("kxhCw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ef348eb99b49bd5e$export$2e2bcd8739ae039; });

var $fIemp = parcelRequire("fIemp");
"use strict";
/**
 * It takes a string like `foo[x][y][z]` and returns an array like `['foo', 'x', 'y', 'z']
 *
 * @param {string} name - The name of the property to get.
 *
 * @returns An array of strings.
 */ function $ef348eb99b49bd5e$var$parsePropPath(name) {
    // foo[x][y][z]
    // foo.x.y.z
    // foo-x-y-z
    // foo x y z
    return (0, $fIemp.default).matchAll(/\w+|\[(\w*)]/g, name).map((match)=>{
        return match[0] === "[]" ? "" : match[1] || match[0];
    });
}
/**
 * Convert an array to an object.
 *
 * @param {Array<any>} arr - The array to convert to an object.
 *
 * @returns An object with the same keys and values as the array.
 */ function $ef348eb99b49bd5e$var$arrayToObject(arr) {
    const obj = {};
    const keys = Object.keys(arr);
    let i;
    const len = keys.length;
    let key;
    for(i = 0; i < len; i++){
        key = keys[i];
        obj[key] = arr[key];
    }
    return obj;
}
/**
 * It takes a FormData object and returns a JavaScript object
 *
 * @param {string} formData The FormData object to convert to JSON.
 *
 * @returns {Object<string, any> | null} The converted object.
 */ function $ef348eb99b49bd5e$var$formDataToJSON(formData) {
    function buildPath(path, value, target, index) {
        let name = path[index++];
        if (name === "__proto__") return true;
        const isNumericKey = Number.isFinite(+name);
        const isLast = index >= path.length;
        name = !name && (0, $fIemp.default).isArray(target) ? target.length : name;
        if (isLast) {
            if ((0, $fIemp.default).hasOwnProp(target, name)) target[name] = [
                target[name],
                value
            ];
            else target[name] = value;
            return !isNumericKey;
        }
        if (!target[name] || !(0, $fIemp.default).isObject(target[name])) target[name] = [];
        const result = buildPath(path, value, target[name], index);
        if (result && (0, $fIemp.default).isArray(target[name])) target[name] = $ef348eb99b49bd5e$var$arrayToObject(target[name]);
        return !isNumericKey;
    }
    if ((0, $fIemp.default).isFormData(formData) && (0, $fIemp.default).isFunction(formData.entries)) {
        const obj = {};
        (0, $fIemp.default).forEachEntry(formData, (name, value)=>{
            buildPath($ef348eb99b49bd5e$var$parsePropPath(name), value, obj, 0);
        });
        return obj;
    }
    return null;
}
var $ef348eb99b49bd5e$export$2e2bcd8739ae039 = $ef348eb99b49bd5e$var$formDataToJSON;

});


parcelRequire.register("9VBYq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $73a6e4adf58fc679$export$2e2bcd8739ae039; });

var $fIemp = parcelRequire("fIemp");

var $hRZmf = parcelRequire("hRZmf");
"use strict";
const $73a6e4adf58fc679$var$$internals = Symbol("internals");
function $73a6e4adf58fc679$var$normalizeHeader(header) {
    return header && String(header).trim().toLowerCase();
}
function $73a6e4adf58fc679$var$normalizeValue(value) {
    if (value === false || value == null) return value;
    return (0, $fIemp.default).isArray(value) ? value.map($73a6e4adf58fc679$var$normalizeValue) : String(value);
}
function $73a6e4adf58fc679$var$parseTokens(str) {
    const tokens = Object.create(null);
    const tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
    let match;
    while(match = tokensRE.exec(str))tokens[match[1]] = match[2];
    return tokens;
}
const $73a6e4adf58fc679$var$isValidHeaderName = (str)=>/^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(str.trim());
function $73a6e4adf58fc679$var$matchHeaderValue(context, value, header, filter, isHeaderNameFilter) {
    if ((0, $fIemp.default).isFunction(filter)) return filter.call(this, value, header);
    if (isHeaderNameFilter) value = header;
    if (!(0, $fIemp.default).isString(value)) return;
    if ((0, $fIemp.default).isString(filter)) return value.indexOf(filter) !== -1;
    if ((0, $fIemp.default).isRegExp(filter)) return filter.test(value);
}
function $73a6e4adf58fc679$var$formatHeader(header) {
    return header.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (w, char, str)=>{
        return char.toUpperCase() + str;
    });
}
function $73a6e4adf58fc679$var$buildAccessors(obj, header) {
    const accessorName = (0, $fIemp.default).toCamelCase(" " + header);
    [
        "get",
        "set",
        "has"
    ].forEach((methodName)=>{
        Object.defineProperty(obj, methodName + accessorName, {
            value: function(arg1, arg2, arg3) {
                return this[methodName].call(this, header, arg1, arg2, arg3);
            },
            configurable: true
        });
    });
}
class $73a6e4adf58fc679$var$AxiosHeaders {
    constructor(headers){
        headers && this.set(headers);
    }
    set(header, valueOrRewrite, rewrite) {
        const self = this;
        function setHeader(_value, _header, _rewrite) {
            const lHeader = $73a6e4adf58fc679$var$normalizeHeader(_header);
            if (!lHeader) throw new Error("header name must be a non-empty string");
            const key = (0, $fIemp.default).findKey(self, lHeader);
            if (!key || self[key] === undefined || _rewrite === true || _rewrite === undefined && self[key] !== false) self[key || _header] = $73a6e4adf58fc679$var$normalizeValue(_value);
        }
        const setHeaders = (headers, _rewrite)=>(0, $fIemp.default).forEach(headers, (_value, _header)=>setHeader(_value, _header, _rewrite));
        if ((0, $fIemp.default).isPlainObject(header) || header instanceof this.constructor) setHeaders(header, valueOrRewrite);
        else if ((0, $fIemp.default).isString(header) && (header = header.trim()) && !$73a6e4adf58fc679$var$isValidHeaderName(header)) setHeaders((0, $hRZmf.default)(header), valueOrRewrite);
        else if ((0, $fIemp.default).isObject(header) && (0, $fIemp.default).isIterable(header)) {
            let obj = {}, dest, key;
            for (const entry of header){
                if (!(0, $fIemp.default).isArray(entry)) throw TypeError("Object iterator must return a key-value pair");
                obj[key = entry[0]] = (dest = obj[key]) ? (0, $fIemp.default).isArray(dest) ? [
                    ...dest,
                    entry[1]
                ] : [
                    dest,
                    entry[1]
                ] : entry[1];
            }
            setHeaders(obj, valueOrRewrite);
        } else header != null && setHeader(valueOrRewrite, header, rewrite);
        return this;
    }
    get(header, parser) {
        header = $73a6e4adf58fc679$var$normalizeHeader(header);
        if (header) {
            const key = (0, $fIemp.default).findKey(this, header);
            if (key) {
                const value = this[key];
                if (!parser) return value;
                if (parser === true) return $73a6e4adf58fc679$var$parseTokens(value);
                if ((0, $fIemp.default).isFunction(parser)) return parser.call(this, value, key);
                if ((0, $fIemp.default).isRegExp(parser)) return parser.exec(value);
                throw new TypeError("parser must be boolean|regexp|function");
            }
        }
    }
    has(header, matcher) {
        header = $73a6e4adf58fc679$var$normalizeHeader(header);
        if (header) {
            const key = (0, $fIemp.default).findKey(this, header);
            return !!(key && this[key] !== undefined && (!matcher || $73a6e4adf58fc679$var$matchHeaderValue(this, this[key], key, matcher)));
        }
        return false;
    }
    delete(header, matcher) {
        const self = this;
        let deleted = false;
        function deleteHeader(_header) {
            _header = $73a6e4adf58fc679$var$normalizeHeader(_header);
            if (_header) {
                const key = (0, $fIemp.default).findKey(self, _header);
                if (key && (!matcher || $73a6e4adf58fc679$var$matchHeaderValue(self, self[key], key, matcher))) {
                    delete self[key];
                    deleted = true;
                }
            }
        }
        if ((0, $fIemp.default).isArray(header)) header.forEach(deleteHeader);
        else deleteHeader(header);
        return deleted;
    }
    clear(matcher) {
        const keys = Object.keys(this);
        let i = keys.length;
        let deleted = false;
        while(i--){
            const key = keys[i];
            if (!matcher || $73a6e4adf58fc679$var$matchHeaderValue(this, this[key], key, matcher, true)) {
                delete this[key];
                deleted = true;
            }
        }
        return deleted;
    }
    normalize(format) {
        const self = this;
        const headers = {};
        (0, $fIemp.default).forEach(this, (value, header)=>{
            const key = (0, $fIemp.default).findKey(headers, header);
            if (key) {
                self[key] = $73a6e4adf58fc679$var$normalizeValue(value);
                delete self[header];
                return;
            }
            const normalized = format ? $73a6e4adf58fc679$var$formatHeader(header) : String(header).trim();
            if (normalized !== header) delete self[header];
            self[normalized] = $73a6e4adf58fc679$var$normalizeValue(value);
            headers[normalized] = true;
        });
        return this;
    }
    concat(...targets) {
        return this.constructor.concat(this, ...targets);
    }
    toJSON(asStrings) {
        const obj = Object.create(null);
        (0, $fIemp.default).forEach(this, (value, header)=>{
            value != null && value !== false && (obj[header] = asStrings && (0, $fIemp.default).isArray(value) ? value.join(", ") : value);
        });
        return obj;
    }
    [Symbol.iterator]() {
        return Object.entries(this.toJSON())[Symbol.iterator]();
    }
    toString() {
        return Object.entries(this.toJSON()).map(([header, value])=>header + ": " + value).join("\n");
    }
    getSetCookie() {
        return this.get("set-cookie") || [];
    }
    get [Symbol.toStringTag]() {
        return "AxiosHeaders";
    }
    static from(thing) {
        return thing instanceof this ? thing : new this(thing);
    }
    static concat(first, ...targets) {
        const computed = new this(first);
        targets.forEach((target)=>computed.set(target));
        return computed;
    }
    static accessor(header) {
        const internals = this[$73a6e4adf58fc679$var$$internals] = this[$73a6e4adf58fc679$var$$internals] = {
            accessors: {}
        };
        const accessors = internals.accessors;
        const prototype = this.prototype;
        function defineAccessor(_header) {
            const lHeader = $73a6e4adf58fc679$var$normalizeHeader(_header);
            if (!accessors[lHeader]) {
                $73a6e4adf58fc679$var$buildAccessors(prototype, _header);
                accessors[lHeader] = true;
            }
        }
        (0, $fIemp.default).isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);
        return this;
    }
}
$73a6e4adf58fc679$var$AxiosHeaders.accessor([
    "Content-Type",
    "Content-Length",
    "Accept",
    "Accept-Encoding",
    "User-Agent",
    "Authorization"
]);
// reserved names hotfix
(0, $fIemp.default).reduceDescriptors($73a6e4adf58fc679$var$AxiosHeaders.prototype, ({ value: value }, key)=>{
    let mapped = key[0].toUpperCase() + key.slice(1); // map `set` => `Set`
    return {
        get: ()=>value,
        set (headerValue) {
            this[mapped] = headerValue;
        }
    };
});
(0, $fIemp.default).freezeMethods($73a6e4adf58fc679$var$AxiosHeaders);
var $73a6e4adf58fc679$export$2e2bcd8739ae039 = $73a6e4adf58fc679$var$AxiosHeaders;

});
parcelRequire.register("hRZmf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d026fb45f0669acb$export$2e2bcd8739ae039; });

var $fIemp = parcelRequire("fIemp");
"use strict";
// RawAxiosHeaders whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
const $d026fb45f0669acb$var$ignoreDuplicateOf = (0, $fIemp.default).toObjectSet([
    "age",
    "authorization",
    "content-length",
    "content-type",
    "etag",
    "expires",
    "from",
    "host",
    "if-modified-since",
    "if-unmodified-since",
    "last-modified",
    "location",
    "max-forwards",
    "proxy-authorization",
    "referer",
    "retry-after",
    "user-agent"
]);
var /**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} rawHeaders Headers needing to be parsed
 *
 * @returns {Object} Headers parsed into an object
 */ $d026fb45f0669acb$export$2e2bcd8739ae039 = (rawHeaders)=>{
    const parsed = {};
    let key;
    let val;
    let i;
    rawHeaders && rawHeaders.split("\n").forEach(function parser(line) {
        i = line.indexOf(":");
        key = line.substring(0, i).trim().toLowerCase();
        val = line.substring(i + 1).trim();
        if (!key || parsed[key] && $d026fb45f0669acb$var$ignoreDuplicateOf[key]) return;
        if (key === "set-cookie") {
            if (parsed[key]) parsed[key].push(val);
            else parsed[key] = [
                val
            ];
        } else parsed[key] = parsed[key] ? parsed[key] + ", " + val : val;
    });
    return parsed;
};

});



parcelRequire.register("f71qq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b0089d808f5f1100$export$2e2bcd8739ae039; });
"use strict";
function $b0089d808f5f1100$export$2e2bcd8739ae039(value) {
    return !!(value && value.__CANCEL__);
}

});

parcelRequire.register("bqef3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $850d2b8ac86dd49c$export$2e2bcd8739ae039; });

var $ax9gu = parcelRequire("ax9gu");

var $fIemp = parcelRequire("fIemp");
"use strict";
/**
 * A `CanceledError` is an object that is thrown when an operation is canceled.
 *
 * @param {string=} message The message.
 * @param {Object=} config The config.
 * @param {Object=} request The request.
 *
 * @returns {CanceledError} The created error.
 */ function $850d2b8ac86dd49c$var$CanceledError(message, config, request) {
    // eslint-disable-next-line no-eq-null,eqeqeq
    (0, $ax9gu.default).call(this, message == null ? "canceled" : message, (0, $ax9gu.default).ERR_CANCELED, config, request);
    this.name = "CanceledError";
}
(0, $fIemp.default).inherits($850d2b8ac86dd49c$var$CanceledError, (0, $ax9gu.default), {
    __CANCEL__: true
});
var $850d2b8ac86dd49c$export$2e2bcd8739ae039 = $850d2b8ac86dd49c$var$CanceledError;

});

parcelRequire.register("i5deJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d2a2f620207f683b$export$2e2bcd8739ae039; });

var $fIemp = parcelRequire("fIemp");

var $lHd6w = parcelRequire("lHd6w");

var $5viP1 = parcelRequire("5viP1");

var $7cBX1 = parcelRequire("7cBX1");

var $ax9gu = parcelRequire("ax9gu");
const $d2a2f620207f683b$var$knownAdapters = {
    http: (0, $lHd6w.default),
    xhr: (0, $5viP1.default),
    fetch: {
        get: $7cBX1.getFetch
    }
};
(0, $fIemp.default).forEach($d2a2f620207f683b$var$knownAdapters, (fn, value)=>{
    if (fn) {
        try {
            Object.defineProperty(fn, "name", {
                value: value
            });
        } catch (e) {
        // eslint-disable-next-line no-empty
        }
        Object.defineProperty(fn, "adapterName", {
            value: value
        });
    }
});
const $d2a2f620207f683b$var$renderReason = (reason)=>`- ${reason}`;
const $d2a2f620207f683b$var$isResolvedHandle = (adapter)=>(0, $fIemp.default).isFunction(adapter) || adapter === null || adapter === false;
var $d2a2f620207f683b$export$2e2bcd8739ae039 = {
    getAdapter: (adapters, config)=>{
        adapters = (0, $fIemp.default).isArray(adapters) ? adapters : [
            adapters
        ];
        const { length: length } = adapters;
        let nameOrAdapter;
        let adapter;
        const rejectedReasons = {};
        for(let i = 0; i < length; i++){
            nameOrAdapter = adapters[i];
            let id;
            adapter = nameOrAdapter;
            if (!$d2a2f620207f683b$var$isResolvedHandle(nameOrAdapter)) {
                adapter = $d2a2f620207f683b$var$knownAdapters[(id = String(nameOrAdapter)).toLowerCase()];
                if (adapter === undefined) throw new (0, $ax9gu.default)(`Unknown adapter '${id}'`);
            }
            if (adapter && ((0, $fIemp.default).isFunction(adapter) || (adapter = adapter.get(config)))) break;
            rejectedReasons[id || "#" + i] = adapter;
        }
        if (!adapter) {
            const reasons = Object.entries(rejectedReasons).map(([id, state])=>`adapter ${id} ` + (state === false ? "is not supported by the environment" : "is not available in the build"));
            let s = length ? reasons.length > 1 ? "since :\n" + reasons.map($d2a2f620207f683b$var$renderReason).join("\n") : " " + $d2a2f620207f683b$var$renderReason(reasons[0]) : "as no adapter specified";
            throw new (0, $ax9gu.default)(`There is no suitable adapter to dispatch the request ` + s, "ERR_NOT_SUPPORT");
        }
        return adapter;
    },
    adapters: $d2a2f620207f683b$var$knownAdapters
};

});
parcelRequire.register("5viP1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $401e72a96f4c2610$export$2e2bcd8739ae039; });

var $fIemp = parcelRequire("fIemp");

var $l4V9M = parcelRequire("l4V9M");

var $anZjS = parcelRequire("anZjS");

var $ax9gu = parcelRequire("ax9gu");

var $bqef3 = parcelRequire("bqef3");

var $6nyWX = parcelRequire("6nyWX");

var $7vFM9 = parcelRequire("7vFM9");

var $9VBYq = parcelRequire("9VBYq");

var $9Mt1i = parcelRequire("9Mt1i");

var $jtJjk = parcelRequire("jtJjk");
const $401e72a96f4c2610$var$isXHRAdapterSupported = typeof XMLHttpRequest !== "undefined";
var $401e72a96f4c2610$export$2e2bcd8739ae039 = $401e72a96f4c2610$var$isXHRAdapterSupported && function(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        const _config = (0, $jtJjk.default)(config);
        let requestData = _config.data;
        const requestHeaders = (0, $9VBYq.default).from(_config.headers).normalize();
        let { responseType: responseType, onUploadProgress: onUploadProgress, onDownloadProgress: onDownloadProgress } = _config;
        let onCanceled;
        let uploadThrottled, downloadThrottled;
        let flushUpload, flushDownload;
        function done() {
            flushUpload && flushUpload(); // flush events
            flushDownload && flushDownload(); // flush events
            _config.cancelToken && _config.cancelToken.unsubscribe(onCanceled);
            _config.signal && _config.signal.removeEventListener("abort", onCanceled);
        }
        let request = new XMLHttpRequest();
        request.open(_config.method.toUpperCase(), _config.url, true);
        // Set the request timeout in MS
        request.timeout = _config.timeout;
        function onloadend() {
            if (!request) return;
            // Prepare the response
            const responseHeaders = (0, $9VBYq.default).from("getAllResponseHeaders" in request && request.getAllResponseHeaders());
            const responseData = !responseType || responseType === "text" || responseType === "json" ? request.responseText : request.response;
            const response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            (0, $l4V9M.default)(function _resolve(value) {
                resolve(value);
                done();
            }, function _reject(err) {
                reject(err);
                done();
            }, response);
            // Clean up request
            request = null;
        }
        if ("onloadend" in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf("file:") === 0)) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject(new (0, $ax9gu.default)("Request aborted", (0, $ax9gu.default).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError(event) {
            // Browsers deliver a ProgressEvent in XHR onerror
            // (message may be empty; when present, surface it)
            // See https://developer.mozilla.org/docs/Web/API/XMLHttpRequest/error_event
            const msg = event && event.message ? event.message : "Network Error";
            const err = new (0, $ax9gu.default)(msg, (0, $ax9gu.default).ERR_NETWORK, config, request);
            // attach the underlying event for consumers who want details
            err.event = event || null;
            reject(err);
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            let timeoutErrorMessage = _config.timeout ? "timeout of " + _config.timeout + "ms exceeded" : "timeout exceeded";
            const transitional = _config.transitional || (0, $anZjS.default);
            if (_config.timeoutErrorMessage) timeoutErrorMessage = _config.timeoutErrorMessage;
            reject(new (0, $ax9gu.default)(timeoutErrorMessage, transitional.clarifyTimeoutError ? (0, $ax9gu.default).ETIMEDOUT : (0, $ax9gu.default).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Remove Content-Type if data is undefined
        requestData === undefined && requestHeaders.setContentType(null);
        // Add headers to the request
        if ("setRequestHeader" in request) (0, $fIemp.default).forEach(requestHeaders.toJSON(), function setRequestHeader(val, key) {
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!(0, $fIemp.default).isUndefined(_config.withCredentials)) request.withCredentials = !!_config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== "json") request.responseType = _config.responseType;
        // Handle progress if needed
        if (onDownloadProgress) {
            [downloadThrottled, flushDownload] = (0, $9Mt1i.progressEventReducer)(onDownloadProgress, true);
            request.addEventListener("progress", downloadThrottled);
        }
        // Not all browsers support upload events
        if (onUploadProgress && request.upload) {
            [uploadThrottled, flushUpload] = (0, $9Mt1i.progressEventReducer)(onUploadProgress);
            request.upload.addEventListener("progress", uploadThrottled);
            request.upload.addEventListener("loadend", flushUpload);
        }
        if (_config.cancelToken || _config.signal) {
            // Handle cancellation
            // eslint-disable-next-line func-names
            onCanceled = (cancel)=>{
                if (!request) return;
                reject(!cancel || cancel.type ? new (0, $bqef3.default)(null, config, request) : cancel);
                request.abort();
                request = null;
            };
            _config.cancelToken && _config.cancelToken.subscribe(onCanceled);
            if (_config.signal) _config.signal.aborted ? onCanceled() : _config.signal.addEventListener("abort", onCanceled);
        }
        const protocol = (0, $6nyWX.default)(_config.url);
        if (protocol && (0, $7vFM9.default).protocols.indexOf(protocol) === -1) {
            reject(new (0, $ax9gu.default)("Unsupported protocol " + protocol + ":", (0, $ax9gu.default).ERR_BAD_REQUEST, config));
            return;
        }
        // Send the request
        request.send(requestData || null);
    });
};

});
parcelRequire.register("l4V9M", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f5864ed60f64acc9$export$2e2bcd8739ae039; });

var $ax9gu = parcelRequire("ax9gu");
"use strict";
function $f5864ed60f64acc9$export$2e2bcd8739ae039(resolve, reject, response) {
    const validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject(new (0, $ax9gu.default)("Request failed with status code " + response.status, [
        (0, $ax9gu.default).ERR_BAD_REQUEST,
        (0, $ax9gu.default).ERR_BAD_RESPONSE
    ][Math.floor(response.status / 100) - 4], response.config, response.request, response));
}

});

parcelRequire.register("6nyWX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4a500068811bfcbf$export$2e2bcd8739ae039; });
"use strict";
function $4a500068811bfcbf$export$2e2bcd8739ae039(url) {
    const match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
    return match && match[1] || "";
}

});

parcelRequire.register("9Mt1i", function(module, exports) {

$parcel$export(module.exports, "progressEventReducer", function () { return $71ef1b7d7333ccc9$export$c1b28109d46c3592; });
$parcel$export(module.exports, "progressEventDecorator", function () { return $71ef1b7d7333ccc9$export$d9fadd12586c18d6; });
$parcel$export(module.exports, "asyncDecorator", function () { return $71ef1b7d7333ccc9$export$5d35863c355a22a9; });

var $2VCML = parcelRequire("2VCML");

var $da4mG = parcelRequire("da4mG");

var $fIemp = parcelRequire("fIemp");
const $71ef1b7d7333ccc9$export$c1b28109d46c3592 = (listener, isDownloadStream, freq = 3)=>{
    let bytesNotified = 0;
    const _speedometer = (0, $2VCML.default)(50, 250);
    return (0, $da4mG.default)((e)=>{
        const loaded = e.loaded;
        const total = e.lengthComputable ? e.total : undefined;
        const progressBytes = loaded - bytesNotified;
        const rate = _speedometer(progressBytes);
        const inRange = loaded <= total;
        bytesNotified = loaded;
        const data = {
            loaded: loaded,
            total: total,
            progress: total ? loaded / total : undefined,
            bytes: progressBytes,
            rate: rate ? rate : undefined,
            estimated: rate && total && inRange ? (total - loaded) / rate : undefined,
            event: e,
            lengthComputable: total != null,
            [isDownloadStream ? "download" : "upload"]: true
        };
        listener(data);
    }, freq);
};
const $71ef1b7d7333ccc9$export$d9fadd12586c18d6 = (total, throttled)=>{
    const lengthComputable = total != null;
    return [
        (loaded)=>throttled[0]({
                lengthComputable: lengthComputable,
                total: total,
                loaded: loaded
            }),
        throttled[1]
    ];
};
const $71ef1b7d7333ccc9$export$5d35863c355a22a9 = (fn)=>(...args)=>(0, $fIemp.default).asap(()=>fn(...args));

});
parcelRequire.register("2VCML", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $221efda3789ca092$export$2e2bcd8739ae039; });
"use strict";
/**
 * Calculate data maxRate
 * @param {Number} [samplesCount= 10]
 * @param {Number} [min= 1000]
 * @returns {Function}
 */ function $221efda3789ca092$var$speedometer(samplesCount, min) {
    samplesCount = samplesCount || 10;
    const bytes = new Array(samplesCount);
    const timestamps = new Array(samplesCount);
    let head = 0;
    let tail = 0;
    let firstSampleTS;
    min = min !== undefined ? min : 1000;
    return function push(chunkLength) {
        const now = Date.now();
        const startedAt = timestamps[tail];
        if (!firstSampleTS) firstSampleTS = now;
        bytes[head] = chunkLength;
        timestamps[head] = now;
        let i = tail;
        let bytesCount = 0;
        while(i !== head){
            bytesCount += bytes[i++];
            i = i % samplesCount;
        }
        head = (head + 1) % samplesCount;
        if (head === tail) tail = (tail + 1) % samplesCount;
        if (now - firstSampleTS < min) return;
        const passed = startedAt && now - startedAt;
        return passed ? Math.round(bytesCount * 1000 / passed) : undefined;
    };
}
var $221efda3789ca092$export$2e2bcd8739ae039 = $221efda3789ca092$var$speedometer;

});

parcelRequire.register("da4mG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $994f984f08529b4c$export$2e2bcd8739ae039; });
/**
 * Throttle decorator
 * @param {Function} fn
 * @param {Number} freq
 * @return {Function}
 */ function $994f984f08529b4c$var$throttle(fn, freq) {
    let timestamp = 0;
    let threshold = 1000 / freq;
    let lastArgs;
    let timer;
    const invoke = (args, now = Date.now())=>{
        timestamp = now;
        lastArgs = null;
        if (timer) {
            clearTimeout(timer);
            timer = null;
        }
        fn(...args);
    };
    const throttled = (...args)=>{
        const now = Date.now();
        const passed = now - timestamp;
        if (passed >= threshold) invoke(args, now);
        else {
            lastArgs = args;
            if (!timer) timer = setTimeout(()=>{
                timer = null;
                invoke(lastArgs);
            }, threshold - passed);
        }
    };
    const flush = ()=>lastArgs && invoke(lastArgs);
    return [
        throttled,
        flush
    ];
}
var $994f984f08529b4c$export$2e2bcd8739ae039 = $994f984f08529b4c$var$throttle;

});


parcelRequire.register("jtJjk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e2e3df8a17ef699e$export$2e2bcd8739ae039; });

var $7vFM9 = parcelRequire("7vFM9");

var $fIemp = parcelRequire("fIemp");

var $aTuz4 = parcelRequire("aTuz4");

var $68dww = parcelRequire("68dww");

var $d9L4R = parcelRequire("d9L4R");

var $cu9jP = parcelRequire("cu9jP");

var $9VBYq = parcelRequire("9VBYq");

var $l0mFf = parcelRequire("l0mFf");
var $e2e3df8a17ef699e$export$2e2bcd8739ae039 = (config)=>{
    const newConfig = (0, $cu9jP.default)({}, config);
    let { data: data, withXSRFToken: withXSRFToken, xsrfHeaderName: xsrfHeaderName, xsrfCookieName: xsrfCookieName, headers: headers, auth: auth } = newConfig;
    newConfig.headers = headers = (0, $9VBYq.default).from(headers);
    newConfig.url = (0, $l0mFf.default)((0, $d9L4R.default)(newConfig.baseURL, newConfig.url, newConfig.allowAbsoluteUrls), config.params, config.paramsSerializer);
    // HTTP basic authentication
    if (auth) headers.set("Authorization", "Basic " + btoa((auth.username || "") + ":" + (auth.password ? unescape(encodeURIComponent(auth.password)) : "")));
    if ((0, $fIemp.default).isFormData(data)) {
        if ((0, $7vFM9.default).hasStandardBrowserEnv || (0, $7vFM9.default).hasStandardBrowserWebWorkerEnv) headers.setContentType(undefined); // browser handles it
        else if ((0, $fIemp.default).isFunction(data.getHeaders)) {
            // Node.js FormData (like form-data package)
            const formHeaders = data.getHeaders();
            // Only set safe headers to avoid overwriting security headers
            const allowedHeaders = [
                "content-type",
                "content-length"
            ];
            Object.entries(formHeaders).forEach(([key, val])=>{
                if (allowedHeaders.includes(key.toLowerCase())) headers.set(key, val);
            });
        }
    }
    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if ((0, $7vFM9.default).hasStandardBrowserEnv) {
        withXSRFToken && (0, $fIemp.default).isFunction(withXSRFToken) && (withXSRFToken = withXSRFToken(newConfig));
        if (withXSRFToken || withXSRFToken !== false && (0, $aTuz4.default)(newConfig.url)) {
            // Add xsrf header
            const xsrfValue = xsrfHeaderName && xsrfCookieName && (0, $68dww.default).read(xsrfCookieName);
            if (xsrfValue) headers.set(xsrfHeaderName, xsrfValue);
        }
    }
    return newConfig;
};

});
parcelRequire.register("aTuz4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7ee6bff338e0f114$export$2e2bcd8739ae039; });

var $7vFM9 = parcelRequire("7vFM9");
var $7ee6bff338e0f114$export$2e2bcd8739ae039 = (0, $7vFM9.default).hasStandardBrowserEnv ? ((origin, isMSIE)=>(url)=>{
        url = new URL(url, (0, $7vFM9.default).origin);
        return origin.protocol === url.protocol && origin.host === url.host && (isMSIE || origin.port === url.port);
    })(new URL((0, $7vFM9.default).origin), (0, $7vFM9.default).navigator && /(msie|trident)/i.test((0, $7vFM9.default).navigator.userAgent)) : ()=>true;

});

parcelRequire.register("68dww", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $476dfaf369f45307$export$2e2bcd8739ae039; });

var $fIemp = parcelRequire("fIemp");

var $7vFM9 = parcelRequire("7vFM9");
var $476dfaf369f45307$export$2e2bcd8739ae039 = (0, $7vFM9.default).hasStandardBrowserEnv ? // Standard browser envs support document.cookie
{
    write (name, value, expires, path, domain, secure) {
        const cookie = [
            name + "=" + encodeURIComponent(value)
        ];
        (0, $fIemp.default).isNumber(expires) && cookie.push("expires=" + new Date(expires).toGMTString());
        (0, $fIemp.default).isString(path) && cookie.push("path=" + path);
        (0, $fIemp.default).isString(domain) && cookie.push("domain=" + domain);
        secure === true && cookie.push("secure");
        document.cookie = cookie.join("; ");
    },
    read (name) {
        const match = document.cookie.match(new RegExp("(^|;\\s*)(" + name + ")=([^;]*)"));
        return match ? decodeURIComponent(match[3]) : null;
    },
    remove (name) {
        this.write(name, "", Date.now() - 86400000);
    }
} : // Non-standard browser env (web workers, react-native) lack needed support.
{
    write () {},
    read () {
        return null;
    },
    remove () {}
};

});

parcelRequire.register("d9L4R", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9940a23ad8397a4e$export$2e2bcd8739ae039; });

var $9HbGF = parcelRequire("9HbGF");

var $fso1N = parcelRequire("fso1N");
"use strict";
function $9940a23ad8397a4e$export$2e2bcd8739ae039(baseURL, requestedURL, allowAbsoluteUrls) {
    let isRelativeUrl = !(0, $9HbGF.default)(requestedURL);
    if (baseURL && (isRelativeUrl || allowAbsoluteUrls == false)) return (0, $fso1N.default)(baseURL, requestedURL);
    return requestedURL;
}

});
parcelRequire.register("9HbGF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $70f1320447dcb1f9$export$2e2bcd8739ae039; });
"use strict";
function $70f1320447dcb1f9$export$2e2bcd8739ae039(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}

});

parcelRequire.register("fso1N", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b40c1c016f5c9fb5$export$2e2bcd8739ae039; });
"use strict";
function $b40c1c016f5c9fb5$export$2e2bcd8739ae039(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/?\/$/, "") + "/" + relativeURL.replace(/^\/+/, "") : baseURL;
}

});


parcelRequire.register("cu9jP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $916f83e25e1f0598$export$2e2bcd8739ae039; });

var $fIemp = parcelRequire("fIemp");

var $9VBYq = parcelRequire("9VBYq");
"use strict";
const $916f83e25e1f0598$var$headersToObject = (thing)=>thing instanceof (0, $9VBYq.default) ? {
        ...thing
    } : thing;
function $916f83e25e1f0598$export$2e2bcd8739ae039(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config2 = config2 || {};
    const config = {};
    function getMergedValue(target, source, prop, caseless) {
        if ((0, $fIemp.default).isPlainObject(target) && (0, $fIemp.default).isPlainObject(source)) return (0, $fIemp.default).merge.call({
            caseless: caseless
        }, target, source);
        else if ((0, $fIemp.default).isPlainObject(source)) return (0, $fIemp.default).merge({}, source);
        else if ((0, $fIemp.default).isArray(source)) return source.slice();
        return source;
    }
    // eslint-disable-next-line consistent-return
    function mergeDeepProperties(a, b, prop, caseless) {
        if (!(0, $fIemp.default).isUndefined(b)) return getMergedValue(a, b, prop, caseless);
        else if (!(0, $fIemp.default).isUndefined(a)) return getMergedValue(undefined, a, prop, caseless);
    }
    // eslint-disable-next-line consistent-return
    function valueFromConfig2(a, b) {
        if (!(0, $fIemp.default).isUndefined(b)) return getMergedValue(undefined, b);
    }
    // eslint-disable-next-line consistent-return
    function defaultToConfig2(a, b) {
        if (!(0, $fIemp.default).isUndefined(b)) return getMergedValue(undefined, b);
        else if (!(0, $fIemp.default).isUndefined(a)) return getMergedValue(undefined, a);
    }
    // eslint-disable-next-line consistent-return
    function mergeDirectKeys(a, b, prop) {
        if (prop in config2) return getMergedValue(a, b);
        else if (prop in config1) return getMergedValue(undefined, a);
    }
    const mergeMap = {
        url: valueFromConfig2,
        method: valueFromConfig2,
        data: valueFromConfig2,
        baseURL: defaultToConfig2,
        transformRequest: defaultToConfig2,
        transformResponse: defaultToConfig2,
        paramsSerializer: defaultToConfig2,
        timeout: defaultToConfig2,
        timeoutMessage: defaultToConfig2,
        withCredentials: defaultToConfig2,
        withXSRFToken: defaultToConfig2,
        adapter: defaultToConfig2,
        responseType: defaultToConfig2,
        xsrfCookieName: defaultToConfig2,
        xsrfHeaderName: defaultToConfig2,
        onUploadProgress: defaultToConfig2,
        onDownloadProgress: defaultToConfig2,
        decompress: defaultToConfig2,
        maxContentLength: defaultToConfig2,
        maxBodyLength: defaultToConfig2,
        beforeRedirect: defaultToConfig2,
        transport: defaultToConfig2,
        httpAgent: defaultToConfig2,
        httpsAgent: defaultToConfig2,
        cancelToken: defaultToConfig2,
        socketPath: defaultToConfig2,
        responseEncoding: defaultToConfig2,
        validateStatus: mergeDirectKeys,
        headers: (a, b, prop)=>mergeDeepProperties($916f83e25e1f0598$var$headersToObject(a), $916f83e25e1f0598$var$headersToObject(b), prop, true)
    };
    (0, $fIemp.default).forEach(Object.keys({
        ...config1,
        ...config2
    }), function computeConfigValue(prop) {
        const merge = mergeMap[prop] || mergeDeepProperties;
        const configValue = merge(config1[prop], config2[prop], prop);
        (0, $fIemp.default).isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
    });
    return config;
}

});



parcelRequire.register("7cBX1", function(module, exports) {

$parcel$export(module.exports, "getFetch", function () { return $53e717a860941be8$export$3105c6651375d4fa; });

var $7vFM9 = parcelRequire("7vFM9");

var $fIemp = parcelRequire("fIemp");

var $ax9gu = parcelRequire("ax9gu");

var $753E2 = parcelRequire("753E2");

var $3yRVS = parcelRequire("3yRVS");

var $9VBYq = parcelRequire("9VBYq");

var $9Mt1i = parcelRequire("9Mt1i");

var $jtJjk = parcelRequire("jtJjk");

var $l4V9M = parcelRequire("l4V9M");
const $53e717a860941be8$var$DEFAULT_CHUNK_SIZE = 65536;
const { isFunction: $53e717a860941be8$var$isFunction } = (0, $fIemp.default);
const $53e717a860941be8$var$globalFetchAPI = (({ fetch: fetch, Request: Request, Response: Response })=>({
        fetch: fetch,
        Request: Request,
        Response: Response
    }))((0, $fIemp.default).global);
const { ReadableStream: $53e717a860941be8$var$ReadableStream, TextEncoder: $53e717a860941be8$var$TextEncoder } = (0, $fIemp.default).global;
const $53e717a860941be8$var$test = (fn, ...args)=>{
    try {
        return !!fn(...args);
    } catch (e) {
        return false;
    }
};
const $53e717a860941be8$var$factory = (env)=>{
    const { fetch: fetch, Request: Request, Response: Response } = Object.assign({}, $53e717a860941be8$var$globalFetchAPI, env);
    const isFetchSupported = $53e717a860941be8$var$isFunction(fetch);
    const isRequestSupported = $53e717a860941be8$var$isFunction(Request);
    const isResponseSupported = $53e717a860941be8$var$isFunction(Response);
    if (!isFetchSupported) return false;
    const isReadableStreamSupported = isFetchSupported && $53e717a860941be8$var$isFunction($53e717a860941be8$var$ReadableStream);
    const encodeText = isFetchSupported && (typeof $53e717a860941be8$var$TextEncoder === "function" ? ((encoder)=>(str)=>encoder.encode(str))(new $53e717a860941be8$var$TextEncoder()) : async (str)=>new Uint8Array(await new Request(str).arrayBuffer()));
    const supportsRequestStream = isRequestSupported && isReadableStreamSupported && $53e717a860941be8$var$test(()=>{
        let duplexAccessed = false;
        const hasContentType = new Request((0, $7vFM9.default).origin, {
            body: new $53e717a860941be8$var$ReadableStream(),
            method: "POST",
            get duplex () {
                duplexAccessed = true;
                return "half";
            }
        }).headers.has("Content-Type");
        return duplexAccessed && !hasContentType;
    });
    const supportsResponseStream = isResponseSupported && isReadableStreamSupported && $53e717a860941be8$var$test(()=>(0, $fIemp.default).isReadableStream(new Response("").body));
    const resolvers = {
        stream: supportsResponseStream && ((res)=>res.body)
    };
    isFetchSupported && (()=>{
        [
            "text",
            "arrayBuffer",
            "blob",
            "formData",
            "stream"
        ].forEach((type)=>{
            !resolvers[type] && (resolvers[type] = (res, config)=>{
                let method = res && res[type];
                if (method) return method.call(res);
                throw new (0, $ax9gu.default)(`Response type '${type}' is not supported`, (0, $ax9gu.default).ERR_NOT_SUPPORT, config);
            });
        });
    })();
    const getBodyLength = async (body)=>{
        if (body == null) return 0;
        if ((0, $fIemp.default).isBlob(body)) return body.size;
        if ((0, $fIemp.default).isSpecCompliantForm(body)) {
            const _request = new Request((0, $7vFM9.default).origin, {
                method: "POST",
                body: body
            });
            return (await _request.arrayBuffer()).byteLength;
        }
        if ((0, $fIemp.default).isArrayBufferView(body) || (0, $fIemp.default).isArrayBuffer(body)) return body.byteLength;
        if ((0, $fIemp.default).isURLSearchParams(body)) body = body + "";
        if ((0, $fIemp.default).isString(body)) return (await encodeText(body)).byteLength;
    };
    const resolveBodyLength = async (headers, body)=>{
        const length = (0, $fIemp.default).toFiniteNumber(headers.getContentLength());
        return length == null ? getBodyLength(body) : length;
    };
    return async (config)=>{
        let { url: url, method: method, data: data, signal: signal, cancelToken: cancelToken, timeout: timeout, onDownloadProgress: onDownloadProgress, onUploadProgress: onUploadProgress, responseType: responseType, headers: headers, withCredentials: withCredentials = "same-origin", fetchOptions: fetchOptions } = (0, $jtJjk.default)(config);
        responseType = responseType ? (responseType + "").toLowerCase() : "text";
        let composedSignal = (0, $753E2.default)([
            signal,
            cancelToken && cancelToken.toAbortSignal()
        ], timeout);
        let request = null;
        const unsubscribe = composedSignal && composedSignal.unsubscribe && (()=>{
            composedSignal.unsubscribe();
        });
        let requestContentLength;
        try {
            if (onUploadProgress && supportsRequestStream && method !== "get" && method !== "head" && (requestContentLength = await resolveBodyLength(headers, data)) !== 0) {
                let _request = new Request(url, {
                    method: "POST",
                    body: data,
                    duplex: "half"
                });
                let contentTypeHeader;
                if ((0, $fIemp.default).isFormData(data) && (contentTypeHeader = _request.headers.get("content-type"))) headers.setContentType(contentTypeHeader);
                if (_request.body) {
                    const [onProgress, flush] = (0, $9Mt1i.progressEventDecorator)(requestContentLength, (0, $9Mt1i.progressEventReducer)((0, $9Mt1i.asyncDecorator)(onUploadProgress)));
                    data = (0, $3yRVS.trackStream)(_request.body, $53e717a860941be8$var$DEFAULT_CHUNK_SIZE, onProgress, flush);
                }
            }
            if (!(0, $fIemp.default).isString(withCredentials)) withCredentials = withCredentials ? "include" : "omit";
            // Cloudflare Workers throws when credentials are defined
            // see https://github.com/cloudflare/workerd/issues/902
            const isCredentialsSupported = isRequestSupported && "credentials" in Request.prototype;
            const resolvedOptions = {
                ...fetchOptions,
                signal: composedSignal,
                method: method.toUpperCase(),
                headers: headers.normalize().toJSON(),
                body: data,
                duplex: "half",
                credentials: isCredentialsSupported ? withCredentials : undefined
            };
            request = isRequestSupported && new Request(url, resolvedOptions);
            let response = await (isRequestSupported ? fetch(request, fetchOptions) : fetch(url, resolvedOptions));
            const isStreamResponse = supportsResponseStream && (responseType === "stream" || responseType === "response");
            if (supportsResponseStream && (onDownloadProgress || isStreamResponse && unsubscribe)) {
                const options = {};
                [
                    "status",
                    "statusText",
                    "headers"
                ].forEach((prop)=>{
                    options[prop] = response[prop];
                });
                const responseContentLength = (0, $fIemp.default).toFiniteNumber(response.headers.get("content-length"));
                const [onProgress, flush] = onDownloadProgress && (0, $9Mt1i.progressEventDecorator)(responseContentLength, (0, $9Mt1i.progressEventReducer)((0, $9Mt1i.asyncDecorator)(onDownloadProgress), true)) || [];
                response = new Response((0, $3yRVS.trackStream)(response.body, $53e717a860941be8$var$DEFAULT_CHUNK_SIZE, onProgress, ()=>{
                    flush && flush();
                    unsubscribe && unsubscribe();
                }), options);
            }
            responseType = responseType || "text";
            let responseData = await resolvers[(0, $fIemp.default).findKey(resolvers, responseType) || "text"](response, config);
            !isStreamResponse && unsubscribe && unsubscribe();
            return await new Promise((resolve, reject)=>{
                (0, $l4V9M.default)(resolve, reject, {
                    data: responseData,
                    headers: (0, $9VBYq.default).from(response.headers),
                    status: response.status,
                    statusText: response.statusText,
                    config: config,
                    request: request
                });
            });
        } catch (err) {
            unsubscribe && unsubscribe();
            if (err && err.name === "TypeError" && /Load failed|fetch/i.test(err.message)) throw Object.assign(new (0, $ax9gu.default)("Network Error", (0, $ax9gu.default).ERR_NETWORK, config, request), {
                cause: err.cause || err
            });
            throw (0, $ax9gu.default).from(err, err && err.code, config, request);
        }
    };
};
const $53e717a860941be8$var$seedCache = new Map();
const $53e717a860941be8$export$3105c6651375d4fa = (config)=>{
    let env = (0, $fIemp.default).merge.call({
        skipUndefined: true
    }, $53e717a860941be8$var$globalFetchAPI, config ? config.env : null);
    const { fetch: fetch, Request: Request, Response: Response } = env;
    const seeds = [
        Request,
        Response,
        fetch
    ];
    let len = seeds.length, i = len, seed, target, map = $53e717a860941be8$var$seedCache;
    while(i--){
        seed = seeds[i];
        target = map.get(seed);
        target === undefined && map.set(seed, target = i ? new Map() : $53e717a860941be8$var$factory(env));
        map = target;
    }
    return target;
};
const $53e717a860941be8$var$adapter = $53e717a860941be8$export$3105c6651375d4fa();
var $53e717a860941be8$export$2e2bcd8739ae039 = $53e717a860941be8$var$adapter;

});
parcelRequire.register("753E2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $527bd3d3b864b5f0$export$2e2bcd8739ae039; });

var $bqef3 = parcelRequire("bqef3");

var $ax9gu = parcelRequire("ax9gu");

var $fIemp = parcelRequire("fIemp");
const $527bd3d3b864b5f0$var$composeSignals = (signals, timeout)=>{
    const { length: length } = signals = signals ? signals.filter(Boolean) : [];
    if (timeout || length) {
        let controller = new AbortController();
        let aborted;
        const onabort = function(reason) {
            if (!aborted) {
                aborted = true;
                unsubscribe();
                const err = reason instanceof Error ? reason : this.reason;
                controller.abort(err instanceof (0, $ax9gu.default) ? err : new (0, $bqef3.default)(err instanceof Error ? err.message : err));
            }
        };
        let timer = timeout && setTimeout(()=>{
            timer = null;
            onabort(new (0, $ax9gu.default)(`timeout ${timeout} of ms exceeded`, (0, $ax9gu.default).ETIMEDOUT));
        }, timeout);
        const unsubscribe = ()=>{
            if (signals) {
                timer && clearTimeout(timer);
                timer = null;
                signals.forEach((signal)=>{
                    signal.unsubscribe ? signal.unsubscribe(onabort) : signal.removeEventListener("abort", onabort);
                });
                signals = null;
            }
        };
        signals.forEach((signal)=>signal.addEventListener("abort", onabort));
        const { signal: signal } = controller;
        signal.unsubscribe = ()=>(0, $fIemp.default).asap(unsubscribe);
        return signal;
    }
};
var $527bd3d3b864b5f0$export$2e2bcd8739ae039 = $527bd3d3b864b5f0$var$composeSignals;

});

parcelRequire.register("3yRVS", function(module, exports) {

$parcel$export(module.exports, "trackStream", function () { return $297e61ed7faa921c$export$b0119225647bd83; });
const $297e61ed7faa921c$export$71b051935044bd5d = function*(chunk, chunkSize) {
    let len = chunk.byteLength;
    if (!chunkSize || len < chunkSize) {
        yield chunk;
        return;
    }
    let pos = 0;
    let end;
    while(pos < len){
        end = pos + chunkSize;
        yield chunk.slice(pos, end);
        pos = end;
    }
};
const $297e61ed7faa921c$export$f9f241124ee3198e = async function*(iterable, chunkSize) {
    for await (const chunk of $297e61ed7faa921c$var$readStream(iterable))yield* $297e61ed7faa921c$export$71b051935044bd5d(chunk, chunkSize);
};
const $297e61ed7faa921c$var$readStream = async function*(stream) {
    if (stream[Symbol.asyncIterator]) {
        yield* stream;
        return;
    }
    const reader = stream.getReader();
    try {
        for(;;){
            const { done: done, value: value } = await reader.read();
            if (done) break;
            yield value;
        }
    } finally{
        await reader.cancel();
    }
};
const $297e61ed7faa921c$export$b0119225647bd83 = (stream, chunkSize, onProgress, onFinish)=>{
    const iterator = $297e61ed7faa921c$export$f9f241124ee3198e(stream, chunkSize);
    let bytes = 0;
    let done;
    let _onFinish = (e)=>{
        if (!done) {
            done = true;
            onFinish && onFinish(e);
        }
    };
    return new ReadableStream({
        async pull (controller) {
            try {
                const { done: done, value: value } = await iterator.next();
                if (done) {
                    _onFinish();
                    controller.close();
                    return;
                }
                let len = value.byteLength;
                if (onProgress) {
                    let loadedBytes = bytes += len;
                    onProgress(loadedBytes);
                }
                controller.enqueue(new Uint8Array(value));
            } catch (err) {
                _onFinish(err);
                throw err;
            }
        },
        cancel (reason) {
            _onFinish(reason);
            return iterator.return();
        }
    }, {
        highWaterMark: 2
    });
};

});




parcelRequire.register("bCA7M", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $875f43e6f4ca5a62$export$2e2bcd8739ae039; });

var $1lg8r = parcelRequire("1lg8r");

var $ax9gu = parcelRequire("ax9gu");
"use strict";
const $875f43e6f4ca5a62$var$validators = {};
// eslint-disable-next-line func-names
[
    "object",
    "boolean",
    "number",
    "function",
    "string",
    "symbol"
].forEach((type, i)=>{
    $875f43e6f4ca5a62$var$validators[type] = function validator(thing) {
        return typeof thing === type || "a" + (i < 1 ? "n " : " ") + type;
    };
});
const $875f43e6f4ca5a62$var$deprecatedWarnings = {};
/**
 * Transitional option validator
 *
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 *
 * @returns {function}
 */ $875f43e6f4ca5a62$var$validators.transitional = function transitional(validator, version, message) {
    function formatMessage(opt, desc) {
        return "[Axios v" + (0, $1lg8r.VERSION) + "] Transitional option '" + opt + "'" + desc + (message ? ". " + message : "");
    }
    // eslint-disable-next-line func-names
    return (value, opt, opts)=>{
        if (validator === false) throw new (0, $ax9gu.default)(formatMessage(opt, " has been removed" + (version ? " in " + version : "")), (0, $ax9gu.default).ERR_DEPRECATED);
        if (version && !$875f43e6f4ca5a62$var$deprecatedWarnings[opt]) {
            $875f43e6f4ca5a62$var$deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, " has been deprecated since v" + version + " and will be removed in the near future"));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
$875f43e6f4ca5a62$var$validators.spelling = function spelling(correctSpelling) {
    return (value, opt)=>{
        // eslint-disable-next-line no-console
        console.warn(`${opt} is likely a misspelling of ${correctSpelling}`);
        return true;
    };
};
/**
 * Assert object's properties type
 *
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 *
 * @returns {object}
 */ function $875f43e6f4ca5a62$var$assertOptions(options, schema, allowUnknown) {
    if (typeof options !== "object") throw new (0, $ax9gu.default)("options must be an object", (0, $ax9gu.default).ERR_BAD_OPTION_VALUE);
    const keys = Object.keys(options);
    let i = keys.length;
    while(i-- > 0){
        const opt = keys[i];
        const validator = schema[opt];
        if (validator) {
            const value = options[opt];
            const result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new (0, $ax9gu.default)("option " + opt + " must be " + result, (0, $ax9gu.default).ERR_BAD_OPTION_VALUE);
            continue;
        }
        if (allowUnknown !== true) throw new (0, $ax9gu.default)("Unknown option " + opt, (0, $ax9gu.default).ERR_BAD_OPTION);
    }
}
var $875f43e6f4ca5a62$export$2e2bcd8739ae039 = {
    assertOptions: $875f43e6f4ca5a62$var$assertOptions,
    validators: $875f43e6f4ca5a62$var$validators
};

});
parcelRequire.register("1lg8r", function(module, exports) {

$parcel$export(module.exports, "VERSION", function () { return $0fa444bbe75ec374$export$a4ad2735b021c132; });
const $0fa444bbe75ec374$export$a4ad2735b021c132 = "1.12.0";

});



parcelRequire.register("ev6QT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a8e946a1437f835d$export$2e2bcd8739ae039; });

var $bqef3 = parcelRequire("bqef3");
"use strict";
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @param {Function} executor The executor function.
 *
 * @returns {CancelToken}
 */ class $a8e946a1437f835d$var$CancelToken {
    constructor(executor){
        if (typeof executor !== "function") throw new TypeError("executor must be a function.");
        let resolvePromise;
        this.promise = new Promise(function promiseExecutor(resolve) {
            resolvePromise = resolve;
        });
        const token = this;
        // eslint-disable-next-line func-names
        this.promise.then((cancel)=>{
            if (!token._listeners) return;
            let i = token._listeners.length;
            while(i-- > 0)token._listeners[i](cancel);
            token._listeners = null;
        });
        // eslint-disable-next-line func-names
        this.promise.then = (onfulfilled)=>{
            let _resolve;
            // eslint-disable-next-line func-names
            const promise = new Promise((resolve)=>{
                token.subscribe(resolve);
                _resolve = resolve;
            }).then(onfulfilled);
            promise.cancel = function reject() {
                token.unsubscribe(_resolve);
            };
            return promise;
        };
        executor(function cancel(message, config, request) {
            if (token.reason) // Cancellation has already been requested
            return;
            token.reason = new (0, $bqef3.default)(message, config, request);
            resolvePromise(token.reason);
        });
    }
    /**
   * Throws a `CanceledError` if cancellation has been requested.
   */ throwIfRequested() {
        if (this.reason) throw this.reason;
    }
    /**
   * Subscribe to the cancel signal
   */ subscribe(listener) {
        if (this.reason) {
            listener(this.reason);
            return;
        }
        if (this._listeners) this._listeners.push(listener);
        else this._listeners = [
            listener
        ];
    }
    /**
   * Unsubscribe from the cancel signal
   */ unsubscribe(listener) {
        if (!this._listeners) return;
        const index = this._listeners.indexOf(listener);
        if (index !== -1) this._listeners.splice(index, 1);
    }
    toAbortSignal() {
        const controller = new AbortController();
        const abort = (err)=>{
            controller.abort(err);
        };
        this.subscribe(abort);
        controller.signal.unsubscribe = ()=>this.unsubscribe(abort);
        return controller.signal;
    }
    /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */ static source() {
        let cancel;
        const token = new $a8e946a1437f835d$var$CancelToken(function executor(c) {
            cancel = c;
        });
        return {
            token: token,
            cancel: cancel
        };
    }
}
var $a8e946a1437f835d$export$2e2bcd8739ae039 = $a8e946a1437f835d$var$CancelToken;

});

parcelRequire.register("f9iLS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b07641ded8349a50$export$2e2bcd8739ae039; });
"use strict";
function $b07641ded8349a50$export$2e2bcd8739ae039(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
}

});

parcelRequire.register("7RWFS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5baaff26af95c09e$export$2e2bcd8739ae039; });

var $fIemp = parcelRequire("fIemp");
"use strict";
function $5baaff26af95c09e$export$2e2bcd8739ae039(payload) {
    return (0, $fIemp.default).isObject(payload) && payload.isAxiosError === true;
}

});

parcelRequire.register("aGTas", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7c889ec1da105db5$export$2e2bcd8739ae039; });
const $7c889ec1da105db5$var$HttpStatusCode = {
    Continue: 100,
    SwitchingProtocols: 101,
    Processing: 102,
    EarlyHints: 103,
    Ok: 200,
    Created: 201,
    Accepted: 202,
    NonAuthoritativeInformation: 203,
    NoContent: 204,
    ResetContent: 205,
    PartialContent: 206,
    MultiStatus: 207,
    AlreadyReported: 208,
    ImUsed: 226,
    MultipleChoices: 300,
    MovedPermanently: 301,
    Found: 302,
    SeeOther: 303,
    NotModified: 304,
    UseProxy: 305,
    Unused: 306,
    TemporaryRedirect: 307,
    PermanentRedirect: 308,
    BadRequest: 400,
    Unauthorized: 401,
    PaymentRequired: 402,
    Forbidden: 403,
    NotFound: 404,
    MethodNotAllowed: 405,
    NotAcceptable: 406,
    ProxyAuthenticationRequired: 407,
    RequestTimeout: 408,
    Conflict: 409,
    Gone: 410,
    LengthRequired: 411,
    PreconditionFailed: 412,
    PayloadTooLarge: 413,
    UriTooLong: 414,
    UnsupportedMediaType: 415,
    RangeNotSatisfiable: 416,
    ExpectationFailed: 417,
    ImATeapot: 418,
    MisdirectedRequest: 421,
    UnprocessableEntity: 422,
    Locked: 423,
    FailedDependency: 424,
    TooEarly: 425,
    UpgradeRequired: 426,
    PreconditionRequired: 428,
    TooManyRequests: 429,
    RequestHeaderFieldsTooLarge: 431,
    UnavailableForLegalReasons: 451,
    InternalServerError: 500,
    NotImplemented: 501,
    BadGateway: 502,
    ServiceUnavailable: 503,
    GatewayTimeout: 504,
    HttpVersionNotSupported: 505,
    VariantAlsoNegotiates: 506,
    InsufficientStorage: 507,
    LoopDetected: 508,
    NotExtended: 510,
    NetworkAuthenticationRequired: 511
};
Object.entries($7c889ec1da105db5$var$HttpStatusCode).forEach(([key, value])=>{
    $7c889ec1da105db5$var$HttpStatusCode[value] = key;
});
var $7c889ec1da105db5$export$2e2bcd8739ae039 = $7c889ec1da105db5$var$HttpStatusCode;

});



parcelRequire.register("6g79T", function(module, exports) {

$parcel$export(module.exports, "getTicket", function () { return $48e9ca3fb35de0f2$export$ec22c3e055f07a21; });
$parcel$export(module.exports, "getRecurringTicket", function () { return $48e9ca3fb35de0f2$export$f8f7fc58d9d25e20; });
parcelRequire("T3ldG");
var $8dOLt = parcelRequire("8dOLt");
const $48e9ca3fb35de0f2$export$ec22c3e055f07a21 = (data)=>{
    return (0, $8dOLt.default).post("https://myheronapis.heron.gr/payment/ticket", data, {
        headers: {
            "Content-Type": "application/json",
            "Ocp-Apim-Subscription-Key": "b0ddbdf4cda04731a709f417e10ff427"
        }
    });
};
const $48e9ca3fb35de0f2$export$f8f7fc58d9d25e20 = (data)=>{
    return (0, $8dOLt.default).post("https://myheronapis.heron.gr/recurring/ticket", data, {
        headers: {
            "Content-Type": "application/json",
            "Ocp-Apim-Subscription-Key": "b0ddbdf4cda04731a709f417e10ff427"
        }
    });
};

});

parcelRequire.register("gLG3I", function(module, exports) {

$parcel$export(module.exports, "getUserDetails", function () { return $c351a921e69d8df9$export$714d3544202969b; });
parcelRequire("T3ldG");
var $8dOLt = parcelRequire("8dOLt");

var $7SNu6 = parcelRequire("7SNu6");
const $c351a921e69d8df9$export$714d3544202969b = (token, accountId)=>{
    const query = (0, $7SNu6.isNullOrWhitespace)(accountId) ? "" : `?accountId=${accountId}`;
    return (0, $8dOLt.default).get(`${"https://myheronapis.heron.gr/account/3DSecureInfo"}${query}`, {
        headers: {
            "Ocp-Apim-Subscription-Key": "b0ddbdf4cda04731a709f417e10ff427",
            Authorization: token
        }
    });
};

});

parcelRequire.register("kWQ6K", function(module, exports) {

$parcel$export(module.exports, "isWebStorageSupported", function () { return $f401a4f31e02019d$export$b930d03bd1628cbe; });
const $f401a4f31e02019d$export$b930d03bd1628cbe = ()=>{
    try {
        var storage = window["localStorage"], x = "__storage_test__";
        storage.setItem(x, x);
        storage.removeItem(x);
        return true;
    } catch (e) {
        return false;
    }
};

});


//# sourceMappingURL=recurring.60c2f42c.js.map
